/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 34);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(41);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export css */
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

// 
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      return [].concat(ruleSet, flatten(chunk, executionContext));
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    return ruleSet.concat(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

// 
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (!Array.isArray(styles) && (typeof styles === 'undefined' ? 'undefined' : _typeof(styles)) === 'object') {
    return flatten(interleave([], [styles].concat(interpolations)));
  }
  return flatten(interleave(styles, interpolations));
});

var stream = {}

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof false === 'boolean' && false || "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new Error();
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 
/* eslint-disable flowtype/object-type-delimiter */
/* eslint-disable react/prop-types */

/* this error is used for makeStyleTag */
var parentNodeUnmountedErr =  false ? '\nTrying to insert a new style tag, but the given Node is unmounted!\n- Are you using a custom target that isn\'t mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n'.trim() : '';

/* this error is used for tags */
var throwCloneTagErr = function throwCloneTagErr() {
  throw new Error( false ? '\nThe clone method cannot be used on the client!\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n'.trim() : '');
};

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new Error(parentNodeUnmountedErr);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: throwCloneTagErr
  };
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;
  var makeTextNode = function makeTextNode(id) {
    return document.createTextNode(makeTextMarker(id));
  };

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: throwCloneTagErr
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    styleTag: null,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: clone
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);
    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, names, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0; i < extracted.length; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0; _i < els.length; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.sealed = false;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var names = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      isStreamed = !!el.getAttribute(SC_STREAM_ATTR) || isStreamed;

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(/\s+/);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
        names.push(name);
      }

      /* extract all components and their CSS */
      extracted = extracted.concat(extractComps(el.textContent));
      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, names, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);
    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;
    this.sealed = true;
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !this.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;
    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      this.sealed = false;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    /* add deferred rules for component */
    var injectRules = cssRules;
    var deferredRules = this.deferred[id];
    if (deferredRules !== undefined) {
      injectRules = deferredRules.concat(injectRules);
      delete this.deferred[id];
    }

    var tag = this.getTagForId(id);
    tag.insertRules(id, injectRules, name);
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    delete this.deferred[id];
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

// 
/* this error is used for makeStyleTag */
var targetPropErr =  false ? '\nThe StyleSheetManager expects a valid target or sheet prop!\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n'.trim() : '';

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new Error(targetPropErr);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 
/* eslint-disable no-underscore-dangle */
/* this error is used for makeStyleTag */
var sheetClosedErr =  false ? '\nCan\'t collect styles once you\'ve consumed a ServerStyleSheet\'s styles!\nServerStyleSheet is a one off instance for each server-side render cycle.\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n'.trim() : '';

var streamBrowserErr =  false ? 'Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.' : '';

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new Error(sheetClosedErr);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new Error(streamBrowserErr);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 
function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|onPointerOu|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|unicodeRange|mathematical|vAlphabetic|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|autoPlay|o(?:verflow|pen)|f(?:o(?:ntSize|rm)|il(?:ter|l))|r(?:e(?:quired|sult|f))?|divisor|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|i(?:temRef|n2|s)|t(?:arget[XY]|o)|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|prefix|typeof|itemID|s(?:t(?:roke|art)|hape|cope|rc)|t(?:arget|ype)|(?:stri|la)ng|a(?:ccept|s)|m(?:edia|a(?:sk|x)|in)|x(?:mlns)?|width|value|size|href|k(?:ey)?|end|low|by|i[dn]|y[12]|g[12]|x[12]|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _ThemeProvider$childC;
var _ThemeProvider$contex;

// 
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (false) {
        throw new Error(process.env.NODE_ENV !== 'production' ? '[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!' : '');
      }
      return mergedTheme;
    }
    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new Error( false ? '[ThemeProvider] Please make your theme prop an object' : '');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

// 

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var identifiers = {};

  /* We depend on components having unique IDs */
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

    /**
     * This ensures uniqueness if two components happen to share
     * the same displayName.
     */
    var nr = (identifiers[displayName] || 0) + 1;
    identifiers[displayName] = nr;

    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  // $FlowFixMe

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_3_react__["Component"]) ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (false) {
          warnTooManyClasses(className);
        }

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a statically-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (prevState) {
        var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;
    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 
var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        var css = stringifyRules(flatCSS, '.' + name);
        styleSheet.inject(this.componentId, css, name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 
var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 
var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new Error( false ? 'Cannot create styled-component for component: ' + String(tag) : '');
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 
var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);


/* harmony default export */ __webpack_exports__["a"] = (styled);
//# sourceMappingURL=styled-components.browser.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10), __webpack_require__(53)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(25);
var isBuffer = __webpack_require__(84);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(57)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(42);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Common=function Common(){var _this=this;_classCallCheck(this,Common);this.selectStyles=function(){return{option:function option(base,state){return Object.assign({},base,{backgroundColor:state.isFocused?'rgba(255, 255, 255, 0.1)':'none',borderBottom:'1px solid black',color:'white',padding:15,'&:hover':{backgroundColor:'rgba(255, 255, 255, 0.1)'},'.Select-option.is-selected':{backgroundColor:'none'},'&:active':{backgroundColor:'rgba(0, 0, 0, 1)'}});},menu:function menu(base){return Object.assign({},base,{backgroundColor:'rgba(0, 0, 0, 0.9)',backgroundImage:'none',border:'0px none'});},control:function control(base){return Object.assign({},base,{backgroundColor:'rgba(0, 0, 0, 0.9)',backgroundImage:'none',border:'0px none',margin:'0;',minWidth:'300px'});},valueContainer:function valueContainer(base){return Object.assign({},base,{backgroundColor:'rgba(0, 0, 0, 0.9)',backgroundImage:'none',border:'0px none'});},multiValue:function multiValue(base){return Object.assign({},base,{backgroundColor:'rgba(255, 255, 255, 0.3)'});},multiValueLabel:function multiValueLabel(base){return Object.assign({},base,{color:'#fff'});},singleValue:function singleValue(base){return Object.assign({},base,{color:'#fff'});},input:function input(base){return Object.assign({},base,{color:'#fff'});}};};this.savedLists=function(){var lists={};var listCache=localStorage.getItem('lists');if(listCache){lists=JSON.parse(listCache);}return lists;};this.listsForSelect=function(){var lists=_this.savedLists();var listNames=[];if(lists){listNames=Object.keys(lists);}return listNames.map(function(name){return{value:name,label:name};});};this.updateListCache=function(listId){var lists={};var listCache=localStorage.getItem('lists');if(listCache){lists=JSON.parse(listCache);}if(listId&&/^\w/.test(listId)){lists[listId]=true;localStorage.setItem('lists',JSON.stringify(lists));}};};/* harmony default export */ __webpack_exports__["a"] = (Common);//# sourceMappingURL=common.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorPrefix = exports.events = undefined;
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
exports.getPosition = getPosition;
exports.isTouchEvent = isTouchEvent;
exports.getEdgeOffset = getEdgeOffset;
exports.getLockPixelOffset = getLockPixelOffset;

var _invariant = __webpack_require__(7);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}

function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}

function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { top: 0, left: 0 };

  // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
  if (node) {
    var nodeOffset = {
      top: offset.top + node.offsetTop,
      left: offset.left + node.offsetLeft
    };

    if (node.parentNode !== parent) {
      return getEdgeOffset(node.parentNode, parent, nodeOffset);
    } else {
      return nodeOffset;
    }
  }
}

function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;

  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

    (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

    offsetX = offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return components; });
/* unused harmony export mergeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_autosize__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);








var diacritics = [{ base: 'A', letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { base: 'AA', letters: /[\uA732]/g }, { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g }, { base: 'AO', letters: /[\uA734]/g }, { base: 'AU', letters: /[\uA736]/g }, { base: 'AV', letters: /[\uA738\uA73A]/g }, { base: 'AY', letters: /[\uA73C]/g }, { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { base: 'DZ', letters: /[\u01F1\u01C4]/g }, { base: 'Dz', letters: /[\u01F2\u01C5]/g }, { base: 'E', letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { base: 'LJ', letters: /[\u01C7]/g }, { base: 'Lj', letters: /[\u01C8]/g }, { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { base: 'NJ', letters: /[\u01CA]/g }, { base: 'Nj', letters: /[\u01CB]/g }, { base: 'O', letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { base: 'OI', letters: /[\u01A2]/g }, { base: 'OO', letters: /[\uA74E]/g }, { base: 'OU', letters: /[\u0222]/g }, { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { base: 'TZ', letters: /[\uA728]/g }, { base: 'U', letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { base: 'VY', letters: /[\uA760]/g }, { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { base: 'a', letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { base: 'aa', letters: /[\uA733]/g }, { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g }, { base: 'ao', letters: /[\uA735]/g }, { base: 'au', letters: /[\uA737]/g }, { base: 'av', letters: /[\uA739\uA73B]/g }, { base: 'ay', letters: /[\uA73D]/g }, { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { base: 'dz', letters: /[\u01F3\u01C6]/g }, { base: 'e', letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { base: 'hv', letters: /[\u0195]/g }, { base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { base: 'lj', letters: /[\u01C9]/g }, { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { base: 'nj', letters: /[\u01CC]/g }, { base: 'o', letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { base: 'oi', letters: /[\u01A3]/g }, { base: 'ou', letters: /[\u0223]/g }, { base: 'oo', letters: /[\uA74F]/g }, { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { base: 'tz', letters: /[\uA729]/g }, { base: 'u', letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { base: 'vy', letters: /[\uA761]/g }, { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < diacritics.length; i++) {
		str = str.replace(diacritics[i].letters, diacritics[i].base);
	}
	return str;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaulStringify = function defaulStringify(option) {
  return option.label + ' ' + option.value;
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _extends({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaulStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var DummyInput = function (_Component) {
  inherits(DummyInput, _Component);

  function DummyInput() {
    classCallCheck(this, DummyInput);
    return possibleConstructorReturn(this, (DummyInput.__proto__ || Object.getPrototypeOf(DummyInput)).apply(this, arguments));
  }

  createClass(DummyInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inProp = _props.in,
          out = _props.out,
          onExited = _props.onExited,
          appear = _props.appear,
          enter = _props.enter,
          exit = _props.exit,
          innerRef = _props.innerRef,
          props = objectWithoutProperties(_props, ['in', 'out', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
        ref: innerRef
      }, props, {
        className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,

          // important! without `width` browsers won't allow focus
          width: 1,

          // remove cursor on desktop
          color: 'transparent',

          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);
  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var NodeResolver = function (_Component) {
  inherits(NodeResolver, _Component);

  function NodeResolver() {
    classCallCheck(this, NodeResolver);
    return possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];

var LOCK_STYLES = {
  boxSizing: 'border-box', // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var activeScrollLocks = 0;

var ScrollLock = function (_Component) {
  inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.originalStyles = {}, _this.listenerOptions = {
      capture: false,
      passive: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;

      var _props = this.props,
          accountForScrollbars = _props.accountForScrollbars,
          touchScrollTarget = _props.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      }

      // apply the lock styles and padding if this is the first scroll lock
      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = adjustedPadding + 'px';
        }
      }

      // account for touch devices
      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions);

        // Allow scroll on provided target
        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }

      // increment active scroll locks
      activeScrollLocks += 1;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;

      var _props2 = this.props,
          accountForScrollbars = _props2.accountForScrollbars,
          touchScrollTarget = _props2.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      // safely decrement active scroll locks
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

      // reapply original body styles, if any
      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      }

      // remove touch listeners
      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

var createPrimitive = function createPrimitive(Tag) {
  return function (_ref) {
    var css$$1 = _ref.css,
        innerRef = _ref.innerRef,
        props = objectWithoutProperties(_ref, ['css', 'innerRef']);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag, _extends({ ref: innerRef, className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(css$$1)
    }, props));
  };
};
var Div = createPrimitive('div');

// Assistive text to describe visual elements. Hidden for sighted users.
var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({
    className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref

var ScrollBlock = function (_PureComponent) {
  inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollBlock.__proto__ || Object.getPrototypeOf(ScrollBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = { touchScrollTarget: null }, _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;
      _this.setState({ touchScrollTarget: ref });
    }, _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // must be in state to trigger a re-render, only runs once per instance


  // this will close the menu when a user clicks outside


  createClass(ScrollBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isEnabled = _props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget;

      // bail early if not enabled

      if (!isEnabled) return children;

      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Div, {
          onClick: this.blurSelectInput,
          className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 })
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NodeResolver,
          { innerRef: this.getScrollTarget },
          children
        ),
        touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollLock, { touchScrollTarget: touchScrollTarget }) : null
      );
    }
  }]);
  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

var ScrollCaptor = function (_Component) {
  inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollCaptor.__proto__ || Object.getPrototypeOf(ScrollCaptor)).call.apply(_ref, [this].concat(args))), _this), _this.isBottom = false, _this.isTop = false, _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;

      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false;

      // reset bottom/top flags
      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }
      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      }

      // bottom limit
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true;

        // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      }

      // cancel scroll
      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    }, _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    }, _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    }, _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
      _this.handleEventDelta(event, deltaY);
    }, _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollCaptor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: 'startListening',
    value: function startListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'stopListening',
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NodeResolver,
        { innerRef: this.getScrollTarget },
        this.props.children
      );
    }
  }]);
  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var ScrollCaptorSwitch = function (_Component2) {
  inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    classCallCheck(this, ScrollCaptorSwitch);
    return possibleConstructorReturn(this, (ScrollCaptorSwitch.__proto__ || Object.getPrototypeOf(ScrollCaptorSwitch)).apply(this, arguments));
  }

  createClass(ScrollCaptorSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEnabled = _props.isEnabled,
          props = objectWithoutProperties(_props, ['isEnabled']);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);
  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollCaptorSwitch.defaultProps = { isEnabled: true };

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label;

  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Backspace to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';
    case 'input':
      return (label ? label : 'Select') + ' is focused ' + (isSearchable ? ',type to refine list' : '') + ', press Down to open the menu, ' + (isMulti ? ' press left to focus selected values' : '');
    case 'value':
      return 'Use left and right to toggle between focused values, press Enter to remove the currently focused value';
  }
};

var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value;

  if (!value) return;
  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return 'option ' + value + ', deselected.';
    case 'select-option':
      return 'option ' + value + ', selected.';
  }
};

var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return 'value ' + getOptionLabel(focusedValue) + ' focused, ' + (selectValue.indexOf(focusedValue) + 1) + ' of ' + selectValue.length + '.';
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return 'option ' + getOptionLabel(focusedOption) + ' focused, ' + (options.indexOf(focusedOption) + 1) + ' of ' + options.length + '.';
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return '' + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + '.';
};

// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push('' + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_3_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  } catch (e) {
    return false;
  }
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var borderRadius = 4;

var colors = {
  text: '#222',
  textLight: '#444',
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral1: 'hsl(0, 0%, 99%)',
  neutral2: 'hsl(0, 0%, 98%)',
  neutral3: 'hsl(0, 0%, 97%)',
  neutral4: 'hsl(0, 0%, 96%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)',
  neutral100: 'hsl(0, 0%, 0%)',

  neutral1a: 'hsla(0, 0%, 0%, 0.01)',
  neutral2a: 'hsla(0, 0%, 0%, 0.02)',
  neutral3a: 'hsla(0, 0%, 0%, 0.03)',
  neutral4a: 'hsla(0, 0%, 0%, 0.04)',
  neutral5a: 'hsla(0, 0%, 0%, 0.05)',
  neutral10a: 'hsla(0, 0%, 0%, 0.1)',
  neutral20a: 'hsla(0, 0%, 0%, 0.2)',
  neutral30a: 'hsla(0, 0%, 0%, 0.3)',
  neutral40a: 'hsla(0, 0%, 0%, 0.4)',
  neutral50a: 'hsla(0, 0%, 0%, 0.5)',
  neutral60a: 'hsla(0, 0%, 0%, 0.6)',
  neutral70a: 'hsla(0, 0%, 0%, 0.7)',
  neutral80a: 'hsla(0, 0%, 0%, 0.8)',
  neutral90a: 'hsla(0, 0%, 0%, 0.9)'
};

var baseUnit = 4;

var spacing = {
  /* Used to calculate consistent margin/padding on elements */
  baseUnit: baseUnit,
  /* The minimum height of the control */
  controlHeight: 38,
  /* The amount of space between the control and menu */
  menuGutter: baseUnit * 2
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null, // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps),
    children
  );
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS() {
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: spacing.baseUnit / 2 + 'px ' + spacing.baseUnit * 2 + 'px',
    WebkitOverflowScrolling: 'touch',
    position: 'relative'
  };
};
var ValueContainer = function (_Component) {
  inherits(ValueContainer, _Component);

  function ValueContainer() {
    classCallCheck(this, ValueContainer);
    return possibleConstructorReturn(this, (ValueContainer.__proto__ || Object.getPrototypeOf(ValueContainer)).apply(this, arguments));
  }

  createClass(ValueContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          isMulti = _props.isMulti,
          getStyles = _props.getStyles,
          hasValue = _props.hasValue;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        },
        children
      );
    }
  }]);
  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;


  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    },
    children
  );
};

// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = objectWithoutProperties(_ref, ['size']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg', _extends({
    height: size,
    width: size,
    viewBox: '0 0 20 20',
    'aria-hidden': 'true',
    focusable: 'false',
    className: /*#__PURE__*/ /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z' })
  );
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z' })
  );
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: spacing.baseUnit * 2,
    transition: 'color 150ms',

    ':hover': {
      color: isFocused ? colors.neutral100 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var _props$children = props.children,
      children = _props$children === undefined ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DownChevron, null) : _props$children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }),
    children
  );
};

var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var _props$children2 = props.children,
      children = _props$children2 === undefined ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, null) : _props$children2,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }),
    children
  );
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: spacing.baseUnit * 2,
    marginTop: spacing.baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({}, innerProps, {
    className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('indicatorSeparator', props)), { 'indicator-separator': true }, className)
  }));
};

// ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';

var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: spacing.baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
    className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
      animationDuration: '1s',
      animationDelay: delay + 'ms',
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

// eslint-disable-next-line no-unused-expressions
Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["b" /* injectGlobal */])('@keyframes ', keyframesName, '{0%,80%,100%{opacity:0;}40%{opacity:1;}};');

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl;

  var color = isFocused ? colors.text : colors.neutral20;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 0, offset: isRtl }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 160, offset: true }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 320, offset: !isRtl })
  );
};
LoadingIndicator.defaultProps = { size: 4 };

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : isFocused ? colors.neutral0 : colors.neutral2,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? '0 0 0 1px ' + colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',

    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerProps = props.innerProps;
  var innerRef = innerProps.innerRef,
      rest = objectWithoutProperties(innerProps, ['innerRef']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused
      }, className)
    }, rest),
    children
  );
};

var groupCSS = function groupCSS() {
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      label = props.label;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('group', props)), { 'group': true }, className)
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Heading,
      { getStyles: getStyles, cx: cx },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      children
    )
  );
};

var groupHeadingCSS = function groupHeadingCSS() {
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      cleanProps = objectWithoutProperties(props, ['className', 'cx', 'getStyles']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', _extends({
    className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('groupHeading', props)), { 'group-heading': true }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.text
  };
};
var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input$1 = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      props = objectWithoutProperties(_ref2, ['className', 'cx', 'getStyles', 'innerRef', 'isHidden', 'isDisabled']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('input', props))
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_autosize___default.a, _extends({
      className: cx(null, { 'input': true }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props))
  );
};

// ==============================
// Menu
// ==============================

// Get Menu Placement
// ------------------------------

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition;

  var scrollParent = getScrollParent(menuEl);
  var defaultState = { placement: 'bottom', maxHeight: maxHeight };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  // $FlowFixMe function returns above if there's no offsetParent


  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var gutter = spacing.menuGutter;

  var viewSpaceAbove = containerTop - gutter;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;

  var scrollDown = menuBottom - viewHeight + scrollTop + gutter;
  var scrollUp = scrollTop + menuTop - gutter;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - gutter : scrollSpaceBelow - gutter;

        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight = isFixedPosition ? viewSpaceAbove - gutter - spacing.controlHeight : scrollSpaceAbove - gutter - spacing.controlHeight;
        }

        return { placement: 'top', maxHeight: _constrainedHeight };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return { placement: 'bottom', maxHeight: maxHeight };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return { placement: 'top', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return { placement: 'top', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - gutter : scrollSpaceAbove - gutter;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return { placement: 'bottom', maxHeight: maxHeight };
    default:
      throw new Error('Invalid placement provided "' + placement + '".');
  }

  // fulfil contract with flow: implicit return value of undefined
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = { bottom: 'top', top: 'bottom' };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement;
  return _ref3 = {}, defineProperty(_ref3, alignToControl(placement), '100%'), defineProperty(_ref3, 'backgroundColor', colors.neutral0), defineProperty(_ref3, 'borderRadius', borderRadius), defineProperty(_ref3, 'boxShadow', '0 0 0 1px ' + colors.neutral10a + ', 0 4px 11px ' + colors.neutral10a), defineProperty(_ref3, 'marginBottom', spacing.menuGutter), defineProperty(_ref3, 'marginTop', spacing.menuGutter), defineProperty(_ref3, 'position', 'absolute'), defineProperty(_ref3, 'width', '100%'), defineProperty(_ref3, 'zIndex', 1), _ref3;
};

var Menu = function (_Component) {
  inherits(Menu, _Component);

  function Menu() {
    var _ref4;

    var _temp, _this, _ret;

    classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref4 = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    }, _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView;
      var getPortalPlacement = _this.context.getPortalPlacement;


      if (!ref) return;

      // DO NOT scroll if position is fixed
      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;

      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition
      });

      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    }, _this.getState = function () {
      var menuPlacement = _this.props.menuPlacement;

      var placement = _this.state.placement || coercePlacement(menuPlacement);

      return _extends({}, _this.props, { placement: placement, maxHeight: _this.state.maxHeight });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          getStyles = _props.getStyles,
          innerProps = _props.innerProps;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        _extends({
          className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('menu', this.getState())), {
            'menu': true
          }, className),
          ref: this.getPlacement
        }, innerProps),
        children
      );
    }
  }]);
  return Menu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Menu.contextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: spacing.baseUnit,
    paddingTop: spacing.baseUnit,
    position: 'relative', // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerProps = props.innerProps;
  var innerRef = innerProps.innerRef;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    },
    children
  );
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS() {
  return {
    color: colors.neutral40,
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;

var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps),
    children
  );
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps),
    children
  );
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = function (_Component2) {
  inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _ref7;

    var _temp2, _this2, _ret2;

    classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = possibleConstructorReturn(this, (_ref7 = MenuPortal.__proto__ || Object.getPrototypeOf(MenuPortal)).call.apply(_ref7, [this].concat(args))), _this2), _this2.state = { placement: null }, _this2.getPortalPlacement = function (_ref8) {
      var placement = _ref8.placement;

      var initialPlacement = coercePlacement(_this2.props.menuPlacement);

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this2.setState({ placement: placement });
      }
    }, _temp2), possibleConstructorReturn(_this2, _ret2);
  }

  createClass(MenuPortal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }

    // callback for occassions where the menu must "flip"

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          appendTo = _props2.appendTo,
          children = _props2.children,
          controlElement = _props2.controlElement,
          menuPlacement = _props2.menuPlacement,
          position = _props2.menuPosition,
          getStyles = _props2.getStyles;

      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = { offset: offset, position: position, rect: rect };

      // same wrapper element whether fixed or portalled
      var menuWrapper = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: /*#__PURE__*/ /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('menuPortal', state))
        },
        children
      );

      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);
  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
MenuPortal.childContextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var multiValueCSS = function multiValueCSS() {
  return {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref) {
  var cropWithEllipsis = _ref.cropWithEllipsis;
  return {
    color: colors.text,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};

var MultiValueContainer = Div;
var MultiValueLabel = Div;

var MultiValueRemove = function (_Component) {
  inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    classCallCheck(this, MultiValueRemove);
    return possibleConstructorReturn(this, (MultiValueRemove.__proto__ || Object.getPrototypeOf(MultiValueRemove)).apply(this, arguments));
  }

  createClass(MultiValueRemove, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = objectWithoutProperties(_props, ['children']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Div,
        props,
        children
      );
    }
  }]);
  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValueRemove.defaultProps = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, { size: 14 })
};

var MultiValue = function (_Component2) {
  inherits(MultiValue, _Component2);

  function MultiValue() {
    classCallCheck(this, MultiValue);
    return possibleConstructorReturn(this, (MultiValue.__proto__ || Object.getPrototypeOf(MultiValue)).apply(this, arguments));
  }

  createClass(MultiValue, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          components = _props2.components,
          cx = _props2.cx,
          getStyles = _props2.getStyles,
          innerProps = _props2.innerProps,
          isDisabled = _props2.isDisabled,
          removeProps = _props2.removeProps;

      var cn = {
        container: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className),
        label: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className),
        remove: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      };
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Container,
        _extends({
          className: cn.container
        }, innerProps),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          { className: cn.label },
          children
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Remove, _extends({ className: cn.remove }, removeProps))
      );
    }
  }]);
  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected;
  return {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? colors.primary : colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerProps = props.innerProps;
  var innerRef = innerProps.innerRef,
      rest = objectWithoutProperties(innerProps, ['innerRef']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, rest),
    children
  );
};

var placeholderCSS = function placeholderCSS() {
  return {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps),
    children
  );
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    color: isDisabled ? colors.neutral40 : colors.text,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: 'calc(100% - ' + spacing.baseUnit * 2 + 'px)',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps),
    children
  );
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
};

// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _extends({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });

  return styles;
}

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return count + ' result' + (count !== 1 ? 's' : '') + ' available';
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

var instanceId = 1;

var Select = function (_Component) {
  inherits(Select, _Component);

  // Lifecycle
  // ------------------------------

  // Refs
  // ------------------------------

  // Misc. Instance Properties
  // ------------------------------

  function Select(props) {
    classCallCheck(this, Select);

    var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;

    _this.components = defaultComponents(props);
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var selectValue = cleanValue(value);
    var menuOptions = _this.buildMenuOptions(props, selectValue);

    _this.state.menuOptions = menuOptions;
    _this.state.selectValue = selectValue;
    return _this;
  } // TODO


  createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListeningToTouch();

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          components$$1 = _props.components,
          options = _props.options,
          value = _props.value,
          inputValue = _props.inputValue;
      // re-cache custom components

      if (nextProps.components !== components$$1) {
        this.components = defaultComponents(nextProps);
      }
      // rebuild the menu options
      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var _selectValue = cleanValue(nextProps.value);
        var _menuOptions = this.buildMenuOptions(nextProps, _selectValue);
        var _focusedValue = this.getNextFocusedValue(_selectValue);
        var _focusedOption = this.getNextFocusedOption(_menuOptions.focusable);
        this.setState({ menuOptions: _menuOptions, selectValue: _selectValue, focusedOption: _focusedOption, focusedValue: _focusedValue });
      }
      // some updates should toggle the state of the input visibility
      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          isDisabled = _props2.isDisabled,
          menuIsOpen = _props2.menuIsOpen;
      var isFocused = this.state.isFocused;


      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListeningToTouch();
    }

    // ==============================
    // Consumer Handlers
    // ==============================

  }, {
    key: 'onMenuOpen',
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: 'onMenuClose',
    value: function onMenuClose() {
      var _props3 = this.props,
          isSearchable = _props3.isSearchable,
          isMulti = _props3.isMulti;

      this.announceAriaLiveContext({ event: 'input', context: { isSearchable: isSearchable, isMulti: isMulti } });
      this.onInputChange('', { action: 'menu-close' });
      this.props.onMenuClose();
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================

  }, {
    key: 'focusInput',
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: 'blurInput',
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers

  }, {
    key: 'openMenu',
    value: function openMenu(focusOption) {
      var _state = this.state,
          menuOptions = _state.menuOptions,
          selectValue = _state.selectValue;
      var isMulti = this.props.isMulti;

      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.inputIsHiddenAfterUpdate = false;

      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });

      this.announceAriaLiveContext({ event: 'menu' });
    }
  }, {
    key: 'focusValue',
    value: function focusValue(direction) {
      var _props4 = this.props,
          isMulti = _props4.isMulti,
          isSearchable = _props4.isSearchable;
      var _state2 = this.state,
          selectValue = _state2.selectValue,
          focusedValue = _state2.focusedValue;

      // Only multiselects support value focusing

      if (!isMulti) return;

      this.setState({
        focusedOption: null
      });

      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'value' });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({ event: 'input', context: { isSearchable: isSearchable, isMulti: isMulti } });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: 'focusOption',
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _state3 = this.state,
          focusedOption = _state3.focusedOption,
          menuOptions = _state3.menuOptions;

      var options = menuOptions.focusable;

      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'menu' });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: 'getCommonProps',


    // ==============================
    // Getters
    // ==============================

    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var className = props.className,
          classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;

      var hasValue = this.hasValue();
      var getValue = function getValue() {
        return selectValue;
      };
      var cxPrefix = classNamePrefix;
      if (className && classNamePrefix === undefined) {
        console.warn('\n        Warning: the behaviour of \'className\' has changed between 2.0.0-beta.2 and 2.0.0-beta.3.\n        You can now use className to specify the class name of the outer container, and classNamePrefix to enable our provided BEM class names for internal elements.\n        The className prop will have no effect on internal elements when 2.0.0 is released.\n      ');
        cxPrefix = className;
      }

      var cx = classNames.bind(null, cxPrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props
      };
    }
  }, {
    key: 'getNextFocusedValue',
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }
      var _state4 = this.state,
          focusedValue = _state4.focusedValue,
          lastSelectValue = _state4.selectValue;

      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }
      return null;
    }
  }, {
    key: 'getNextFocusedOption',
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;

      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }

    // ==============================
    // Helpers
    // ==============================

  }, {
    key: 'hasValue',
    value: function hasValue() {
      var selectValue = this.state.selectValue;

      return selectValue.length > 0;
    }
  }, {
    key: 'hasOptions',
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: 'countOptions',
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: 'isClearable',
    value: function isClearable() {
      var _props5 = this.props,
          isClearable = _props5.isClearable,
          isMulti = _props5.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;

      return isClearable;
    }
  }, {
    key: 'isOptionDisabled',
    value: function isOptionDisabled$$1(option) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option) : false;
    }
  }, {
    key: 'isOptionSelected',
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;
      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }
      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: 'formatOptionLabel',
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue2 = this.state.selectValue;

        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue2
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: 'formatGroupLabel',
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: 'startListeningToTouch',


    // ==============================
    // Touch Handlers
    // ==============================

    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: 'stopListeningToTouch',
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }

    // ==============================
    // Focus Handlers
    // ==============================

    // ==============================
    // Keyboard Handlers
    // ==============================

  }, {
    key: 'buildMenuOptions',


    // ==============================
    // Menu Options
    // ==============================

    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === undefined ? '' : _props$inputValue,
          options = props.options;


      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option);
        var isSelected = _this3.isOptionSelected(option, selectValue);
        var label = _this3.getOptionLabel(option);
        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({ label: label, value: value, data: option }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = _this3.getElementId('option') + '-' + id;

        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            role: 'option',
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;

          var items = item.options;

          var children = items.map(function (child, i) {
            var option = toOption(child, itemIndex + '-' + i);
            if (option && !option.isDisabled) acc.focusable.push(child);
            return option;
          }).filter(Boolean);
          if (children.length) {
            var groupId = _this3.getElementId('group') + '-' + itemIndex;
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, '' + itemIndex);
          if (option) {
            acc.render.push(option);
            if (!option.isDisabled) acc.focusable.push(item);
          }
        }
        return acc;
      }, { render: [], focusable: [] });
    }

    // ==============================
    // Renderers
    // ==============================

  }, {
    key: 'constructAriaLiveMessage',
    value: function constructAriaLiveMessage() {
      var _state5 = this.state,
          ariaLiveContext = _state5.ariaLiveContext,
          selectValue = _state5.selectValue,
          focusedValue = _state5.focusedValue,
          focusedOption = _state5.focusedOption;
      var _props6 = this.props,
          options = _props6.options,
          menuIsOpen = _props6.menuIsOpen,
          inputValue = _props6.inputValue,
          screenReaderStatus = _props6.screenReaderStatus;

      // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({ focusedValue: focusedValue, getOptionLabel: this.getOptionLabel, selectValue: selectValue }) : '';
      // An aria live message representing the currently focused option in the select.
      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({ focusedOption: focusedOption, getOptionLabel: this.getOptionLabel, options: options }) : '';
      // An aria live message representing the set of focusable results and current searchterm/inputvalue.
      var resultsMsg = resultsAriaMessage({ inputValue: inputValue, screenReaderMessage: screenReaderStatus({ count: this.countOptions() }) });

      return focusedValueMsg + ' ' + focusedOptionMsg + ' ' + resultsMsg + ' ' + ariaLiveContext;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props7 = this.props,
          isDisabled = _props7.isDisabled,
          isSearchable = _props7.isSearchable,
          inputId = _props7.inputId,
          inputValue = _props7.inputValue,
          tabIndex = _props7.tabIndex;
      var Input$$1 = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;


      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          tabIndex: tabIndex,
          value: ''
        });
      }

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      var cx = this.commonProps.cx;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input$$1, _extends({
        autoCapitalize: 'none',
        autoComplete: 'off',
        autoCorrect: 'off',
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: 'false',
        tabIndex: tabIndex,
        type: 'text',
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: 'renderPlaceholderOrValue',
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _components = this.components,
          MultiValue = _components.MultiValue,
          MultiValueContainer = _components.MultiValueContainer,
          MultiValueLabel = _components.MultiValueLabel,
          MultiValueRemove = _components.MultiValueRemove,
          SingleValue = _components.SingleValue,
          Placeholder = _components.Placeholder;
      var commonProps = this.commonProps;
      var _props8 = this.props,
          controlShouldRenderValue = _props8.controlShouldRenderValue,
          isDisabled = _props8.isDisabled,
          isMulti = _props8.isMulti,
          inputValue = _props8.inputValue,
          placeholder = _props8.placeholder;
      var _state6 = this.state,
          selectValue = _state6.selectValue,
          focusedValue = _state6.focusedValue;


      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Placeholder,
          _extends({}, commonProps, { key: 'placeholder', isDisabled: isDisabled }),
          placeholder
        );
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            MultiValue,
            _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isFocused,
              isDisabled: isDisabled,
              key: _this4.getOptionValue(opt),
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }),
            _this4.formatOptionLabel(opt, 'value')
          );
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SingleValue,
        _extends({}, commonProps, { data: singleValue, isDisabled: isDisabled }),
        this.formatOptionLabel(singleValue, 'value')
      );
    }
  }, {
    key: 'renderClearIndicator',
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _props9 = this.props,
          isDisabled = _props9.isDisabled,
          isLoading = _props9.isLoading;
      var isFocused = this.state.isFocused;


      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderLoadingIndicator',
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _props10 = this.props,
          isDisabled = _props10.isDisabled,
          isLoading = _props10.isLoading;
      var isFocused = this.state.isFocused;


      if (!LoadingIndicator || !isLoading) return null;

      var innerProps = { 'aria-hidden': 'true' };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderIndicatorSeparator',
    value: function renderIndicatorSeparator() {
      var _components2 = this.components,
          DropdownIndicator = _components2.DropdownIndicator,
          IndicatorSeparator = _components2.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;

      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderDropdownIndicator',
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this5 = this;

      var _components3 = this.components,
          Group = _components3.Group,
          GroupHeading = _components3.GroupHeading,
          Menu = _components3.Menu,
          MenuList = _components3.MenuList,
          MenuPortal = _components3.MenuPortal,
          LoadingMessage = _components3.LoadingMessage,
          NoOptionsMessage = _components3.NoOptionsMessage,
          Option = _components3.Option;
      var commonProps = this.commonProps;
      var _state7 = this.state,
          focusedOption = _state7.focusedOption,
          menuOptions = _state7.menuOptions;
      var _props11 = this.props,
          captureMenuScroll = _props11.captureMenuScroll,
          inputValue = _props11.inputValue,
          isLoading = _props11.isLoading,
          loadingMessage = _props11.loadingMessage,
          minMenuHeight = _props11.minMenuHeight,
          maxMenuHeight = _props11.maxMenuHeight,
          menuIsOpen = _props11.menuIsOpen,
          menuPlacement = _props11.menuPlacement,
          menuPosition = _props11.menuPosition,
          menuPortalTarget = _props11.menuPortalTarget,
          menuShouldBlockScroll = _props11.menuShouldBlockScroll,
          menuShouldScrollIntoView = _props11.menuShouldScrollIntoView,
          noOptionsMessage = _props11.noOptionsMessage,
          onMenuScrollToTop = _props11.onMenuScrollToTop,
          onMenuScrollToBottom = _props11.onMenuScrollToBottom;


      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerProps.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Option,
          _extends({}, commonProps, props, { isFocused: isFocused }),
          _this5.formatOptionLabel(props.data, 'menu')
        );
      };

      var menuUI = void 0;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = objectWithoutProperties(item, ['type']);

            var headingId = item.key + '-heading';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              Group,
              _extends({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId
                },
                label: _this5.formatGroupLabel(item.data)
              }),
              item.options.map(function (option) {
                return render(option);
              })
            );
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({ inputValue: inputValue });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          LoadingMessage,
          commonProps,
          message
        );
      } else {
        var _message = noOptionsMessage({ inputValue: inputValue });
        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NoOptionsMessage,
          commonProps,
          _message
        );
      }

      var menuElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Menu,
          _extends({}, commonProps, {
            innerProps: {
              onMouseDown: this.onMenuMouseDown,
              onMouseMove: this.onMenuMouseMove
            },
            isLoading: isLoading,
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ScrollCaptorSwitch,
            {
              isEnabled: captureMenuScroll,
              onTopArrive: onMenuScrollToTop,
              onBottomArrive: onMenuScrollToBottom
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              ScrollBlock,
              { isEnabled: menuShouldBlockScroll },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                MenuList,
                _extends({}, commonProps, {
                  innerProps: {
                    innerRef: this.getMenuListRef
                  },
                  isLoading: isLoading,
                  maxHeight: maxMenuHeight
                }),
                menuUI
              )
            )
          )
        )
      );

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuPortal,
        _extends({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }),
        menuElement
      ) : menuElement;
    }
  }, {
    key: 'renderFormField',
    value: function renderFormField() {
      var _this6 = this;

      var _props12 = this.props,
          delimiter = _props12.delimiter,
          isDisabled = _props12.isDisabled,
          isMulti = _props12.isMulti,
          name = _props12.name;
      var selectValue = this.state.selectValue;


      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var _value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value });
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            selectValue.map(function (opt, i) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                key: 'i-' + i,
                name: name,
                type: 'hidden',
                value: _this6.getOptionValue(opt)
              });
            })
          );
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value2 });
      }
    }
  }, {
    key: 'renderLiveRegion',
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        A11yText,
        { 'aria-live': 'assertive' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-selection-event' },
          '\xA0',
          this.state.ariaLiveSelection
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-context' },
          '\xA0',
          this.constructAriaLiveMessage()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _components4 = this.components,
          Control = _components4.Control,
          IndicatorsContainer = _components4.IndicatorsContainer,
          SelectContainer = _components4.SelectContainer,
          ValueContainer = _components4.ValueContainer;
      var _props13 = this.props,
          className = _props13.className,
          id = _props13.id,
          isDisabled = _props13.isDisabled;
      var isFocused = this.state.isFocused;


      var commonProps = this.commonProps = this.getCommonProps();

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SelectContainer,
        _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }),
        this.renderLiveRegion(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Control,
          _extends({}, commonProps, {
            innerProps: {
              innerRef: this.getControlRef,
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ValueContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderPlaceholderOrValue(),
            this.renderInput()
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            IndicatorsContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderClearIndicator(),
            this.renderLoadingIndicator(),
            this.renderIndicatorSeparator(),
            this.renderDropdownIndicator()
          )
        ),
        this.renderMenu(),
        this.renderFormField()
      );
    }
  }]);
  return Select;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Select.defaultProps = defaultProps;

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.state = {
    ariaLiveSelection: '',
    ariaLiveContext: '',
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: false,
    isFocused: false,
    menuOptions: { render: [], focusable: [] },
    selectValue: []
  };
  this.blockOptionHover = false;
  this.clearFocusValueOnUpdate = false;
  this.hasGroups = false;
  this.initialTouchX = 0;
  this.initialTouchY = 0;
  this.instancePrefix = '';
  this.openAfterFocus = false;
  this.scrollToFocusedOptionOnUpdate = false;
  this.controlRef = null;

  this.getControlRef = function (ref) {
    _this7.controlRef = ref;
  };

  this.focusedOptionRef = null;

  this.getFocusedOptionRef = function (ref) {
    _this7.focusedOptionRef = ref;
  };

  this.menuListRef = null;

  this.getMenuListRef = function (ref) {
    _this7.menuListRef = ref;
  };

  this.inputRef = null;

  this.getInputRef = function (ref) {
    _this7.inputRef = ref;
  };

  this.focus = this.focusInput;
  this.blur = this.blurInput;

  this.setValue = function (newValue) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
    var option = arguments[2];
    var _props14 = _this7.props,
        closeMenuOnSelect = _props14.closeMenuOnSelect,
        isMulti = _props14.isMulti,
        onChange = _props14.onChange;

    _this7.onInputChange('', { action: 'set-value' });
    if (closeMenuOnSelect) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    }
    // when the select value should change, we should reset focusedValue
    _this7.clearFocusValueOnUpdate = true;
    onChange(newValue, { action: action, option: option });
  };

  this.selectOption = function (newValue) {
    var _props15 = _this7.props,
        blurInputOnSelect = _props15.blurInputOnSelect,
        isMulti = _props15.isMulti;


    if (isMulti) {
      var _selectValue3 = _this7.state.selectValue;

      if (_this7.isOptionSelected(newValue, _selectValue3)) {
        var candidate = _this7.getOptionValue(newValue);
        _this7.setValue(_selectValue3.filter(function (i) {
          return _this7.getOptionValue(i) !== candidate;
        }), 'deselect-option', newValue);
        _this7.announceAriaLiveSelection({ event: 'deselect-option', context: { value: _this7.getOptionLabel(newValue) } });
      } else {

        _this7.setValue([].concat(toConsumableArray(_selectValue3), [newValue]), 'select-option', newValue);
        _this7.announceAriaLiveSelection({ event: 'select-option', context: { value: _this7.getOptionLabel(newValue) } });
      }
    } else {
      _this7.setValue(newValue, 'select-option');
      _this7.announceAriaLiveSelection({ event: 'select-option', context: { value: _this7.getOptionLabel(newValue) } });
    }

    if (blurInputOnSelect) {
      _this7.blurInput();
    }
  };

  this.removeValue = function (removedValue) {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var candidate = _this7.getOptionValue(removedValue);
    onChange(selectValue.filter(function (i) {
      return _this7.getOptionValue(i) !== candidate;
    }), {
      action: 'remove-value',
      removedValue: removedValue
    });
    _this7.announceAriaLiveSelection({ event: 'remove-value', context: { value: removedValue ? _this7.getOptionLabel(removedValue) : undefined } });
    _this7.focusInput();
  };

  this.clearValue = function () {
    var _props16 = _this7.props,
        isMulti = _props16.isMulti,
        onChange = _props16.onChange;

    onChange(isMulti ? [] : null, { action: 'clear' });
  };

  this.popValue = function () {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var lastSelectedValue = selectValue[selectValue.length - 1];
    _this7.announceAriaLiveSelection({ event: 'pop-value', context: { value: lastSelectedValue ? _this7.getOptionLabel(lastSelectedValue) : undefined } });
    onChange(selectValue.slice(0, selectValue.length - 1), {
      action: 'pop-value',
      removedValue: lastSelectedValue
    });
  };

  this.getOptionLabel = function (data) {
    return _this7.props.getOptionLabel(data);
  };

  this.getOptionValue = function (data) {
    return _this7.props.getOptionValue(data);
  };

  this.getStyles = function (key, props) {
    var base = defaultStyles[key](props);
    base.boxSizing = 'border-box';
    var custom = _this7.props.styles[key];
    return custom ? custom(base, props) : base;
  };

  this.getElementId = function (element) {
    return _this7.instancePrefix + '-' + element;
  };

  this.getActiveDescendentId = function () {
    var menuIsOpen = _this7.props.menuIsOpen;
    var _state8 = _this7.state,
        menuOptions = _state8.menuOptions,
        focusedOption = _state8.focusedOption;


    if (!focusedOption || !menuIsOpen) return undefined;

    var index = menuOptions.focusable.indexOf(focusedOption);
    var option = menuOptions.render[index];

    return option && option.key;
  };

  this.announceAriaLiveSelection = function (_ref2) {
    var event = _ref2.event,
        context = _ref2.context;

    _this7.setState({
      ariaLiveSelection: valueEventAriaMessage(event, context)
    });
  };

  this.announceAriaLiveContext = function (_ref3) {
    var event = _ref3.event,
        context = _ref3.context;

    _this7.setState({
      ariaLiveContext: instructionsAriaMessage(event, _extends({}, context, { label: _this7.props['aria-label'] }))
    });
  };

  this.onMenuMouseDown = function (event) {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    _this7.focusInput();
  };

  this.onMenuMouseMove = function (event) {
    _this7.blockOptionHover = false;
  };

  this.onControlMouseDown = function (event) {
    var openMenuOnClick = _this7.props.openMenuOnClick;

    if (!_this7.state.isFocused) {
      if (openMenuOnClick) {
        _this7.openAfterFocus = true;
      }
      _this7.focusInput();
    } else if (!_this7.props.menuIsOpen) {
      _this7.openMenu('first');
    } else {
      _this7.onMenuClose();
    }
    // $FlowFixMe HTMLElement type does not have tagName property
    if (event.target.tagName !== 'INPUT') {
      event.preventDefault();
    }
  };

  this.onDropdownIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    if (_this7.props.isDisabled) return;
    var _props17 = _this7.props,
        isMulti = _props17.isMulti,
        menuIsOpen = _props17.menuIsOpen;

    _this7.focusInput();
    if (menuIsOpen) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    } else {
      _this7.openMenu('first');
    }
    event.preventDefault();
    event.stopPropagation();
  };

  this.onClearIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    _this7.clearValue();
    event.stopPropagation();
    _this7.openAfterFocus = false;
    setTimeout(function () {
      return _this7.focusInput();
    });
  };

  this.onTouchStart = function (_ref4) {
    var _ref4$touches = slicedToArray(_ref4.touches, 1),
        touch = _ref4$touches[0];

    _this7.initialTouchX = touch.clientX;
    _this7.initialTouchY = touch.clientY;
    _this7.userIsDragging = false;
  };

  this.onTouchMove = function (_ref5) {
    var _ref5$touches = slicedToArray(_ref5.touches, 1),
        touch = _ref5$touches[0];

    var deltaX = Math.abs(touch.clientX - _this7.initialTouchX);
    var deltaY = Math.abs(touch.clientY - _this7.initialTouchY);
    var moveThreshold = 5;

    _this7.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
  };

  this.onTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    // type cast the EventTarget
    var target = event.target;

    // close the menu if the user taps outside
    if (_this7.controlRef && !_this7.controlRef.contains(target) && _this7.menuListRef && !_this7.menuListRef.contains(target)) {
      _this7.blurInput();
    }

    // reset move vars
    _this7.initialTouchX = 0;
    _this7.initialTouchY = 0;
  };

  this.onControlTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onControlMouseDown(event);
  };

  this.onClearIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onClearIndicatorMouseDown(event);
  };

  this.onDropdownIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onDropdownIndicatorMouseDown(event);
  };

  this.handleInputChange = function (event) {
    var inputValue = event.currentTarget.value;
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.onInputChange(inputValue, { action: 'input-change' });
    _this7.onMenuOpen();
  };

  this.onInputFocus = function (event) {
    var _props18 = _this7.props,
        isSearchable = _props18.isSearchable,
        isMulti = _props18.isMulti;

    if (_this7.props.onFocus) {
      _this7.props.onFocus(event);
    }
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.announceAriaLiveContext({ event: 'input', context: { isSearchable: isSearchable, isMulti: isMulti } });
    _this7.setState({
      isFocused: true
    });
    if (_this7.openAfterFocus || _this7.props.openMenuOnFocus) {
      _this7.openMenu('first');
    }
    _this7.openAfterFocus = false;
  };

  this.onInputBlur = function (event) {
    if (_this7.props.onBlur) {
      _this7.props.onBlur(event);
    }
    _this7.onInputChange('', { action: 'input-blur' });
    _this7.onMenuClose();
    _this7.setState({
      focusedValue: null,
      isFocused: false
    });
  };

  this.onOptionHover = function (focusedOption) {
    if (_this7.blockOptionHover || _this7.state.focusedOption === focusedOption) {
      return;
    }
    _this7.setState({ focusedOption: focusedOption });
  };

  this.shouldHideSelectedOptions = function () {
    var _props19 = _this7.props,
        hideSelectedOptions = _props19.hideSelectedOptions,
        isMulti = _props19.isMulti;

    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  this.onKeyDown = function (event) {
    var _props20 = _this7.props,
        isMulti = _props20.isMulti,
        backspaceRemovesValue = _props20.backspaceRemovesValue,
        escapeClearsValue = _props20.escapeClearsValue,
        inputValue = _props20.inputValue,
        isClearable = _props20.isClearable,
        isDisabled = _props20.isDisabled,
        menuIsOpen = _props20.menuIsOpen,
        onKeyDown = _props20.onKeyDown,
        tabSelectsValue = _props20.tabSelectsValue,
        openMenuOnFocus = _props20.openMenuOnFocus;
    var _state9 = _this7.state,
        focusedOption = _state9.focusedOption,
        focusedValue = _state9.focusedValue,
        selectValue = _state9.selectValue;


    if (isDisabled) return;

    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    // Block option hover events when the user has just pressed a key
    _this7.blockOptionHover = true;
    switch (event.key) {
      case 'ArrowLeft':
        if (!isMulti || inputValue) return;
        _this7.focusValue('previous');
        break;
      case 'ArrowRight':
        if (!isMulti || inputValue) return;
        _this7.focusValue('next');
        break;
      case 'Backspace':
        if (inputValue) return;
        if (focusedValue) {
          _this7.removeValue(focusedValue);
        } else {
          if (!backspaceRemovesValue) return;
          _this7.popValue();
        }
        break;
      case 'Tab':
        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
        // don't capture the event if the menu opens on focus and the focused
        // option is already selected; it breaks the flow of navigation
        openMenuOnFocus && _this7.isOptionSelected(focusedOption, selectValue)) {
          return;
        }
        _this7.selectOption(focusedOption);
        break;
      case 'Enter':
        if (menuIsOpen) {
          if (!focusedOption) return;
          _this7.selectOption(focusedOption);
        } else {
          _this7.focusOption('first');
        }
        break;
      case 'Escape':
        if (menuIsOpen) {
          _this7.inputIsHiddenAfterUpdate = false;
          _this7.onInputChange('', { action: 'menu-close' });
          _this7.onMenuClose();
        } else if (isClearable && escapeClearsValue) {
          _this7.clearValue();
        }
        break;
      case ' ':
        // space
        if (inputValue) {
          return;
        }
        if (!menuIsOpen) {
          _this7.openMenu('first');
          break;
        }
        if (!focusedOption) return;
        _this7.selectOption(focusedOption);
        break;
      case 'ArrowUp':
        if (menuIsOpen) {
          _this7.focusOption('up');
        } else {
          _this7.openMenu('last');
        }
        break;
      case 'ArrowDown':
        if (menuIsOpen) {
          _this7.focusOption('down');
        } else {
          _this7.openMenu('first');
        }
        break;
      case 'PageUp':
        if (!menuIsOpen) return;
        _this7.focusOption('pageup');
        break;
      case 'PageDown':
        if (!menuIsOpen) return;
        _this7.focusOption('pagedown');
        break;
      case 'Home':
        if (!menuIsOpen) return;
        _this7.focusOption('first');
        break;
      case 'End':
        if (!menuIsOpen) return;
        _this7.focusOption('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  };
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    inherits(StateManager, _Component);

    function StateManager() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = StateManager.__proto__ || Object.getPrototypeOf(StateManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      }, _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);
        _this.setState({ value: value });
      }, _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);
        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      }, _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');
        _this.setState({ menuIsOpen: true });
      }, _this.onMenuClose = function () {
        _this.callProp('onMenuClose');
        _this.setState({ menuIsOpen: false });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(StateManager, [{
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'getProp',
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      }
    }, {
      key: 'callProp',
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _props;

          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_props = this.props)[name].apply(_props, toConsumableArray(args));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            _this2.select = _ref2;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);
    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  }, _temp2;
};

var defaultProps$1 = {
  cacheOptions: false,
  defaultOptions: false
};

var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Async, _Component);

    function Async(props) {
      classCallCheck(this, Async);

      var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this));

      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange;
        // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);
        if (!inputValue) {
          delete _this.lastRequest;
          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });
          return;
        }
        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};
          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;
              if (options) {
                _this.optionsCache[inputValue] = options;
              }
              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;
              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }
        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    createClass(Async, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;

        if (defaultOptions === true) {
          this.loadOptions('', function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;
            _this2.setState({ defaultOptions: options || [], isLoading: isLoading });
          });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'loadOptions',
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;

        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            loadOptions = _props.loadOptions,
            props = objectWithoutProperties(_props, ['loadOptions']);
        var _state = this.state,
            defaultOptions = _state.defaultOptions,
            inputValue = _state.inputValue,
            isLoading = _state.isLoading,
            loadedInputValue = _state.loadedInputValue,
            loadedOptions = _state.loadedOptions,
            passEmptyOptions = _state.passEmptyOptions;

        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return (
          // $FlowFixMe
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            filterOption: null,
            isLoading: isLoading,
            onInputChange: this.handleInputChange
          }))
        );
      }
    }]);
    return Async;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$1, _temp;
};
var Async = makeAsyncSelect(manageState(Select));

var compareOption = function compareOption(inputValue, option) {
  var candidate = inputValue.toLowerCase();
  return option.value.toLowerCase() === candidate || option.label.toLowerCase() === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "' + inputValue + '"';
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};

var defaultProps$2 = _extends({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);

var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Creatable, _Component);

    function Creatable(props) {
      classCallCheck(this, Creatable);

      var _this = possibleConstructorReturn(this, (Creatable.__proto__ || Object.getPrototypeOf(Creatable)).call(this, props));

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }
        var newOption = _this.state.newOption;

        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = { action: 'create-option' };
            if (isMulti) {
              onChange([].concat(toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }
        onChange(newValue, actionMeta);
      };

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    createClass(Creatable, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;

        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }
        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(toConsumableArray(options)) : [].concat(toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var props = objectWithoutProperties(this.props, []);
        var options = this.state.options;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);
    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$2, _temp;
};
var Creatable = manageState(makeCreatableSelect(Select));

var AsyncCreatable = makeAsyncSelect(manageState(makeCreatableSelect(Select)));

// ==============================
// Fade Transition
// ==============================

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = objectWithoutProperties(_ref, ['component', 'duration', 'in', 'onExited']);

  var transition = {
    entering: { opacity: 0 },
    entered: { opacity: 1, transition: 'opacity ' + duration + 'ms' },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"],
    { mountOnEnter: true, unmountOnExit: true, 'in': inProp, timeout: duration },
    function (state) {
      var innerProps = {
        style: _extends({}, transition[state])
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag, _extends({ innerProps: innerProps }, props));
    }
  );
};
var collapseDuration = 260;

// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref2, [this].concat(args))), _this), _this.duration = collapseDuration, _this.state = { width: 'auto' }, _this.transition = {
      exiting: { width: 0, transition: 'width ' + _this.duration + 'ms ease-out' },
      exited: { width: 0 }
    }, _this.getWidth = function (ref) {
      if (ref && isNaN(_this.state.width)) {
        // cannot use `offsetWidth` because it is rounded
        var _ref$getBoundingClien = ref.getBoundingClientRect(),
            _width = _ref$getBoundingClien.width;

        _this.setState({ width: _width });
      }
    }, _this.getStyle = function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    }, _this.getTransition = function (state) {
      return _this.transition[state];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // width must be calculated; cannot transition from `undefined` to `number`


  // get base styles


  // get transition styles


  createClass(Collapse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          inProp = _props.in;
      var width = this.state.width;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"],
        {
          enter: false,
          mountOnEnter: true,
          unmountOnExit: true,
          'in': inProp,
          timeout: this.duration
        },
        function (state) {
          var style = _extends({}, _this2.getStyle(width), _this2.getTransition(state));
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { ref: _this2.getWidth, style: style },
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        innerRef = _ref.innerRef,
        props = objectWithoutProperties(_ref, ['in', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);
    return (
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ innerRef: innerRef }, props))
    );
  };
};

// strip transition props off before spreading onto actual component


var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = objectWithoutProperties(_ref, ['in', 'onExited']);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Collapse,
      { 'in': inProp, onExited: onExited },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ cropWithEllipsis: inProp }, props))
    );
  };
};

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

// instant fade; all transition-group children must be transitions

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({ component: WrappedComponent }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["TransitionGroup"], _extends({ component: WrappedComponent }, props));
  };
};

var makeAnimated = function makeAnimated(externalComponents) {
  var components$$1 = defaultComponents({ components: externalComponents });
  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = objectWithoutProperties(components$$1, ['Input', 'MultiValue', 'Placeholder', 'SingleValue', 'ValueContainer']);

  return _extends({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();

var Input$2 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;

var index = manageState(Select);

/* harmony default export */ __webpack_exports__["b"] = (index);



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral([''],['']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyleDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);var IconAdd=function(_React$Component){_inherits(IconAdd,_React$Component);function IconAdd(){_classCallCheck(this,IconAdd);return _possibleConstructorReturn(this,(IconAdd.__proto__||Object.getPrototypeOf(IconAdd)).apply(this,arguments));}_createClass(IconAdd,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyleDiv,{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{onClick:this.props.clicked,width:this.props.width,height:this.props.height,viewBox:"0 0 510 510"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"add-circle"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M382.5,280.5h-102v102h-51v-102    h-102v-51h102v-102h51v102h102V280.5z"})))),this.props.children);}}]);return IconAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (IconAdd);//# sourceMappingURL=IconAdd.js.map

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NHLAPI; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var axios=__webpack_require__(24);var NHLAPI=function NHLAPI(){var _this=this;var version=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;_classCallCheck(this,NHLAPI);this.url=function(endpoint){return _this.api[_this.version].url+'/'+endpoint;};this.teams=function(){return axios.get(_this.url('teams'));};this.team=function(id){return axios.get(_this.url('teams/'+id));};this.roster=function(id){return axios.get(_this.url('teams/'+id+'/roster'));};this.player=function(id){return axios.get(_this.url('people/'+id));};this.playerStats=function(id){return axios.get(_this.url('people/'+id+'?hydrate=stats(splits=statsSingleSeason)'));};this.playerProfileImage=function(id){return"https://nhl.bamcontent.com/images/headshots/current/168x168/"+id+".png";};this.playerProfileImageSmall=function(id){return"https://nhl.bamcontent.com/images/headshots/current/60x60/"+id+".png";};this.playerActionShotImage=function(id){return"https://nhl.bamcontent.com/images/actionshots/"+id+".jpg";};this.playerActionShotImageLow=function(id){return"https://nhl.bamcontent.com/images/actionshots/"+id+"_low_resolution.jpg";};this.version=version;this.api={'1':{url:'https://statsapi.web.nhl.com/api/v1'}};};//# sourceMappingURL=NHLAPI.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(2);
var normalizeHeaderName = __webpack_require__(86);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(26);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(26);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(37);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(3);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(21);

var _PropTypes = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(21);

var _ChildMapping = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(83);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);
var settle = __webpack_require__(87);
var buildURL = __webpack_require__(89);
var parseHeaders = __webpack_require__(90);
var isURLSameOrigin = __webpack_require__(91);
var createError = __webpack_require__(27);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(92);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(93);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(88);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = {"positionMap":{"C":{"label":"Center","type":"forward"},"LW":{"label":"Left Wing","type":"forward"},"RW":{"label":"Right Wing","type":"forward"},"D":{"label":"Defense","type":"defenseman"},"G":{"label":"Goalie","type":"goalie"}},"pointMap":{"forward":{"goals":"3.5","assists":"2.5","plusMinus":"1","penaltyMinutes":"-0.5","hits":"0.25","shots":"0.1","blocked":"0.75","powerPlayPoints":"0.5","shortHandedPoints":"3.5"},"defenseman":{"goals":"3.5","assists":"2.5","plusMinus":"1","penaltyMinutes":"-0.5","hits":"0.25","shots":"0.1","blocked":"0.75","powerPlayPoints":"0.5","shortHandedPoints":"3.5"},"goalie":{"shutouts":"5","goalsAgainst":"-1","saves":"0.2","wins":"1"}},"statMap":{"forward":{"_fantasyPoints":{"label":"Fantasy Points","abbr":"FanPts"},"_fantasyPointsAverage":{"label":"Fantasy Points Average (per Game)","abbr":"FanPtsAvg"},"points":{"label":"Points","abbr":"Pts"},"goals":{"label":"Goals","abbr":"G"},"assists":{"label":"Assists","abbr":"A"},"penaltyMinutes":{"label":"Penalty Minutes","abbr":"PIM"},"plusMinus":{"label":"Plus Minus","abbr":"+/-"},"hits":{"label":"Hits","abbr":"Hits"},"powerPlayGoals":{"label":"Powerplay Goals","abbr":"PPG"},"powerPlayPoints":{"label":"Powerplay Points","abbr":"PPP"},"shortHandedGoals":{"label":"Shorthanded Goals","abbr":"SHG"},"shortHandedPoints":{"label":"Shorthanded Points","abbr":"SHP"},"shots":{"label":"Shots","abbr":"Shots"},"blocked":{"label":"Blocks","abbr":"Blk"},"faceOffPct":{"label":"Face Off %","abbr":"FO%"},"gameWinningGoals":{"label":"Game Wining Goals","abbr":"GWG"},"games":{"label":"Games Played","abbr":"GP"},"timeOnIcePerGame":{"label":"Time on Ice","abbr":"TOI"}},"defenseman":{"_fantasyPoints":{"label":"Fantasy Points","abbr":"FanPts"},"_fantasyPointsAverage":{"label":"Fantasy Points Average (per Game)","abbr":"FanPtsAvg"},"points":{"label":"Points","abbr":"Pts"},"goals":{"label":"Goals","abbr":"G"},"assists":{"label":"Assists","abbr":"A"},"penaltyMinutes":{"label":"Penalty Minutes","abbr":"PIM"},"plusMinus":{"label":"Plus Minus","abbr":"+/-"},"hits":{"label":"Hits","abbr":"Hits"},"powerPlayGoals":{"label":"Powerplay Goals","abbr":"PPG"},"powerPlayPoints":{"label":"Powerplay Points","abbr":"PPP"},"shortHandedGoals":{"label":"Shorthanded Goals","abbr":"SHG"},"shortHandedPoints":{"label":"Shorthanded Points","abbr":"SHP"},"shots":{"label":"Shots","abbr":"Shots"},"blocked":{"label":"Blocks","abbr":"Blk"},"faceOffPct":{"label":"Face Off %","abbr":"FO%"},"gameWinningGoals":{"label":"Game Wining Goals","abbr":"GWG"},"games":{"label":"Games Played","abbr":"GP"},"timeOnIcePerGame":{"label":"Time on Ice","abbr":"TOI"}},"goalie":{"_fantasyPoints":{"label":"Fantasy Points","abbr":"FanPts"},"_fantasyPointsAverage":{"label":"Fantasy Points Average (per Game)","abbr":"FanPtsAvg"},"savePercentage":{"label":"Save Percentage","abbr":"SV%"},"goalAgainstAverage":{"label":"Goals Against Average","abbr":"GAA"},"wins":{"label":"Wins","abbr":"W"},"losses":{"label":"Losses","abbr":"L"},"saves":{"label":"Saves","abbr":"S"},"goalsAgainst":{"label":"Goals Against","abbr":"GA"},"shutouts":{"label":"Shutouts","abbr":"SO"}}}}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(6);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(107);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(109);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(110);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Overlay__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: rgba(40, 40, 40, 0.95);\n  border: 1px solid #777;\n  box-shadow: 10px 10px 15px black;\n  box-sizing: border-box;\n  left: 25%;\n  position: fixed;\n  top: 10%;\n  transition: all 0.3s ease-out;\n  width: 50%;\n  z-index: 500;\n\n  h1 {\n    background-color: #000;\n    font-weight: normal;\n    margin: 0;\n    padding: 20px;\n  }\n\n  .content,\n  .buttons {\n    padding: 16px;\n  }\n'],['\n  background-color: rgba(40, 40, 40, 0.95);\n  border: 1px solid #777;\n  box-shadow: 10px 10px 15px black;\n  box-sizing: border-box;\n  left: 25%;\n  position: fixed;\n  top: 10%;\n  transition: all 0.3s ease-out;\n  width: 50%;\n  z-index: 500;\n\n  h1 {\n    background-color: #000;\n    font-weight: normal;\n    margin: 0;\n    padding: 20px;\n  }\n\n  .content,\n  .buttons {\n    padding: 16px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var modal=function modal(props){console.log("render modal");var buttons=function buttons(){if(props.buttons){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{className:"buttons"},props.buttons);}return null;};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Overlay__["a" /* default */],{show:props.show,clicked:props.handlers.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ModalStyle,{style:{display:props.show?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1",null,props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{className:"content"},props.children),buttons()));};/* harmony default export */ __webpack_exports__["a"] = (modal);var ModalStyle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].div(_templateObject);//# sourceMappingURL=Modal.js.map

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  border: 1px solid #666;\n  color: white;\n  cursor: pointer;\n  display: inline-block;\n  margin: 10px 10px 10px 0;\n  padding: 3px;\n\n  &:hover {\n    border-color: #fff;\n  }\n\n  &:active {\n    border-color: #555;\n  }\n\n  &:active span {\n    background-color: #555;\n  }\n'],['\n  border: 1px solid #666;\n  color: white;\n  cursor: pointer;\n  display: inline-block;\n  margin: 10px 10px 10px 0;\n  padding: 3px;\n\n  &:hover {\n    border-color: #fff;\n  }\n\n  &:active {\n    border-color: #555;\n  }\n\n  &:active span {\n    background-color: #555;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: rgba(0, 0, 0, 0.85);\n  display: inline-block;\n  padding: 5px;\n'],['\n  background-color: rgba(0, 0, 0, 0.85);\n  display: inline-block;\n  padding: 5px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Button=function(_React$Component){_inherits(Button,_React$Component);function Button(){_classCallCheck(this,Button);return _possibleConstructorReturn(this,(Button.__proto__||Object.getPrototypeOf(Button)).apply(this,arguments));}_createClass(Button,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledButton,{onClick:function onClick(){_this2.props.clicked();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledSpan,null,this.props.label));}}]);return Button;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Button);var StyledButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);var StyledSpan=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].span(_templateObject2);//# sourceMappingURL=Button.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35);
module.exports = __webpack_require__(40);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(36).enable();
  window.Promise = __webpack_require__(38);
}

// fetch() polyfill for making API calls.
__webpack_require__(39);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(9);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(15);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(15);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(117);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(9),n=__webpack_require__(16),p=__webpack_require__(17),q=__webpack_require__(18),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(16),ba=__webpack_require__(0),m=__webpack_require__(43),p=__webpack_require__(9),v=__webpack_require__(18),da=__webpack_require__(44),ea=__webpack_require__(45),fa=__webpack_require__(46),ha=__webpack_require__(17);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(47);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(48);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layout__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Footer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Content__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WelcomeModal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_common__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_React$Component){_inherits(App,_React$Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));_this.state={listId:undefined};_this.common=new __WEBPACK_IMPORTED_MODULE_7__util_common__["a" /* default */]();_this.closeWelcomeModalHandler=function(){};_this.loadListHandler=function(listId){_this.setState({listId:listId});_this.common.updateListCache(listId);};_this.handlers={closeWelcomeModal:_this.closeWelcomeModalHandler,loadList:_this.loadListHandler};return _this;}_createClass(App,[{key:'render',value:function render(){var content=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_Content__["a" /* default */],{appState:Object.assign({},this.state),handlers:this.handlers});if(!this.state.listId){content=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_WelcomeModal__["a" /* default */],{handlers:this.handlers});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Layout__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],{appState:Object.assign({},this.state),handlers:this.handlers}),content,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Footer__["a" /* default */],null)));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);//# sourceMappingURL=App.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n  color: #fff;\n  display: grid;\n  grid-gap: 1px;\n  grid-template-columns: 300px auto;\n  grid-template-rows: auto;\n  grid-template-areas:\n    "header header"\n    "content content"\n    "footer footer";\n'],['\n  color: #fff;\n  display: grid;\n  grid-gap: 1px;\n  grid-template-columns: 300px auto;\n  grid-template-rows: auto;\n  grid-template-areas:\n    "header header"\n    "content content"\n    "footer footer";\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var layout=function layout(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LayoutStyle,null,props.children);};/* harmony default export */ __webpack_exports__["a"] = (layout);var LayoutStyle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);//# sourceMappingURL=Layout.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(55);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							code = body.charCodeAt(caret)

							switch (code) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(58);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(61);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.timeout"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&(a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return q(a)===m};
exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_common__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IconAdd__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: rgba(95,50,6,0.6);\n  grid-area: header;\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n\n  .button {\n    cursor: pointer;\n    height: 30px;\n    margin-right: 10px;\n\n    svg {\n      fill: rgba(255, 255, 255, 0.5);\n    }\n  }\n'],['\n  background-color: rgba(95,50,6,0.6);\n  grid-area: header;\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n\n  .button {\n    cursor: pointer;\n    height: 30px;\n    margin-right: 10px;\n\n    svg {\n      fill: rgba(255, 255, 255, 0.5);\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  flex-grow: 3;\n\n  h1 {\n    font-size: 1.5em;\n    font-weight: normal;\n    margin: 0;\n    padding: 0;\n  }\n'],['\n  flex-grow: 3;\n\n  h1 {\n    font-size: 1.5em;\n    font-weight: normal;\n    margin: 0;\n    padding: 0;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end;\n'],['\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var header=function header(props){var common=new __WEBPACK_IMPORTED_MODULE_2__util_common__["a" /* default */]();var placeholder=props.appState.listId?props.appState.listId:'Select List...';var loadList=function loadList(listId){var loadListId=listId?listId:props.appState.listId;props.handlers.loadList(loadListId);};var newListHandler=function newListHandler(){props.handlers.loadList();};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderLeft,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1",null,"Draft Assist")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderRight,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__IconAdd__["a" /* default */],{className:"button",width:"30px",height:"30px",clicked:newListHandler}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_select__["b" /* default */],{onChange:function onChange(data){loadList(data.value);},isSearchable:false,placeholder:placeholder,styles:common.selectStyles(),isMulti:false,options:common.listsForSelect()})));};/* harmony default export */ __webpack_exports__["a"] = (header);var Header=__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* default */].header(_templateObject);var HeaderLeft=__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* default */].div(_templateObject2);var HeaderRight=__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* default */].div(_templateObject3);//# sourceMappingURL=Header.js.map

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export flush */
/* unused harmony export hydrate */
/* unused harmony export cx */
/* unused harmony export merge */
/* unused harmony export getRegisteredStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export sheet */
/* unused harmony export caches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(64);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;


//# sourceMappingURL=index.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

function _StyleSheet(options) {
  this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

  this.tags = [];
  this.ctr = 0;
  this.opts = options;
}

function _inject() {
  if (this.injected) {
    throw new Error('already injected!');
  }

  this.tags[0] = makeStyleTag(this.opts);
  this.injected = true;
}

function _speedy(bool) {
  if (this.ctr !== 0) {
    // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
    throw new Error("cannot change speedy now");
  }

  this.isSpeedy = !!bool;
}

function _insert(rule, sourceMap) {
  // this is the ultrafast version, works across browsers
  if (this.isSpeedy) {
    var tag = this.tags[this.tags.length - 1];
    var sheet = sheetForTag(tag);

    try {
      sheet.insertRule(rule, sheet.cssRules.length);
    } catch (e) {
      if (false) {
        console.warn('illegal rule', rule); // eslint-disable-line no-console
      }
    }
  } else {
    var _tag = makeStyleTag(this.opts);

    this.tags.push(_tag);

    _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
  }

  this.ctr++;

  if (this.ctr % 65000 === 0) {
    this.tags.push(makeStyleTag(this.opts));
  }
}

function _ref(tag) {
  return tag.parentNode.removeChild(tag);
}

function _flush() {
  // $FlowFixMe
  this.tags.forEach(_ref);
  this.tags = [];
  this.ctr = 0; // todo - look for remnants in document.styleSheets

  this.injected = false;
}

var StyleSheet =
/*#__PURE__*/
function () {
  var _proto = _StyleSheet.prototype;
  _proto.inject = _inject;
  _proto.speedy = _speedy;
  _proto.insert = _insert;
  _proto.flush = _flush;
  return _StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    function _ref(interpolation) {
      string += handleInterpolation.call(this, interpolation, false);
    }

    function _ref3(key) {
      function _ref2(value) {
        string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
      }

      if (typeof obj[key] !== 'object') {
        if (caches.registered[obj[key]] !== undefined) {
          string += key + "{" + caches.registered[obj[key]] + "}";
        } else {
          string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
          obj[key].forEach(_ref2);
        } else {
          string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
        }
      }
    }

    if (Array.isArray(obj)) {
      obj.forEach(_ref, this);
    } else {
      Object.keys(obj).forEach(_ref3, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
    return styles;
  };

  if (false) {
    var sourceMapRegEx = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      var result = sourceMapRegEx.exec(styles);
      currentSourceMap = result ? result[0] : '';
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  function _ref4(node) {
    // $FlowFixMe
    sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

    node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, _ref4);
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (index);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var V = function ca(W) {
  function M(d, c, f, h, a) {
    for (var k = 0, b = 0, u = 0, l = 0, q, m, e, D = 0, y = 0, r, E = r = q = 0, n = 0, J = m = 0, t = 0, K = f.length, F = K - 1, w, g = "", p = "", G = "", H = "", A; n < K;) {
      e = f.charCodeAt(n);
      n === F && 0 !== b + l + u + k && (0 !== b && (e = 47 === b ? 10 : 47), l = u = k = 0, K++, F++);

      if (0 === b + l + u + k) {
        if (n === F && (0 < m && (g = g.replace(N, "")), 0 < g.trim().length)) {
          switch (e) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              g += f.charAt(n);
          }

          e = 59;
        }

        switch (e) {
          case 123:
            g = g.trim();
            q = g.charCodeAt(0);
            r = 1;

            for (t = ++n; n < K;) {
              e = f.charCodeAt(n);

              switch (e) {
                case 123:
                  r++;
                  break;

                case 125:
                  r--;
              }

              if (0 === r) break;
              n++;
            }

            e = f.substring(t, n);
            0 === q && (q = (g = g.replace(da, "").trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < m && (g = g.replace(N, ""));
                m = g.charCodeAt(1);

                switch (m) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                e = M(c, r, e, m, a + 1);
                t = e.length;
                0 < z && (r = X(O, g, J), A = I(3, e, r, c, B, x, t, m, a, h), g = r.join(""), void 0 !== A && 0 === (t = (e = A.trim()).length) && (m = 0, e = ""));
                if (0 < t) switch (m) {
                  case 115:
                    g = g.replace(ea, fa);

                  case 100:
                  case 109:
                  case 45:
                    e = g + "{" + e + "}";
                    break;

                  case 107:
                    g = g.replace(ha, "$1 $2");
                    e = g + "{" + e + "}";
                    e = 1 === v || 2 === v && L("@" + e, 3) ? "@-webkit-" + e + "@" + e : "@" + e;
                    break;

                  default:
                    e = g + e, 112 === h && (e = (p += e, ""));
                } else e = "";
                break;

              default:
                e = M(c, X(c, g, J), e, h, a + 1);
            }

            G += e;
            r = J = m = E = q = 0;
            g = "";
            e = f.charCodeAt(++n);
            break;

          case 125:
          case 59:
            g = (0 < m ? g.replace(N, "") : g).trim();
            if (1 < (t = g.length)) switch (0 === E && (q = g.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (g = g.replace(" ", ":")).length), 0 < z && void 0 !== (A = I(1, g, c, d, B, x, p.length, h, a, h)) && 0 === (t = (g = A.trim()).length) && (g = "\x00\x00"), q = g.charCodeAt(0), m = g.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === m || 99 === m) {
                  H += g + f.charAt(n);
                  break;
                }

              default:
                58 !== g.charCodeAt(t - 1) && (p += P(g, q, m, g.charCodeAt(2)));
            }
            J = m = E = q = 0;
            g = "";
            e = f.charCodeAt(++n);
        }
      }

      switch (e) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < g.length && (m = 1, g += "\x00");
          0 < z * Y && I(0, g, c, d, B, x, p.length, h, a, h);
          x = 1;
          B++;
          break;

        case 59:
        case 125:
          if (0 === b + l + u + k) {
            x++;
            break;
          }

        default:
          x++;
          w = f.charAt(n);

          switch (e) {
            case 9:
            case 32:
              if (0 === l + k + b) switch (D) {
                case 44:
                case 58:
                case 9:
                case 32:
                  w = "";
                  break;

                default:
                  32 !== e && (w = " ");
              }
              break;

            case 0:
              w = "\\0";
              break;

            case 12:
              w = "\\f";
              break;

            case 11:
              w = "\\v";
              break;

            case 38:
              0 === l + b + k && (m = J = 1, w = "\f" + w);
              break;

            case 108:
              if (0 === l + b + k + C && 0 < E) switch (n - E) {
                case 2:
                  112 === D && 58 === f.charCodeAt(n - 3) && (C = D);

                case 8:
                  111 === y && (C = y);
              }
              break;

            case 58:
              0 === l + b + k && (E = n);
              break;

            case 44:
              0 === b + u + l + k && (m = 1, w += "\r");
              break;

            case 34:
            case 39:
              0 === b && (l = l === e ? 0 : 0 === l ? e : l);
              break;

            case 91:
              0 === l + b + u && k++;
              break;

            case 93:
              0 === l + b + u && k--;
              break;

            case 41:
              0 === l + b + k && u--;
              break;

            case 40:
              if (0 === l + b + k) {
                if (0 === q) switch (2 * D + 3 * y) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                u++;
              }

              break;

            case 64:
              0 === b + u + l + k + E + r && (r = 1);
              break;

            case 42:
            case 47:
              if (!(0 < l + k + u)) switch (b) {
                case 0:
                  switch (2 * e + 3 * f.charCodeAt(n + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = n, b = 42;
                  }

                  break;

                case 42:
                  47 === e && 42 === D && (33 === f.charCodeAt(t + 2) && (p += f.substring(t, n + 1)), w = "", b = 0);
              }
          }

          0 === b && (g += w);
      }

      y = D;
      D = e;
      n++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < z && (A = I(2, p, r, d, B, x, t, h, a, h), void 0 !== A && 0 === (p = A).length)) return H + p + G;
      p = r.join(",") + "{" + p + "}";

      if (0 !== v * C) {
        2 !== v || L(p, 2) || (C = 0);

        switch (C) {
          case 111:
            p = p.replace(ia, ":-moz-$1") + p;
            break;

          case 112:
            p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
        }

        C = 0;
      }
    }

    return H + p + G;
  }

  function X(d, c, f) {
    var h = c.trim().split(ja);
    c = h;
    var a = h.length,
        k = d.length;

    switch (k) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === k ? "" : d[0] + " "; b < a; ++b) {
          c[b] = Z(d, c[b], f, k).trim();
        }

        break;

      default:
        var u = b = 0;

        for (c = []; b < a; ++b) {
          for (var l = 0; l < k; ++l) {
            c[u++] = Z(d[l] + " ", h[b], f, k).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, f) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, "$1" + d.trim());

      case 58:
        switch (c.charCodeAt(1)) {
          case 103:
            break;

          default:
            return d.trim() + c.replace(F, "$1" + d.trim());
        }

      default:
        if (0 < 1 * f && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
    }

    return d + c;
  }

  function P(d, c, f, h) {
    var a = d + ";",
        k = 2 * c + 3 * f + 4 * h;

    if (944 === k) {
      d = a.indexOf(":", 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ";";
      return 1 === v || 2 === v && L(b, 1) ? "-webkit-" + b + b : b;
    }

    if (0 === v || 2 === v && !L(a, 1)) return a;

    switch (k) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + a + a;

      case 978:
        return "-webkit-" + a + "-moz-" + a + a;

      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11)) return a.replace(ka, "$1-webkit-$2") + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;

          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;

          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;

      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;

      case 1005:
        return la.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf("-") + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, "tb");
            break;

          case 232:
            b = a.replace(G, "tb-rl");
            break;

          case 220:
            b = a.replace(G, "lr");
            break;

          default:
            return a;
        }

        return "-webkit-" + a + "-ms-" + b + a;

      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();

        switch (k = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, "-webkit-" + b) + ";" + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, "-webkit-" + (102 < k ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
        }

        return a + ";";

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;

          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;

          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === ma.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, f, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
        break;

      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === f + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(na, "$1-webkit-$2") + a;
    }

    return a;
  }

  function L(d, c) {
    var f = d.indexOf(1 === c ? ":" : "{"),
        h = d.substring(0, 3 !== c ? f : 10);
    f = d.substring(f + 1, d.length - 1);
    return H(2 !== c ? h : h.replace(oa, "$1"), f, c);
  }

  function fa(d, c) {
    var f = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return f !== c + ";" ? f.replace(pa, " or ($1)").substring(4) : "(" + c + ")";
  }

  function I(d, c, f, h, a, k, b, u, l, q) {
    for (var m = 0, e = c, v; m < z; ++m) {
      switch (v = R[m].call(y, d, e, f, h, a, k, b, u, l, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          e = v;
      }
    }

    if (e !== c) return e;
  }

  function S(d) {
    switch (d) {
      case void 0:
      case null:
        z = R.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, f = d.length; c < f; ++c) {
              S(d[c]);
            }

            break;

          case Function:
            R[z++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return S;
  }

  function T(d) {
    d = d.prefix;
    void 0 !== d && (H = null, d ? "function" !== typeof d ? v = 1 : (v = 2, H = d) : v = 0);
    return T;
  }

  function y(d, c) {
    if (void 0 !== this && this.constructor === y) return ca(d);
    var f = d;
    33 > f.charCodeAt(0) && (f = f.trim());
    U = f;
    f = [U];

    if (0 < z) {
      var h = I(-1, c, f, f, B, x, 0, 0, 0, 0);
      void 0 !== h && "string" === typeof h && (c = h);
    }

    var a = M(O, f, c, 0, 0);
    0 < z && (h = I(-2, a, f, f, B, x, a.length, 0, 0, 0), void 0 !== h && (a = h));
    U = "";
    C = 0;
    x = B = 1;
    return a;
  }

  var da = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      la = /zoo|gra/,
      na = /([,: ])(transform)/g,
      ja = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      ha = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ia = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      ea = /\(\s*(.*)\s*\)/g,
      pa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      oa = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      ma = /stretch|:\s*\w+\-(?:conte|avail)/,
      ka = /([^-])(image-set\()/,
      x = 1,
      B = 1,
      C = 0,
      v = 1,
      O = [],
      R = [],
      z = 0,
      H = null,
      Y = 0,
      U = "";
  y.use = S;
  y.set = T;
  void 0 !== W && T(W);
  return y;
};

/* harmony default export */ __webpack_exports__["a"] = (V);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(70)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(73);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(77);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(23);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(20);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(74);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(76);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(20);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(75);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(4);

var _TransitionGroup = __webpack_require__(23);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: #000;\n  grid-area: footer;\n  padding: 20px;\n'],['\n  background-color: #000;\n  grid-area: footer;\n  padding: 20px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var footer=function footer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Footer,null,props.children);};/* harmony default export */ __webpack_exports__["a"] = (footer);var Footer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].footer(_templateObject);//# sourceMappingURL=Footer.js.map

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraftChoices__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: #000;\n  grid-area: content;\n'],['\n  background-color: #000;\n  grid-area: content;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Content=function(_React$Component){_inherits(Content,_React$Component);function Content(){_classCallCheck(this,Content);return _possibleConstructorReturn(this,(Content.__proto__||Object.getPrototypeOf(Content)).apply(this,arguments));}_createClass(Content,[{key:'render',value:function render(){console.log("CONFIG",this.props.appState);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContentStyle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftChoices__["a" /* default */],Object.assign({},this.props)));}}]);return Content;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Content);var ContentStyle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);//# sourceMappingURL=Content.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DraftPlayerStatLine__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraftColumn__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlayerSearchModal__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_NHLAPI__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-image: url(',');\n  background-size: cover;\n'],['\n  background-image: url(',');\n  background-size: cover;\n']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: rgba(0,0,0,0.7);\n'],['\n  background-color: rgba(0,0,0,0.7);\n']),_templateObject3=_taggedTemplateLiteral(['\n  background-color: rgba(0,0,0,0.7);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n'],['\n  background-color: rgba(0,0,0,0.7);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DraftChoices=function(_React$Component){_inherits(DraftChoices,_React$Component);function DraftChoices(){_classCallCheck(this,DraftChoices);var _this=_possibleConstructorReturn(this,(DraftChoices.__proto__||Object.getPrototypeOf(DraftChoices)).apply(this,arguments));_this.newPlayersHash=function(){return{C:{order:[],info:{}},LW:{order:[],info:{}},RW:{order:[],info:{}},D:{order:[],info:{}},G:{order:[],info:{}}};};_this.state={players:_this.newPlayersHash(),showPlayerSearchModal:false,playerPosition:'C',selectedPlayer:undefined};_this.nhl=new __WEBPACK_IMPORTED_MODULE_5__modules_NHLAPI__["a" /* NHLAPI */]();_this.fetchList=function(){if(_this.props.appState.listId){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://draft-assist.firebaseio.com/lists/'+_this.props.appState.listId+'/players.json').then(function(response){_this.setState(function(){return{players:Object.assign({},_this.newPlayersHash(),response.data)};});}).catch(function(){});}};_this.save=function(players){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.put('https://draft-assist.firebaseio.com/lists/'+_this.props.appState.listId+'/players.json',players).then(function(){}).catch(function(){});};_this.showPlayerModalHandler=function(playerPosition){_this.setState({showPlayerSearchModal:true,playerPosition:playerPosition});};_this.closePlayerModalHandler=function(){_this.setState({showPlayerSearchModal:false});};_this.cancelPlayerModalHandler=function(){_this.setState({showPlayerSearchModal:false});};_this.selectPlayerHandler=function(player){_this.setState({selectedPlayer:Object.assign({},player)});};_this.addPlayerHandler=function(players){_this.setState(function(prevState){var addedPlayers={order:[],info:{}};players.forEach(function(player){if(!prevState.players[prevState.playerPosition].info[player.id]){addedPlayers.order.push(player.id);addedPlayers.info[player.id]=Object.assign({},player);}});var _state={players:Object.assign({},prevState.players,_defineProperty({},_this.state.playerPosition,Object.assign({},prevState.players[_this.state.playerPosition],{order:[].concat(_toConsumableArray(prevState.players[_this.state.playerPosition].order),_toConsumableArray(addedPlayers.order)),info:Object.assign({},prevState.players[_this.state.playerPosition].info,addedPlayers.info)}))),showPlayerSearchModal:false};_this.save(_state.players);return _state;});};_this.removePlayerHandler=function(player,playerColumnPosition){_this.setState(function(prevState){var order=prevState.players[playerColumnPosition].order;order.splice(order.indexOf(player.id),1);var info=prevState.players[playerColumnPosition].info;delete info[player.id];var _state={players:Object.assign({},prevState.players,_defineProperty({},playerColumnPosition,Object.assign({},prevState.players[playerColumnPosition],{order:[].concat(_toConsumableArray(order)),info:Object.assign({},info)})))};_this.save(_state.players);return _state;});};_this.updatePlayerOrderHandler=function(playerPosition,oldIndex,newIndex){_this.setState(function(prevState){var order=[].concat(_toConsumableArray(prevState.players[playerPosition].order));order.splice(newIndex,0,order.splice(oldIndex,1)[0]);var _state={players:Object.assign({},prevState.players,_defineProperty({},playerPosition,Object.assign({},prevState.players[playerPosition],{order:[].concat(_toConsumableArray(order))})))};_this.save(_state.players);return _state;});};_this.handlers={showPlayerModal:_this.showPlayerModalHandler,closePlayerModal:_this.closePlayerModalHandler,cancelPlayerModal:_this.cancelPlayerModalHandler,addPlayer:_this.addPlayerHandler,removePlayer:_this.removePlayerHandler,updatePlayerOrder:_this.updatePlayerOrderHandler,selectPlayer:_this.selectPlayerHandler};return _this;}_createClass(DraftChoices,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.appState.listId!==this.props.appState.listId){this.fetchList();}}},{key:'componentDidMount',value:function componentDidMount(){this.fetchList();}},{key:'render',value:function render(){var playerSearchModal=null;if(this.state.showPlayerSearchModal){playerSearchModal=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PlayerSearchModal__["a" /* default */],{show:this.state.showPlayerSearchModal,playerPosition:this.state.playerPosition,handlers:this.handlers});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DraftChoiceStyle,{imageURL:this.state.selectedPlayer?this.nhl.playerActionShotImage(this.state.selectedPlayer.id):"none"},playerSearchModal,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DraftPlayerStatLineStyle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__DraftPlayerStatLine__["a" /* default */],{player:this.state.selectedPlayer})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DraftColumnStyle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftColumn__["a" /* default */],{playerPosition:'C',title:'Center',players:this.state.players.C,handlers:this.handlers}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftColumn__["a" /* default */],{playerPosition:'LW',title:'Left Wing',players:this.state.players.LW,handlers:this.handlers}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftColumn__["a" /* default */],{playerPosition:'RW',title:'Right Wing',players:this.state.players.RW,handlers:this.handlers}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftColumn__["a" /* default */],{playerPosition:'D',title:'Defense',players:this.state.players.D,handlers:this.handlers}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftColumn__["a" /* default */],{playerPosition:'G',title:'Goalie',players:this.state.players.G,handlers:this.handlers})));}}]);return DraftChoices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (DraftChoices);var DraftChoiceStyle=__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* default */].div(_templateObject,function(props){return props.imageURL;});var DraftPlayerStatLineStyle=__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* default */].div(_templateObject2);var DraftColumnStyle=__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* default */].div(_templateObject3);//# sourceMappingURL=DraftChoices.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_NHLAPI__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: rgba(0,0,0,0.5);\n  border-bottom: 1px solid #666;\n  box-sizing: border-box;\n  min-height: 122px;\n  padding: 10px\n\n  img, div {\n    display: inline-block;\n    vertical-align: top;\n  }\n\n  div {\n    margin-left: 20px;\n  }\n\n  h3 {\n    margin: 7px;\n  }\n\n  table {\n    text-align: left;\n  }\n\n  th, td {\n    padding: 5px 10px;\n  }\n\n  th {\n    background-color: rgba(95, 50, 6, 0.6)\n  }\n\n  td {\n    background-color: rgba(255,255,255,0.2);\n  }\n'],['\n  background-color: rgba(0,0,0,0.5);\n  border-bottom: 1px solid #666;\n  box-sizing: border-box;\n  min-height: 122px;\n  padding: 10px\n\n  img, div {\n    display: inline-block;\n    vertical-align: top;\n  }\n\n  div {\n    margin-left: 20px;\n  }\n\n  h3 {\n    margin: 7px;\n  }\n\n  table {\n    text-align: left;\n  }\n\n  th, td {\n    padding: 5px 10px;\n  }\n\n  th {\n    background-color: rgba(95, 50, 6, 0.6)\n  }\n\n  td {\n    background-color: rgba(255,255,255,0.2);\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var settings=__webpack_require__(30);var allTeams=__webpack_require__(101);var DraftPlayerStatLine=function(_React$Component){_inherits(DraftPlayerStatLine,_React$Component);function DraftPlayerStatLine(){_classCallCheck(this,DraftPlayerStatLine);var _this=_possibleConstructorReturn(this,(DraftPlayerStatLine.__proto__||Object.getPrototypeOf(DraftPlayerStatLine)).apply(this,arguments));_this.nhl=new __WEBPACK_IMPORTED_MODULE_2__modules_NHLAPI__["a" /* NHLAPI */]();return _this;}_createClass(DraftPlayerStatLine,[{key:'render',value:function render(){var statLine=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null);if(this.props.player){console.log("PLAY FOR STAT LINE:",this.props.player);var player=this.props.player;var position=settings.positionMap[this.props.player.position].type;var fields=undefined;var stats=undefined;if(settings.statMap[position]){var statMap=settings.statMap[position];fields=Object.keys(statMap).map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th",{key:player.id+"_field_"+key},statMap[key].abbr);});stats=Object.keys(statMap).map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{key:player.id+key},player.stats[key]);});}statLine=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img",{width:"100",height:"100",src:this.nhl.playerProfileImage(player.id),alt:player.fullName}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3",null,player.fullName," (",allTeams[player.currentTeamId].abbreviation,")"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,fields)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,stats)))));}return statLine;}}]);return DraftPlayerStatLine;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (DraftPlayerStatLine);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);//# sourceMappingURL=DraftPlayerStatLine.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);
var bind = __webpack_require__(25);
var Axios = __webpack_require__(85);
var defaults = __webpack_require__(14);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(29);
axios.CancelToken = __webpack_require__(99);
axios.isCancel = __webpack_require__(28);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(100);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(14);
var utils = __webpack_require__(2);
var InterceptorManager = __webpack_require__(94);
var dispatchRequest = __webpack_require__(95);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(27);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);
var transformData = __webpack_require__(96);
var isCancel = __webpack_require__(28);
var defaults = __webpack_require__(14);
var isAbsoluteURL = __webpack_require__(97);
var combineURLs = __webpack_require__(98);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(29);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = {"1":{"id":1,"name":"New Jersey Devils","link":"/api/v1/teams/1","venue":{"id":5067,"name":"Prudential Center","link":"/api/v1/venues/5067","city":"Newark","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"NJD","teamName":"Devils","locationName":"New Jersey","firstYearOfPlay":"1982","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":23,"teamName":"Devils","link":"/api/v1/franchises/23"},"shortName":"New Jersey","officialSiteUrl":"http://www.newjerseydevils.com","franchiseId":23,"active":true},"2":{"id":2,"name":"New York Islanders","link":"/api/v1/teams/2","venue":{"id":5026,"name":"Barclays Center","link":"/api/v1/venues/5026","city":"Brooklyn","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"NYI","teamName":"Islanders","locationName":"New York","firstYearOfPlay":"1972","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":22,"teamName":"Islanders","link":"/api/v1/franchises/22"},"shortName":"NY Islanders","officialSiteUrl":"http://www.newyorkislanders.com","franchiseId":22,"active":true},"3":{"id":3,"name":"New York Rangers","link":"/api/v1/teams/3","venue":{"id":5054,"name":"Madison Square Garden","link":"/api/v1/venues/5054","city":"New York","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"NYR","teamName":"Rangers","locationName":"New York","firstYearOfPlay":"1926","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":10,"teamName":"Rangers","link":"/api/v1/franchises/10"},"shortName":"NY Rangers","officialSiteUrl":"http://www.newyorkrangers.com","franchiseId":10,"active":true},"4":{"id":4,"name":"Philadelphia Flyers","link":"/api/v1/teams/4","venue":{"id":5096,"name":"Wells Fargo Center","link":"/api/v1/venues/5096","city":"Philadelphia","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"PHI","teamName":"Flyers","locationName":"Philadelphia","firstYearOfPlay":"1967","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":16,"teamName":"Flyers","link":"/api/v1/franchises/16"},"shortName":"Philadelphia","officialSiteUrl":"http://www.philadelphiaflyers.com","franchiseId":16,"active":true},"5":{"id":5,"name":"Pittsburgh Penguins","link":"/api/v1/teams/5","venue":{"id":5034,"name":"PPG Paints Arena","link":"/api/v1/venues/5034","city":"Pittsburgh","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"PIT","teamName":"Penguins","locationName":"Pittsburgh","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":17,"teamName":"Penguins","link":"/api/v1/franchises/17"},"shortName":"Pittsburgh","officialSiteUrl":"http://pittsburghpenguins.com","franchiseId":17,"active":true},"6":{"id":6,"name":"Boston Bruins","link":"/api/v1/teams/6","venue":{"id":5085,"name":"TD Garden","link":"/api/v1/venues/5085","city":"Boston","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"BOS","teamName":"Bruins","locationName":"Boston","firstYearOfPlay":"1924","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":6,"teamName":"Bruins","link":"/api/v1/franchises/6"},"shortName":"Boston","officialSiteUrl":"http://www.bostonbruins.com","franchiseId":6,"active":true},"7":{"id":7,"name":"Buffalo Sabres","link":"/api/v1/teams/7","venue":{"id":5039,"name":"KeyBank Center","link":"/api/v1/venues/5039","city":"Buffalo","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"BUF","teamName":"Sabres","locationName":"Buffalo","firstYearOfPlay":"1970","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":19,"teamName":"Sabres","link":"/api/v1/franchises/19"},"shortName":"Buffalo","officialSiteUrl":"http://www.sabres.com","franchiseId":19,"active":true},"8":{"id":8,"name":"Montréal Canadiens","link":"/api/v1/teams/8","venue":{"id":5028,"name":"Bell Centre","link":"/api/v1/venues/5028","city":"Montréal","timeZone":{"id":"America/Montreal","offset":-4,"tz":"EDT"}},"abbreviation":"MTL","teamName":"Canadiens","locationName":"Montréal","firstYearOfPlay":"1909","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":1,"teamName":"Canadiens","link":"/api/v1/franchises/1"},"shortName":"Montréal","officialSiteUrl":"http://www.canadiens.com","franchiseId":1,"active":true},"9":{"id":9,"name":"Ottawa Senators","link":"/api/v1/teams/9","venue":{"id":5031,"name":"Canadian Tire Centre","link":"/api/v1/venues/5031","city":"Ottawa","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"OTT","teamName":"Senators","locationName":"Ottawa","firstYearOfPlay":"1990","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":30,"teamName":"Senators","link":"/api/v1/franchises/30"},"shortName":"Ottawa","officialSiteUrl":"http://www.ottawasenators.com","franchiseId":30,"active":true},"10":{"id":10,"name":"Toronto Maple Leafs","link":"/api/v1/teams/10","venue":{"name":"Scotiabank Arena","link":"/api/v1/venues/null","city":"Toronto","timeZone":{"id":"America/Toronto","offset":-4,"tz":"EDT"}},"abbreviation":"TOR","teamName":"Maple Leafs","locationName":"Toronto","firstYearOfPlay":"1917","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":5,"teamName":"Maple Leafs","link":"/api/v1/franchises/5"},"shortName":"Toronto","officialSiteUrl":"http://www.mapleleafs.com","franchiseId":5,"active":true},"12":{"id":12,"name":"Carolina Hurricanes","link":"/api/v1/teams/12","venue":{"id":5066,"name":"PNC Arena","link":"/api/v1/venues/5066","city":"Raleigh","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"CAR","teamName":"Hurricanes","locationName":"Carolina","firstYearOfPlay":"1979","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":26,"teamName":"Hurricanes","link":"/api/v1/franchises/26"},"shortName":"Carolina","officialSiteUrl":"http://www.carolinahurricanes.com","franchiseId":26,"active":true},"13":{"id":13,"name":"Florida Panthers","link":"/api/v1/teams/13","venue":{"id":5027,"name":"BB&T Center","link":"/api/v1/venues/5027","city":"Sunrise","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"FLA","teamName":"Panthers","locationName":"Florida","firstYearOfPlay":"1993","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":33,"teamName":"Panthers","link":"/api/v1/franchises/33"},"shortName":"Florida","officialSiteUrl":"http://www.floridapanthers.com","franchiseId":33,"active":true},"14":{"id":14,"name":"Tampa Bay Lightning","link":"/api/v1/teams/14","venue":{"id":5017,"name":"Amalie Arena","link":"/api/v1/venues/5017","city":"Tampa","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"TBL","teamName":"Lightning","locationName":"Tampa Bay","firstYearOfPlay":"1991","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":31,"teamName":"Lightning","link":"/api/v1/franchises/31"},"shortName":"Tampa Bay","officialSiteUrl":"http://www.tampabaylightning.com","franchiseId":31,"active":true},"15":{"id":15,"name":"Washington Capitals","link":"/api/v1/teams/15","venue":{"id":5094,"name":"Capital One Arena","link":"/api/v1/venues/5094","city":"Washington","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"WSH","teamName":"Capitals","locationName":"Washington","firstYearOfPlay":"1974","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":24,"teamName":"Capitals","link":"/api/v1/franchises/24"},"shortName":"Washington","officialSiteUrl":"http://www.washingtoncapitals.com","franchiseId":24,"active":true},"16":{"id":16,"name":"Chicago Blackhawks","link":"/api/v1/teams/16","venue":{"id":5092,"name":"United Center","link":"/api/v1/venues/5092","city":"Chicago","timeZone":{"id":"America/Chicago","offset":-5,"tz":"CDT"}},"abbreviation":"CHI","teamName":"Blackhawks","locationName":"Chicago","firstYearOfPlay":"1926","division":{"id":16,"name":"Central","nameShort":"CEN","link":"/api/v1/divisions/16","abbreviation":"C"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":11,"teamName":"Blackhawks","link":"/api/v1/franchises/11"},"shortName":"Chicago","officialSiteUrl":"http://www.chicagoblackhawks.com","franchiseId":11,"active":true},"17":{"id":17,"name":"Detroit Red Wings","link":"/api/v1/teams/17","venue":{"id":5145,"name":"Little Caesars Arena","link":"/api/v1/venues/5145","city":"Detroit","timeZone":{"id":"America/Detroit","offset":-4,"tz":"EDT"}},"abbreviation":"DET","teamName":"Red Wings","locationName":"Detroit","firstYearOfPlay":"1926","division":{"id":17,"name":"Atlantic","nameShort":"ATL","link":"/api/v1/divisions/17","abbreviation":"A"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":12,"teamName":"Red Wings","link":"/api/v1/franchises/12"},"shortName":"Detroit","officialSiteUrl":"http://www.detroitredwings.com","franchiseId":12,"active":true},"18":{"id":18,"name":"Nashville Predators","link":"/api/v1/teams/18","venue":{"id":5030,"name":"Bridgestone Arena","link":"/api/v1/venues/5030","city":"Nashville","timeZone":{"id":"America/Chicago","offset":-5,"tz":"CDT"}},"abbreviation":"NSH","teamName":"Predators","locationName":"Nashville","firstYearOfPlay":"1997","division":{"id":16,"name":"Central","nameShort":"CEN","link":"/api/v1/divisions/16","abbreviation":"C"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":34,"teamName":"Predators","link":"/api/v1/franchises/34"},"shortName":"Nashville","officialSiteUrl":"http://www.nashvillepredators.com","franchiseId":34,"active":true},"19":{"id":19,"name":"St. Louis Blues","link":"/api/v1/teams/19","venue":{"name":"Enterprise Center","link":"/api/v1/venues/null","city":"St. Louis","timeZone":{"id":"America/Chicago","offset":-5,"tz":"CDT"}},"abbreviation":"STL","teamName":"Blues","locationName":"St. Louis","firstYearOfPlay":"1967","division":{"id":16,"name":"Central","nameShort":"CEN","link":"/api/v1/divisions/16","abbreviation":"C"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":18,"teamName":"Blues","link":"/api/v1/franchises/18"},"shortName":"St Louis","officialSiteUrl":"http://www.stlouisblues.com","franchiseId":18,"active":true},"20":{"id":20,"name":"Calgary Flames","link":"/api/v1/teams/20","venue":{"id":5075,"name":"Scotiabank Saddledome","link":"/api/v1/venues/5075","city":"Calgary","timeZone":{"id":"America/Denver","offset":-6,"tz":"MDT"}},"abbreviation":"CGY","teamName":"Flames","locationName":"Calgary","firstYearOfPlay":"1980","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":21,"teamName":"Flames","link":"/api/v1/franchises/21"},"shortName":"Calgary","officialSiteUrl":"http://www.calgaryflames.com","franchiseId":21,"active":true},"21":{"id":21,"name":"Colorado Avalanche","link":"/api/v1/teams/21","venue":{"id":5064,"name":"Pepsi Center","link":"/api/v1/venues/5064","city":"Denver","timeZone":{"id":"America/Denver","offset":-6,"tz":"MDT"}},"abbreviation":"COL","teamName":"Avalanche","locationName":"Colorado","firstYearOfPlay":"1979","division":{"id":16,"name":"Central","nameShort":"CEN","link":"/api/v1/divisions/16","abbreviation":"C"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":27,"teamName":"Avalanche","link":"/api/v1/franchises/27"},"shortName":"Colorado","officialSiteUrl":"http://www.coloradoavalanche.com","franchiseId":27,"active":true},"22":{"id":22,"name":"Edmonton Oilers","link":"/api/v1/teams/22","venue":{"id":5100,"name":"Rogers Place","link":"/api/v1/venues/5100","city":"Edmonton","timeZone":{"id":"America/Edmonton","offset":-6,"tz":"MDT"}},"abbreviation":"EDM","teamName":"Oilers","locationName":"Edmonton","firstYearOfPlay":"1979","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":25,"teamName":"Oilers","link":"/api/v1/franchises/25"},"shortName":"Edmonton","officialSiteUrl":"http://www.edmontonoilers.com","franchiseId":25,"active":true},"23":{"id":23,"name":"Vancouver Canucks","link":"/api/v1/teams/23","venue":{"id":5073,"name":"Rogers Arena","link":"/api/v1/venues/5073","city":"Vancouver","timeZone":{"id":"America/Vancouver","offset":-7,"tz":"PDT"}},"abbreviation":"VAN","teamName":"Canucks","locationName":"Vancouver","firstYearOfPlay":"1970","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":20,"teamName":"Canucks","link":"/api/v1/franchises/20"},"shortName":"Vancouver","officialSiteUrl":"http://www.canucks.com","franchiseId":20,"active":true},"24":{"id":24,"name":"Anaheim Ducks","link":"/api/v1/teams/24","venue":{"id":5046,"name":"Honda Center","link":"/api/v1/venues/5046","city":"Anaheim","timeZone":{"id":"America/Los_Angeles","offset":-7,"tz":"PDT"}},"abbreviation":"ANA","teamName":"Ducks","locationName":"Anaheim","firstYearOfPlay":"1993","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":32,"teamName":"Ducks","link":"/api/v1/franchises/32"},"shortName":"Anaheim","officialSiteUrl":"http://www.anaheimducks.com","franchiseId":32,"active":true},"25":{"id":25,"name":"Dallas Stars","link":"/api/v1/teams/25","venue":{"id":5019,"name":"American Airlines Center","link":"/api/v1/venues/5019","city":"Dallas","timeZone":{"id":"America/Chicago","offset":-5,"tz":"CDT"}},"abbreviation":"DAL","teamName":"Stars","locationName":"Dallas","firstYearOfPlay":"1967","division":{"id":16,"name":"Central","nameShort":"CEN","link":"/api/v1/divisions/16","abbreviation":"C"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":15,"teamName":"Stars","link":"/api/v1/franchises/15"},"shortName":"Dallas","officialSiteUrl":"http://www.dallasstars.com","franchiseId":15,"active":true},"26":{"id":26,"name":"Los Angeles Kings","link":"/api/v1/teams/26","venue":{"name":"STAPLES Center","link":"/api/v1/venues/null","city":"Los Angeles","timeZone":{"id":"America/Los_Angeles","offset":-7,"tz":"PDT"}},"abbreviation":"LAK","teamName":"Kings","locationName":"Los Angeles","firstYearOfPlay":"1967","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":14,"teamName":"Kings","link":"/api/v1/franchises/14"},"shortName":"Los Angeles","officialSiteUrl":"http://www.lakings.com","franchiseId":14,"active":true},"28":{"id":28,"name":"San Jose Sharks","link":"/api/v1/teams/28","venue":{"name":"SAP Center at San Jose","link":"/api/v1/venues/null","city":"San Jose","timeZone":{"id":"America/Los_Angeles","offset":-7,"tz":"PDT"}},"abbreviation":"SJS","teamName":"Sharks","locationName":"San Jose","firstYearOfPlay":"1990","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":29,"teamName":"Sharks","link":"/api/v1/franchises/29"},"shortName":"San Jose","officialSiteUrl":"http://www.sjsharks.com","franchiseId":29,"active":true},"29":{"id":29,"name":"Columbus Blue Jackets","link":"/api/v1/teams/29","venue":{"id":5059,"name":"Nationwide Arena","link":"/api/v1/venues/5059","city":"Columbus","timeZone":{"id":"America/New_York","offset":-4,"tz":"EDT"}},"abbreviation":"CBJ","teamName":"Blue Jackets","locationName":"Columbus","firstYearOfPlay":"1997","division":{"id":18,"name":"Metropolitan","nameShort":"Metro","link":"/api/v1/divisions/18","abbreviation":"M"},"conference":{"id":6,"name":"Eastern","link":"/api/v1/conferences/6"},"franchise":{"franchiseId":36,"teamName":"Blue Jackets","link":"/api/v1/franchises/36"},"shortName":"Columbus","officialSiteUrl":"http://www.bluejackets.com","franchiseId":36,"active":true},"30":{"id":30,"name":"Minnesota Wild","link":"/api/v1/teams/30","venue":{"id":5098,"name":"Xcel Energy Center","link":"/api/v1/venues/5098","city":"St. Paul","timeZone":{"id":"America/Chicago","offset":-5,"tz":"CDT"}},"abbreviation":"MIN","teamName":"Wild","locationName":"Minnesota","firstYearOfPlay":"1997","division":{"id":16,"name":"Central","nameShort":"CEN","link":"/api/v1/divisions/16","abbreviation":"C"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":37,"teamName":"Wild","link":"/api/v1/franchises/37"},"shortName":"Minnesota","officialSiteUrl":"http://www.wild.com","franchiseId":37,"active":true},"52":{"id":52,"name":"Winnipeg Jets","link":"/api/v1/teams/52","venue":{"id":5058,"name":"Bell MTS Place","link":"/api/v1/venues/5058","city":"Winnipeg","timeZone":{"id":"America/Winnipeg","offset":-5,"tz":"CDT"}},"abbreviation":"WPG","teamName":"Jets","locationName":"Winnipeg","firstYearOfPlay":"2011","division":{"id":16,"name":"Central","nameShort":"CEN","link":"/api/v1/divisions/16","abbreviation":"C"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":35,"teamName":"Jets","link":"/api/v1/franchises/35"},"shortName":"Winnipeg","officialSiteUrl":"http://winnipegjets.com","franchiseId":35,"active":true},"53":{"id":53,"name":"Arizona Coyotes","link":"/api/v1/teams/53","venue":{"id":5043,"name":"Gila River Arena","link":"/api/v1/venues/5043","city":"Glendale","timeZone":{"id":"America/Phoenix","offset":-7,"tz":"MST"}},"abbreviation":"ARI","teamName":"Coyotes","locationName":"Arizona","firstYearOfPlay":"1979","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":28,"teamName":"Coyotes","link":"/api/v1/franchises/28"},"shortName":"Arizona","officialSiteUrl":"http://www.arizonacoyotes.com","franchiseId":28,"active":true},"54":{"id":54,"name":"Vegas Golden Knights","link":"/api/v1/teams/54","venue":{"id":5178,"name":"T-Mobile Arena","link":"/api/v1/venues/5178","city":"Las Vegas","timeZone":{"id":"America/Los_Angeles","offset":-7,"tz":"PDT"}},"abbreviation":"VGK","teamName":"Golden Knights","locationName":"Vegas","firstYearOfPlay":"2016","division":{"id":15,"name":"Pacific","nameShort":"PAC","link":"/api/v1/divisions/15","abbreviation":"P"},"conference":{"id":5,"name":"Western","link":"/api/v1/conferences/5"},"franchise":{"franchiseId":38,"teamName":"Golden Knights","link":"/api/v1/franchises/38"},"shortName":"Vegas","officialSiteUrl":"http://www.vegasgoldenknights.com","franchiseId":38,"active":true}}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DraftColumnOptions__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraftColumnPlayer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: rgba(0,0,0,0.7);\n  display: inline-block;\n  flex-grow: 1;\n  margin: 0 0;\n'],['\n  background-color: rgba(0,0,0,0.7);\n  display: inline-block;\n  flex-grow: 1;\n  margin: 0 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: rgba(0,0,0,0.7);\n  padding: 10px;\n  \n  h2 {\n    display: inline-block;\n    padding: 0;\n    margin: 0;\n  }\n'],['\n  background-color: rgba(0,0,0,0.7);\n  padding: 10px;\n  \n  h2 {\n    display: inline-block;\n    padding: 0;\n    margin: 0;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  list-style: none none outside;\n  margin: 0;\n  padding: 0;\n'],['\n  list-style: none none outside;\n  margin: 0;\n  padding: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DraftColumn=function(_React$PureComponent){_inherits(DraftColumn,_React$PureComponent);function DraftColumn(){_classCallCheck(this,DraftColumn);var _this=_possibleConstructorReturn(this,(DraftColumn.__proto__||Object.getPrototypeOf(DraftColumn)).apply(this,arguments));_this.state={isRemovingPlayers:false};_this.isSorting=false;_this.onSortStart=function(){_this.isSorting=true;};_this.onSortEnd=function(_ref){var oldIndex=_ref.oldIndex,newIndex=_ref.newIndex;_this.isSorting=false;_this.props.handlers.updatePlayerOrder(_this.props.playerPosition,oldIndex,newIndex);};_this.toggleRemovePlayerModeHandler=function(){console.log("toggleRemovePlayerMode");_this.setState(function(prevState){return{isRemovingPlayers:!prevState.isRemovingPlayers};});};_this.handlers={toggleRemovePlayerMode:_this.toggleRemovePlayerModeHandler};return _this;}_createClass(DraftColumn,[{key:'render',value:function render(){var _this2=this;console.log("render [DrafColumn]",this.props.playerPosition);var SortableList=Object(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__["SortableContainer"])(function(_ref2){var players=_ref2.players;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](List,null,players.order.map(function(playerId,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftColumnPlayer__["a" /* default */],{isRemovingPlayers:_this2.state.isRemovingPlayers,disabled:_this2.state.isRemovingPlayers,isSorting:_this2.isSorting,index:index,key:playerId,handlers:Object.assign({},_this2.props.handlers,_this2.handlers),playerColumnPosition:_this2.props.playerPosition,player:_this2.props.players.info[playerId]});}));});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DraftColumnStyle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DraftColumnTitleStyle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2",null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__DraftColumnOptions__["a" /* default */],{playerPosition:this.props.playerPosition,handlers:Object.assign({},this.props.handlers,this.handlers),isRemovingPlayers:this.state.isRemovingPlayers})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SortableList,{players:this.props.players,onSortStart:this.onSortStart,onSortEnd:this.onSortEnd}));}}]);return DraftColumn;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);;/* harmony default export */ __webpack_exports__["a"] = (DraftColumn);var DraftColumnStyle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */].div(_templateObject);var DraftColumnTitleStyle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */].div(_templateObject2);var List=__WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */].ul(_templateObject3);//# sourceMappingURL=DraftColumn.js.map

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IconAdd__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IconRemove__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  margin-left: 5px;\n  padding: 5px;\n  text-align: right;\n\n  svg {\n    cursor: pointer;\n    margin: 0 5px;\n  }\n\n  .button {\n    display: inline-block;\n  }\n\n  .addPlayer svg {\n    fill: #008619;\n  }\n\n  .removePlayer svg {\n    fill: #a00;\n  }\n'],['\n  display: inline-block;\n  margin-left: 5px;\n  padding: 5px;\n  text-align: right;\n\n  svg {\n    cursor: pointer;\n    margin: 0 5px;\n  }\n\n  .button {\n    display: inline-block;\n  }\n\n  .addPlayer svg {\n    fill: #008619;\n  }\n\n  .removePlayer svg {\n    fill: #a00;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DraftColumnOptions=function(_React$Component){_inherits(DraftColumnOptions,_React$Component);function DraftColumnOptions(){_classCallCheck(this,DraftColumnOptions);var _this=_possibleConstructorReturn(this,(DraftColumnOptions.__proto__||Object.getPrototypeOf(DraftColumnOptions)).apply(this,arguments));_this.addPlayerHandler=function(){_this.props.handlers.showPlayerModal(_this.props.playerPosition);};_this.removePlayerHandler=function(){_this.props.handlers.toggleRemovePlayerMode();};return _this;}_createClass(DraftColumnOptions,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__IconAdd__["a" /* default */],{className:"button addPlayer",width:"18px",height:"18px",clicked:this.addPlayerHandler}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__IconRemove__["a" /* default */],{className:"button removePlayer",width:"18px",height:"18px",clicked:this.removePlayerHandler}));}}]);return DraftColumnOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (DraftColumnOptions);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);//# sourceMappingURL=DraftColumnOptions.js.map

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral([''],['']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyleDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);var IconRemove=function(_React$Component){_inherits(IconRemove,_React$Component);function IconRemove(){_classCallCheck(this,IconRemove);return _possibleConstructorReturn(this,(IconRemove.__proto__||Object.getPrototypeOf(IconRemove)).apply(this,arguments));}_createClass(IconRemove,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyleDiv,{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{onClick:this.props.clicked,width:this.props.width,height:this.props.height,viewBox:"0 0 510 510"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"remove-circle"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M382.5,280.5h-255v-51h255V280.5z    "})))));}}]);return IconRemove;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (IconRemove);//# sourceMappingURL=IconRemove.js.map

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraftColumnPlayerIcon__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sortable_hoc__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_sortable_hoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconX__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: rgba(200,200,200,0.1);\n  color: #fff;\n  cursor: pointer;\n  position: relative;\n  vertical-align: middle;\n  list-style: none none outside;\n  user-select: none;\n\n  span {\n    padding-left: 10px;\n  }\n\n  &:nth-child(even) {\n    background-color: rgba(150, 150, 150, 0.4);\n  }\n  \n  .button {\n    background-color: rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 0, 0, 0);\n    height: 20px;\n    padding: 9px 0;\n    width: 40px;\n  }\n\n  .button:hover {\n    background-color: rgba(0, 0, 0, 1);\n    border: 1px solid rgba(255, 0, 0, 0.5);\n  }\n'],['\n  background-color: rgba(200,200,200,0.1);\n  color: #fff;\n  cursor: pointer;\n  position: relative;\n  vertical-align: middle;\n  list-style: none none outside;\n  user-select: none;\n\n  span {\n    padding-left: 10px;\n  }\n\n  &:nth-child(even) {\n    background-color: rgba(150, 150, 150, 0.4);\n  }\n  \n  .button {\n    background-color: rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 0, 0, 0);\n    height: 20px;\n    padding: 9px 0;\n    width: 40px;\n  }\n\n  .button:hover {\n    background-color: rgba(0, 0, 0, 1);\n    border: 1px solid rgba(255, 0, 0, 0.5);\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DraftColumnPlayer=function(_React$Component){_inherits(DraftColumnPlayer,_React$Component);function DraftColumnPlayer(){_classCallCheck(this,DraftColumnPlayer);var _this=_possibleConstructorReturn(this,(DraftColumnPlayer.__proto__||Object.getPrototypeOf(DraftColumnPlayer)).apply(this,arguments));_this.hover=function(){if(!_this.props.isSorting){_this.props.handlers.selectPlayer(_this.props.player);}};return _this;}_createClass(DraftColumnPlayer,[{key:'render',value:function render(){var _this2=this;console.log("render [DraftColumnPlayer]");var removeButton=null;if(this.props.isRemovingPlayers){removeButton=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconX__["a" /* default */],{className:"button",width:"20px",height:"20px",clicked:function clicked(){_this2.props.handlers.removePlayer(_this2.props.player,_this2.props.playerColumnPosition);}});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{onMouseEnter:function onMouseEnter(){_this2.hover();}},removeButton,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DraftColumnPlayerIcon__["a" /* default */],{player:this.props.player}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,this.props.player.fullName));}}]);return DraftColumnPlayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_sortable_hoc__["SortableElement"])(DraftColumnPlayer));var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].li(_templateObject);//# sourceMappingURL=DraftColumnPlayer.js.map

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_NHLAPI__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: rgba(0,0,0,1);\n  background-image: url(',');\n  background-size: contain;\n  border-right: 2px solid #000;\n  display: inline-block;\n  height: 40px;\n  vertical-align: middle;\n  width: 40px;\n'],['\n  background-color: rgba(0,0,0,1);\n  background-image: url(',');\n  background-size: contain;\n  border-right: 2px solid #000;\n  display: inline-block;\n  height: 40px;\n  vertical-align: middle;\n  width: 40px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DraftColumnPlayerIcon=function(_React$Component){_inherits(DraftColumnPlayerIcon,_React$Component);function DraftColumnPlayerIcon(){_classCallCheck(this,DraftColumnPlayerIcon);var _this=_possibleConstructorReturn(this,(DraftColumnPlayerIcon.__proto__||Object.getPrototypeOf(DraftColumnPlayerIcon)).apply(this,arguments));_this.nhl=new __WEBPACK_IMPORTED_MODULE_2__modules_NHLAPI__["a" /* NHLAPI */]();return _this;}_createClass(DraftColumnPlayerIcon,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{imageURL:this.nhl.playerProfileImageSmall(this.props.player.id)});}}]);return DraftColumnPlayerIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DraftColumnPlayerIcon);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject,function(props){return props.imageURL;});//# sourceMappingURL=DraftColumnPlayerIcon.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _invariant = __webpack_require__(7);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(108);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (event.button === 2 || shouldCancelStart(event)) {
          return false;
        }

        _this._touched = true;
        _this._pos = (0, _utils.getPosition)(event);

        var node = (0, _utils.closest)(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(event.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (!(0, _utils.isTouchEvent)(event) && event.target.tagName.toLowerCase() === 'a') {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          var position = (0, _utils.getPosition)(event);
          var delta = _this._delta = {
            x: _this._pos.x - position.x,
            y: _this._pos.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);

          if (!distance && (!pressThreshold || pressThreshold && combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (event) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = (0, _utils.getEdgeOffset)(node, _this.container);
          _this.initialOffset = (0, _utils.getPosition)(event);
          _this.initialScroll = {
            top: _this.container.scrollTop,
            left: _this.container.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = event.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) {
            onSortStart({ node: node, index: index, collection: collection }, event);
          }
        }
      };

      _this.handleSortMove = function (event) {
        var onSortMove = _this.props.onSortMove;

        event.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(event);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      };

      _this.handleSortEnd = function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, event);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var container = this.getContainer();

        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;

          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;

          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : _this2.container;

          var _loop = function _loop(key) {
            if (_this2.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this2.container.addEventListener(eventName, _this2.events[key], false);
              });
            }
          };

          for (var key in _this2.events) {
            _loop(key);
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.container) {
          var _loop2 = function _loop2(key) {
            if (_this3.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this3.container.removeEventListener(eventName, _this3.events[key]);
              });
            }
          };

          for (var key in this.events) {
            _loop2(key);
          }
        }
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var width = this.width,
            height = this.height;
        var lockOffset = this.props.lockOffset;

        var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];

        (0, _invariant2.default)(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _offsets = _slicedToArray(offsets, 2),
            minLockOffset = _offsets[0],
            maxLockOffset = _offsets[1];

        return [(0, _utils.getLockPixelOffset)({ lockOffset: minLockOffset, width: width, height: height }), (0, _utils.getLockPixelOffset)({ lockOffset: maxLockOffset, width: width, height: height })];
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(event) {
        var _props = this.props,
            lockAxis = _props.lockAxis,
            lockToContainerEdges = _props.lockToContainerEdges;


        var offset = (0, _utils.getPosition)(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };

        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props2 = this.props,
            transitionDuration = _props2.transitionDuration,
            hideSortableGhost = _props2.hideSortableGhost,
            onSortOver = _props2.onSortOver;

        var nodes = this.manager.getOrderedRefs();
        var containerScrollDelta = {
          left: this.container.scrollLeft - this.initialScroll.left,
          top: this.container.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var windowScrollDelta = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = (0, _utils.getEdgeOffset)(node, this.container);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = (0, _utils.getEdgeOffset)(nextNode.node, this.container);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (onSortOver && this.newIndex !== prevIndex) {
          onSortOver({
            newIndex: this.newIndex,
            oldIndex: prevIndex,
            index: this.index,
            collection: this.manager.active.collection
          });
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'getContainer',
      value: function getContainer() {
        var getContainer = this.props.getContainer;


        if (typeof getContainer !== 'function') {
          return (0, _reactDom.findDOMNode)(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortOver: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

exports.default = Manager;


function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;

  return index1 - index2;
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _invariant = __webpack_require__(7);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(4);

var _invariant = __webpack_require__(7);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n\n  svg {\n    fill: #a00;\n  }\n'],['\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n\n  svg {\n    fill: #a00;\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyleDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);var IconX=function(_React$Component){_inherits(IconX,_React$Component);function IconX(){_classCallCheck(this,IconX);return _possibleConstructorReturn(this,(IconX.__proto__||Object.getPrototypeOf(IconX)).apply(this,arguments));}_createClass(IconX,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyleDiv,{className:this.props.className,onClick:this.props.clicked},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{width:this.props.width,height:this.props.height,viewBox:"0 0 28 28"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"c142_x"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M13.98,0C6.259,0,0,6.261,0,13.983c0,7.721,6.259,13.982,13.98,13.982c7.725,0,13.985-6.262,13.985-13.982\n                C27.965,6.261,21.705,0,13.98,0z M19.992,17.769l-2.227,2.224c0,0-3.523-3.78-3.786-3.78c-0.259,0-3.783,3.78-3.783,3.78\n                l-2.228-2.224c0,0,3.784-3.472,3.784-3.781c0-0.314-3.784-3.787-3.784-3.787l2.228-2.229c0,0,3.553,3.782,3.783,3.782\n                c0.232,0,3.786-3.782,3.786-3.782l2.227,2.229c0,0-3.785,3.523-3.785,3.787C16.207,14.239,19.992,17.769,19.992,17.769z"})))));}}]);return IconX;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (IconX);//# sourceMappingURL=IconX.js.map

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_common__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(1);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  table {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n\n  table td:first-child {\n    width: 200px;\n  }\n'],['\n  table {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n\n  table td:first-child {\n    width: 200px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: #3b5a89;\n  border-radius: 5px;\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  text-align: center;\n  width: 45px;\n  padding: 5px;\n'],['\n  background-color: #3b5a89;\n  border-radius: 5px;\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  text-align: center;\n  width: 45px;\n  padding: 5px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var settings=__webpack_require__(30);var allPlayers=__webpack_require__(114);var PlayerSearchModal=function(_React$Component){_inherits(PlayerSearchModal,_React$Component);function PlayerSearchModal(){_classCallCheck(this,PlayerSearchModal);var _this=_possibleConstructorReturn(this,(PlayerSearchModal.__proto__||Object.getPrototypeOf(PlayerSearchModal)).apply(this,arguments));_this.state={restrictByPosition:true,sortType:"_fantasyPoints"};_this.players=[];_this.selectPlayerHandler=function(data){console.log(data);_this.players=[];data.forEach(function(player){_this.players.push(Object.assign({},player.player));});};_this.sortPlayers=function(data){console.log("sortPlayers",data);_this.setState({sortType:data.value});};_this.addPlayerHandler=function(){_this.props.handlers.addPlayer([].concat(_toConsumableArray(_this.players)));};_this.cancelPlayerModalHandler=function(){_this.props.handlers.cancelPlayerModal();};_this.restrictByPositionHandler=function(willRestrict){_this.setState({restrictByPosition:willRestrict});};_this.hasPlayerStats=function(player){return player['stats']&&(_typeof(player.stats)==='object'||_typeof(player.stats)==='object');};_this.playerStats=function(player){if(_this.hasPlayerStats(player)){return player.stats;}return undefined;};_this.sortOptions=function(){return[{value:"_fantasyPoints",label:"Fantasy Points"},{value:"_fantasyPointsAverage",label:"Fantasy Points Average"},{value:"points",label:"Points"},{value:"goals",label:"Goals"},{value:"assists",label:"Assists"},{value:"penaltyMinutes",label:"Penalty Minutes"},{value:"plusMinus",label:"Plus/Minus"},{value:"hits",label:"Hits"},{value:"powerPlayGoals",label:"Power Play Goals"},{value:"powerPlayPoints",label:"Power Play Points"},{value:"shots",label:"Shots"},{value:"blocked",label:"Blocks"}];};return _this;}_createClass(PlayerSearchModal,[{key:'render',value:function render(){var _this2=this;console.log("render modal");var common=new __WEBPACK_IMPORTED_MODULE_4__util_common__["a" /* default */]();var players=allPlayers.map(function(player){return{value:player.id,label:player.fullName,player:Object.assign({},player)};}).sort(function(a,b){var statA=0;var statB=0;if(a.player.stats&&a.player.stats[_this2.state.sortType]){if(typeof a.player.stats[_this2.state.sortType]==='string'){statA=parseFloat(a.player.stats[_this2.state.sortType]);}else{statA=a.player.stats[_this2.state.sortType];}}if(b.player.stats&&b.player.stats[_this2.state.sortType]){if(typeof b.player.stats[_this2.state.sortType]==='string'){statB=parseFloat(b.player.stats[_this2.state.sortType]);}else{statB=b.player.stats[_this2.state.sortType];}}return statB-statA;});if(this.state.restrictByPosition){players=players.filter(function(player){return player.player.position===_this2.props.playerPosition;});}var SelectPlayerOption=function SelectPlayerOption(props){var statValue=0;if(_this2.playerStats(props.data.player)){statValue=props.data.player.stats[_this2.state.sortType];}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* components */].Option,Object.assign({},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FanPts,null,statValue)," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,props.label)));};var title="Add Players ("+settings.positionMap[this.props.playerPosition].label+")";var buttons=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */],{label:"Add",clicked:this.addPlayerHandler}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */],{label:"Cancel",clicked:this.cancelPlayerModalHandler}));var handlers={closeModal:this.props.handlers.closePlayerModal};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */],{show:true,title:title,buttons:buttons,handlers:handlers},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ModalStyle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label",{htmlFor:"restrictByPosition"},"Show Only ",settings.positionMap[this.props.playerPosition].label)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input",{id:"restrictByPosition",type:"checkbox",checked:this.state.restrictByPosition,onChange:function onChange(event){_this2.restrictByPositionHandler(event.target.checked);}}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,"Sort By"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["b" /* default */],{onChange:this.sortPlayers,defaultValue:this.sortOptions()[0],styles:common.selectStyles(),isMulti:false,options:this.sortOptions()}))))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["b" /* default */],{onChange:this.selectPlayerHandler,placeholder:"Select Players...",styles:common.selectStyles(),isMulti:true,closeMenuOnSelect:false,components:{Option:SelectPlayerOption},options:players})));}}]);return PlayerSearchModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (PlayerSearchModal);var ModalStyle=__WEBPACK_IMPORTED_MODULE_5_styled_components__["a" /* default */].div(_templateObject);var FanPts=__WEBPACK_IMPORTED_MODULE_5_styled_components__["a" /* default */].span(_templateObject2);//# sourceMappingURL=PlayerSearchModal.js.map

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: rgba(55, 55, 55, 0.7);\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 100;\n'],['\n  background-color: rgba(55, 55, 55, 0.7);\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 100;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var overlay=function overlay(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,{style:{display:props.show?'block':'none'},onClick:props.clicked});};/* harmony default export */ __webpack_exports__["a"] = (overlay);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = [{"id":8477015,"firstName":"Connor","lastName":"Brown","fullName":"Connor Brown","number":"28","position":"RW","stats":{"_fantasyPoints":118.15,"_fantasyPointsAverage":1.44,"points":28,"goals":14,"assists":14,"penaltyMinutes":18,"plusMinus":0,"hits":23,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":1,"shots":119,"blocked":28,"faceOffPct":38.81,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"15:00"},"currentTeamId":10},{"id":8480157,"firstName":"Calle","lastName":"Rosen","fullName":"Calle Rosen","number":"48","position":"D","stats":{"_fantasyPoints":-1.75,"_fantasyPointsAverage":-0.44,"points":1,"goals":0,"assists":1,"penaltyMinutes":4,"plusMinus":-3,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":5,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"12:47"},"currentTeamId":10},{"id":8479675,"firstName":"Trevor","lastName":"Moore","fullName":"Trevor Moore","number":"42","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8479336,"firstName":"Carl","lastName":"Grundstrom","fullName":"Carl Grundstrom","number":"20","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8477512,"firstName":"Frederik","lastName":"Gauthier","fullName":"Frederik Gauthier","number":"33","position":"C","stats":{"_fantasyPoints":7.45,"_fantasyPointsAverage":0.83,"points":1,"goals":1,"assists":0,"penaltyMinutes":0,"plusMinus":-4,"hits":12,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":12,"blocked":5,"faceOffPct":49.09,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"08:44"},"currentTeamId":10},{"id":8477147,"firstName":"Vincent","lastName":"LoVerde","fullName":"Vincent LoVerde","number":"45","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8476913,"firstName":"Devin","lastName":"Shore","fullName":"Devin Shore","number":"17","position":"C","stats":{"_fantasyPoints":139.3,"_fantasyPointsAverage":1.7,"points":32,"goals":11,"assists":21,"penaltyMinutes":14,"plusMinus":-30,"hits":71,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":2,"shots":123,"blocked":57,"faceOffPct":46.31,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"15:25"},"currentTeamId":25},{"id":8480043,"firstName":"Timothy","lastName":"Liljegren","fullName":"Timothy Liljegren","number":"37","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8478996,"firstName":"Adam","lastName":"Brooks","fullName":"Adam Brooks","number":"77","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8476941,"firstName":"Connor","lastName":"Carrick","fullName":"Connor Carrick","number":"8","position":"D","stats":{"_fantasyPoints":82.25,"_fantasyPointsAverage":1.75,"points":12,"goals":4,"assists":8,"penaltyMinutes":27,"plusMinus":5,"hits":42,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":55,"blocked":53,"faceOffPct":0,"gameWinningGoals":3,"games":47,"timeOnIcePerGame":"15:08"},"currentTeamId":10},{"id":8475166,"firstName":"John","lastName":"Tavares","fullName":"John Tavares","number":"91","position":"C","stats":{"_fantasyPoints":306.2,"_fantasyPointsAverage":3.73,"points":84,"goals":37,"assists":47,"penaltyMinutes":26,"plusMinus":-12,"hits":30,"powerPlayGoals":12,"powerPlayPoints":12,"shortHandedGoals":2,"shortHandedPoints":3,"shots":257,"blocked":34,"faceOffPct":52.89,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"19:55"},"currentTeamId":10},{"id":8468493,"firstName":"Ron","lastName":"Hainsey","fullName":"Ron Hainsey","number":"2","position":"D","stats":{"_fantasyPoints":227.8,"_fantasyPointsAverage":2.85,"points":23,"goals":4,"assists":19,"penaltyMinutes":20,"plusMinus":12,"hits":91,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":2,"shots":73,"blocked":169,"faceOffPct":0,"gameWinningGoals":2,"games":80,"timeOnIcePerGame":"21:51"},"currentTeamId":10},{"id":8480799,"firstName":"Blade","lastName":"Jenkins","fullName":"Blade Jenkins","number":"52","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8478404,"firstName":"Jeremy","lastName":"Bracco","fullName":"Jeremy Bracco","number":"59","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8471774,"firstName":"Alex","lastName":"Stalock","fullName":"Alex Stalock","number":"32","position":"G","stats":{"_fantasyPoints":"87.20","_fantasyPointsAverage":"3.11","savePercentage":0.91,"goalAgainstAverage":2.85,"wins":10,"losses":10,"saves":716,"goalsAgainst":71,"shutouts":1},"currentTeamId":30},{"id":8478857,"firstName":"Dmytro","lastName":"Timashov","fullName":"Dmytro Timashov","number":"41","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8466139,"firstName":"Patrick","lastName":"Marleau","fullName":"Patrick Marleau","number":"12","position":"C","stats":{"_fantasyPoints":203.05,"_fantasyPointsAverage":2.48,"points":47,"goals":27,"assists":20,"penaltyMinutes":16,"plusMinus":1,"hits":85,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":203,"blocked":26,"faceOffPct":52.15,"gameWinningGoals":5,"games":82,"timeOnIcePerGame":"16:59"},"currentTeamId":10},{"id":8479318,"firstName":"Auston","lastName":"Matthews","fullName":"Auston Matthews","number":"34","position":"C","stats":{"_fantasyPoints":285.45,"_fantasyPointsAverage":4.6,"points":63,"goals":34,"assists":29,"penaltyMinutes":12,"plusMinus":25,"hits":16,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":187,"blocked":61,"faceOffPct":54.5,"gameWinningGoals":5,"games":62,"timeOnIcePerGame":"18:07"},"currentTeamId":10},{"id":8471418,"firstName":"Anton","lastName":"Khudobin","fullName":"Anton Khudobin","number":"35","position":"G","stats":{"_fantasyPoints":"105.00","_fantasyPointsAverage":"3.39","savePercentage":0.913,"goalAgainstAverage":2.56,"wins":16,"losses":6,"saves":800,"goalsAgainst":76,"shutouts":1},"currentTeamId":25},{"id":8479358,"firstName":"Carsen","lastName":"Twarynski","fullName":"Carsen Twarynski","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8473994,"firstName":"Jamie","lastName":"Benn","fullName":"Jamie Benn","number":"14","position":"LW","stats":{"_fantasyPoints":350.1,"_fantasyPointsAverage":4.27,"points":79,"goals":36,"assists":43,"penaltyMinutes":54,"plusMinus":20,"hits":140,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":1,"shortHandedPoints":2,"shots":241,"blocked":62,"faceOffPct":52.47,"gameWinningGoals":7,"games":82,"timeOnIcePerGame":"19:49"},"currentTeamId":25},{"id":8470047,"firstName":"Valtteri","lastName":"Filppula","fullName":"Valtteri Filppula","number":"51","position":"C","stats":{"_fantasyPoints":140,"_fantasyPointsAverage":1.73,"points":33,"goals":11,"assists":22,"penaltyMinutes":20,"plusMinus":-7,"hits":25,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":2,"shots":70,"blocked":55,"faceOffPct":51.26,"gameWinningGoals":4,"games":81,"timeOnIcePerGame":"16:28"},"currentTeamId":2},{"id":8480873,"firstName":"Rasmus","lastName":"Sandin","fullName":"Rasmus Sandin","number":"78","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8477953,"firstName":"Kasperi","lastName":"Kapanen","fullName":"Kasperi Kapanen","number":"24","position":"RW","stats":{"_fantasyPoints":56.5,"_fantasyPointsAverage":1.49,"points":9,"goals":7,"assists":2,"penaltyMinutes":4,"plusMinus":-1,"hits":57,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":55,"blocked":9,"faceOffPct":14.28,"gameWinningGoals":1,"games":38,"timeOnIcePerGame":"11:14"},"currentTeamId":10},{"id":8474009,"firstName":"Nick","lastName":"Bonino","fullName":"Nick Bonino","number":"13","position":"C","stats":{"_fantasyPoints":135.3,"_fantasyPointsAverage":1.91,"points":25,"goals":12,"assists":13,"penaltyMinutes":20,"plusMinus":4,"hits":18,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":83,"blocked":72,"faceOffPct":54.33,"gameWinningGoals":0,"games":71,"timeOnIcePerGame":"15:38"},"currentTeamId":18},{"id":8478365,"firstName":"Danick","lastName":"Martel","fullName":"Danick Martel","number":"70","position":"LW","stats":{"_fantasyPoints":6.85,"_fantasyPointsAverage":1.71,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":9,"faceOffPct":0,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"10:13"},"currentTeamId":4},{"id":8475906,"firstName":"John","lastName":"Klingberg","fullName":"John Klingberg","number":"3","position":"D","stats":{"_fantasyPoints":297.15,"_fantasyPointsAverage":3.62,"points":67,"goals":8,"assists":59,"penaltyMinutes":26,"plusMinus":10,"hits":44,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":204,"blocked":109,"faceOffPct":0,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"24:04"},"currentTeamId":25},{"id":8473463,"firstName":"Leo","lastName":"Komarov","fullName":"Leo Komarov","number":"47","position":"C","stats":{"_fantasyPoints":146.15,"_fantasyPointsAverage":1.98,"points":19,"goals":7,"assists":12,"penaltyMinutes":31,"plusMinus":0,"hits":219,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":1,"shots":114,"blocked":48,"faceOffPct":52.83,"gameWinningGoals":0,"games":74,"timeOnIcePerGame":"15:47"},"currentTeamId":2},{"id":8480869,"firstName":"Luke","lastName":"Henman","fullName":"Luke Henman","number":"52","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8476372,"firstName":"Nick","lastName":"Seeler","fullName":"Nick Seeler","number":"36","position":"D","stats":{"_fantasyPoints":34.95,"_fantasyPointsAverage":1.59,"points":4,"goals":0,"assists":4,"penaltyMinutes":21,"plusMinus":10,"hits":20,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":17,"blocked":25,"faceOffPct":0,"gameWinningGoals":0,"games":22,"timeOnIcePerGame":"14:32"},"currentTeamId":30},{"id":8477461,"firstName":"Remi","lastName":"Elie","fullName":"Remi Elie","number":"40","position":"LW","stats":{"_fantasyPoints":84.25,"_fantasyPointsAverage":1.17,"points":14,"goals":6,"assists":8,"penaltyMinutes":18,"plusMinus":5,"hits":101,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":70,"blocked":20,"faceOffPct":35.71,"gameWinningGoals":1,"games":72,"timeOnIcePerGame":"10:15"},"currentTeamId":25},{"id":8476894,"firstName":"Brendan","lastName":"Leipsic","fullName":"Brendan Leipsic","number":"9","position":"LW","stats":{"_fantasyPoints":83,"_fantasyPointsAverage":1.43,"points":22,"goals":5,"assists":17,"penaltyMinutes":14,"plusMinus":-4,"hits":32,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":95,"blocked":22,"faceOffPct":57.14,"gameWinningGoals":1,"games":58,"timeOnIcePerGame":"13:08"},"currentTeamId":23},{"id":8477091,"firstName":"Evan","lastName":"McEneny","fullName":"Evan McEneny","number":"61","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8479397,"firstName":"Pascal","lastName":"Laberge","fullName":"Pascal Laberge","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8470187,"firstName":"Johnny","lastName":"Boychuk","fullName":"Johnny Boychuk","number":"55","position":"D","stats":{"_fantasyPoints":155.6,"_fantasyPointsAverage":2.68,"points":18,"goals":6,"assists":12,"penaltyMinutes":30,"plusMinus":-8,"hits":114,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":141,"blocked":112,"faceOffPct":0,"gameWinningGoals":3,"games":58,"timeOnIcePerGame":"20:11"},"currentTeamId":2},{"id":8475807,"firstName":"Joakim","lastName":"Nordstrom","fullName":"Joakim Nordstrom","number":"20","position":"C","stats":{"_fantasyPoints":72.7,"_fantasyPointsAverage":0.97,"points":7,"goals":2,"assists":5,"penaltyMinutes":6,"plusMinus":-11,"hits":107,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":97,"blocked":41,"faceOffPct":46.75,"gameWinningGoals":0,"games":75,"timeOnIcePerGame":"10:34"},"currentTeamId":6},{"id":8478075,"firstName":"Anders","lastName":"Bjork","fullName":"Anders Bjork","number":"10","position":"LW","stats":{"_fantasyPoints":50.5,"_fantasyPointsAverage":1.68,"points":12,"goals":4,"assists":8,"penaltyMinutes":6,"plusMinus":2,"hits":19,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":30,"blocked":11,"faceOffPct":50,"gameWinningGoals":0,"games":30,"timeOnIcePerGame":"12:20"},"currentTeamId":6},{"id":8477511,"firstName":"Anthony","lastName":"Mantha","fullName":"Anthony Mantha","number":"39","position":"RW","stats":{"_fantasyPoints":191.75,"_fantasyPointsAverage":2.4,"points":48,"goals":24,"assists":24,"penaltyMinutes":52,"plusMinus":-1,"hits":91,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":190,"blocked":36,"faceOffPct":32.69,"gameWinningGoals":2,"games":80,"timeOnIcePerGame":"17:17"},"currentTeamId":17},{"id":8477479,"firstName":"Tyler","lastName":"Bertuzzi","fullName":"Tyler Bertuzzi","number":"59","position":"LW","stats":{"_fantasyPoints":91.55,"_fantasyPointsAverage":1.91,"points":24,"goals":7,"assists":17,"penaltyMinutes":39,"plusMinus":-7,"hits":53,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":83,"blocked":38,"faceOffPct":12.5,"gameWinningGoals":1,"games":48,"timeOnIcePerGame":"14:24"},"currentTeamId":17},{"id":8474600,"firstName":"Roman","lastName":"Josi","fullName":"Roman Josi","number":"59","position":"D","stats":{"_fantasyPoints":307.3,"_fantasyPointsAverage":4.1,"points":53,"goals":14,"assists":39,"penaltyMinutes":24,"plusMinus":24,"hits":80,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":1,"shots":253,"blocked":120,"faceOffPct":0,"gameWinningGoals":3,"games":75,"timeOnIcePerGame":"24:28"},"currentTeamId":18},{"id":8474068,"firstName":"Kyle","lastName":"Turris","fullName":"Kyle Turris","number":"8","position":"C","stats":{"_fantasyPoints":206,"_fantasyPointsAverage":2.71,"points":51,"goals":16,"assists":35,"penaltyMinutes":26,"plusMinus":19,"hits":21,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":145,"blocked":35,"faceOffPct":51.49,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"16:36"},"currentTeamId":18},{"id":8479772,"firstName":"Zack","lastName":"MacEwen","fullName":"Zack MacEwen","number":"71","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8476867,"firstName":"Brendan","lastName":"Gaunce","fullName":"Brendan Gaunce","number":"50","position":"C","stats":{"_fantasyPoints":40.25,"_fantasyPointsAverage":1.09,"points":6,"goals":4,"assists":2,"penaltyMinutes":10,"plusMinus":0,"hits":48,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":55,"blocked":11,"faceOffPct":45.23,"gameWinningGoals":1,"games":37,"timeOnIcePerGame":"13:18"},"currentTeamId":23},{"id":8474584,"firstName":"Michael","lastName":"Del Zotto","fullName":"Michael Del Zotto","number":"4","position":"D","stats":{"_fantasyPoints":200.55,"_fantasyPointsAverage":2.45,"points":22,"goals":6,"assists":16,"penaltyMinutes":48,"plusMinus":-8,"hits":244,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":128,"blocked":127,"faceOffPct":0,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"20:48"},"currentTeamId":23},{"id":8478436,"firstName":"David","lastName":"Kase","fullName":"David Kase","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8478096,"firstName":"Radel","lastName":"Fazleev","fullName":"Radel Fazleev","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8476472,"firstName":"Oscar","lastName":"Klefbom","fullName":"Oscar Klefbom","number":"77","position":"D","stats":{"_fantasyPoints":177.55,"_fantasyPointsAverage":2.69,"points":21,"goals":5,"assists":16,"penaltyMinutes":18,"plusMinus":-12,"hits":49,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":1,"shots":203,"blocked":136,"faceOffPct":0,"gameWinningGoals":1,"games":66,"timeOnIcePerGame":"22:50"},"currentTeamId":22},{"id":8469459,"firstName":"Mikko","lastName":"Koivu","fullName":"Mikko Koivu","number":"9","position":"C","stats":{"_fantasyPoints":192.5,"_fantasyPointsAverage":2.35,"points":45,"goals":14,"assists":31,"penaltyMinutes":46,"plusMinus":9,"hits":51,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":170,"blocked":53,"faceOffPct":51.36,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"18:29"},"currentTeamId":30},{"id":8476416,"firstName":"Dillon","lastName":"Simpson","fullName":"Dillon Simpson","number":"79","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8475780,"firstName":"Chris","lastName":"Wagner","fullName":"Chris Wagner","number":"14","position":"RW","stats":{"_fantasyPoints":136.3,"_fantasyPointsAverage":1.73,"points":16,"goals":7,"assists":9,"penaltyMinutes":37,"plusMinus":-10,"hits":253,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":2,"shortHandedPoints":2,"shots":93,"blocked":49,"faceOffPct":48.93,"gameWinningGoals":0,"games":79,"timeOnIcePerGame":"13:16"},"currentTeamId":6},{"id":8481258,"firstName":"Sergei","lastName":"Shumakov","fullName":"Sergei Shumakov","number":"17","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":15},{"id":8475200,"firstName":"Dmitry","lastName":"Orlov","fullName":"Dmitry Orlov","number":"9","position":"D","stats":{"_fantasyPoints":220,"_fantasyPointsAverage":2.68,"points":31,"goals":10,"assists":21,"penaltyMinutes":22,"plusMinus":10,"hits":128,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":125,"blocked":116,"faceOffPct":0,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"23:07"},"currentTeamId":15},{"id":8474189,"firstName":"Lars","lastName":"Eller","fullName":"Lars Eller","number":"20","position":"C","stats":{"_fantasyPoints":176.6,"_fantasyPointsAverage":2.18,"points":38,"goals":18,"assists":20,"penaltyMinutes":38,"plusMinus":-6,"hits":71,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":161,"blocked":69,"faceOffPct":49.26,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"15:18"},"currentTeamId":15},{"id":8474736,"firstName":"Zac","lastName":"Rinaldo","fullName":"Zac Rinaldo","number":"36","position":"C","stats":{"_fantasyPoints":63.35,"_fantasyPointsAverage":1.2,"points":7,"goals":5,"assists":2,"penaltyMinutes":44,"plusMinus":-7,"hits":188,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":56,"blocked":23,"faceOffPct":26.66,"gameWinningGoals":0,"games":53,"timeOnIcePerGame":"11:17"},"currentTeamId":18},{"id":8477018,"firstName":"Ben","lastName":"Hutton","fullName":"Ben Hutton","number":"27","position":"D","stats":{"_fantasyPoints":70.3,"_fantasyPointsAverage":1.15,"points":6,"goals":0,"assists":6,"penaltyMinutes":23,"plusMinus":-9,"hits":40,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":103,"blocked":68,"faceOffPct":0,"gameWinningGoals":0,"games":61,"timeOnIcePerGame":"18:24"},"currentTeamId":23},{"id":8473415,"firstName":"Alex","lastName":"Biega","fullName":"Alex Biega","number":"55","position":"D","stats":{"_fantasyPoints":93.15,"_fantasyPointsAverage":2.12,"points":9,"goals":1,"assists":8,"penaltyMinutes":32,"plusMinus":3,"hits":126,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":79,"blocked":53,"faceOffPct":0,"gameWinningGoals":1,"games":44,"timeOnIcePerGame":"15:01"},"currentTeamId":23},{"id":8471303,"firstName":"Alexander","lastName":"Edler","fullName":"Alexander Edler","number":"23","position":"D","stats":{"_fantasyPoints":255.2,"_fantasyPointsAverage":3.65,"points":34,"goals":6,"assists":28,"penaltyMinutes":68,"plusMinus":-18,"hits":157,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":172,"blocked":203,"faceOffPct":50,"gameWinningGoals":2,"games":70,"timeOnIcePerGame":"24:16"},"currentTeamId":23},{"id":8478500,"firstName":"Ivan","lastName":"Provorov","fullName":"Ivan Provorov","number":"9","position":"D","stats":{"_fantasyPoints":313.05,"_fantasyPointsAverage":3.82,"points":41,"goals":17,"assists":24,"penaltyMinutes":20,"plusMinus":17,"hits":148,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":203,"blocked":169,"faceOffPct":0,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"24:09"},"currentTeamId":4},{"id":8475186,"firstName":"John","lastName":"Moore","fullName":"John Moore","number":"27","position":"D","stats":{"_fantasyPoints":162.6,"_fantasyPointsAverage":2.01,"points":18,"goals":7,"assists":11,"penaltyMinutes":47,"plusMinus":3,"hits":135,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":141,"blocked":105,"faceOffPct":0,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"20:00"},"currentTeamId":6},{"id":8470638,"firstName":"Patrice","lastName":"Bergeron","fullName":"Patrice Bergeron","number":"37","position":"C","stats":{"_fantasyPoints":282.4,"_fantasyPointsAverage":4.41,"points":63,"goals":30,"assists":33,"penaltyMinutes":26,"plusMinus":21,"hits":48,"powerPlayGoals":10,"powerPlayPoints":10,"shortHandedGoals":2,"shortHandedPoints":3,"shots":224,"blocked":42,"faceOffPct":57.31,"gameWinningGoals":6,"games":64,"timeOnIcePerGame":"19:26"},"currentTeamId":6},{"id":8475793,"firstName":"Ryan","lastName":"Johansen","fullName":"Ryan Johansen","number":"92","position":"C","stats":{"_fantasyPoints":199.4,"_fantasyPointsAverage":2.52,"points":54,"goals":15,"assists":39,"penaltyMinutes":78,"plusMinus":13,"hits":87,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":2,"shots":129,"blocked":35,"faceOffPct":55.44,"gameWinningGoals":3,"games":79,"timeOnIcePerGame":"18:32"},"currentTeamId":18},{"id":8475462,"firstName":"Radko","lastName":"Gudas","fullName":"Radko Gudas","number":"3","position":"D","stats":{"_fantasyPoints":152.95,"_fantasyPointsAverage":2.19,"points":16,"goals":2,"assists":14,"penaltyMinutes":83,"plusMinus":0,"hits":170,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":142,"blocked":123,"faceOffPct":0,"gameWinningGoals":0,"games":70,"timeOnIcePerGame":"17:06"},"currentTeamId":4},{"id":8474176,"firstName":"Carl","lastName":"Hagelin","fullName":"Carl Hagelin","number":"62","position":"LW","stats":{"_fantasyPoints":160.4,"_fantasyPointsAverage":1.98,"points":31,"goals":10,"assists":21,"penaltyMinutes":28,"plusMinus":8,"hits":112,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":169,"blocked":36,"faceOffPct":42.85,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"15:56"},"currentTeamId":5},{"id":8479482,"firstName":"Michal","lastName":"Kempny","fullName":"Michal Kempny","number":"6","position":"D","stats":{"_fantasyPoints":112.95,"_fantasyPointsAverage":2.13,"points":10,"goals":3,"assists":7,"penaltyMinutes":26,"plusMinus":14,"hits":57,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":82,"blocked":82,"faceOffPct":0,"gameWinningGoals":0,"games":53,"timeOnIcePerGame":"15:54"},"currentTeamId":15},{"id":8476887,"firstName":"Filip","lastName":"Forsberg","fullName":"Filip Forsberg","number":"9","position":"LW","stats":{"_fantasyPoints":275.15,"_fantasyPointsAverage":4.11,"points":64,"goals":26,"assists":38,"penaltyMinutes":38,"plusMinus":27,"hits":86,"powerPlayGoals":13,"powerPlayPoints":13,"shortHandedGoals":0,"shortHandedPoints":1,"shots":179,"blocked":37,"faceOffPct":44.44,"gameWinningGoals":6,"games":67,"timeOnIcePerGame":"17:28"},"currentTeamId":18},{"id":8475797,"firstName":"Jarred","lastName":"Tinordi","fullName":"Jarred Tinordi","number":"24","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8478483,"firstName":"Mitchell","lastName":"Marner","fullName":"Mitchell Marner","number":"16","position":"C","stats":{"_fantasyPoints":239.9,"_fantasyPointsAverage":2.93,"points":69,"goals":22,"assists":47,"penaltyMinutes":26,"plusMinus":-1,"hits":31,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":0,"shortHandedPoints":0,"shots":194,"blocked":25,"faceOffPct":52.63,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"16:23"},"currentTeamId":10},{"id":8479268,"firstName":"Casey","lastName":"Nelson","fullName":"Casey Nelson","number":"8","position":"D","stats":{"_fantasyPoints":52.3,"_fantasyPointsAverage":1.41,"points":8,"goals":3,"assists":5,"penaltyMinutes":8,"plusMinus":-14,"hits":31,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":48,"blocked":37,"faceOffPct":0,"gameWinningGoals":0,"games":37,"timeOnIcePerGame":"18:46"},"currentTeamId":7},{"id":8469465,"firstName":"Dan","lastName":"Hamhuis","fullName":"Dan Hamhuis","number":"5","position":"D","stats":{"_fantasyPoints":153.35,"_fantasyPointsAverage":1.92,"points":24,"goals":3,"assists":21,"penaltyMinutes":33,"plusMinus":-6,"hits":82,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":66,"blocked":113,"faceOffPct":0,"gameWinningGoals":1,"games":80,"timeOnIcePerGame":"20:11"},"currentTeamId":18},{"id":8476397,"firstName":"Keegan","lastName":"Lowe","fullName":"Keegan Lowe","number":"47","position":"D","stats":{"_fantasyPoints":0.4,"_fantasyPointsAverage":0.2,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"13:54"},"currentTeamId":22},{"id":8476873,"firstName":"Mark","lastName":"Jankowski","fullName":"Mark Jankowski","number":"77","position":"C","stats":{"_fantasyPoints":123.3,"_fantasyPointsAverage":1.71,"points":25,"goals":17,"assists":8,"penaltyMinutes":33,"plusMinus":-7,"hits":35,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":2,"shortHandedPoints":2,"shots":118,"blocked":51,"faceOffPct":48.76,"gameWinningGoals":3,"games":72,"timeOnIcePerGame":"13:21"},"currentTeamId":20},{"id":8475738,"firstName":"Jordan","lastName":"Weal","fullName":"Jordan Weal","number":"40","position":"C","stats":{"_fantasyPoints":79.2,"_fantasyPointsAverage":1.15,"points":21,"goals":8,"assists":13,"penaltyMinutes":12,"plusMinus":-10,"hits":17,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":102,"blocked":25,"faceOffPct":45.69,"gameWinningGoals":1,"games":69,"timeOnIcePerGame":"12:57"},"currentTeamId":4},{"id":8476892,"firstName":"Colton","lastName":"Parayko","fullName":"Colton Parayko","number":"55","position":"D","stats":{"_fantasyPoints":241.45,"_fantasyPointsAverage":2.94,"points":35,"goals":6,"assists":29,"penaltyMinutes":13,"plusMinus":-7,"hits":120,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":212,"blocked":141,"faceOffPct":0,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"22:36"},"currentTeamId":19},{"id":8476412,"firstName":"Jordan","lastName":"Binnington","fullName":"Jordan Binnington","number":"50","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":19},{"id":8475098,"firstName":"Tyler","lastName":"Bozak","fullName":"Tyler Bozak","number":"21","position":"C","stats":{"_fantasyPoints":164.15,"_fantasyPointsAverage":2.03,"points":43,"goals":11,"assists":32,"penaltyMinutes":28,"plusMinus":6,"hits":43,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":154,"blocked":28,"faceOffPct":53.63,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"15:38"},"currentTeamId":19},{"id":8480078,"firstName":"Filip","lastName":"Chytil","fullName":"Filip Chytil","number":"72","position":"C","stats":{"_fantasyPoints":5.1,"_fantasyPointsAverage":0.57,"points":3,"goals":1,"assists":2,"penaltyMinutes":4,"plusMinus":-5,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":21,"blocked":1,"faceOffPct":36.84,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"13:36"},"currentTeamId":3},{"id":8478896,"firstName":"Tyler","lastName":"Moy","fullName":"Tyler Moy","number":"70","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8474134,"firstName":"Yannick","lastName":"Weber","fullName":"Yannick Weber","number":"7","position":"D","stats":{"_fantasyPoints":50.5,"_fantasyPointsAverage":1.07,"points":5,"goals":2,"assists":3,"penaltyMinutes":16,"plusMinus":2,"hits":47,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":40,"blocked":35,"faceOffPct":0,"gameWinningGoals":0,"games":47,"timeOnIcePerGame":"12:03"},"currentTeamId":18},{"id":8471734,"firstName":"Jonathan","lastName":"Quick","fullName":"Jonathan Quick","number":"32","position":"G","stats":{"_fantasyPoints":"255.00","_fantasyPointsAverage":"3.98","savePercentage":0.921,"goalAgainstAverage":2.4,"wins":33,"losses":28,"saves":1720,"goalsAgainst":147,"shutouts":5},"currentTeamId":26},{"id":8470602,"firstName":"Dion","lastName":"Phaneuf","fullName":"Dion Phaneuf","number":"3","position":"D","stats":{"_fantasyPoints":206.15,"_fantasyPointsAverage":2.61,"points":26,"goals":6,"assists":20,"penaltyMinutes":49,"plusMinus":-15,"hits":161,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":134,"blocked":154,"faceOffPct":0,"gameWinningGoals":0,"games":79,"timeOnIcePerGame":"19:59"},"currentTeamId":26},{"id":8476428,"firstName":"Rocco","lastName":"Grimaldi","fullName":"Rocco Grimaldi","number":"23","position":"C","stats":{"_fantasyPoints":13.7,"_fantasyPointsAverage":2.28,"points":3,"goals":1,"assists":2,"penaltyMinutes":0,"plusMinus":0,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":7,"blocked":5,"faceOffPct":0,"gameWinningGoals":0,"games":6,"timeOnIcePerGame":"09:38"},"currentTeamId":18},{"id":8478465,"firstName":"Guillaume","lastName":"Brisebois","fullName":"Guillaume Brisebois","number":"56","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8475195,"firstName":"Anders","lastName":"Nilsson","fullName":"Anders Nilsson","number":"31","position":"G","stats":{"_fantasyPoints":"86.20","_fantasyPointsAverage":"3.19","savePercentage":0.901,"goalAgainstAverage":3.44,"wins":7,"losses":14,"saves":766,"goalsAgainst":84,"shutouts":2},"currentTeamId":23},{"id":8474563,"firstName":"Drew","lastName":"Doughty","fullName":"Drew Doughty","number":"8","position":"D","stats":{"_fantasyPoints":317.75,"_fantasyPointsAverage":3.88,"points":60,"goals":10,"assists":50,"penaltyMinutes":54,"plusMinus":23,"hits":127,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":1,"shortHandedPoints":1,"shots":205,"blocked":128,"faceOffPct":0,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"26:50"},"currentTeamId":26},{"id":8470606,"firstName":"Dustin","lastName":"Brown","fullName":"Dustin Brown","number":"23","position":"RW","stats":{"_fantasyPoints":287.7,"_fantasyPointsAverage":3.55,"points":61,"goals":28,"assists":33,"penaltyMinutes":58,"plusMinus":31,"hits":189,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":1,"shortHandedPoints":1,"shots":222,"blocked":33,"faceOffPct":36.95,"gameWinningGoals":6,"games":81,"timeOnIcePerGame":"19:50"},"currentTeamId":26},{"id":8475225,"firstName":"Craig","lastName":"Smith","fullName":"Craig Smith","number":"15","position":"RW","stats":{"_fantasyPoints":231.65,"_fantasyPointsAverage":2.93,"points":51,"goals":25,"assists":26,"penaltyMinutes":24,"plusMinus":20,"hits":60,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":229,"blocked":35,"faceOffPct":42.55,"gameWinningGoals":2,"games":79,"timeOnIcePerGame":"15:22"},"currentTeamId":18},{"id":8479329,"firstName":"Frederic","lastName":"Allard","fullName":"Frederic Allard","number":"72","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8474162,"firstName":"Jake","lastName":"Muzzin","fullName":"Jake Muzzin","number":"6","position":"D","stats":{"_fantasyPoints":263.65,"_fantasyPointsAverage":3.56,"points":42,"goals":8,"assists":34,"penaltyMinutes":40,"plusMinus":10,"hits":170,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":1,"shots":154,"blocked":123,"faceOffPct":0,"gameWinningGoals":1,"games":74,"timeOnIcePerGame":"21:39"},"currentTeamId":26},{"id":8476436,"firstName":"Dmitrij","lastName":"Jaskin","fullName":"Dmitrij Jaskin","number":"23","position":"RW","stats":{"_fantasyPoints":146.65,"_fantasyPointsAverage":1.93,"points":17,"goals":6,"assists":11,"penaltyMinutes":14,"plusMinus":6,"hits":207,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":124,"blocked":46,"faceOffPct":15.38,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"12:26"},"currentTeamId":19},{"id":8474574,"firstName":"Tyler","lastName":"Myers","fullName":"Tyler Myers","number":"57","position":"D","stats":{"_fantasyPoints":214.25,"_fantasyPointsAverage":2.61,"points":36,"goals":6,"assists":30,"penaltyMinutes":48,"plusMinus":9,"hits":68,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":1,"shortHandedPoints":1,"shots":150,"blocked":119,"faceOffPct":0,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"21:25"},"currentTeamId":52},{"id":8470755,"firstName":"Brad","lastName":"Richardson","fullName":"Brad Richardson","number":"15","position":"C","stats":{"_fantasyPoints":61.5,"_fantasyPointsAverage":0.81,"points":15,"goals":3,"assists":12,"penaltyMinutes":45,"plusMinus":-24,"hits":72,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":105,"blocked":52,"faceOffPct":52.06,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"14:46"},"currentTeamId":53},{"id":8470320,"firstName":"Cam","lastName":"Ward","fullName":"Cam Ward","number":"30","position":"G","stats":{"_fantasyPoints":"136.00","_fantasyPointsAverage":"3.16","savePercentage":0.906,"goalAgainstAverage":2.73,"wins":23,"losses":14,"saves":1075,"goalsAgainst":112,"shutouts":2},"currentTeamId":16},{"id":8475171,"firstName":"Oliver","lastName":"Ekman-Larsson","fullName":"Oliver Ekman-Larsson","number":"23","position":"D","stats":{"_fantasyPoints":195.95,"_fantasyPointsAverage":2.39,"points":42,"goals":14,"assists":28,"penaltyMinutes":44,"plusMinus":-28,"hits":160,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":202,"blocked":79,"faceOffPct":0,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"23:40"},"currentTeamId":53},{"id":8478911,"firstName":"Matt","lastName":"Roy","fullName":"Matt Roy","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8470655,"firstName":"David","lastName":"Backes","fullName":"David Backes","number":"42","position":"RW","stats":{"_fantasyPoints":147.5,"_fantasyPointsAverage":2.59,"points":33,"goals":14,"assists":19,"penaltyMinutes":53,"plusMinus":2,"hits":137,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":1,"shots":160,"blocked":25,"faceOffPct":51.65,"gameWinningGoals":1,"games":57,"timeOnIcePerGame":"15:23"},"currentTeamId":6},{"id":8478542,"firstName":"Evan","lastName":"Rodrigues","fullName":"Evan Rodrigues","number":"71","position":"LW","stats":{"_fantasyPoints":86.6,"_fantasyPointsAverage":1.8,"points":25,"goals":7,"assists":18,"penaltyMinutes":14,"plusMinus":-10,"hits":19,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":91,"blocked":23,"faceOffPct":42.39,"gameWinningGoals":0,"games":48,"timeOnIcePerGame":"13:55"},"currentTeamId":7},{"id":8475311,"firstName":"Darcy","lastName":"Kuemper","fullName":"Darcy Kuemper","number":"35","position":"G","stats":{"_fantasyPoints":"118.20","_fantasyPointsAverage":"4.08","savePercentage":0.92,"goalAgainstAverage":2.52,"wins":12,"losses":7,"saves":766,"goalsAgainst":67,"shutouts":4},"currentTeamId":53},{"id":8471761,"firstName":"Chris","lastName":"Butler","fullName":"Chris Butler","number":"25","position":"D","stats":{"_fantasyPoints":3.2,"_fantasyPointsAverage":0.53,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":1,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":3,"faceOffPct":0,"gameWinningGoals":0,"games":6,"timeOnIcePerGame":"13:18"},"currentTeamId":19},{"id":8479423,"firstName":"Alexander","lastName":"Nylander","fullName":"Alexander Nylander","number":"92","position":"RW","stats":{"_fantasyPoints":0.7,"_fantasyPointsAverage":0.23,"points":1,"goals":1,"assists":0,"penaltyMinutes":0,"plusMinus":-3,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"12:51"},"currentTeamId":7},{"id":8476452,"firstName":"Tyler","lastName":"Wotherspoon","fullName":"Tyler Wotherspoon","number":"47","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8475158,"firstName":"Ryan","lastName":"O'Reilly","fullName":"Ryan O'Reilly","number":"90","position":"C","stats":{"_fantasyPoints":247.5,"_fantasyPointsAverage":3.06,"points":61,"goals":24,"assists":37,"penaltyMinutes":2,"plusMinus":-23,"hits":42,"powerPlayGoals":15,"powerPlayPoints":15,"shortHandedGoals":0,"shortHandedPoints":4,"shots":230,"blocked":48,"faceOffPct":59.98,"gameWinningGoals":3,"games":81,"timeOnIcePerGame":"20:49"},"currentTeamId":19},{"id":8474145,"firstName":"Robert","lastName":"Bortuzzo","fullName":"Robert Bortuzzo","number":"41","position":"D","stats":{"_fantasyPoints":145.85,"_fantasyPointsAverage":2.03,"points":13,"goals":4,"assists":9,"penaltyMinutes":41,"plusMinus":11,"hits":121,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":76,"blocked":108,"faceOffPct":0,"gameWinningGoals":1,"games":72,"timeOnIcePerGame":"14:48"},"currentTeamId":19},{"id":8476902,"firstName":"Esa","lastName":"Lindell","fullName":"Esa Lindell","number":"23","position":"D","stats":{"_fantasyPoints":214.45,"_fantasyPointsAverage":2.68,"points":27,"goals":7,"assists":20,"penaltyMinutes":24,"plusMinus":19,"hits":92,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":137,"blocked":123,"faceOffPct":0,"gameWinningGoals":0,"games":80,"timeOnIcePerGame":"22:04"},"currentTeamId":25},{"id":8470257,"firstName":"Alexander","lastName":"Steen","fullName":"Alexander Steen","number":"20","position":"LW","stats":{"_fantasyPoints":193.05,"_fantasyPointsAverage":2.54,"points":46,"goals":15,"assists":31,"penaltyMinutes":20,"plusMinus":-11,"hits":53,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":1,"shortHandedPoints":1,"shots":168,"blocked":58,"faceOffPct":40.67,"gameWinningGoals":2,"games":76,"timeOnIcePerGame":"18:41"},"currentTeamId":19},{"id":8470610,"firstName":"Zach","lastName":"Parise","fullName":"Zach Parise","number":"11","position":"LW","stats":{"_fantasyPoints":115.65,"_fantasyPointsAverage":2.75,"points":24,"goals":15,"assists":9,"penaltyMinutes":14,"plusMinus":0,"hits":26,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":119,"blocked":37,"faceOffPct":41.66,"gameWinningGoals":4,"games":42,"timeOnIcePerGame":"17:04"},"currentTeamId":30},{"id":8477335,"firstName":"Kyle","lastName":"Burroughs","fullName":"Kyle Burroughs","number":"38","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8479339,"firstName":"Patrik","lastName":"Laine","fullName":"Patrik Laine","number":"29","position":"RW","stats":{"_fantasyPoints":305.35,"_fantasyPointsAverage":3.72,"points":70,"goals":44,"assists":26,"penaltyMinutes":24,"plusMinus":8,"hits":74,"powerPlayGoals":20,"powerPlayPoints":20,"shortHandedGoals":0,"shortHandedPoints":0,"shots":241,"blocked":43,"faceOffPct":25.58,"gameWinningGoals":8,"games":82,"timeOnIcePerGame":"16:28"},"currentTeamId":52},{"id":8475660,"firstName":"Cam","lastName":"Talbot","fullName":"Cam Talbot","number":"33","position":"G","stats":{"_fantasyPoints":"217.60","_fantasyPointsAverage":"3.25","savePercentage":0.908,"goalAgainstAverage":3.02,"wins":31,"losses":31,"saves":1848,"goalsAgainst":188,"shutouts":1},"currentTeamId":22},{"id":8475325,"firstName":"Jordan","lastName":"Nolan","fullName":"Jordan Nolan","number":"71","position":"C","stats":{"_fantasyPoints":25,"_fantasyPointsAverage":0.36,"points":8,"goals":4,"assists":4,"penaltyMinutes":69,"plusMinus":-13,"hits":123,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":50,"blocked":17,"faceOffPct":25,"gameWinningGoals":0,"games":69,"timeOnIcePerGame":"09:47"},"currentTeamId":19},{"id":8474125,"firstName":"Carl","lastName":"Gunnarsson","fullName":"Carl Gunnarsson","number":"4","position":"D","stats":{"_fantasyPoints":122.65,"_fantasyPointsAverage":1.95,"points":9,"goals":5,"assists":4,"penaltyMinutes":22,"plusMinus":15,"hits":35,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":59,"blocked":102,"faceOffPct":0,"gameWinningGoals":2,"games":63,"timeOnIcePerGame":"16:09"},"currentTeamId":19},{"id":8479999,"firstName":"Casey","lastName":"Mittelstadt","fullName":"Casey Mittelstadt","number":"37","position":"C","stats":{"_fantasyPoints":16.9,"_fantasyPointsAverage":2.82,"points":5,"goals":1,"assists":4,"penaltyMinutes":2,"plusMinus":1,"hits":2,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":9,"blocked":2,"faceOffPct":47.22,"gameWinningGoals":0,"games":6,"timeOnIcePerGame":"14:01"},"currentTeamId":7},{"id":8480930,"firstName":"Filip","lastName":"Pyrochta","fullName":"Filip Pyrochta","number":"58","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8476356,"firstName":"Tobias","lastName":"Rieder","fullName":"Tobias Rieder","number":"22","position":"RW","stats":{"_fantasyPoints":127.15,"_fantasyPointsAverage":1.63,"points":25,"goals":12,"assists":13,"penaltyMinutes":6,"plusMinus":-12,"hits":96,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":114,"blocked":41,"faceOffPct":47.82,"gameWinningGoals":0,"games":78,"timeOnIcePerGame":"14:39"},"currentTeamId":22},{"id":8474161,"firstName":"Jakub","lastName":"Voracek","fullName":"Jakub Voracek","number":"93","position":"RW","stats":{"_fantasyPoints":287.55,"_fantasyPointsAverage":3.51,"points":85,"goals":20,"assists":65,"penaltyMinutes":50,"plusMinus":10,"hits":23,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":228,"blocked":32,"faceOffPct":44.11,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"19:27"},"currentTeamId":4},{"id":8475857,"firstName":"Kevin","lastName":"Gravel","fullName":"Kevin Gravel","number":"5","position":"D","stats":{"_fantasyPoints":21.25,"_fantasyPointsAverage":1.33,"points":3,"goals":0,"assists":3,"penaltyMinutes":2,"plusMinus":-3,"hits":16,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":20,"blocked":15,"faceOffPct":0,"gameWinningGoals":0,"games":16,"timeOnIcePerGame":"14:02"},"currentTeamId":22},{"id":8477202,"firstName":"Andrew","lastName":"Hammond","fullName":"Andrew Hammond","number":"35","position":"G","stats":{"_fantasyPoints":"4.20","_fantasyPointsAverage":"4.20","savePercentage":0.939,"goalAgainstAverage":2.07,"wins":0,"losses":1,"saves":31,"goalsAgainst":2,"shutouts":0},"currentTeamId":30},{"id":8476396,"firstName":"Steven","lastName":"Fogarty","fullName":"Steven Fogarty","number":"38","position":"C","stats":{"_fantasyPoints":-0.4,"_fantasyPointsAverage":-0.4,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":0,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"12:16"},"currentTeamId":3},{"id":8478402,"firstName":"Connor","lastName":"McDavid","fullName":"Connor McDavid","number":"97","position":"C","stats":{"_fantasyPoints":410.9,"_fantasyPointsAverage":5.01,"points":108,"goals":41,"assists":67,"penaltyMinutes":26,"plusMinus":20,"hits":28,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":1,"shortHandedPoints":4,"shots":274,"blocked":46,"faceOffPct":41.36,"gameWinningGoals":7,"games":82,"timeOnIcePerGame":"21:33"},"currentTeamId":22},{"id":8476884,"firstName":"Derrick","lastName":"Pouliot","fullName":"Derrick Pouliot","number":"5","position":"D","stats":{"_fantasyPoints":140.55,"_fantasyPointsAverage":1.98,"points":22,"goals":3,"assists":19,"penaltyMinutes":39,"plusMinus":-22,"hits":79,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":78,"blocked":118,"faceOffPct":0,"gameWinningGoals":3,"games":71,"timeOnIcePerGame":"17:51"},"currentTeamId":23},{"id":8475260,"firstName":"Corban","lastName":"Knight","fullName":"Corban Knight","number":"53","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8474037,"firstName":"James","lastName":"van Riemsdyk","fullName":"James van Riemsdyk","number":"25","position":"LW","stats":{"_fantasyPoints":219.05,"_fantasyPointsAverage":2.7,"points":54,"goals":36,"assists":18,"penaltyMinutes":30,"plusMinus":1,"hits":40,"powerPlayGoals":11,"powerPlayPoints":11,"shortHandedGoals":0,"shortHandedPoints":0,"shots":248,"blocked":23,"faceOffPct":0,"gameWinningGoals":5,"games":81,"timeOnIcePerGame":"14:53"},"currentTeamId":4},{"id":8476457,"firstName":"Adam","lastName":"Larsson","fullName":"Adam Larsson","number":"6","position":"D","stats":{"_fantasyPoints":203.45,"_fantasyPointsAverage":3.23,"points":13,"goals":4,"assists":9,"penaltyMinutes":34,"plusMinus":10,"hits":239,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":92,"blocked":140,"faceOffPct":0,"gameWinningGoals":1,"games":63,"timeOnIcePerGame":"21:55"},"currentTeamId":22},{"id":8477948,"firstName":"Travis","lastName":"Sanheim","fullName":"Travis Sanheim","number":"6","position":"D","stats":{"_fantasyPoints":51.2,"_fantasyPointsAverage":1.04,"points":10,"goals":2,"assists":8,"penaltyMinutes":20,"plusMinus":-6,"hits":27,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":72,"blocked":35,"faceOffPct":0,"gameWinningGoals":0,"games":49,"timeOnIcePerGame":"15:35"},"currentTeamId":4},{"id":8476932,"firstName":"Anthony","lastName":"Stolarz","fullName":"Anthony Stolarz","number":"41","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":4},{"id":8476463,"firstName":"Jonas","lastName":"Brodin","fullName":"Jonas Brodin","number":"25","position":"D","stats":{"_fantasyPoints":188.45,"_fantasyPointsAverage":2.58,"points":21,"goals":6,"assists":15,"penaltyMinutes":30,"plusMinus":23,"hits":34,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":77,"blocked":139,"faceOffPct":0,"gameWinningGoals":1,"games":73,"timeOnIcePerGame":"21:36"},"currentTeamId":30},{"id":8474716,"firstName":"Jared","lastName":"Spurgeon","fullName":"Jared Spurgeon","number":"46","position":"D","stats":{"_fantasyPoints":220.25,"_fantasyPointsAverage":3.61,"points":37,"goals":9,"assists":28,"penaltyMinutes":8,"plusMinus":-6,"hits":64,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":110,"blocked":127,"faceOffPct":0,"gameWinningGoals":2,"games":61,"timeOnIcePerGame":"24:32"},"currentTeamId":30},{"id":8476278,"firstName":"Colin","lastName":"Blackwell","fullName":"Colin Blackwell","number":"42","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8477213,"firstName":"Tim","lastName":"Schaller","fullName":"Tim Schaller","number":"59","position":"C","stats":{"_fantasyPoints":142.05,"_fantasyPointsAverage":1.73,"points":22,"goals":12,"assists":10,"penaltyMinutes":42,"plusMinus":-5,"hits":132,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":3,"shortHandedPoints":3,"shots":133,"blocked":59,"faceOffPct":45.78,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"13:16"},"currentTeamId":23},{"id":8474040,"firstName":"Sam","lastName":"Gagner","fullName":"Sam Gagner","number":"89","position":"C","stats":{"_fantasyPoints":108.4,"_fantasyPointsAverage":1.46,"points":31,"goals":10,"assists":21,"penaltyMinutes":35,"plusMinus":-18,"hits":54,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":164,"blocked":28,"faceOffPct":47.72,"gameWinningGoals":2,"games":74,"timeOnIcePerGame":"15:06"},"currentTeamId":23},{"id":8476439,"firstName":"Brett","lastName":"Ritchie","fullName":"Brett Ritchie","number":"25","position":"RW","stats":{"_fantasyPoints":85.7,"_fantasyPointsAverage":1.21,"points":14,"goals":7,"assists":7,"penaltyMinutes":42,"plusMinus":1,"hits":172,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":117,"blocked":10,"faceOffPct":0,"gameWinningGoals":0,"games":71,"timeOnIcePerGame":"10:50"},"currentTeamId":25},{"id":8478970,"firstName":"Jalen","lastName":"Chatfield","fullName":"Jalen Chatfield","number":"63","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8478408,"firstName":"Travis","lastName":"Dermott","fullName":"Travis Dermott","number":"23","position":"D","stats":{"_fantasyPoints":89.9,"_fantasyPointsAverage":2.43,"points":13,"goals":1,"assists":12,"penaltyMinutes":8,"plusMinus":16,"hits":48,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":54,"blocked":36,"faceOffPct":0,"gameWinningGoals":0,"games":37,"timeOnIcePerGame":"15:59"},"currentTeamId":10},{"id":8471769,"firstName":"Niklas","lastName":"Hjalmarsson","fullName":"Niklas Hjalmarsson","number":"4","position":"D","stats":{"_fantasyPoints":107.7,"_fantasyPointsAverage":2.24,"points":9,"goals":1,"assists":8,"penaltyMinutes":18,"plusMinus":-3,"hits":16,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":32,"blocked":118,"faceOffPct":0,"gameWinningGoals":0,"games":48,"timeOnIcePerGame":"20:41"},"currentTeamId":53},{"id":8477387,"firstName":"Emil","lastName":"Pettersson","fullName":"Emil Pettersson","number":"65","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8477527,"firstName":"Ross","lastName":"Johnston","fullName":"Ross Johnston","number":"32","position":"LW","stats":{"_fantasyPoints":8.65,"_fantasyPointsAverage":0.36,"points":6,"goals":3,"assists":3,"penaltyMinutes":62,"plusMinus":0,"hits":46,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":19,"blocked":11,"faceOffPct":20,"gameWinningGoals":0,"games":24,"timeOnIcePerGame":"09:20"},"currentTeamId":2},{"id":8474535,"firstName":"Chris","lastName":"Mueller","fullName":"Chris Mueller","number":"49","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8471284,"firstName":"Andrej","lastName":"Sekera","fullName":"Andrej Sekera","number":"2","position":"D","stats":{"_fantasyPoints":44.85,"_fantasyPointsAverage":1.25,"points":8,"goals":0,"assists":8,"penaltyMinutes":6,"plusMinus":-15,"hits":27,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":36,"blocked":42,"faceOffPct":0,"gameWinningGoals":0,"games":36,"timeOnIcePerGame":"16:19"},"currentTeamId":22},{"id":8480895,"firstName":"Yannick","lastName":"Rathgeb","fullName":"Yannick Rathgeb","number":"43","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8475718,"firstName":"Justin","lastName":"Holl","fullName":"Justin Holl","number":"54","position":"D","stats":{"_fantasyPoints":14.95,"_fantasyPointsAverage":7.47,"points":2,"goals":2,"assists":0,"penaltyMinutes":0,"plusMinus":5,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":3,"faceOffPct":0,"gameWinningGoals":1,"games":2,"timeOnIcePerGame":"17:21"},"currentTeamId":10},{"id":8480771,"firstName":"Daniel","lastName":"Brickley","fullName":"Daniel Brickley","number":"78","position":"D","stats":{"_fantasyPoints":4.5,"_fantasyPointsAverage":4.5,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":1,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"10:48"},"currentTeamId":26},{"id":8477982,"firstName":"Jack","lastName":"Dougherty","fullName":"Jack Dougherty","number":"53","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8476856,"firstName":"Matt","lastName":"Dumba","fullName":"Matt Dumba","number":"24","position":"D","stats":{"_fantasyPoints":278.6,"_fantasyPointsAverage":3.4,"points":50,"goals":14,"assists":36,"penaltyMinutes":41,"plusMinus":15,"hits":136,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":1,"shots":176,"blocked":112,"faceOffPct":100,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"23:48"},"currentTeamId":30},{"id":8475181,"firstName":"Nick","lastName":"Leddy","fullName":"Nick Leddy","number":"2","position":"D","stats":{"_fantasyPoints":187.05,"_fantasyPointsAverage":2.34,"points":42,"goals":10,"assists":32,"penaltyMinutes":20,"plusMinus":-42,"hits":95,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":153,"blocked":104,"faceOffPct":0,"gameWinningGoals":1,"games":80,"timeOnIcePerGame":"22:25"},"currentTeamId":2},{"id":8476177,"firstName":"Matt","lastName":"Read","fullName":"Matt Read","number":"10","position":"RW","stats":{"_fantasyPoints":15.6,"_fantasyPointsAverage":0.82,"points":1,"goals":1,"assists":0,"penaltyMinutes":2,"plusMinus":-2,"hits":21,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":16,"blocked":11,"faceOffPct":33.33,"gameWinningGoals":0,"games":19,"timeOnIcePerGame":"10:54"},"currentTeamId":30},{"id":8475798,"firstName":"Mikael","lastName":"Granlund","fullName":"Mikael Granlund","number":"64","position":"RW","stats":{"_fantasyPoints":277.3,"_fantasyPointsAverage":3.6,"points":67,"goals":21,"assists":46,"penaltyMinutes":18,"plusMinus":13,"hits":47,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":1,"shortHandedPoints":3,"shots":193,"blocked":45,"faceOffPct":55.2,"gameWinningGoals":2,"games":77,"timeOnIcePerGame":"18:46"},"currentTeamId":30},{"id":8474066,"firstName":"Thomas","lastName":"Hickey","fullName":"Thomas Hickey","number":"4","position":"D","stats":{"_fantasyPoints":185.7,"_fantasyPointsAverage":2.69,"points":25,"goals":5,"assists":20,"penaltyMinutes":24,"plusMinus":20,"hits":76,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":87,"blocked":110,"faceOffPct":0,"gameWinningGoals":0,"games":69,"timeOnIcePerGame":"18:04"},"currentTeamId":2},{"id":8474102,"firstName":"David","lastName":"Perron","fullName":"David Perron","number":"57","position":"LW","stats":{"_fantasyPoints":223,"_fantasyPointsAverage":3.19,"points":66,"goals":16,"assists":50,"penaltyMinutes":50,"plusMinus":1,"hits":118,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":125,"blocked":20,"faceOffPct":40.33,"gameWinningGoals":4,"games":70,"timeOnIcePerGame":"17:48"},"currentTeamId":19},{"id":8477293,"firstName":"Antti","lastName":"Raanta","fullName":"Antti Raanta","number":"32","position":"G","stats":{"_fantasyPoints":"197.20","_fantasyPointsAverage":"4.20","savePercentage":0.93,"goalAgainstAverage":2.24,"wins":21,"losses":17,"saves":1291,"goalsAgainst":97,"shutouts":3},"currentTeamId":53},{"id":8478508,"firstName":"Yakov","lastName":"Trenin","fullName":"Yakov Trenin","number":"32","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8478038,"firstName":"Devon","lastName":"Toews","fullName":"Devon Toews","number":"25","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8477989,"firstName":"Christian","lastName":"Dvorak","fullName":"Christian Dvorak","number":"18","position":"C","stats":{"_fantasyPoints":155.1,"_fantasyPointsAverage":1.99,"points":37,"goals":15,"assists":22,"penaltyMinutes":22,"plusMinus":-19,"hits":92,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":151,"blocked":48,"faceOffPct":51.36,"gameWinningGoals":2,"games":78,"timeOnIcePerGame":"16:26"},"currentTeamId":53},{"id":8475160,"firstName":"Kyle","lastName":"Clifford","fullName":"Kyle Clifford","number":"13","position":"LW","stats":{"_fantasyPoints":48.85,"_fantasyPointsAverage":0.98,"points":10,"goals":6,"assists":4,"penaltyMinutes":48,"plusMinus":-4,"hits":127,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":81,"blocked":8,"faceOffPct":11.11,"gameWinningGoals":0,"games":50,"timeOnIcePerGame":"10:32"},"currentTeamId":26},{"id":8477833,"firstName":"Greg","lastName":"Carey","fullName":"Greg Carey","number":"54","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8476857,"firstName":"Pontus","lastName":"Aberg","fullName":"Pontus Aberg","number":"46","position":"LW","stats":{"_fantasyPoints":67.5,"_fantasyPointsAverage":1.27,"points":16,"goals":4,"assists":12,"penaltyMinutes":10,"plusMinus":9,"hits":24,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":70,"blocked":8,"faceOffPct":33.33,"gameWinningGoals":3,"games":53,"timeOnIcePerGame":"12:10"},"currentTeamId":22},{"id":8468498,"firstName":"Brooks","lastName":"Orpik","fullName":"Brooks Orpik","number":"44","position":"D","stats":{"_fantasyPoints":167.9,"_fantasyPointsAverage":2.07,"points":10,"goals":0,"assists":10,"penaltyMinutes":68,"plusMinus":-9,"hits":218,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":54,"blocked":168,"faceOffPct":0,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"19:21"},"currentTeamId":15},{"id":8480336,"firstName":"Sean","lastName":"Walker","fullName":"Sean Walker","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8480014,"firstName":"Gabriel","lastName":"Vilardi","fullName":"Gabriel Vilardi","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8474089,"firstName":"Brad","lastName":"Malone","fullName":"Brad Malone","number":"24","position":"C","stats":{"_fantasyPoints":4.9,"_fantasyPointsAverage":0.7,"points":0,"goals":0,"assists":0,"penaltyMinutes":6,"plusMinus":0,"hits":19,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":9,"blocked":3,"faceOffPct":67.74,"gameWinningGoals":0,"games":7,"timeOnIcePerGame":"07:59"},"currentTeamId":22},{"id":8479591,"firstName":"Michael","lastName":"Eyssimont","fullName":"Michael Eyssimont","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8478135,"firstName":"Spencer","lastName":"Watson","fullName":"Spencer Watson","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8477960,"firstName":"Adrian","lastName":"Kempe","fullName":"Adrian Kempe","number":"9","position":"C","stats":{"_fantasyPoints":145.65,"_fantasyPointsAverage":1.8,"points":37,"goals":16,"assists":21,"penaltyMinutes":49,"plusMinus":11,"hits":91,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":119,"blocked":18,"faceOffPct":38.5,"gameWinningGoals":3,"games":81,"timeOnIcePerGame":"13:19"},"currentTeamId":26},{"id":8474627,"firstName":"Jori","lastName":"Lehtera","fullName":"Jori Lehtera","number":"15","position":"C","stats":{"_fantasyPoints":45.5,"_fantasyPointsAverage":0.73,"points":8,"goals":3,"assists":5,"penaltyMinutes":14,"plusMinus":-8,"hits":55,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":45,"blocked":21,"faceOffPct":57.04,"gameWinningGoals":0,"games":62,"timeOnIcePerGame":"10:30"},"currentTeamId":4},{"id":8478451,"firstName":"Ethan","lastName":"Bear","fullName":"Ethan Bear","number":"74","position":"D","stats":{"_fantasyPoints":22.5,"_fantasyPointsAverage":1.25,"points":4,"goals":1,"assists":3,"penaltyMinutes":10,"plusMinus":-11,"hits":14,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":20,"blocked":28,"faceOffPct":0,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"18:37"},"currentTeamId":22},{"id":8480839,"firstName":"Rasmus","lastName":"Dahlin","fullName":"Rasmus Dahlin","number":"26","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8476303,"firstName":"Rob","lastName":"O'Gara","fullName":"Rob O'Gara","number":"46","position":"D","stats":{"_fantasyPoints":43.1,"_fantasyPointsAverage":1.44,"points":3,"goals":0,"assists":3,"penaltyMinutes":6,"plusMinus":-7,"hits":42,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":21,"blocked":44,"faceOffPct":0,"gameWinningGoals":0,"games":30,"timeOnIcePerGame":"15:30"},"currentTeamId":3},{"id":8480221,"firstName":"Drake","lastName":"Rymsha","fullName":"Drake Rymsha","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8477991,"firstName":"Alex","lastName":"Lintuniemi","fullName":"Alex Lintuniemi","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8477380,"firstName":"Jonny","lastName":"Brodzinski","fullName":"Jonny Brodzinski","number":"76","position":"RW","stats":{"_fantasyPoints":40.8,"_fantasyPointsAverage":1.17,"points":6,"goals":4,"assists":2,"penaltyMinutes":6,"plusMinus":4,"hits":35,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":53,"blocked":9,"faceOffPct":40,"gameWinningGoals":1,"games":35,"timeOnIcePerGame":"09:30"},"currentTeamId":26},{"id":8480803,"firstName":"Evan","lastName":"Bouchard","fullName":"Evan Bouchard","number":"75","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":22},{"id":8474849,"firstName":"Antoine","lastName":"Roussel","fullName":"Antoine Roussel","number":"26","position":"LW","stats":{"_fantasyPoints":51.5,"_fantasyPointsAverage":0.71,"points":17,"goals":5,"assists":12,"penaltyMinutes":126,"plusMinus":1,"hits":104,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":85,"blocked":42,"faceOffPct":57.89,"gameWinningGoals":0,"games":73,"timeOnIcePerGame":"12:25"},"currentTeamId":23},{"id":8465009,"firstName":"Zdeno","lastName":"Chara","fullName":"Zdeno Chara","number":"33","position":"D","stats":{"_fantasyPoints":200.65,"_fantasyPointsAverage":2.75,"points":24,"goals":7,"assists":17,"penaltyMinutes":60,"plusMinus":22,"hits":141,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":144,"blocked":118,"faceOffPct":0,"gameWinningGoals":3,"games":73,"timeOnIcePerGame":"22:54"},"currentTeamId":6},{"id":8476326,"firstName":"Josh","lastName":"Archibald","fullName":"Josh Archibald","number":"45","position":"RW","stats":{"_fantasyPoints":55.7,"_fantasyPointsAverage":1.33,"points":11,"goals":5,"assists":6,"penaltyMinutes":25,"plusMinus":-2,"hits":86,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":42,"blocked":16,"faceOffPct":38.46,"gameWinningGoals":0,"games":42,"timeOnIcePerGame":"11:56"},"currentTeamId":53},{"id":8471214,"firstName":"Alex","lastName":"Ovechkin","fullName":"Alex Ovechkin","number":"8","position":"LW","stats":{"_fantasyPoints":355,"_fantasyPointsAverage":4.33,"points":87,"goals":49,"assists":38,"penaltyMinutes":32,"plusMinus":3,"hits":139,"powerPlayGoals":17,"powerPlayPoints":17,"shortHandedGoals":0,"shortHandedPoints":0,"shots":355,"blocked":21,"faceOffPct":37.5,"gameWinningGoals":7,"games":82,"timeOnIcePerGame":"20:08"},"currentTeamId":15},{"id":8478147,"firstName":"Bokondji","lastName":"Imama","fullName":"Bokondji Imama","number":"58","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8475726,"firstName":"Tyler","lastName":"Toffoli","fullName":"Tyler Toffoli","number":"73","position":"RW","stats":{"_fantasyPoints":205.1,"_fantasyPointsAverage":2.5,"points":47,"goals":24,"assists":23,"penaltyMinutes":16,"plusMinus":9,"hits":75,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":251,"blocked":17,"faceOffPct":36,"gameWinningGoals":6,"games":82,"timeOnIcePerGame":"16:07"},"currentTeamId":26},{"id":8474218,"firstName":"Jason","lastName":"Demers","fullName":"Jason Demers","number":"55","position":"D","stats":{"_fantasyPoints":120.25,"_fantasyPointsAverage":1.74,"points":20,"goals":6,"assists":14,"penaltyMinutes":37,"plusMinus":-4,"hits":66,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":95,"blocked":79,"faceOffPct":0,"gameWinningGoals":2,"games":69,"timeOnIcePerGame":"21:08"},"currentTeamId":53},{"id":8477967,"firstName":"Thatcher","lastName":"Demko","fullName":"Thatcher Demko","number":"35","position":"G","stats":{"_fantasyPoints":"2.20","_fantasyPointsAverage":"2.20","savePercentage":0.867,"goalAgainstAverage":3.93,"wins":1,"losses":0,"saves":26,"goalsAgainst":4,"shutouts":0},"currentTeamId":23},{"id":8477290,"firstName":"Michael","lastName":"Raffl","fullName":"Michael Raffl","number":"12","position":"LW","stats":{"_fantasyPoints":133.1,"_fantasyPointsAverage":1.75,"points":22,"goals":13,"assists":9,"penaltyMinutes":28,"plusMinus":9,"hits":90,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":96,"blocked":50,"faceOffPct":59.09,"gameWinningGoals":3,"games":76,"timeOnIcePerGame":"13:15"},"currentTeamId":4},{"id":8480971,"firstName":"Martin","lastName":"Bakos","fullName":"Martin Bakos","number":"59","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8471794,"firstName":"Darren","lastName":"Helm","fullName":"Darren Helm","number":"43","position":"LW","stats":{"_fantasyPoints":161.85,"_fantasyPointsAverage":2.16,"points":31,"goals":13,"assists":18,"penaltyMinutes":39,"plusMinus":3,"hits":131,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":2,"shortHandedPoints":4,"shots":141,"blocked":36,"faceOffPct":44.11,"gameWinningGoals":0,"games":75,"timeOnIcePerGame":"15:33"},"currentTeamId":17},{"id":8479394,"firstName":"Carter","lastName":"Hart","fullName":"Carter Hart","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":4},{"id":8478844,"firstName":"Mikhail","lastName":"Vorobyov","fullName":"Mikhail Vorobyov","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8475792,"firstName":"Brett","lastName":"Connolly","fullName":"Brett Connolly","number":"10","position":"RW","stats":{"_fantasyPoints":106.7,"_fantasyPointsAverage":1.52,"points":27,"goals":15,"assists":12,"penaltyMinutes":30,"plusMinus":-6,"hits":72,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":67,"blocked":24,"faceOffPct":45.16,"gameWinningGoals":2,"games":70,"timeOnIcePerGame":"12:00"},"currentTeamId":15},{"id":8471707,"firstName":"James","lastName":"Neal","fullName":"James Neal","number":"18","position":"LW","stats":{"_fantasyPoints":170.2,"_fantasyPointsAverage":2.4,"points":44,"goals":25,"assists":19,"penaltyMinutes":24,"plusMinus":-11,"hits":44,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":202,"blocked":30,"faceOffPct":0,"gameWinningGoals":6,"games":71,"timeOnIcePerGame":"17:10"},"currentTeamId":20},{"id":8474722,"firstName":"Luke","lastName":"Witkowski","fullName":"Luke Witkowski","number":"28","position":"RW","stats":{"_fantasyPoints":0.1,"_fantasyPointsAverage":0,"points":4,"goals":1,"assists":3,"penaltyMinutes":68,"plusMinus":-1,"hits":57,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":16,"blocked":11,"faceOffPct":50,"gameWinningGoals":0,"games":31,"timeOnIcePerGame":"06:53"},"currentTeamId":17},{"id":8475625,"firstName":"Matt","lastName":"Irwin","fullName":"Matt Irwin","number":"52","position":"D","stats":{"_fantasyPoints":86.2,"_fantasyPointsAverage":1.72,"points":8,"goals":2,"assists":6,"penaltyMinutes":8,"plusMinus":2,"hits":78,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":62,"blocked":54,"faceOffPct":0,"gameWinningGoals":0,"games":50,"timeOnIcePerGame":"13:25"},"currentTeamId":18},{"id":8481142,"firstName":"Jan","lastName":"Kovar","fullName":"Jan Kovar","number":"10","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8479402,"firstName":"Jake","lastName":"Bean","fullName":"Jake Bean","number":"24","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8478895,"firstName":"Lukas","lastName":"Jasek","fullName":"Lukas Jasek","number":"67","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8471729,"firstName":"Kris","lastName":"Russell","fullName":"Kris Russell","number":"4","position":"D","stats":{"_fantasyPoints":247,"_fantasyPointsAverage":3.17,"points":21,"goals":4,"assists":17,"penaltyMinutes":8,"plusMinus":-7,"hits":97,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":90,"blocked":223,"faceOffPct":0,"gameWinningGoals":0,"games":78,"timeOnIcePerGame":"19:04"},"currentTeamId":22},{"id":8471260,"firstName":"Blake","lastName":"Comeau","fullName":"Blake Comeau","number":"15","position":"LW","stats":{"_fantasyPoints":165.55,"_fantasyPointsAverage":2.1,"points":34,"goals":13,"assists":21,"penaltyMinutes":50,"plusMinus":5,"hits":145,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":3,"shortHandedPoints":3,"shots":123,"blocked":38,"faceOffPct":38.37,"gameWinningGoals":3,"games":79,"timeOnIcePerGame":"15:52"},"currentTeamId":25},{"id":8475832,"firstName":"Tom","lastName":"Kuhnhackl","fullName":"Tom Kuhnhackl","number":"14","position":"RW","stats":{"_fantasyPoints":95.55,"_fantasyPointsAverage":1.38,"points":8,"goals":2,"assists":6,"penaltyMinutes":6,"plusMinus":-6,"hits":139,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":63,"blocked":50,"faceOffPct":16.66,"gameWinningGoals":1,"games":69,"timeOnIcePerGame":"10:01"},"currentTeamId":2},{"id":8480021,"firstName":"Jack","lastName":"Studnicka","fullName":"Jack Studnicka","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8476806,"firstName":"J.T.","lastName":"Brown","fullName":"J.T. Brown","number":"71","position":"RW","stats":{"_fantasyPoints":41.5,"_fantasyPointsAverage":0.88,"points":7,"goals":2,"assists":5,"penaltyMinutes":24,"plusMinus":-5,"hits":71,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":40,"blocked":23,"faceOffPct":43.59,"gameWinningGoals":1,"games":47,"timeOnIcePerGame":"09:04"},"currentTeamId":30},{"id":8475730,"firstName":"Stephen","lastName":"Johns","fullName":"Stephen Johns","number":"28","position":"D","stats":{"_fantasyPoints":217.1,"_fantasyPointsAverage":2.89,"points":15,"goals":8,"assists":7,"penaltyMinutes":41,"plusMinus":10,"hits":201,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":121,"blocked":155,"faceOffPct":0,"gameWinningGoals":2,"games":75,"timeOnIcePerGame":"17:32"},"currentTeamId":25},{"id":8476393,"firstName":"Nick","lastName":"Cousins","fullName":"Nick Cousins","number":"25","position":"C","stats":{"_fantasyPoints":107.9,"_fantasyPointsAverage":1.52,"points":19,"goals":12,"assists":7,"penaltyMinutes":31,"plusMinus":-7,"hits":117,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":119,"blocked":39,"faceOffPct":37.5,"gameWinningGoals":1,"games":71,"timeOnIcePerGame":"12:51"},"currentTeamId":53},{"id":8478439,"firstName":"Travis","lastName":"Konecny","fullName":"Travis Konecny","number":"11","position":"C","stats":{"_fantasyPoints":218.7,"_fantasyPointsAverage":2.7,"points":47,"goals":24,"assists":23,"penaltyMinutes":46,"plusMinus":17,"hits":97,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":177,"blocked":53,"faceOffPct":33.33,"gameWinningGoals":6,"games":81,"timeOnIcePerGame":"14:54"},"currentTeamId":4},{"id":8478458,"firstName":"Jack","lastName":"Roslovic","fullName":"Jack Roslovic","number":"28","position":"C","stats":{"_fantasyPoints":59.55,"_fantasyPointsAverage":1.92,"points":14,"goals":5,"assists":9,"penaltyMinutes":2,"plusMinus":5,"hits":20,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":38,"blocked":9,"faceOffPct":46.15,"gameWinningGoals":1,"games":31,"timeOnIcePerGame":"12:19"},"currentTeamId":52},{"id":8477935,"firstName":"Sam","lastName":"Bennett","fullName":"Sam Bennett","number":"93","position":"C","stats":{"_fantasyPoints":106.2,"_fantasyPointsAverage":1.3,"points":26,"goals":11,"assists":15,"penaltyMinutes":59,"plusMinus":-18,"hits":140,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":157,"blocked":34,"faceOffPct":54.33,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"14:24"},"currentTeamId":20},{"id":8479345,"firstName":"Jakob","lastName":"Chychrun","fullName":"Jakob Chychrun","number":"6","position":"D","stats":{"_fantasyPoints":117.7,"_fantasyPointsAverage":2.35,"points":14,"goals":4,"assists":10,"penaltyMinutes":16,"plusMinus":2,"hits":74,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":102,"blocked":72,"faceOffPct":0,"gameWinningGoals":1,"games":50,"timeOnIcePerGame":"20:15"},"currentTeamId":53},{"id":8478067,"firstName":"Oskar","lastName":"Lindblom","fullName":"Oskar Lindblom","number":"54","position":"LW","stats":{"_fantasyPoints":37.6,"_fantasyPointsAverage":1.63,"points":6,"goals":2,"assists":4,"penaltyMinutes":8,"plusMinus":4,"hits":27,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":36,"blocked":13,"faceOffPct":0,"gameWinningGoals":1,"games":23,"timeOnIcePerGame":"14:35"},"currentTeamId":4},{"id":8480005,"firstName":"Kristian","lastName":"Vesalainen","fullName":"Kristian Vesalainen","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":52},{"id":8469454,"firstName":"Ilya","lastName":"Kovalchuk","fullName":"Ilya Kovalchuk","number":"17","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8476906,"firstName":"Shayne","lastName":"Gostisbehere","fullName":"Shayne Gostisbehere","number":"53","position":"D","stats":{"_fantasyPoints":311.85,"_fantasyPointsAverage":4,"points":65,"goals":13,"assists":52,"penaltyMinutes":25,"plusMinus":10,"hits":53,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":221,"blocked":116,"faceOffPct":0,"gameWinningGoals":2,"games":78,"timeOnIcePerGame":"21:27"},"currentTeamId":4},{"id":8474113,"firstName":"TJ","lastName":"Brennan","fullName":"TJ Brennan","number":"43","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8479328,"firstName":"Julien","lastName":"Gauthier","fullName":"Julien Gauthier","number":"21","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8476851,"firstName":"Alex","lastName":"Galchenyuk","fullName":"Alex Galchenyuk","number":"17","position":"C","stats":{"_fantasyPoints":173.8,"_fantasyPointsAverage":2.12,"points":51,"goals":19,"assists":32,"penaltyMinutes":22,"plusMinus":-31,"hits":33,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":213,"blocked":37,"faceOffPct":44.95,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"16:14"},"currentTeamId":53},{"id":8476953,"firstName":"Trevor","lastName":"Carrick","fullName":"Trevor Carrick","number":"46","position":"D","stats":{"_fantasyPoints":-0.9,"_fantasyPointsAverage":-0.9,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"07:32"},"currentTeamId":12},{"id":8471215,"firstName":"Evgeni","lastName":"Malkin","fullName":"Evgeni Malkin","number":"71","position":"C","stats":{"_fantasyPoints":338.4,"_fantasyPointsAverage":4.34,"points":98,"goals":42,"assists":56,"penaltyMinutes":87,"plusMinus":16,"hits":48,"powerPlayGoals":14,"powerPlayPoints":14,"shortHandedGoals":0,"shortHandedPoints":0,"shots":239,"blocked":32,"faceOffPct":43.72,"gameWinningGoals":7,"games":78,"timeOnIcePerGame":"18:59"},"currentTeamId":5},{"id":8480208,"firstName":"Drake","lastName":"Batherson","fullName":"Drake Batherson","number":"79","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8477940,"firstName":"Nikolaj","lastName":"Ehlers","fullName":"Nikolaj Ehlers","number":"27","position":"LW","stats":{"_fantasyPoints":239.6,"_fantasyPointsAverage":2.92,"points":60,"goals":29,"assists":31,"penaltyMinutes":26,"plusMinus":14,"hits":39,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":231,"blocked":27,"faceOffPct":55.55,"gameWinningGoals":7,"games":82,"timeOnIcePerGame":"16:04"},"currentTeamId":52},{"id":8473412,"firstName":"Bryan","lastName":"Little","fullName":"Bryan Little","number":"18","position":"C","stats":{"_fantasyPoints":167.65,"_fantasyPointsAverage":2.04,"points":43,"goals":16,"assists":27,"penaltyMinutes":28,"plusMinus":2,"hits":50,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":129,"blocked":33,"faceOffPct":56.04,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"16:56"},"currentTeamId":52},{"id":8470281,"firstName":"Duncan","lastName":"Keith","fullName":"Duncan Keith","number":"2","position":"D","stats":{"_fantasyPoints":196.7,"_fantasyPointsAverage":2.4,"points":32,"goals":2,"assists":30,"penaltyMinutes":28,"plusMinus":-29,"hits":41,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":187,"blocked":165,"faceOffPct":0,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"23:49"},"currentTeamId":16},{"id":8477950,"firstName":"Tony","lastName":"DeAngelo","fullName":"Tony DeAngelo","number":"77","position":"D","stats":{"_fantasyPoints":45.55,"_fantasyPointsAverage":1.42,"points":8,"goals":0,"assists":8,"penaltyMinutes":11,"plusMinus":-18,"hits":31,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":68,"blocked":42,"faceOffPct":100,"gameWinningGoals":0,"games":32,"timeOnIcePerGame":"16:33"},"currentTeamId":3},{"id":8474610,"firstName":"Zac","lastName":"Dalpe","fullName":"Zac Dalpe","number":"29","position":"C","stats":{"_fantasyPoints":-3.2,"_fantasyPointsAverage":-0.27,"points":0,"goals":0,"assists":0,"penaltyMinutes":13,"plusMinus":-3,"hits":6,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":18,"blocked":4,"faceOffPct":29.16,"gameWinningGoals":0,"games":12,"timeOnIcePerGame":"07:26"},"currentTeamId":29},{"id":8476983,"firstName":"Paul","lastName":"LaDue","fullName":"Paul LaDue","number":"38","position":"D","stats":{"_fantasyPoints":28.05,"_fantasyPointsAverage":2.34,"points":4,"goals":3,"assists":1,"penaltyMinutes":6,"plusMinus":5,"hits":12,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":13,"blocked":11,"faceOffPct":0,"gameWinningGoals":2,"games":12,"timeOnIcePerGame":"13:58"},"currentTeamId":26},{"id":8477956,"firstName":"David","lastName":"Pastrnak","fullName":"David Pastrnak","number":"88","position":"RW","stats":{"_fantasyPoints":301.1,"_fantasyPointsAverage":3.67,"points":80,"goals":35,"assists":45,"penaltyMinutes":37,"plusMinus":10,"hits":55,"powerPlayGoals":13,"powerPlayPoints":13,"shortHandedGoals":0,"shortHandedPoints":0,"shots":246,"blocked":31,"faceOffPct":20,"gameWinningGoals":5,"games":82,"timeOnIcePerGame":"17:57"},"currentTeamId":6},{"id":8476462,"firstName":"Dougie","lastName":"Hamilton","fullName":"Dougie Hamilton","number":"19","position":"D","stats":{"_fantasyPoints":209.75,"_fantasyPointsAverage":2.56,"points":44,"goals":17,"assists":27,"penaltyMinutes":64,"plusMinus":1,"hits":83,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":270,"blocked":80,"faceOffPct":33.33,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"21:31"},"currentTeamId":12},{"id":8477573,"firstName":"Nathan","lastName":"Walker","fullName":"Nathan Walker","number":"79","position":"LW","stats":{"_fantasyPoints":6.35,"_fantasyPointsAverage":0.71,"points":1,"goals":1,"assists":0,"penaltyMinutes":6,"plusMinus":0,"hits":18,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"09:26"},"currentTeamId":15},{"id":8476422,"firstName":"Mike","lastName":"Reilly","fullName":"Mike Reilly","number":"28","position":"D","stats":{"_fantasyPoints":76.5,"_fantasyPointsAverage":1.34,"points":18,"goals":2,"assists":16,"penaltyMinutes":26,"plusMinus":-5,"hits":41,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":65,"blocked":37,"faceOffPct":0,"gameWinningGoals":0,"games":57,"timeOnIcePerGame":"14:57"},"currentTeamId":8},{"id":8480018,"firstName":"Nick","lastName":"Suzuki","fullName":"Nick Suzuki","number":"88","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8475844,"firstName":"Kenny","lastName":"Agostino","fullName":"Kenny Agostino","position":"LW","stats":{"_fantasyPoints":2.85,"_fantasyPointsAverage":0.57,"points":1,"goals":0,"assists":1,"penaltyMinutes":4,"plusMinus":-1,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":11,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":5,"timeOnIcePerGame":"12:02"},"currentTeamId":8},{"id":8475149,"firstName":"Marcus","lastName":"Johansson","fullName":"Marcus Johansson","number":"90","position":"LW","stats":{"_fantasyPoints":36.45,"_fantasyPointsAverage":1.26,"points":14,"goals":5,"assists":9,"penaltyMinutes":14,"plusMinus":-11,"hits":8,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":42,"blocked":9,"faceOffPct":48.64,"gameWinningGoals":0,"games":29,"timeOnIcePerGame":"15:59"},"currentTeamId":1},{"id":8474567,"firstName":"Zach","lastName":"Bogosian","fullName":"Zach Bogosian","number":"4","position":"D","stats":{"_fantasyPoints":9.15,"_fantasyPointsAverage":0.51,"points":1,"goals":0,"assists":1,"penaltyMinutes":20,"plusMinus":-9,"hits":22,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":29,"blocked":23,"faceOffPct":0,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"19:09"},"currentTeamId":7},{"id":8477359,"firstName":"Tucker","lastName":"Poolman","fullName":"Tucker Poolman","number":"3","position":"D","stats":{"_fantasyPoints":29.2,"_fantasyPointsAverage":1.22,"points":2,"goals":1,"assists":1,"penaltyMinutes":0,"plusMinus":2,"hits":20,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":27,"blocked":18,"faceOffPct":0,"gameWinningGoals":0,"games":24,"timeOnIcePerGame":"12:33"},"currentTeamId":52},{"id":8477494,"firstName":"Jonathan","lastName":"Drouin","fullName":"Jonathan Drouin","number":"92","position":"C","stats":{"_fantasyPoints":146.4,"_fantasyPointsAverage":1.9,"points":46,"goals":13,"assists":33,"penaltyMinutes":30,"plusMinus":-28,"hits":55,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":164,"blocked":27,"faceOffPct":42.53,"gameWinningGoals":4,"games":77,"timeOnIcePerGame":"17:35"},"currentTeamId":8},{"id":8477476,"firstName":"Artturi","lastName":"Lehkonen","fullName":"Artturi Lehkonen","number":"62","position":"LW","stats":{"_fantasyPoints":100.4,"_fantasyPointsAverage":1.52,"points":21,"goals":12,"assists":9,"penaltyMinutes":20,"plusMinus":-11,"hits":71,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":1,"shortHandedPoints":1,"shots":164,"blocked":23,"faceOffPct":36.66,"gameWinningGoals":3,"games":66,"timeOnIcePerGame":"16:29"},"currentTeamId":8},{"id":8480255,"firstName":"Sebastian","lastName":"Repo","fullName":"Sebastian Repo","number":"92","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8477947,"firstName":"Sonny","lastName":"Milano","fullName":"Sonny Milano","number":"22","position":"LW","stats":{"_fantasyPoints":80.15,"_fantasyPointsAverage":1.46,"points":22,"goals":14,"assists":8,"penaltyMinutes":10,"plusMinus":-8,"hits":28,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":69,"blocked":11,"faceOffPct":0,"gameWinningGoals":3,"games":55,"timeOnIcePerGame":"11:38"},"currentTeamId":29},{"id":8475296,"firstName":"Mitch","lastName":"Callahan","fullName":"Mitch Callahan","number":"15","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":22},{"id":8477503,"firstName":"Max","lastName":"Domi","fullName":"Max Domi","number":"13","position":"LW","stats":{"_fantasyPoints":130.75,"_fantasyPointsAverage":1.59,"points":45,"goals":9,"assists":36,"penaltyMinutes":73,"plusMinus":-7,"hits":49,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":150,"blocked":28,"faceOffPct":44.9,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"16:42"},"currentTeamId":8},{"id":8475848,"firstName":"Brendan","lastName":"Gallagher","fullName":"Brendan Gallagher","number":"11","position":"RW","stats":{"_fantasyPoints":229.05,"_fantasyPointsAverage":2.79,"points":54,"goals":31,"assists":23,"penaltyMinutes":34,"plusMinus":-13,"hits":90,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":1,"shortHandedPoints":1,"shots":278,"blocked":41,"faceOffPct":46.7,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"16:09"},"currentTeamId":8},{"id":8475808,"firstName":"Michael","lastName":"Chaput","fullName":"Michael Chaput","number":"43","position":"C","stats":{"_fantasyPoints":-0.8,"_fantasyPointsAverage":-0.09,"points":0,"goals":0,"assists":0,"penaltyMinutes":5,"plusMinus":-4,"hits":16,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":2,"faceOffPct":58.1,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"09:47"},"currentTeamId":8},{"id":8475278,"firstName":"Byron","lastName":"Froese","fullName":"Byron Froese","number":"42","position":"C","stats":{"_fantasyPoints":67.4,"_fantasyPointsAverage":1.4,"points":11,"goals":3,"assists":8,"penaltyMinutes":26,"plusMinus":0,"hits":54,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":49,"blocked":42,"faceOffPct":44.31,"gameWinningGoals":0,"games":48,"timeOnIcePerGame":"11:34"},"currentTeamId":8},{"id":8477355,"firstName":"Will","lastName":"Butcher","fullName":"Will Butcher","number":"8","position":"D","stats":{"_fantasyPoints":184.05,"_fantasyPointsAverage":2.27,"points":44,"goals":5,"assists":39,"penaltyMinutes":8,"plusMinus":1,"hits":21,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":88,"blocked":62,"faceOffPct":0,"gameWinningGoals":1,"games":81,"timeOnIcePerGame":"16:03"},"currentTeamId":1},{"id":8475222,"firstName":"Sami","lastName":"Vatanen","fullName":"Sami Vatanen","number":"45","position":"D","stats":{"_fantasyPoints":183.25,"_fantasyPointsAverage":2.55,"points":32,"goals":4,"assists":28,"penaltyMinutes":40,"plusMinus":-7,"hits":92,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":145,"blocked":105,"faceOffPct":0,"gameWinningGoals":0,"games":72,"timeOnIcePerGame":"22:24"},"currentTeamId":1},{"id":8472382,"firstName":"Andy","lastName":"Greene","fullName":"Andy Greene","number":"6","position":"D","stats":{"_fantasyPoints":187.3,"_fantasyPointsAverage":2.31,"points":13,"goals":3,"assists":10,"penaltyMinutes":21,"plusMinus":-9,"hits":84,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":93,"blocked":188,"faceOffPct":0,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"21:07"},"currentTeamId":1},{"id":8471233,"firstName":"Travis","lastName":"Zajac","fullName":"Travis Zajac","number":"19","position":"C","stats":{"_fantasyPoints":120.1,"_fantasyPointsAverage":1.91,"points":26,"goals":12,"assists":14,"penaltyMinutes":25,"plusMinus":-8,"hits":64,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":2,"shots":91,"blocked":38,"faceOffPct":50.91,"gameWinningGoals":0,"games":63,"timeOnIcePerGame":"17:54"},"currentTeamId":1},{"id":8480955,"firstName":"Bogdan","lastName":"Kiselevich","fullName":"Bogdan Kiselevich","number":"55","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8476850,"firstName":"Ryan","lastName":"Murray","fullName":"Ryan Murray","number":"27","position":"D","stats":{"_fantasyPoints":98.4,"_fantasyPointsAverage":2.24,"points":12,"goals":1,"assists":11,"penaltyMinutes":8,"plusMinus":4,"hits":31,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":34,"blocked":75,"faceOffPct":0,"gameWinningGoals":0,"games":44,"timeOnIcePerGame":"18:26"},"currentTeamId":29},{"id":8474651,"firstName":"Braden","lastName":"Holtby","fullName":"Braden Holtby","number":"70","position":"G","stats":{"_fantasyPoints":"180.00","_fantasyPointsAverage":"3.33","savePercentage":0.907,"goalAgainstAverage":2.99,"wins":34,"losses":16,"saves":1495,"goalsAgainst":153,"shutouts":0},"currentTeamId":15},{"id":8475156,"firstName":"Mikko","lastName":"Koskinen","fullName":"Mikko Koskinen","number":"19","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":22},{"id":8478115,"firstName":"Pierre","lastName":"Engvall","fullName":"Pierre Engvall","number":"47","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8478966,"firstName":"Alexandre","lastName":"Alain","fullName":"Alexandre Alain","number":"68","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8477957,"firstName":"Nikita","lastName":"Scherbak","fullName":"Nikita Scherbak","number":"38","position":"RW","stats":{"_fantasyPoints":34.65,"_fantasyPointsAverage":1.33,"points":6,"goals":4,"assists":2,"penaltyMinutes":8,"plusMinus":-5,"hits":18,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":1,"shots":39,"blocked":15,"faceOffPct":100,"gameWinningGoals":0,"games":26,"timeOnIcePerGame":"13:22"},"currentTeamId":8},{"id":8473565,"firstName":"Brian","lastName":"Strait","fullName":"Brian Strait","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8475287,"firstName":"Erik","lastName":"Haula","fullName":"Erik Haula","number":"56","position":"LW","stats":{"_fantasyPoints":211.75,"_fantasyPointsAverage":2.79,"points":55,"goals":29,"assists":26,"penaltyMinutes":37,"plusMinus":-16,"hits":85,"powerPlayGoals":12,"powerPlayPoints":12,"shortHandedGoals":0,"shortHandedPoints":0,"shots":175,"blocked":42,"faceOffPct":50.51,"gameWinningGoals":4,"games":76,"timeOnIcePerGame":"17:22"},"currentTeamId":54},{"id":8470594,"firstName":"Marc-Andre","lastName":"Fleury","fullName":"Marc-Andre Fleury","number":"29","position":"G","stats":{"_fantasyPoints":"204.20","_fantasyPointsAverage":"4.44","savePercentage":0.927,"goalAgainstAverage":2.24,"wins":29,"losses":13,"saves":1276,"goalsAgainst":100,"shutouts":4},"currentTeamId":54},{"id":8476466,"firstName":"Sven","lastName":"Baertschi","fullName":"Sven Baertschi","number":"47","position":"LW","stats":{"_fantasyPoints":118.7,"_fantasyPointsAverage":2.24,"points":29,"goals":14,"assists":15,"penaltyMinutes":20,"plusMinus":3,"hits":19,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":82,"blocked":29,"faceOffPct":14.28,"gameWinningGoals":2,"games":53,"timeOnIcePerGame":"15:36"},"currentTeamId":23},{"id":8477591,"firstName":"Josh","lastName":"Jooris","fullName":"Josh Jooris","number":"36","position":"RW","stats":{"_fantasyPoints":29,"_fantasyPointsAverage":0.72,"points":6,"goals":3,"assists":3,"penaltyMinutes":16,"plusMinus":-7,"hits":51,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":50,"blocked":11,"faceOffPct":46.01,"gameWinningGoals":0,"games":40,"timeOnIcePerGame":"09:45"},"currentTeamId":10},{"id":8480953,"firstName":"David","lastName":"Sklenicka","fullName":"David Sklenicka","number":"57","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8478454,"firstName":"Noah","lastName":"Juulsen","fullName":"Noah Juulsen","number":"58","position":"D","stats":{"_fantasyPoints":50.8,"_fantasyPointsAverage":2.21,"points":3,"goals":1,"assists":2,"penaltyMinutes":4,"plusMinus":1,"hits":58,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":33,"blocked":34,"faceOffPct":0,"gameWinningGoals":0,"games":23,"timeOnIcePerGame":"19:25"},"currentTeamId":8},{"id":8478076,"firstName":"Daniel","lastName":"Audette","fullName":"Daniel Audette","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8477446,"firstName":"Michael","lastName":"McCarron","fullName":"Michael McCarron","number":"34","position":"RW","stats":{"_fantasyPoints":12.75,"_fantasyPointsAverage":0.71,"points":1,"goals":0,"assists":1,"penaltyMinutes":32,"plusMinus":-1,"hits":61,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":15,"blocked":14,"faceOffPct":48.78,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"08:45"},"currentTeamId":8},{"id":8476469,"firstName":"Joel","lastName":"Armia","fullName":"Joel Armia","number":"40","position":"RW","stats":{"_fantasyPoints":149.05,"_fantasyPointsAverage":1.89,"points":29,"goals":12,"assists":17,"penaltyMinutes":22,"plusMinus":3,"hits":86,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":128,"blocked":39,"faceOffPct":46.66,"gameWinningGoals":2,"games":79,"timeOnIcePerGame":"12:36"},"currentTeamId":8},{"id":8470619,"firstName":"Brian","lastName":"Boyle","fullName":"Brian Boyle","number":"11","position":"C","stats":{"_fantasyPoints":105.5,"_fantasyPointsAverage":1.53,"points":23,"goals":13,"assists":10,"penaltyMinutes":45,"plusMinus":-9,"hits":126,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":120,"blocked":26,"faceOffPct":50.48,"gameWinningGoals":2,"games":69,"timeOnIcePerGame":"13:17"},"currentTeamId":1},{"id":8477425,"firstName":"Miles","lastName":"Wood","fullName":"Miles Wood","number":"44","position":"LW","stats":{"_fantasyPoints":104.75,"_fantasyPointsAverage":1.38,"points":32,"goals":19,"assists":13,"penaltyMinutes":84,"plusMinus":-6,"hits":75,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":170,"blocked":22,"faceOffPct":66.66,"gameWinningGoals":2,"games":76,"timeOnIcePerGame":"12:27"},"currentTeamId":1},{"id":8476539,"firstName":"Jonathan","lastName":"Marchessault","fullName":"Jonathan Marchessault","number":"81","position":"C","stats":{"_fantasyPoints":309.55,"_fantasyPointsAverage":4.02,"points":75,"goals":27,"assists":48,"penaltyMinutes":40,"plusMinus":36,"hits":99,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":268,"blocked":26,"faceOffPct":43.49,"gameWinningGoals":6,"games":77,"timeOnIcePerGame":"17:30"},"currentTeamId":54},{"id":8475310,"firstName":"Curtis","lastName":"McKenzie","fullName":"Curtis McKenzie","number":"11","position":"LW","stats":{"_fantasyPoints":6.35,"_fantasyPointsAverage":0.91,"points":2,"goals":0,"assists":2,"penaltyMinutes":11,"plusMinus":3,"hits":8,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":11,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":7,"timeOnIcePerGame":"08:06"},"currentTeamId":54},{"id":8474157,"firstName":"Max","lastName":"Pacioretty","fullName":"Max Pacioretty","number":"67","position":"LW","stats":{"_fantasyPoints":160.45,"_fantasyPointsAverage":2.51,"points":37,"goals":17,"assists":20,"penaltyMinutes":30,"plusMinus":-16,"hits":118,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":1,"shortHandedPoints":1,"shots":212,"blocked":27,"faceOffPct":35,"gameWinningGoals":4,"games":64,"timeOnIcePerGame":"19:00"},"currentTeamId":54},{"id":8469455,"firstName":"Jason","lastName":"Spezza","fullName":"Jason Spezza","number":"90","position":"C","stats":{"_fantasyPoints":97.8,"_fantasyPointsAverage":1.25,"points":26,"goals":8,"assists":18,"penaltyMinutes":12,"plusMinus":-12,"hits":16,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":138,"blocked":26,"faceOffPct":55.82,"gameWinningGoals":3,"games":78,"timeOnIcePerGame":"13:00"},"currentTeamId":25},{"id":8479376,"firstName":"Victor","lastName":"Mete","fullName":"Victor Mete","number":"53","position":"D","stats":{"_fantasyPoints":80.3,"_fantasyPointsAverage":1.64,"points":7,"goals":0,"assists":7,"penaltyMinutes":4,"plusMinus":5,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":43,"blocked":71,"faceOffPct":0,"gameWinningGoals":0,"games":49,"timeOnIcePerGame":"15:35"},"currentTeamId":8},{"id":8477455,"firstName":"Jacob","lastName":"de la Rose","fullName":"Jacob de la Rose","number":"25","position":"LW","stats":{"_fantasyPoints":85.05,"_fantasyPointsAverage":1.55,"points":12,"goals":4,"assists":8,"penaltyMinutes":29,"plusMinus":-2,"hits":127,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":53,"blocked":36,"faceOffPct":44.11,"gameWinningGoals":0,"games":55,"timeOnIcePerGame":"11:50"},"currentTeamId":8},{"id":8476948,"firstName":"Charles","lastName":"Hudon","fullName":"Charles Hudon","number":"54","position":"LW","stats":{"_fantasyPoints":139.4,"_fantasyPointsAverage":1.94,"points":30,"goals":10,"assists":20,"penaltyMinutes":38,"plusMinus":-12,"hits":126,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":179,"blocked":38,"faceOffPct":40.18,"gameWinningGoals":1,"games":72,"timeOnIcePerGame":"14:01"},"currentTeamId":8},{"id":8474550,"firstName":"Antti","lastName":"Niemi","fullName":"Antti Niemi","number":"37","position":"G","stats":{"_fantasyPoints":"78.40","_fantasyPointsAverage":"3.27","savePercentage":0.911,"goalAgainstAverage":3.12,"wins":7,"losses":9,"saves":647,"goalsAgainst":63,"shutouts":1},"currentTeamId":8},{"id":8475791,"firstName":"Taylor","lastName":"Hall","fullName":"Taylor Hall","number":"9","position":"LW","stats":{"_fantasyPoints":369.3,"_fantasyPointsAverage":4.86,"points":93,"goals":39,"assists":54,"penaltyMinutes":34,"plusMinus":14,"hits":72,"powerPlayGoals":13,"powerPlayPoints":13,"shortHandedGoals":1,"shortHandedPoints":1,"shots":278,"blocked":44,"faceOffPct":48.64,"gameWinningGoals":7,"games":76,"timeOnIcePerGame":"19:08"},"currentTeamId":1},{"id":8471239,"firstName":"Cory","lastName":"Schneider","fullName":"Cory Schneider","number":"35","position":"G","stats":{"_fantasyPoints":"130.80","_fantasyPointsAverage":"3.27","savePercentage":0.907,"goalAgainstAverage":2.93,"wins":17,"losses":16,"saves":1114,"goalsAgainst":114,"shutouts":1},"currentTeamId":1},{"id":8476509,"firstName":"Maxime","lastName":"Lagace","fullName":"Maxime Lagace","number":"33","position":"G","stats":{"_fantasyPoints":"23.60","_fantasyPointsAverage":"1.48","savePercentage":0.867,"goalAgainstAverage":3.91,"wins":6,"losses":7,"saves":373,"goalsAgainst":57,"shutouts":0},"currentTeamId":54},{"id":8476443,"firstName":"Xavier","lastName":"Ouellet","fullName":"Xavier Ouellet","number":"61","position":"D","stats":{"_fantasyPoints":58.45,"_fantasyPointsAverage":1.3,"points":7,"goals":0,"assists":7,"penaltyMinutes":6,"plusMinus":-3,"hits":36,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":57,"blocked":43,"faceOffPct":0,"gameWinningGoals":0,"games":45,"timeOnIcePerGame":"13:51"},"currentTeamId":8},{"id":8474818,"firstName":"Jordie","lastName":"Benn","fullName":"Jordie Benn","number":"8","position":"D","stats":{"_fantasyPoints":170.35,"_fantasyPointsAverage":2.21,"points":15,"goals":4,"assists":11,"penaltyMinutes":34,"plusMinus":-2,"hits":90,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":106,"blocked":153,"faceOffPct":0,"gameWinningGoals":0,"games":77,"timeOnIcePerGame":"18:58"},"currentTeamId":8},{"id":8474038,"firstName":"Paul","lastName":"Byron","fullName":"Paul Byron","number":"41","position":"LW","stats":{"_fantasyPoints":188,"_fantasyPointsAverage":2.29,"points":35,"goals":20,"assists":15,"penaltyMinutes":23,"plusMinus":-4,"hits":137,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":2,"shots":115,"blocked":55,"faceOffPct":37.03,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"16:07"},"currentTeamId":8},{"id":8473933,"firstName":"Ben","lastName":"Lovejoy","fullName":"Ben Lovejoy","number":"12","position":"D","stats":{"_fantasyPoints":112.9,"_fantasyPointsAverage":1.98,"points":8,"goals":2,"assists":6,"penaltyMinutes":25,"plusMinus":7,"hits":84,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":74,"blocked":86,"faceOffPct":0,"gameWinningGoals":0,"games":57,"timeOnIcePerGame":"16:35"},"currentTeamId":1},{"id":8475750,"firstName":"Jon","lastName":"Merrill","fullName":"Jon Merrill","number":"15","position":"D","stats":{"_fantasyPoints":47.75,"_fantasyPointsAverage":1.4,"points":3,"goals":1,"assists":2,"penaltyMinutes":22,"plusMinus":7,"hits":35,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":30,"blocked":42,"faceOffPct":0,"gameWinningGoals":1,"games":34,"timeOnIcePerGame":"16:05"},"currentTeamId":54},{"id":8475613,"firstName":"Nate","lastName":"Prosser","fullName":"Nate Prosser","number":"39","position":"D","stats":{"_fantasyPoints":108.2,"_fantasyPointsAverage":1.9,"points":9,"goals":3,"assists":6,"penaltyMinutes":19,"plusMinus":8,"hits":60,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":27,"blocked":84,"faceOffPct":0,"gameWinningGoals":1,"games":57,"timeOnIcePerGame":"13:27"},"currentTeamId":30},{"id":8480829,"firstName":"Jesperi","lastName":"Kotkaniemi","fullName":"Jesperi Kotkaniemi","number":"15","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8477445,"firstName":"Hunter","lastName":"Shinkaruk","fullName":"Hunter Shinkaruk","number":"45","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8479034,"firstName":"Scott","lastName":"Eansor","fullName":"Scott Eansor","number":"57","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8476479,"firstName":"Phillip","lastName":"Danault","fullName":"Phillip Danault","number":"24","position":"C","stats":{"_fantasyPoints":110.65,"_fantasyPointsAverage":2.13,"points":25,"goals":8,"assists":17,"penaltyMinutes":34,"plusMinus":0,"hits":59,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":94,"blocked":38,"faceOffPct":52.77,"gameWinningGoals":2,"games":52,"timeOnIcePerGame":"16:35"},"currentTeamId":8},{"id":8471691,"firstName":"Martin","lastName":"Hanzal","fullName":"Martin Hanzal","number":"11","position":"C","stats":{"_fantasyPoints":44.45,"_fantasyPointsAverage":1.17,"points":10,"goals":5,"assists":5,"penaltyMinutes":23,"plusMinus":-14,"hits":66,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":62,"blocked":21,"faceOffPct":55.06,"gameWinningGoals":1,"games":38,"timeOnIcePerGame":"14:06"},"currentTeamId":25},{"id":8480158,"firstName":"Andreas","lastName":"Borgman","fullName":"Andreas Borgman","number":"55","position":"D","stats":{"_fantasyPoints":82.35,"_fantasyPointsAverage":1.72,"points":11,"goals":3,"assists":8,"penaltyMinutes":28,"plusMinus":4,"hits":121,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":46,"blocked":36,"faceOffPct":0,"gameWinningGoals":0,"games":48,"timeOnIcePerGame":"13:41"},"currentTeamId":10},{"id":8473468,"firstName":"Eric","lastName":"Gryba","fullName":"Eric Gryba","position":"D","stats":{"_fantasyPoints":23.9,"_fantasyPointsAverage":1.14,"points":2,"goals":0,"assists":2,"penaltyMinutes":31,"plusMinus":4,"hits":57,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":19,"blocked":19,"faceOffPct":0,"gameWinningGoals":0,"games":21,"timeOnIcePerGame":"14:44"},"currentTeamId":1},{"id":8477937,"firstName":"Jake","lastName":"Virtanen","fullName":"Jake Virtanen","number":"18","position":"RW","stats":{"_fantasyPoints":99.75,"_fantasyPointsAverage":1.33,"points":20,"goals":10,"assists":10,"penaltyMinutes":46,"plusMinus":-11,"hits":156,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":130,"blocked":29,"faceOffPct":31.81,"gameWinningGoals":1,"games":75,"timeOnIcePerGame":"11:59"},"currentTeamId":23},{"id":8477945,"firstName":"Julius","lastName":"Honka","fullName":"Julius Honka","number":"6","position":"D","stats":{"_fantasyPoints":33.7,"_fantasyPointsAverage":0.8,"points":4,"goals":1,"assists":3,"penaltyMinutes":14,"plusMinus":-1,"hits":20,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":42,"blocked":28,"faceOffPct":0,"gameWinningGoals":0,"games":42,"timeOnIcePerGame":"13:00"},"currentTeamId":25},{"id":8478849,"firstName":"Brad","lastName":"Morrison","fullName":"Brad Morrison","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8476461,"firstName":"Sean","lastName":"Couturier","fullName":"Sean Couturier","number":"14","position":"C","stats":{"_fantasyPoints":320.7,"_fantasyPointsAverage":3.91,"points":76,"goals":31,"assists":45,"penaltyMinutes":31,"plusMinus":34,"hits":74,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":227,"blocked":44,"faceOffPct":52.84,"gameWinningGoals":6,"games":82,"timeOnIcePerGame":"21:35"},"currentTeamId":4},{"id":8477850,"firstName":"Christian","lastName":"Folin","fullName":"Christian Folin","number":"26","position":"D","stats":{"_fantasyPoints":152.05,"_fantasyPointsAverage":2.34,"points":13,"goals":3,"assists":10,"penaltyMinutes":30,"plusMinus":1,"hits":167,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":58,"blocked":106,"faceOffPct":0,"gameWinningGoals":0,"games":65,"timeOnIcePerGame":"15:39"},"currentTeamId":4},{"id":8475178,"firstName":"Zack","lastName":"Kassian","fullName":"Zack Kassian","number":"44","position":"RW","stats":{"_fantasyPoints":55.6,"_fantasyPointsAverage":0.75,"points":19,"goals":7,"assists":12,"penaltyMinutes":92,"plusMinus":-8,"hits":129,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":2,"shots":86,"blocked":9,"faceOffPct":20.83,"gameWinningGoals":0,"games":74,"timeOnIcePerGame":"11:40"},"currentTeamId":22},{"id":8477460,"firstName":"Laurent","lastName":"Dauphin","fullName":"Laurent Dauphin","number":"12","position":"C","stats":{"_fantasyPoints":-0.15,"_fantasyPointsAverage":-0.07,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":-1,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":2,"faceOffPct":55.55,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"07:13"},"currentTeamId":53},{"id":8477498,"firstName":"Darnell","lastName":"Nurse","fullName":"Darnell Nurse","number":"25","position":"D","stats":{"_fantasyPoints":226.9,"_fantasyPointsAverage":2.77,"points":26,"goals":6,"assists":20,"penaltyMinutes":67,"plusMinus":15,"hits":161,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":194,"blocked":153,"faceOffPct":0,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"22:14"},"currentTeamId":22},{"id":8478413,"firstName":"Jordan","lastName":"Greenway","fullName":"Jordan Greenway","number":"18","position":"LW","stats":{"_fantasyPoints":6.4,"_fantasyPointsAverage":1.07,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":0,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":3,"faceOffPct":0,"gameWinningGoals":0,"games":6,"timeOnIcePerGame":"11:26"},"currentTeamId":30},{"id":8470147,"firstName":"Curtis","lastName":"McElhinney","fullName":"Curtis McElhinney","number":"35","position":"G","stats":{"_fantasyPoints":"89.60","_fantasyPointsAverage":"4.98","savePercentage":0.934,"goalAgainstAverage":2.15,"wins":11,"losses":5,"saves":493,"goalsAgainst":35,"shutouts":3},"currentTeamId":10},{"id":8475235,"firstName":"Nicolas","lastName":"Deslauriers","fullName":"Nicolas Deslauriers","number":"20","position":"LW","stats":{"_fantasyPoints":117.7,"_fantasyPointsAverage":2.03,"points":14,"goals":10,"assists":4,"penaltyMinutes":55,"plusMinus":7,"hits":238,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":77,"blocked":30,"faceOffPct":66.66,"gameWinningGoals":1,"games":58,"timeOnIcePerGame":"11:35"},"currentTeamId":8},{"id":8481068,"firstName":"Yegor","lastName":"Sharangovich","fullName":"Yegor Sharangovich","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8475716,"firstName":"Martin","lastName":"Marincin","fullName":"Martin Marincin","number":"52","position":"D","stats":{"_fantasyPoints":0.25,"_fantasyPointsAverage":0.13,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":-2,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":4,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"16:40"},"currentTeamId":10},{"id":8480760,"firstName":"Cameron","lastName":"Johnson","fullName":"Cameron Johnson","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":1},{"id":8471679,"firstName":"Carey","lastName":"Price","fullName":"Carey Price","number":"31","position":"G","stats":{"_fantasyPoints":"140.80","_fantasyPointsAverage":"2.87","savePercentage":0.9,"goalAgainstAverage":3.11,"wins":16,"losses":26,"saves":1339,"goalsAgainst":148,"shutouts":1},"currentTeamId":8},{"id":8480226,"firstName":"Marian","lastName":"Studenic","fullName":"Marian Studenic","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8470642,"firstName":"Shea","lastName":"Weber","fullName":"Shea Weber","number":"6","position":"D","stats":{"_fantasyPoints":105.25,"_fantasyPointsAverage":4.05,"points":16,"goals":6,"assists":10,"penaltyMinutes":14,"plusMinus":-8,"hits":66,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":1,"shots":75,"blocked":59,"faceOffPct":0,"gameWinningGoals":1,"games":26,"timeOnIcePerGame":"25:20"},"currentTeamId":8},{"id":8479315,"firstName":"Joey","lastName":"Anderson","fullName":"Joey Anderson","number":"49","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8477361,"firstName":"Cal","lastName":"Petersen","fullName":"Cal Petersen","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":26},{"id":8475172,"firstName":"Nazem","lastName":"Kadri","fullName":"Nazem Kadri","number":"43","position":"C","stats":{"_fantasyPoints":224.1,"_fantasyPointsAverage":2.8,"points":55,"goals":32,"assists":23,"penaltyMinutes":42,"plusMinus":2,"hits":94,"powerPlayGoals":12,"powerPlayPoints":12,"shortHandedGoals":0,"shortHandedPoints":0,"shots":211,"blocked":26,"faceOffPct":49.95,"gameWinningGoals":3,"games":80,"timeOnIcePerGame":"16:45"},"currentTeamId":10},{"id":8480952,"firstName":"Michal","lastName":"Moravcik","fullName":"Michal Moravcik","number":"73","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8480462,"firstName":"Hayden","lastName":"Verbeek","fullName":"Hayden Verbeek","number":"96","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":8},{"id":8476399,"firstName":"Blake","lastName":"Coleman","fullName":"Blake Coleman","number":"20","position":"C","stats":{"_fantasyPoints":179.35,"_fantasyPointsAverage":2.27,"points":25,"goals":13,"assists":12,"penaltyMinutes":50,"plusMinus":7,"hits":216,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":3,"shortHandedPoints":3,"shots":146,"blocked":57,"faceOffPct":46.92,"gameWinningGoals":2,"games":79,"timeOnIcePerGame":"14:23"},"currentTeamId":1},{"id":8474589,"firstName":"Tyler","lastName":"Ennis","fullName":"Tyler Ennis","number":"63","position":"C","stats":{"_fantasyPoints":106.5,"_fantasyPointsAverage":1.46,"points":22,"goals":8,"assists":14,"penaltyMinutes":12,"plusMinus":-1,"hits":51,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":115,"blocked":33,"faceOffPct":25,"gameWinningGoals":3,"games":73,"timeOnIcePerGame":"11:58"},"currentTeamId":10},{"id":8477215,"firstName":"Danny","lastName":"DeKeyser","fullName":"Danny DeKeyser","number":"65","position":"D","stats":{"_fantasyPoints":143.25,"_fantasyPointsAverage":2.2,"points":12,"goals":6,"assists":6,"penaltyMinutes":28,"plusMinus":2,"hits":76,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":65,"blocked":125,"faceOffPct":0,"gameWinningGoals":0,"games":65,"timeOnIcePerGame":"20:19"},"currentTeamId":17},{"id":8474581,"firstName":"Jake","lastName":"Gardiner","fullName":"Jake Gardiner","number":"51","position":"D","stats":{"_fantasyPoints":238.8,"_fantasyPointsAverage":2.91,"points":52,"goals":5,"assists":47,"penaltyMinutes":32,"plusMinus":9,"hits":51,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":133,"blocked":103,"faceOffPct":0,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"22:31"},"currentTeamId":10},{"id":8480948,"firstName":"Egor","lastName":"Iakovlev","fullName":"Egor Iakovlev","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8476343,"firstName":"Garret","lastName":"Sparks","fullName":"Garret Sparks","number":"40","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":10},{"id":8475193,"firstName":"Tomas","lastName":"Tatar","fullName":"Tomas Tatar","number":"90","position":"LW","stats":{"_fantasyPoints":131.4,"_fantasyPointsAverage":1.6,"points":34,"goals":20,"assists":14,"penaltyMinutes":34,"plusMinus":-19,"hits":67,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":174,"blocked":29,"faceOffPct":13.33,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"16:15"},"currentTeamId":8},{"id":8473991,"firstName":"Karl","lastName":"Alzner","fullName":"Karl Alzner","number":"27","position":"D","stats":{"_fantasyPoints":159.15,"_fantasyPointsAverage":1.94,"points":12,"goals":1,"assists":11,"penaltyMinutes":40,"plusMinus":-7,"hits":141,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":84,"blocked":144,"faceOffPct":0,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"20:04"},"currentTeamId":8},{"id":8479407,"firstName":"Jesper","lastName":"Bratt","fullName":"Jesper Bratt","number":"63","position":"LW","stats":{"_fantasyPoints":126,"_fantasyPointsAverage":1.7,"points":35,"goals":13,"assists":22,"penaltyMinutes":18,"plusMinus":-16,"hits":44,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":1,"shortHandedPoints":2,"shots":100,"blocked":22,"faceOffPct":63.63,"gameWinningGoals":2,"games":74,"timeOnIcePerGame":"15:15"},"currentTeamId":1},{"id":8478841,"firstName":"Colton","lastName":"White","fullName":"Colton White","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8478406,"firstName":"Mackenzie","lastName":"Blackwood","fullName":"Mackenzie Blackwood","number":"70","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":1},{"id":8478401,"firstName":"Pavel","lastName":"Zacha","fullName":"Pavel Zacha","number":"37","position":"C","stats":{"_fantasyPoints":103.7,"_fantasyPointsAverage":1.5,"points":25,"goals":8,"assists":17,"penaltyMinutes":30,"plusMinus":-3,"hits":70,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":1,"shots":112,"blocked":22,"faceOffPct":43.86,"gameWinningGoals":0,"games":69,"timeOnIcePerGame":"14:22"},"currentTeamId":1},{"id":8480002,"firstName":"Nico","lastName":"Hischier","fullName":"Nico Hischier","number":"13","position":"C","stats":{"_fantasyPoints":211.25,"_fantasyPointsAverage":2.58,"points":52,"goals":20,"assists":32,"penaltyMinutes":26,"plusMinus":10,"hits":56,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":180,"blocked":39,"faceOffPct":42.93,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"16:18"},"currentTeamId":1},{"id":8478480,"firstName":"Blake","lastName":"Speers","fullName":"Blake Speers","number":"74","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8474025,"firstName":"Eric","lastName":"Tangradi","fullName":"Eric Tangradi","number":"49","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8473507,"firstName":"Jeff","lastName":"Petry","fullName":"Jeff Petry","number":"26","position":"D","stats":{"_fantasyPoints":247.55,"_fantasyPointsAverage":3.02,"points":42,"goals":12,"assists":30,"penaltyMinutes":28,"plusMinus":-30,"hits":167,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":178,"blocked":138,"faceOffPct":0,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"23:29"},"currentTeamId":8},{"id":8469521,"firstName":"Tomas","lastName":"Plekanec","fullName":"Tomas Plekanec","number":"14","position":"C","stats":{"_fantasyPoints":109.9,"_fantasyPointsAverage":1.43,"points":26,"goals":6,"assists":20,"penaltyMinutes":45,"plusMinus":1,"hits":61,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":144,"blocked":41,"faceOffPct":53.31,"gameWinningGoals":1,"games":77,"timeOnIcePerGame":"15:08"},"currentTeamId":8},{"id":8479692,"firstName":"Colby","lastName":"Sissons","fullName":"Colby Sissons","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8479414,"firstName":"Nathan","lastName":"Bastian","fullName":"Nathan Bastian","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8476853,"firstName":"Morgan","lastName":"Rielly","fullName":"Morgan Rielly","number":"44","position":"D","stats":{"_fantasyPoints":230.7,"_fantasyPointsAverage":3.04,"points":52,"goals":6,"assists":46,"penaltyMinutes":14,"plusMinus":-4,"hits":48,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":182,"blocked":84,"faceOffPct":0,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"21:35"},"currentTeamId":10},{"id":8475786,"firstName":"Zach","lastName":"Hyman","fullName":"Zach Hyman","number":"11","position":"C","stats":{"_fantasyPoints":210.8,"_fantasyPointsAverage":2.57,"points":40,"goals":15,"assists":25,"penaltyMinutes":37,"plusMinus":22,"hits":117,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":148,"blocked":55,"faceOffPct":42.85,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"17:21"},"currentTeamId":10},{"id":8473673,"firstName":"David","lastName":"Schlemko","fullName":"David Schlemko","number":"21","position":"D","stats":{"_fantasyPoints":80.55,"_fantasyPointsAverage":2.18,"points":5,"goals":1,"assists":4,"penaltyMinutes":6,"plusMinus":3,"hits":33,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":38,"blocked":72,"faceOffPct":0,"gameWinningGoals":1,"games":37,"timeOnIcePerGame":"18:03"},"currentTeamId":8},{"id":8480883,"firstName":"Ty","lastName":"Smith","fullName":"Ty Smith","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8479330,"firstName":"Brandon","lastName":"Gignac","fullName":"Brandon Gignac","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8478881,"firstName":"Brett","lastName":"Seney","fullName":"Brett Seney","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8477972,"firstName":"Josh","lastName":"Jacobs","fullName":"Josh Jacobs","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8476545,"firstName":"Kurtis","lastName":"Gabriel","fullName":"Kurtis Gabriel","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8476474,"firstName":"Stefan","lastName":"Noesen","fullName":"Stefan Noesen","number":"23","position":"RW","stats":{"_fantasyPoints":145.95,"_fantasyPointsAverage":2.03,"points":27,"goals":13,"assists":14,"penaltyMinutes":36,"plusMinus":12,"hits":112,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":127,"blocked":41,"faceOffPct":36.36,"gameWinningGoals":4,"games":72,"timeOnIcePerGame":"13:17"},"currentTeamId":1},{"id":8476234,"firstName":"Keith","lastName":"Kinkaid","fullName":"Keith Kinkaid","number":"1","position":"G","stats":{"_fantasyPoints":"146.60","_fantasyPointsAverage":"3.58","savePercentage":0.913,"goalAgainstAverage":2.77,"wins":26,"losses":10,"saves":1108,"goalsAgainst":106,"shutouts":1},"currentTeamId":1},{"id":8475829,"firstName":"John","lastName":"Ramage","fullName":"John Ramage","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8477993,"firstName":"Justin","lastName":"Kirkland","fullName":"Justin Kirkland","number":"43","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8476285,"firstName":"Matthew","lastName":"Peca","fullName":"Matthew Peca","number":"63","position":"C","stats":{"_fantasyPoints":30.95,"_fantasyPointsAverage":3.09,"points":5,"goals":2,"assists":3,"penaltyMinutes":0,"plusMinus":6,"hits":11,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":17,"blocked":8,"faceOffPct":56.93,"gameWinningGoals":0,"games":10,"timeOnIcePerGame":"13:40"},"currentTeamId":8},{"id":8477631,"firstName":"Brandon","lastName":"Baddock","fullName":"Brandon Baddock","number":"52","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":1},{"id":8476866,"firstName":"Nicolas","lastName":"Kerdiles","fullName":"Nicolas Kerdiles","number":"58","position":"LW","stats":{"_fantasyPoints":0.25,"_fantasyPointsAverage":0.13,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"03:45"},"currentTeamId":52},{"id":8470966,"firstName":"Mark","lastName":"Giordano","fullName":"Mark Giordano","number":"5","position":"D","stats":{"_fantasyPoints":250.4,"_fantasyPointsAverage":3.05,"points":38,"goals":13,"assists":25,"penaltyMinutes":63,"plusMinus":0,"hits":93,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":1,"shots":214,"blocked":161,"faceOffPct":0,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"24:47"},"currentTeamId":20},{"id":8474679,"firstName":"Gustav","lastName":"Nyquist","fullName":"Gustav Nyquist","number":"14","position":"RW","stats":{"_fantasyPoints":177.55,"_fantasyPointsAverage":2.17,"points":40,"goals":21,"assists":19,"penaltyMinutes":20,"plusMinus":-2,"hits":65,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":213,"blocked":36,"faceOffPct":46.15,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"17:51"},"currentTeamId":17},{"id":8478046,"firstName":"Danton","lastName":"Heinen","fullName":"Danton Heinen","number":"43","position":"C","stats":{"_fantasyPoints":194.5,"_fantasyPointsAverage":2.53,"points":47,"goals":16,"assists":31,"penaltyMinutes":16,"plusMinus":10,"hits":45,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":1,"shots":135,"blocked":33,"faceOffPct":43.47,"gameWinningGoals":4,"games":77,"timeOnIcePerGame":"15:01"},"currentTeamId":6},{"id":8479314,"firstName":"Matthew","lastName":"Tkachuk","fullName":"Matthew Tkachuk","number":"19","position":"LW","stats":{"_fantasyPoints":174.3,"_fantasyPointsAverage":2.56,"points":49,"goals":24,"assists":25,"penaltyMinutes":61,"plusMinus":-1,"hits":80,"powerPlayGoals":10,"powerPlayPoints":10,"shortHandedGoals":0,"shortHandedPoints":0,"shots":188,"blocked":16,"faceOffPct":41.17,"gameWinningGoals":2,"games":68,"timeOnIcePerGame":"17:15"},"currentTeamId":20},{"id":8480001,"firstName":"Urho","lastName":"Vaakanainen","fullName":"Urho Vaakanainen","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8477987,"firstName":"Ryan","lastName":"Donato","fullName":"Ryan Donato","number":"17","position":"C","stats":{"_fantasyPoints":35.9,"_fantasyPointsAverage":2.99,"points":9,"goals":5,"assists":4,"penaltyMinutes":2,"plusMinus":2,"hits":6,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":24,"blocked":2,"faceOffPct":75,"gameWinningGoals":0,"games":12,"timeOnIcePerGame":"14:41"},"currentTeamId":6},{"id":8476381,"firstName":"Andrew","lastName":"Shaw","fullName":"Andrew Shaw","number":"65","position":"RW","stats":{"_fantasyPoints":77.9,"_fantasyPointsAverage":1.53,"points":20,"goals":10,"assists":10,"penaltyMinutes":53,"plusMinus":-8,"hits":80,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":94,"blocked":26,"faceOffPct":54.29,"gameWinningGoals":0,"games":51,"timeOnIcePerGame":"15:48"},"currentTeamId":8},{"id":8476316,"firstName":"Laurent","lastName":"Brossoit","fullName":"Laurent Brossoit","number":"30","position":"G","stats":{"_fantasyPoints":"23.60","_fantasyPointsAverage":"1.69","savePercentage":0.883,"goalAgainstAverage":3.24,"wins":3,"losses":7,"saves":303,"goalsAgainst":40,"shutouts":0},"currentTeamId":52},{"id":8473564,"firstName":"Michael","lastName":"Frolik","fullName":"Michael Frolik","number":"67","position":"RW","stats":{"_fantasyPoints":102.45,"_fantasyPointsAverage":1.46,"points":25,"goals":10,"assists":15,"penaltyMinutes":26,"plusMinus":-19,"hits":48,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":2,"shortHandedPoints":2,"shots":167,"blocked":35,"faceOffPct":45.83,"gameWinningGoals":1,"games":70,"timeOnIcePerGame":"16:55"},"currentTeamId":20},{"id":8476392,"firstName":"Adam","lastName":"Lowry","fullName":"Adam Lowry","number":"17","position":"C","stats":{"_fantasyPoints":125.5,"_fantasyPointsAverage":2.79,"points":21,"goals":8,"assists":13,"penaltyMinutes":8,"plusMinus":9,"hits":124,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":70,"blocked":28,"faceOffPct":55.88,"gameWinningGoals":1,"games":45,"timeOnIcePerGame":"14:53"},"currentTeamId":52},{"id":8476960,"firstName":"Andreas","lastName":"Athanasiou","fullName":"Andreas Athanasiou","number":"72","position":"C","stats":{"_fantasyPoints":121,"_fantasyPointsAverage":1.7,"points":33,"goals":16,"assists":17,"penaltyMinutes":16,"plusMinus":-15,"hits":24,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":170,"blocked":28,"faceOffPct":41.56,"gameWinningGoals":2,"games":71,"timeOnIcePerGame":"15:18"},"currentTeamId":17},{"id":8476988,"firstName":"Matt","lastName":"Benning","fullName":"Matt Benning","number":"83","position":"D","stats":{"_fantasyPoints":153.35,"_fantasyPointsAverage":2.1,"points":21,"goals":6,"assists":15,"penaltyMinutes":49,"plusMinus":5,"hits":149,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":111,"blocked":82,"faceOffPct":0,"gameWinningGoals":2,"games":73,"timeOnIcePerGame":"17:16"},"currentTeamId":22},{"id":8479588,"firstName":"Nolan","lastName":"Stevens","fullName":"Nolan Stevens","number":"51","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8475151,"firstName":"Kyle","lastName":"Palmieri","fullName":"Kyle Palmieri","number":"21","position":"RW","stats":{"_fantasyPoints":208.6,"_fantasyPointsAverage":3.36,"points":44,"goals":24,"assists":20,"penaltyMinutes":30,"plusMinus":-1,"hits":94,"powerPlayGoals":11,"powerPlayPoints":11,"shortHandedGoals":0,"shortHandedPoints":0,"shots":181,"blocked":50,"faceOffPct":33.33,"gameWinningGoals":5,"games":62,"timeOnIcePerGame":"17:18"},"currentTeamId":1},{"id":8479304,"firstName":"Kyle","lastName":"Criscuolo","fullName":"Kyle Criscuolo","number":"51","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":4,"plusMinus":-4,"hits":13,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":5,"blocked":3,"faceOffPct":46.34,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"08:00"},"currentTeamId":7},{"id":8476897,"firstName":"Oskar","lastName":"Sundqvist","fullName":"Oskar Sundqvist","number":"70","position":"C","stats":{"_fantasyPoints":27.85,"_fantasyPointsAverage":0.66,"points":5,"goals":1,"assists":4,"penaltyMinutes":14,"plusMinus":-5,"hits":47,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":41,"blocked":14,"faceOffPct":44.58,"gameWinningGoals":0,"games":42,"timeOnIcePerGame":"10:28"},"currentTeamId":19},{"id":8476441,"firstName":"Joel","lastName":"Edmundson","fullName":"Joel Edmundson","number":"6","position":"D","stats":{"_fantasyPoints":173.9,"_fantasyPointsAverage":2.52,"points":17,"goals":7,"assists":10,"penaltyMinutes":57,"plusMinus":-1,"hits":116,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":124,"blocked":150,"faceOffPct":0,"gameWinningGoals":0,"games":69,"timeOnIcePerGame":"20:44"},"currentTeamId":19},{"id":8478840,"firstName":"William","lastName":"Borgen","fullName":"William Borgen","number":"33","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8477995,"firstName":"Brandon","lastName":"Hickey","fullName":"Brandon Hickey","number":"44","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8480011,"firstName":"Klim","lastName":"Kostin","fullName":"Klim Kostin","number":"37","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8479252,"firstName":"Dan","lastName":"Renouf","fullName":"Dan Renouf","number":"76","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8480761,"firstName":"Mitch","lastName":"Reinke","fullName":"Mitch Reinke","number":"39","position":"D","stats":{"_fantasyPoints":1.6,"_fantasyPointsAverage":1.6,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"13:05"},"currentTeamId":19},{"id":8479335,"firstName":"Rasmus","lastName":"Asplund","fullName":"Rasmus Asplund","number":"74","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8478013,"firstName":"Jake","lastName":"Walman","fullName":"Jake Walman","number":"46","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8479249,"firstName":"Andrew","lastName":"Poturalski","fullName":"Andrew Poturalski","number":"29","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8479389,"firstName":"Cliff","lastName":"Pu","fullName":"Cliff Pu","number":"61","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8469608,"firstName":"Mike","lastName":"Smith","fullName":"Mike Smith","number":"41","position":"G","stats":{"_fantasyPoints":"208.00","_fantasyPointsAverage":"3.78","savePercentage":0.916,"goalAgainstAverage":2.65,"wins":25,"losses":22,"saves":1545,"goalsAgainst":141,"shutouts":3},"currentTeamId":20},{"id":8478440,"firstName":"Dylan","lastName":"Strome","fullName":"Dylan Strome","number":"20","position":"C","stats":{"_fantasyPoints":40.75,"_fantasyPointsAverage":1.94,"points":9,"goals":4,"assists":5,"penaltyMinutes":8,"plusMinus":4,"hits":7,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":30,"blocked":12,"faceOffPct":42.99,"gameWinningGoals":0,"games":21,"timeOnIcePerGame":"12:56"},"currentTeamId":53},{"id":8478423,"firstName":"Adam","lastName":"Musil","fullName":"Adam Musil","number":"54","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8475170,"firstName":"Brayden","lastName":"Schenn","fullName":"Brayden Schenn","number":"10","position":"C","stats":{"_fantasyPoints":281.75,"_fantasyPointsAverage":3.44,"points":70,"goals":28,"assists":42,"penaltyMinutes":56,"plusMinus":10,"hits":154,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":0,"shortHandedPoints":0,"shots":210,"blocked":37,"faceOffPct":48.03,"gameWinningGoals":8,"games":82,"timeOnIcePerGame":"19:43"},"currentTeamId":19},{"id":8474152,"firstName":"Scott","lastName":"Darling","fullName":"Scott Darling","number":"33","position":"G","stats":{"_fantasyPoints":"90.00","_fantasyPointsAverage":"2.09","savePercentage":0.888,"goalAgainstAverage":3.18,"wins":13,"losses":21,"saves":1040,"goalsAgainst":131,"shutouts":0},"currentTeamId":12},{"id":8478855,"firstName":"Devante","lastName":"Stephens","fullName":"Devante Stephens","number":"61","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8480025,"firstName":"MacKenzie","lastName":"Entwistle","fullName":"MacKenzie Entwistle","number":"58","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8478839,"firstName":"Aleksi","lastName":"Saarela","fullName":"Aleksi Saarela","number":"15","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8477981,"firstName":"Roland","lastName":"McKeown","fullName":"Roland McKeown","number":"55","position":"D","stats":{"_fantasyPoints":6.2,"_fantasyPointsAverage":0.62,"points":3,"goals":0,"assists":3,"penaltyMinutes":19,"plusMinus":3,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":7,"blocked":5,"faceOffPct":0,"gameWinningGoals":0,"games":10,"timeOnIcePerGame":"13:24"},"currentTeamId":12},{"id":8477968,"firstName":"Alex","lastName":"Nedeljkovic","fullName":"Alex Nedeljkovic","number":"35","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":12},{"id":8477887,"firstName":"Patrick","lastName":"Brown","fullName":"Patrick Brown","number":"36","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8480243,"firstName":"Brendan","lastName":"De Jong","fullName":"Brendan De Jong","number":"62","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8476882,"firstName":"Teuvo","lastName":"Teravainen","fullName":"Teuvo Teravainen","number":"86","position":"LW","stats":{"_fantasyPoints":235.5,"_fantasyPointsAverage":2.87,"points":64,"goals":23,"assists":41,"penaltyMinutes":14,"plusMinus":8,"hits":26,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":185,"blocked":22,"faceOffPct":30.61,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"16:53"},"currentTeamId":12},{"id":8478473,"firstName":"Callum","lastName":"Booth","fullName":"Callum Booth","number":"70","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":12},{"id":8478026,"firstName":"Josh","lastName":"Wesley","fullName":"Josh Wesley","number":"38","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8477357,"firstName":"Saku","lastName":"Maenalanen","fullName":"Saku Maenalanen","number":"8","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8478859,"firstName":"Niko","lastName":"Mikkola","fullName":"Niko Mikkola","number":"77","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8477998,"firstName":"Warren","lastName":"Foegele","fullName":"Warren Foegele","number":"13","position":"LW","stats":{"_fantasyPoints":15.1,"_fantasyPointsAverage":7.55,"points":3,"goals":2,"assists":1,"penaltyMinutes":0,"plusMinus":3,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"11:55"},"currentTeamId":12},{"id":8476921,"firstName":"Jordan","lastName":"Martinook","fullName":"Jordan Martinook","number":"48","position":"LW","stats":{"_fantasyPoints":75.2,"_fantasyPointsAverage":0.93,"points":15,"goals":6,"assists":9,"penaltyMinutes":45,"plusMinus":-24,"hits":128,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":112,"blocked":42,"faceOffPct":36.44,"gameWinningGoals":1,"games":81,"timeOnIcePerGame":"14:00"},"currentTeamId":12},{"id":8476923,"firstName":"Damon","lastName":"Severson","fullName":"Damon Severson","number":"28","position":"D","stats":{"_fantasyPoints":127.35,"_fantasyPointsAverage":1.68,"points":24,"goals":9,"assists":15,"penaltyMinutes":42,"plusMinus":-8,"hits":107,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":121,"blocked":62,"faceOffPct":0,"gameWinningGoals":2,"games":76,"timeOnIcePerGame":"19:40"},"currentTeamId":1},{"id":8478427,"firstName":"Sebastian","lastName":"Aho","fullName":"Sebastian Aho","number":"20","position":"RW","stats":{"_fantasyPoints":240.5,"_fantasyPointsAverage":3.08,"points":65,"goals":29,"assists":36,"penaltyMinutes":24,"plusMinus":4,"hits":65,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":0,"shortHandedPoints":0,"shots":200,"blocked":17,"faceOffPct":45.34,"gameWinningGoals":4,"games":78,"timeOnIcePerGame":"17:55"},"currentTeamId":12},{"id":8479385,"firstName":"Jordan","lastName":"Kyrou","fullName":"Jordan Kyrou","number":"72","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8475852,"firstName":"Petr","lastName":"Mrazek","fullName":"Petr Mrazek","number":"34","position":"G","stats":{"_fantasyPoints":"122.80","_fantasyPointsAverage":"3.15","savePercentage":0.902,"goalAgainstAverage":3.03,"wins":14,"losses":13,"saves":974,"goalsAgainst":106,"shutouts":4},"currentTeamId":12},{"id":8478373,"firstName":"Nikita","lastName":"Soshnikov","fullName":"Nikita Soshnikov","number":"86","position":"RW","stats":{"_fantasyPoints":11.2,"_fantasyPointsAverage":0.75,"points":2,"goals":1,"assists":1,"penaltyMinutes":4,"plusMinus":-2,"hits":24,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":17,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":15,"timeOnIcePerGame":"11:01"},"currentTeamId":19},{"id":8469501,"firstName":"Chris","lastName":"Thorburn","fullName":"Chris Thorburn","number":"22","position":"RW","stats":{"_fantasyPoints":24.75,"_fantasyPointsAverage":0.49,"points":7,"goals":1,"assists":6,"penaltyMinutes":60,"plusMinus":-4,"hits":99,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":35,"blocked":16,"faceOffPct":58.33,"gameWinningGoals":0,"games":50,"timeOnIcePerGame":"07:02"},"currentTeamId":19},{"id":8477391,"firstName":"Sean","lastName":"Malone","fullName":"Sean Malone","number":"42","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8475784,"firstName":"Jeff","lastName":"Skinner","fullName":"Jeff Skinner","number":"53","position":"C","stats":{"_fantasyPoints":161.45,"_fantasyPointsAverage":1.97,"points":49,"goals":24,"assists":25,"penaltyMinutes":34,"plusMinus":-27,"hits":35,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":277,"blocked":24,"faceOffPct":43.33,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"16:42"},"currentTeamId":7},{"id":8478049,"firstName":"Ben","lastName":"Thomas","fullName":"Ben Thomas","number":"56","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8476958,"firstName":"Jaccob","lastName":"Slavin","fullName":"Jaccob Slavin","number":"74","position":"D","stats":{"_fantasyPoints":222.65,"_fantasyPointsAverage":2.72,"points":30,"goals":8,"assists":22,"penaltyMinutes":10,"plusMinus":1,"hits":47,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":154,"blocked":154,"faceOffPct":0,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"22:35"},"currentTeamId":12},{"id":8474565,"firstName":"Alex","lastName":"Pietrangelo","fullName":"Alex Pietrangelo","number":"27","position":"D","stats":{"_fantasyPoints":313.6,"_fantasyPointsAverage":4.02,"points":54,"goals":15,"assists":39,"penaltyMinutes":22,"plusMinus":8,"hits":48,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":216,"blocked":164,"faceOffPct":0,"gameWinningGoals":5,"games":78,"timeOnIcePerGame":"25:44"},"currentTeamId":19},{"id":8477499,"firstName":"Rasmus","lastName":"Ristolainen","fullName":"Rasmus Ristolainen","number":"55","position":"D","stats":{"_fantasyPoints":223.95,"_fantasyPointsAverage":3.07,"points":41,"goals":6,"assists":35,"penaltyMinutes":48,"plusMinus":-25,"hits":206,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":182,"blocked":111,"faceOffPct":0,"gameWinningGoals":1,"games":73,"timeOnIcePerGame":"26:29"},"currentTeamId":7},{"id":8476883,"firstName":"Andrei","lastName":"Vasilevskiy","fullName":"Andrei Vasilevskiy","number":"88","position":"G","stats":{"_fantasyPoints":"298.60","_fantasyPointsAverage":"4.59","savePercentage":0.92,"goalAgainstAverage":2.62,"wins":44,"losses":17,"saves":1908,"goalsAgainst":167,"shutouts":8},"currentTeamId":14},{"id":8476434,"firstName":"John","lastName":"Gibson","fullName":"John Gibson","number":"36","position":"G","stats":{"_fantasyPoints":"258.60","_fantasyPointsAverage":"4.31","savePercentage":0.926,"goalAgainstAverage":2.43,"wins":31,"losses":18,"saves":1733,"goalsAgainst":139,"shutouts":4},"currentTeamId":24},{"id":8480209,"firstName":"Kyle","lastName":"Olson","fullName":"Kyle Olson","number":"70","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8476432,"firstName":"Boone","lastName":"Jenner","fullName":"Boone Jenner","number":"38","position":"C","stats":{"_fantasyPoints":208.2,"_fantasyPointsAverage":2.78,"points":32,"goals":13,"assists":19,"penaltyMinutes":39,"plusMinus":1,"hits":205,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":187,"blocked":83,"faceOffPct":55.48,"gameWinningGoals":2,"games":75,"timeOnIcePerGame":"16:27"},"currentTeamId":29},{"id":8476312,"firstName":"Josh","lastName":"Manson","fullName":"Josh Manson","number":"42","position":"D","stats":{"_fantasyPoints":236.95,"_fantasyPointsAverage":2.96,"points":37,"goals":7,"assists":30,"penaltyMinutes":62,"plusMinus":34,"hits":180,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":117,"blocked":99,"faceOffPct":0,"gameWinningGoals":2,"games":80,"timeOnIcePerGame":"20:21"},"currentTeamId":24},{"id":8478403,"firstName":"Jack","lastName":"Eichel","fullName":"Jack Eichel","number":"9","position":"C","stats":{"_fantasyPoints":224.85,"_fantasyPointsAverage":3.36,"points":64,"goals":25,"assists":39,"penaltyMinutes":32,"plusMinus":-25,"hits":52,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":2,"shots":246,"blocked":35,"faceOffPct":41.5,"gameWinningGoals":4,"games":67,"timeOnIcePerGame":"20:08"},"currentTeamId":7},{"id":8481018,"firstName":"Axel","lastName":"Andersson","fullName":"Axel Andersson","number":"56","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8478109,"firstName":"Victor","lastName":"Olofsson","fullName":"Victor Olofsson","number":"41","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8471677,"firstName":"Jack","lastName":"Johnson","fullName":"Jack Johnson","number":"73","position":"D","stats":{"_fantasyPoints":148.8,"_fantasyPointsAverage":1.93,"points":11,"goals":3,"assists":8,"penaltyMinutes":22,"plusMinus":-6,"hits":101,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":88,"blocked":135,"faceOffPct":0,"gameWinningGoals":1,"games":77,"timeOnIcePerGame":"19:32"},"currentTeamId":5},{"id":8476166,"firstName":"Taylor","lastName":"Fedun","fullName":"Taylor Fedun","number":"27","position":"D","stats":{"_fantasyPoints":9.8,"_fantasyPointsAverage":1.4,"points":1,"goals":0,"assists":1,"penaltyMinutes":2,"plusMinus":-1,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":8,"blocked":10,"faceOffPct":0,"gameWinningGoals":0,"games":7,"timeOnIcePerGame":"14:41"},"currentTeamId":7},{"id":8476207,"firstName":"Brian","lastName":"Gibbons","fullName":"Brian Gibbons","number":"23","position":"C","stats":{"_fantasyPoints":153.95,"_fantasyPointsAverage":2.61,"points":26,"goals":12,"assists":14,"penaltyMinutes":20,"plusMinus":10,"hits":35,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":3,"shortHandedPoints":5,"shots":72,"blocked":58,"faceOffPct":43.13,"gameWinningGoals":3,"games":59,"timeOnIcePerGame":"14:25"},"currentTeamId":24},{"id":8479377,"firstName":"Jonathan","lastName":"Ang","fullName":"Jonathan Ang","number":"82","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8474636,"firstName":"Michael","lastName":"Hutchinson","fullName":"Michael Hutchinson","number":"39","position":"G","stats":{"_fantasyPoints":"8.60","_fantasyPointsAverage":"2.87","savePercentage":0.907,"goalAgainstAverage":3.26,"wins":2,"losses":1,"saves":68,"goalsAgainst":7,"shutouts":0},"currentTeamId":13},{"id":8479399,"firstName":"Evan","lastName":"Fitzpatrick","fullName":"Evan Fitzpatrick","number":"85","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":19},{"id":8473560,"firstName":"Korbinian","lastName":"Holzer","fullName":"Korbinian Holzer","number":"5","position":"D","stats":{"_fantasyPoints":11,"_fantasyPointsAverage":0.69,"points":0,"goals":0,"assists":0,"penaltyMinutes":6,"plusMinus":-3,"hits":22,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":10,"blocked":14,"faceOffPct":0,"gameWinningGoals":0,"games":16,"timeOnIcePerGame":"11:36"},"currentTeamId":24},{"id":8476374,"firstName":"Sean","lastName":"Kuraly","fullName":"Sean Kuraly","number":"52","position":"C","stats":{"_fantasyPoints":85.15,"_fantasyPointsAverage":1.14,"points":14,"goals":6,"assists":8,"penaltyMinutes":40,"plusMinus":-5,"hits":143,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":134,"blocked":22,"faceOffPct":46.46,"gameWinningGoals":1,"games":75,"timeOnIcePerGame":"12:14"},"currentTeamId":6},{"id":8477318,"firstName":"Zachary","lastName":"Leslie","fullName":"Zachary Leslie","number":"63","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8474641,"firstName":"Adam","lastName":"Henrique","fullName":"Adam Henrique","number":"14","position":"C","stats":{"_fantasyPoints":243.1,"_fantasyPointsAverage":3,"points":50,"goals":24,"assists":26,"penaltyMinutes":20,"plusMinus":11,"hits":61,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":1,"shortHandedPoints":3,"shots":151,"blocked":61,"faceOffPct":48.15,"gameWinningGoals":8,"games":81,"timeOnIcePerGame":"17:47"},"currentTeamId":24},{"id":8475236,"firstName":"Cody","lastName":"Eakin","fullName":"Cody Eakin","number":"21","position":"C","stats":{"_fantasyPoints":132.2,"_fantasyPointsAverage":1.65,"points":27,"goals":11,"assists":16,"penaltyMinutes":22,"plusMinus":-6,"hits":63,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":3,"shots":107,"blocked":45,"faceOffPct":52.12,"gameWinningGoals":2,"games":80,"timeOnIcePerGame":"14:32"},"currentTeamId":54},{"id":8480015,"firstName":"Owen","lastName":"Tippett","fullName":"Owen Tippett","number":"74","position":"RW","stats":{"_fantasyPoints":2.95,"_fantasyPointsAverage":0.42,"points":1,"goals":1,"assists":0,"penaltyMinutes":0,"plusMinus":-6,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":17,"blocked":4,"faceOffPct":0,"gameWinningGoals":0,"games":7,"timeOnIcePerGame":"11:07"},"currentTeamId":13},{"id":8479989,"firstName":"Stelio","lastName":"Mattheos","fullName":"Stelio Mattheos","number":"51","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8477478,"firstName":"William","lastName":"Carrier","fullName":"William Carrier","number":"28","position":"LW","stats":{"_fantasyPoints":36.95,"_fantasyPointsAverage":1,"points":3,"goals":1,"assists":2,"penaltyMinutes":19,"plusMinus":-3,"hits":113,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":52,"blocked":10,"faceOffPct":0,"gameWinningGoals":0,"games":37,"timeOnIcePerGame":"08:50"},"currentTeamId":54},{"id":8477493,"firstName":"Aleksander","lastName":"Barkov","fullName":"Aleksander Barkov","number":"16","position":"C","stats":{"_fantasyPoints":333.35,"_fantasyPointsAverage":4.22,"points":78,"goals":27,"assists":51,"penaltyMinutes":14,"plusMinus":9,"hits":30,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":5,"shortHandedPoints":5,"shots":256,"blocked":67,"faceOffPct":53.5,"gameWinningGoals":3,"games":79,"timeOnIcePerGame":"22:04"},"currentTeamId":13},{"id":8473422,"firstName":"Nick","lastName":"Foligno","fullName":"Nick Foligno","number":"71","position":"LW","stats":{"_fantasyPoints":179.7,"_fantasyPointsAverage":2.5,"points":33,"goals":15,"assists":18,"penaltyMinutes":50,"plusMinus":1,"hits":182,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":137,"blocked":60,"faceOffPct":45.88,"gameWinningGoals":1,"games":72,"timeOnIcePerGame":"18:21"},"currentTeamId":29},{"id":8476951,"firstName":"Doyle","lastName":"Somerby","fullName":"Doyle Somerby","number":"33","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8480906,"firstName":"Andrew","lastName":"Oglevie","fullName":"Andrew Oglevie","number":"52","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8478394,"firstName":"Ryan","lastName":"Gropp","fullName":"Ryan Gropp","number":"78","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8476483,"firstName":"Rickard","lastName":"Rakell","fullName":"Rickard Rakell","number":"67","position":"C","stats":{"_fantasyPoints":288.75,"_fantasyPointsAverage":3.75,"points":69,"goals":34,"assists":35,"penaltyMinutes":14,"plusMinus":6,"hits":115,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":0,"shortHandedPoints":0,"shots":230,"blocked":30,"faceOffPct":46.46,"gameWinningGoals":3,"games":77,"timeOnIcePerGame":"19:25"},"currentTeamId":24},{"id":8477932,"firstName":"Aaron","lastName":"Ekblad","fullName":"Aaron Ekblad","number":"5","position":"D","stats":{"_fantasyPoints":216.9,"_fantasyPointsAverage":2.65,"points":38,"goals":16,"assists":22,"penaltyMinutes":71,"plusMinus":9,"hits":69,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":189,"blocked":121,"faceOffPct":0,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"23:23"},"currentTeamId":13},{"id":8479553,"firstName":"Maxim","lastName":"Mamin","fullName":"Maxim Mamin","number":"78","position":"C","stats":{"_fantasyPoints":33.8,"_fantasyPointsAverage":1.3,"points":4,"goals":3,"assists":1,"penaltyMinutes":7,"plusMinus":2,"hits":51,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":28,"blocked":9,"faceOffPct":0,"gameWinningGoals":1,"games":26,"timeOnIcePerGame":"10:31"},"currentTeamId":13},{"id":8477496,"firstName":"Elias","lastName":"Lindholm","fullName":"Elias Lindholm","number":"28","position":"C","stats":{"_fantasyPoints":187.55,"_fantasyPointsAverage":2.32,"points":44,"goals":16,"assists":28,"penaltyMinutes":18,"plusMinus":-8,"hits":98,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":1,"shots":153,"blocked":41,"faceOffPct":54.47,"gameWinningGoals":4,"games":81,"timeOnIcePerGame":"17:53"},"currentTeamId":20},{"id":8475755,"firstName":"Alexander","lastName":"Petrovic","fullName":"Alexander Petrovic","number":"6","position":"D","stats":{"_fantasyPoints":80.5,"_fantasyPointsAverage":1.2,"points":13,"goals":2,"assists":11,"penaltyMinutes":98,"plusMinus":-2,"hits":142,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":60,"blocked":74,"faceOffPct":0,"gameWinningGoals":1,"games":67,"timeOnIcePerGame":"14:39"},"currentTeamId":13},{"id":8480047,"firstName":"Alexei","lastName":"Lipanov","fullName":"Alexei Lipanov","number":"36","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8480186,"firstName":"Alexander","lastName":"Volkov","fullName":"Alexander Volkov","number":"79","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8479404,"firstName":"Henrik","lastName":"Borgstrom","fullName":"Henrik Borgstrom","number":"95","position":"C","stats":{"_fantasyPoints":4.1,"_fantasyPointsAverage":1.02,"points":1,"goals":1,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":1,"faceOffPct":40.54,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"12:39"},"currentTeamId":13},{"id":8477220,"firstName":"Nate","lastName":"Schmidt","fullName":"Nate Schmidt","number":"88","position":"D","stats":{"_fantasyPoints":222.8,"_fantasyPointsAverage":2.93,"points":36,"goals":5,"assists":31,"penaltyMinutes":16,"plusMinus":19,"hits":41,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":103,"blocked":121,"faceOffPct":0,"gameWinningGoals":1,"games":76,"timeOnIcePerGame":"22:14"},"currentTeamId":54},{"id":8475191,"firstName":"Reilly","lastName":"Smith","fullName":"Reilly Smith","number":"19","position":"RW","stats":{"_fantasyPoints":249.2,"_fantasyPointsAverage":3.72,"points":60,"goals":22,"assists":38,"penaltyMinutes":24,"plusMinus":31,"hits":40,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":1,"shortHandedPoints":2,"shots":162,"blocked":24,"faceOffPct":30.76,"gameWinningGoals":4,"games":67,"timeOnIcePerGame":"17:55"},"currentTeamId":54},{"id":8479718,"firstName":"Alex","lastName":"Barre-Boulet","fullName":"Alex Barre-Boulet","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8470616,"firstName":"Ryan","lastName":"Kesler","fullName":"Ryan Kesler","number":"17","position":"C","stats":{"_fantasyPoints":71.05,"_fantasyPointsAverage":1.61,"points":14,"goals":8,"assists":6,"penaltyMinutes":46,"plusMinus":-4,"hits":71,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":78,"blocked":38,"faceOffPct":53.33,"gameWinningGoals":2,"games":44,"timeOnIcePerGame":"18:02"},"currentTeamId":24},{"id":8476617,"firstName":"Tomas","lastName":"Hyka","fullName":"Tomas Hyka","number":"38","position":"RW","stats":{"_fantasyPoints":16.25,"_fantasyPointsAverage":1.63,"points":3,"goals":1,"assists":2,"penaltyMinutes":0,"plusMinus":2,"hits":6,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":15,"blocked":3,"faceOffPct":0,"gameWinningGoals":0,"games":10,"timeOnIcePerGame":"12:03"},"currentTeamId":54},{"id":8479027,"firstName":"Brandon","lastName":"Crawley","fullName":"Brandon Crawley","number":"73","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8471887,"firstName":"Patric","lastName":"Hornqvist","fullName":"Patric Hornqvist","number":"72","position":"RW","stats":{"_fantasyPoints":242.45,"_fantasyPointsAverage":3.46,"points":49,"goals":29,"assists":20,"penaltyMinutes":58,"plusMinus":2,"hits":137,"powerPlayGoals":15,"powerPlayPoints":15,"shortHandedGoals":0,"shortHandedPoints":0,"shots":247,"blocked":64,"faceOffPct":48.48,"gameWinningGoals":1,"games":70,"timeOnIcePerGame":"17:19"},"currentTeamId":5},{"id":8476971,"firstName":"Kevin","lastName":"Roy","fullName":"Kevin Roy","number":"63","position":"LW","stats":{"_fantasyPoints":34.6,"_fantasyPointsAverage":1.38,"points":7,"goals":6,"assists":1,"penaltyMinutes":6,"plusMinus":3,"hits":11,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":26,"blocked":7,"faceOffPct":0,"gameWinningGoals":1,"games":25,"timeOnIcePerGame":"13:38"},"currentTeamId":24},{"id":8476981,"firstName":"Josh","lastName":"Anderson","fullName":"Josh Anderson","number":"77","position":"RW","stats":{"_fantasyPoints":138.05,"_fantasyPointsAverage":2.19,"points":30,"goals":19,"assists":11,"penaltyMinutes":42,"plusMinus":-1,"hits":109,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":188,"blocked":24,"faceOffPct":41.93,"gameWinningGoals":5,"games":63,"timeOnIcePerGame":"18:02"},"currentTeamId":29},{"id":8477529,"firstName":"Colby","lastName":"Cave","fullName":"Colby Cave","number":"26","position":"C","stats":{"_fantasyPoints":1.45,"_fantasyPointsAverage":0.48,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":0,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":2,"faceOffPct":41.66,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"11:27"},"currentTeamId":6},{"id":8475796,"firstName":"Mark","lastName":"Pysyk","fullName":"Mark Pysyk","number":"13","position":"D","stats":{"_fantasyPoints":153.35,"_fantasyPointsAverage":1.87,"points":16,"goals":3,"assists":13,"penaltyMinutes":20,"plusMinus":-8,"hits":102,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":106,"blocked":123,"faceOffPct":0,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"18:45"},"currentTeamId":13},{"id":8475804,"firstName":"Brooks","lastName":"Macek","fullName":"Brooks Macek","number":"10","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8477509,"firstName":"Mirco","lastName":"Mueller","fullName":"Mirco Mueller","number":"25","position":"D","stats":{"_fantasyPoints":53.15,"_fantasyPointsAverage":1.9,"points":4,"goals":0,"assists":4,"penaltyMinutes":4,"plusMinus":1,"hits":15,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":2,"shots":19,"blocked":42,"faceOffPct":0,"gameWinningGoals":0,"games":28,"timeOnIcePerGame":"16:40"},"currentTeamId":1},{"id":8471817,"firstName":"Ryan","lastName":"Reaves","fullName":"Ryan Reaves","number":"75","position":"RW","stats":{"_fantasyPoints":58.45,"_fantasyPointsAverage":0.74,"points":10,"goals":4,"assists":6,"penaltyMinutes":94,"plusMinus":-7,"hits":236,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":42,"blocked":27,"faceOffPct":50,"gameWinningGoals":1,"games":79,"timeOnIcePerGame":"07:35"},"currentTeamId":54},{"id":8477955,"firstName":"Jared","lastName":"McCann","fullName":"Jared McCann","number":"90","position":"C","stats":{"_fantasyPoints":128.05,"_fantasyPointsAverage":1.88,"points":28,"goals":9,"assists":19,"penaltyMinutes":30,"plusMinus":11,"hits":43,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":143,"blocked":32,"faceOffPct":38.54,"gameWinningGoals":4,"games":68,"timeOnIcePerGame":"13:15"},"currentTeamId":13},{"id":8476779,"firstName":"Brad","lastName":"Hunt","fullName":"Brad Hunt","number":"77","position":"D","stats":{"_fantasyPoints":85.75,"_fantasyPointsAverage":1.91,"points":18,"goals":3,"assists":15,"penaltyMinutes":6,"plusMinus":-5,"hits":19,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":80,"blocked":36,"faceOffPct":0,"gameWinningGoals":0,"games":45,"timeOnIcePerGame":"16:38"},"currentTeamId":54},{"id":8479574,"firstName":"Mikhail","lastName":"Berdin","fullName":"Mikhail Berdin","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":52},{"id":8476448,"firstName":"William","lastName":"Karlsson","fullName":"William Karlsson","number":"71","position":"C","stats":{"_fantasyPoints":370.65,"_fantasyPointsAverage":4.52,"points":78,"goals":43,"assists":35,"penaltyMinutes":12,"plusMinus":49,"hits":48,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":4,"shortHandedPoints":5,"shots":184,"blocked":45,"faceOffPct":48.02,"gameWinningGoals":6,"games":82,"timeOnIcePerGame":"18:43"},"currentTeamId":54},{"id":8477452,"firstName":"Ian","lastName":"McCoshen","fullName":"Ian McCoshen","number":"12","position":"D","stats":{"_fantasyPoints":43.1,"_fantasyPointsAverage":1.13,"points":4,"goals":3,"assists":1,"penaltyMinutes":25,"plusMinus":-10,"hits":71,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":26,"blocked":43,"faceOffPct":0,"gameWinningGoals":1,"games":38,"timeOnIcePerGame":"15:04"},"currentTeamId":13},{"id":8477416,"firstName":"Oliver","lastName":"Bjorkstrand","fullName":"Oliver Bjorkstrand","number":"28","position":"RW","stats":{"_fantasyPoints":179.55,"_fantasyPointsAverage":2.19,"points":40,"goals":11,"assists":29,"penaltyMinutes":9,"plusMinus":4,"hits":64,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":163,"blocked":43,"faceOffPct":12.5,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"14:17"},"currentTeamId":29},{"id":8471724,"firstName":"Kris","lastName":"Letang","fullName":"Kris Letang","number":"58","position":"D","stats":{"_fantasyPoints":243.45,"_fantasyPointsAverage":3.08,"points":51,"goals":9,"assists":42,"penaltyMinutes":56,"plusMinus":-9,"hits":109,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":1,"shots":222,"blocked":108,"faceOffPct":0,"gameWinningGoals":1,"games":79,"timeOnIcePerGame":"25:19"},"currentTeamId":5},{"id":8475224,"firstName":"Jordan","lastName":"Szwarz","fullName":"Jordan Szwarz","number":"21","position":"RW","stats":{"_fantasyPoints":13.15,"_fantasyPointsAverage":1.1,"points":3,"goals":0,"assists":3,"penaltyMinutes":2,"plusMinus":-4,"hits":9,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":19,"blocked":8,"faceOffPct":40,"gameWinningGoals":0,"games":12,"timeOnIcePerGame":"11:30"},"currentTeamId":6},{"id":8470860,"firstName":"Jaroslav","lastName":"Halak","fullName":"Jaroslav Halak","number":"41","position":"G","stats":{"_fantasyPoints":"180.60","_fantasyPointsAverage":"3.34","savePercentage":0.908,"goalAgainstAverage":3.19,"wins":20,"losses":26,"saves":1583,"goalsAgainst":161,"shutouts":1},"currentTeamId":6},{"id":8476994,"firstName":"Vinnie","lastName":"Hinostroza","fullName":"Vinnie Hinostroza","number":"13","position":"C","stats":{"_fantasyPoints":99.85,"_fantasyPointsAverage":2,"points":25,"goals":7,"assists":18,"penaltyMinutes":10,"plusMinus":5,"hits":26,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":86,"blocked":17,"faceOffPct":43.82,"gameWinningGoals":1,"games":50,"timeOnIcePerGame":"13:49"},"currentTeamId":53},{"id":8478448,"firstName":"Chaz","lastName":"Reddekopp","fullName":"Chaz Reddekopp","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8475842,"firstName":"Sam","lastName":"Carrick","fullName":"Sam Carrick","number":"56","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8474884,"firstName":"Mike","lastName":"Hoffman","fullName":"Mike Hoffman","number":"68","position":"LW","stats":{"_fantasyPoints":195.45,"_fantasyPointsAverage":2.38,"points":56,"goals":22,"assists":34,"penaltyMinutes":32,"plusMinus":-20,"hits":31,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":0,"shortHandedPoints":0,"shots":257,"blocked":34,"faceOffPct":55,"gameWinningGoals":5,"games":82,"timeOnIcePerGame":"18:24"},"currentTeamId":13},{"id":8474149,"firstName":"Evgenii","lastName":"Dadonov","fullName":"Evgenii Dadonov","number":"63","position":"RW","stats":{"_fantasyPoints":253.3,"_fantasyPointsAverage":3.42,"points":65,"goals":28,"assists":37,"penaltyMinutes":8,"plusMinus":10,"hits":27,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":188,"blocked":33,"faceOffPct":0,"gameWinningGoals":6,"games":74,"timeOnIcePerGame":"18:41"},"currentTeamId":13},{"id":8478010,"firstName":"Brayden","lastName":"Point","fullName":"Brayden Point","number":"21","position":"C","stats":{"_fantasyPoints":296.95,"_fantasyPointsAverage":3.62,"points":66,"goals":32,"assists":34,"penaltyMinutes":24,"plusMinus":18,"hits":26,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":3,"shortHandedPoints":5,"shots":217,"blocked":57,"faceOffPct":47.44,"gameWinningGoals":12,"games":82,"timeOnIcePerGame":"19:37"},"currentTeamId":14},{"id":8476456,"firstName":"Jonathan","lastName":"Huberdeau","fullName":"Jonathan Huberdeau","number":"11","position":"LW","stats":{"_fantasyPoints":253.15,"_fantasyPointsAverage":3.09,"points":69,"goals":27,"assists":42,"penaltyMinutes":32,"plusMinus":-2,"hits":41,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":204,"blocked":42,"faceOffPct":47.72,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"19:12"},"currentTeamId":13},{"id":8478058,"firstName":"CJ","lastName":"Suess","fullName":"CJ Suess","number":"73","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":52},{"id":8476885,"firstName":"Jacob","lastName":"Trouba","fullName":"Jacob Trouba","number":"8","position":"D","stats":{"_fantasyPoints":170.4,"_fantasyPointsAverage":3.1,"points":24,"goals":3,"assists":21,"penaltyMinutes":34,"plusMinus":9,"hits":84,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":144,"blocked":100,"faceOffPct":0,"gameWinningGoals":2,"games":55,"timeOnIcePerGame":"21:53"},"currentTeamId":52},{"id":8476346,"firstName":"Johnny","lastName":"Gaudreau","fullName":"Johnny Gaudreau","number":"13","position":"LW","stats":{"_fantasyPoints":275.2,"_fantasyPointsAverage":3.44,"points":84,"goals":24,"assists":60,"penaltyMinutes":26,"plusMinus":2,"hits":16,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":227,"blocked":18,"faceOffPct":20,"gameWinningGoals":4,"games":80,"timeOnIcePerGame":"19:25"},"currentTeamId":20},{"id":8477424,"firstName":"Juuse","lastName":"Saros","fullName":"Juuse Saros","number":"74","position":"G","stats":{"_fantasyPoints":"114.80","_fantasyPointsAverage":"4.42","savePercentage":0.925,"goalAgainstAverage":2.44,"wins":11,"losses":5,"saves":749,"goalsAgainst":61,"shutouts":3},"currentTeamId":18},{"id":8477497,"firstName":"Sean","lastName":"Monahan","fullName":"Sean Monahan","number":"23","position":"C","stats":{"_fantasyPoints":233.2,"_fantasyPointsAverage":3.15,"points":64,"goals":31,"assists":33,"penaltyMinutes":24,"plusMinus":3,"hits":35,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":202,"blocked":17,"faceOffPct":50.39,"gameWinningGoals":11,"games":74,"timeOnIcePerGame":"18:40"},"currentTeamId":20},{"id":8479616,"firstName":"Maxime","lastName":"Fortier","fullName":"Maxime Fortier","number":"36","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8480074,"firstName":"Alexandre","lastName":"Texier","fullName":"Alexandre Texier","number":"42","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8476471,"firstName":"Mark","lastName":"McNeill","fullName":"Mark McNeill","number":"62","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8479348,"firstName":"Kale","lastName":"Clague","fullName":"Kale Clague","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8478398,"firstName":"Kyle","lastName":"Connor","fullName":"Kyle Connor","number":"81","position":"LW","stats":{"_fantasyPoints":222.2,"_fantasyPointsAverage":2.92,"points":57,"goals":31,"assists":26,"penaltyMinutes":16,"plusMinus":8,"hits":18,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":192,"blocked":26,"faceOffPct":28.57,"gameWinningGoals":7,"games":76,"timeOnIcePerGame":"16:54"},"currentTeamId":52},{"id":8471695,"firstName":"Tuukka","lastName":"Rask","fullName":"Tuukka Rask","number":"40","position":"G","stats":{"_fantasyPoints":"201.60","_fantasyPointsAverage":"3.73","savePercentage":0.917,"goalAgainstAverage":2.36,"wins":34,"losses":14,"saves":1388,"goalsAgainst":125,"shutouts":3},"currentTeamId":6},{"id":8477851,"firstName":"Jordan","lastName":"Oesterle","fullName":"Jordan Oesterle","number":"82","position":"D","stats":{"_fantasyPoints":127.15,"_fantasyPointsAverage":2.31,"points":15,"goals":5,"assists":10,"penaltyMinutes":8,"plusMinus":-11,"hits":62,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":99,"blocked":97,"faceOffPct":0,"gameWinningGoals":0,"games":55,"timeOnIcePerGame":"20:30"},"currentTeamId":53},{"id":8480776,"firstName":"Sheldon","lastName":"Rempal","fullName":"Sheldon Rempal","number":"41","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8480467,"firstName":"Austin","lastName":"Strand","fullName":"Austin Strand","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8476440,"firstName":"Markus","lastName":"Granlund","fullName":"Markus Granlund","number":"60","position":"C","stats":{"_fantasyPoints":62.55,"_fantasyPointsAverage":1.18,"points":12,"goals":8,"assists":4,"penaltyMinutes":8,"plusMinus":-10,"hits":47,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":2,"shortHandedPoints":2,"shots":93,"blocked":12,"faceOffPct":40.78,"gameWinningGoals":1,"games":53,"timeOnIcePerGame":"16:15"},"currentTeamId":23},{"id":8478517,"firstName":"Simon","lastName":"Bourque","fullName":"Simon Bourque","number":"60","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":52},{"id":8475868,"firstName":"Anthony","lastName":"Bitetto","fullName":"Anthony Bitetto","number":"2","position":"D","stats":{"_fantasyPoints":29.75,"_fantasyPointsAverage":0.93,"points":3,"goals":1,"assists":2,"penaltyMinutes":27,"plusMinus":-1,"hits":40,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":25,"blocked":31,"faceOffPct":0,"gameWinningGoals":1,"games":32,"timeOnIcePerGame":"13:26"},"currentTeamId":18},{"id":8477508,"firstName":"Curtis","lastName":"Lazar","fullName":"Curtis Lazar","number":"20","position":"C","stats":{"_fantasyPoints":71,"_fantasyPointsAverage":1.09,"points":12,"goals":2,"assists":10,"penaltyMinutes":23,"plusMinus":-8,"hits":130,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":65,"blocked":26,"faceOffPct":39.66,"gameWinningGoals":1,"games":65,"timeOnIcePerGame":"09:51"},"currentTeamId":20},{"id":8478409,"firstName":"Anthony","lastName":"Richard","fullName":"Anthony Richard","number":"90","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8475736,"firstName":"Connor","lastName":"Brickley","fullName":"Connor Brickley","number":"56","position":"LW","stats":{"_fantasyPoints":66.2,"_fantasyPointsAverage":1.5,"points":12,"goals":4,"assists":8,"penaltyMinutes":19,"plusMinus":-6,"hits":82,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":62,"blocked":28,"faceOffPct":18.75,"gameWinningGoals":2,"games":44,"timeOnIcePerGame":"11:53"},"currentTeamId":18},{"id":8478528,"firstName":"Tanner","lastName":"Kero","fullName":"Tanner Kero","number":"17","position":"C","stats":{"_fantasyPoints":16.2,"_fantasyPointsAverage":2.02,"points":3,"goals":1,"assists":2,"penaltyMinutes":0,"plusMinus":1,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":7,"blocked":7,"faceOffPct":46.05,"gameWinningGoals":0,"games":8,"timeOnIcePerGame":"11:26"},"currentTeamId":23},{"id":8473533,"firstName":"Jordan","lastName":"Staal","fullName":"Jordan Staal","number":"11","position":"C","stats":{"_fantasyPoints":215.25,"_fantasyPointsAverage":2.72,"points":46,"goals":19,"assists":27,"penaltyMinutes":26,"plusMinus":-4,"hits":181,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":2,"shortHandedPoints":2,"shots":160,"blocked":32,"faceOffPct":56.57,"gameWinningGoals":2,"games":79,"timeOnIcePerGame":"19:15"},"currentTeamId":12},{"id":8479994,"firstName":"Jaret","lastName":"Anderson-Dolan","fullName":"Jaret Anderson-Dolan","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8479661,"firstName":"Tanner","lastName":"Jeannot","fullName":"Tanner Jeannot","number":"84","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8477085,"firstName":"Ashton","lastName":"Sautner","fullName":"Ashton Sautner","number":"59","position":"D","stats":{"_fantasyPoints":14.3,"_fantasyPointsAverage":2.86,"points":2,"goals":0,"assists":2,"penaltyMinutes":2,"plusMinus":4,"hits":9,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":3,"blocked":5,"faceOffPct":0,"gameWinningGoals":0,"games":5,"timeOnIcePerGame":"13:21"},"currentTeamId":23},{"id":8477458,"firstName":"Valentin","lastName":"Zykov","fullName":"Valentin Zykov","number":"73","position":"LW","stats":{"_fantasyPoints":26.8,"_fantasyPointsAverage":2.68,"points":7,"goals":3,"assists":4,"penaltyMinutes":2,"plusMinus":4,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":18,"blocked":1,"faceOffPct":0,"gameWinningGoals":1,"games":10,"timeOnIcePerGame":"13:42"},"currentTeamId":12},{"id":8474131,"firstName":"Mario","lastName":"Kempe","fullName":"Mario Kempe","number":"29","position":"RW","stats":{"_fantasyPoints":24.25,"_fantasyPointsAverage":1.35,"points":4,"goals":2,"assists":2,"penaltyMinutes":4,"plusMinus":-1,"hits":20,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":20,"blocked":11,"faceOffPct":38.57,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"11:05"},"currentTeamId":53},{"id":8477903,"firstName":"Garnet","lastName":"Hathaway","fullName":"Garnet Hathaway","number":"21","position":"RW","stats":{"_fantasyPoints":68.3,"_fantasyPointsAverage":1.16,"points":13,"goals":4,"assists":9,"penaltyMinutes":88,"plusMinus":3,"hits":154,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":68,"blocked":32,"faceOffPct":10,"gameWinningGoals":0,"games":59,"timeOnIcePerGame":"11:31"},"currentTeamId":20},{"id":8479644,"firstName":"Matt","lastName":"Luff","fullName":"Matt Luff","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8479421,"firstName":"Jacob","lastName":"Moverare","fullName":"Jacob Moverare","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8476525,"firstName":"Colin","lastName":"Miller","fullName":"Colin Miller","number":"6","position":"D","stats":{"_fantasyPoints":200.95,"_fantasyPointsAverage":2.45,"points":41,"goals":10,"assists":31,"penaltyMinutes":53,"plusMinus":-4,"hits":165,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":1,"shots":177,"blocked":64,"faceOffPct":100,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"19:20"},"currentTeamId":54},{"id":8477407,"firstName":"Anthony","lastName":"Duclair","fullName":"Anthony Duclair","number":"91","position":"LW","stats":{"_fantasyPoints":97.7,"_fantasyPointsAverage":1.74,"points":23,"goals":11,"assists":12,"penaltyMinutes":16,"plusMinus":-5,"hits":46,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":97,"blocked":26,"faceOffPct":50,"gameWinningGoals":2,"games":56,"timeOnIcePerGame":"13:17"},"currentTeamId":29},{"id":8476437,"firstName":"Victor","lastName":"Rask","fullName":"Victor Rask","number":"49","position":"C","stats":{"_fantasyPoints":140.85,"_fantasyPointsAverage":1.98,"points":31,"goals":14,"assists":17,"penaltyMinutes":12,"plusMinus":0,"hits":62,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":126,"blocked":29,"faceOffPct":54.88,"gameWinningGoals":3,"games":71,"timeOnIcePerGame":"15:22"},"currentTeamId":12},{"id":8476418,"firstName":"Robbie","lastName":"Russo","fullName":"Robbie Russo","number":"18","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":53},{"id":8478455,"firstName":"Austin","lastName":"Wagner","fullName":"Austin Wagner","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8480012,"firstName":"Elias","lastName":"Pettersson","fullName":"Elias Pettersson","number":"40","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8475790,"firstName":"Erik","lastName":"Gudbranson","fullName":"Erik Gudbranson","number":"44","position":"D","stats":{"_fantasyPoints":87.55,"_fantasyPointsAverage":1.68,"points":5,"goals":2,"assists":3,"penaltyMinutes":35,"plusMinus":-7,"hits":126,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":53,"blocked":81,"faceOffPct":0,"gameWinningGoals":0,"games":52,"timeOnIcePerGame":"18:25"},"currentTeamId":23},{"id":8475690,"firstName":"Christopher","lastName":"Tanev","fullName":"Christopher Tanev","number":"8","position":"D","stats":{"_fantasyPoints":100.35,"_fantasyPointsAverage":2.39,"points":11,"goals":2,"assists":9,"penaltyMinutes":8,"plusMinus":7,"hits":21,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":2,"shots":31,"blocked":70,"faceOffPct":0,"gameWinningGoals":0,"games":42,"timeOnIcePerGame":"19:46"},"currentTeamId":23},{"id":8476914,"firstName":"Joonas","lastName":"Korpisalo","fullName":"Joonas Korpisalo","number":"70","position":"G","stats":{"_fantasyPoints":"51.20","_fantasyPointsAverage":"2.84","savePercentage":0.897,"goalAgainstAverage":3.32,"wins":8,"losses":8,"saves":506,"goalsAgainst":58,"shutouts":0},"currentTeamId":29},{"id":8479355,"firstName":"Olli","lastName":"Juolevi","fullName":"Olli Juolevi","number":"48","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8474291,"firstName":"Jay","lastName":"Beagle","fullName":"Jay Beagle","number":"83","position":"C","stats":{"_fantasyPoints":117.25,"_fantasyPointsAverage":1.48,"points":22,"goals":7,"assists":15,"penaltyMinutes":16,"plusMinus":3,"hits":69,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":65,"blocked":44,"faceOffPct":58.51,"gameWinningGoals":2,"games":79,"timeOnIcePerGame":"12:26"},"currentTeamId":23},{"id":8479558,"firstName":"Stepan","lastName":"Falkovsky","fullName":"Stepan Falkovsky","number":"80","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":26},{"id":8475176,"firstName":"Ryan","lastName":"Ellis","fullName":"Ryan Ellis","number":"4","position":"D","stats":{"_fantasyPoints":205.75,"_fantasyPointsAverage":4.68,"points":32,"goals":9,"assists":23,"penaltyMinutes":6,"plusMinus":26,"hits":27,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":3,"shots":110,"blocked":84,"faceOffPct":0,"gameWinningGoals":2,"games":44,"timeOnIcePerGame":"23:21"},"currentTeamId":18},{"id":8474593,"firstName":"Jacob","lastName":"Markstrom","fullName":"Jacob Markstrom","number":"25","position":"G","stats":{"_fantasyPoints":"197.20","_fantasyPointsAverage":"3.29","savePercentage":0.912,"goalAgainstAverage":2.71,"wins":23,"losses":26,"saves":1591,"goalsAgainst":154,"shutouts":2},"currentTeamId":23},{"id":8475714,"firstName":"Calle","lastName":"Jarnkrok","fullName":"Calle Jarnkrok","number":"19","position":"C","stats":{"_fantasyPoints":169.25,"_fantasyPointsAverage":2.49,"points":35,"goals":16,"assists":19,"penaltyMinutes":12,"plusMinus":20,"hits":36,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":2,"shortHandedPoints":2,"shots":105,"blocked":31,"faceOffPct":51.25,"gameWinningGoals":3,"games":68,"timeOnIcePerGame":"15:53"},"currentTeamId":18},{"id":8474024,"firstName":"Jim","lastName":"O'Brien","fullName":"Jim O'Brien","number":"40","position":"C","stats":{"_fantasyPoints":8.85,"_fantasyPointsAverage":0.89,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":-1,"hits":10,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":11,"blocked":5,"faceOffPct":42.18,"gameWinningGoals":0,"games":10,"timeOnIcePerGame":"08:45"},"currentTeamId":9},{"id":8480922,"firstName":"Michael","lastName":"Lindqvist","fullName":"Michael Lindqvist","number":"34","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8480436,"firstName":"Cole","lastName":"Kehler","fullName":"Cole Kehler","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":26},{"id":8476854,"firstName":"Hampus","lastName":"Lindholm","fullName":"Hampus Lindholm","number":"47","position":"D","stats":{"_fantasyPoints":202.6,"_fantasyPointsAverage":2.94,"points":31,"goals":13,"assists":18,"penaltyMinutes":34,"plusMinus":16,"hits":93,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":131,"blocked":97,"faceOffPct":0,"gameWinningGoals":3,"games":69,"timeOnIcePerGame":"22:44"},"currentTeamId":24},{"id":8477845,"firstName":"Trevor","lastName":"van Riemsdyk","fullName":"Trevor van Riemsdyk","number":"57","position":"D","stats":{"_fantasyPoints":144.1,"_fantasyPointsAverage":1.82,"points":16,"goals":3,"assists":13,"penaltyMinutes":20,"plusMinus":9,"hits":25,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":111,"blocked":113,"faceOffPct":0,"gameWinningGoals":1,"games":79,"timeOnIcePerGame":"17:03"},"currentTeamId":12},{"id":8477353,"firstName":"Tyler","lastName":"Motte","fullName":"Tyler Motte","number":"64","position":"C","stats":{"_fantasyPoints":65.4,"_fantasyPointsAverage":1.42,"points":7,"goals":5,"assists":2,"penaltyMinutes":6,"plusMinus":-4,"hits":93,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":64,"blocked":27,"faceOffPct":27.27,"gameWinningGoals":0,"games":46,"timeOnIcePerGame":"11:13"},"currentTeamId":23},{"id":8470621,"firstName":"Corey","lastName":"Perry","fullName":"Corey Perry","number":"10","position":"RW","stats":{"_fantasyPoints":164.05,"_fantasyPointsAverage":2.31,"points":49,"goals":17,"assists":32,"penaltyMinutes":71,"plusMinus":-4,"hits":59,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":168,"blocked":36,"faceOffPct":12.5,"gameWinningGoals":1,"games":71,"timeOnIcePerGame":"17:46"},"currentTeamId":24},{"id":8475622,"firstName":"Carter","lastName":"Hutton","fullName":"Carter Hutton","number":"40","position":"G","stats":{"_fantasyPoints":"126.80","_fantasyPointsAverage":"3.96","savePercentage":0.931,"goalAgainstAverage":2.09,"wins":17,"losses":7,"saves":754,"goalsAgainst":56,"shutouts":3},"currentTeamId":7},{"id":8479532,"firstName":"Jeremy","lastName":"Helvig","fullName":"Jeremy Helvig","number":"50","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":12},{"id":8480072,"firstName":"Lias","lastName":"Andersson","fullName":"Lias Andersson","number":"50","position":"C","stats":{"_fantasyPoints":12,"_fantasyPointsAverage":1.71,"points":2,"goals":1,"assists":1,"penaltyMinutes":0,"plusMinus":1,"hits":9,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":5,"blocked":3,"faceOffPct":40.42,"gameWinningGoals":0,"games":7,"timeOnIcePerGame":"11:56"},"currentTeamId":3},{"id":8476875,"firstName":"Mike","lastName":"Matheson","fullName":"Mike Matheson","number":"19","position":"D","stats":{"_fantasyPoints":184.2,"_fantasyPointsAverage":2.27,"points":27,"goals":10,"assists":17,"penaltyMinutes":61,"plusMinus":-1,"hits":53,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":167,"blocked":137,"faceOffPct":0,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"21:20"},"currentTeamId":13},{"id":8474062,"firstName":"Riley","lastName":"Nash","fullName":"Riley Nash","number":"20","position":"C","stats":{"_fantasyPoints":209.05,"_fantasyPointsAverage":2.75,"points":41,"goals":15,"assists":26,"penaltyMinutes":18,"plusMinus":16,"hits":86,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":113,"blocked":67,"faceOffPct":48.36,"gameWinningGoals":1,"games":76,"timeOnIcePerGame":"15:24"},"currentTeamId":29},{"id":8476391,"firstName":"TJ","lastName":"Tynan","fullName":"TJ Tynan","number":"68","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8473465,"firstName":"Jamie","lastName":"McGinn","fullName":"Jamie McGinn","number":"88","position":"LW","stats":{"_fantasyPoints":125.1,"_fantasyPointsAverage":1.65,"points":29,"goals":13,"assists":16,"penaltyMinutes":33,"plusMinus":-5,"hits":120,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":116,"blocked":22,"faceOffPct":26.92,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"13:27"},"currentTeamId":13},{"id":8471426,"firstName":"Troy","lastName":"Brouwer","fullName":"Troy Brouwer","number":"22","position":"RW","stats":{"_fantasyPoints":104.15,"_fantasyPointsAverage":1.37,"points":22,"goals":6,"assists":16,"penaltyMinutes":53,"plusMinus":-7,"hits":125,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":79,"blocked":42,"faceOffPct":46.54,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"13:55"},"currentTeamId":13},{"id":8476945,"firstName":"Connor","lastName":"Hellebuyck","fullName":"Connor Hellebuyck","number":"37","position":"G","stats":{"_fantasyPoints":"296.40","_fantasyPointsAverage":"4.42","savePercentage":0.924,"goalAgainstAverage":2.36,"wins":44,"losses":11,"saves":1892,"goalsAgainst":156,"shutouts":6},"currentTeamId":52},{"id":8476870,"firstName":"Stefan","lastName":"Matteau","fullName":"Stefan Matteau","number":"25","position":"C","stats":{"_fantasyPoints":6.05,"_fantasyPointsAverage":0.76,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":0,"hits":8,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":8,"blocked":1,"faceOffPct":50,"gameWinningGoals":0,"games":8,"timeOnIcePerGame":"08:12"},"currentTeamId":54},{"id":8480113,"firstName":"Alex","lastName":"Iafallo","fullName":"Alex Iafallo","number":"19","position":"LW","stats":{"_fantasyPoints":127.4,"_fantasyPointsAverage":1.7,"points":25,"goals":9,"assists":16,"penaltyMinutes":12,"plusMinus":10,"hits":53,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":129,"blocked":33,"faceOffPct":46.66,"gameWinningGoals":1,"games":75,"timeOnIcePerGame":"15:06"},"currentTeamId":26},{"id":8471698,"firstName":"T.J.","lastName":"Oshie","fullName":"T.J. Oshie","number":"77","position":"RW","stats":{"_fantasyPoints":215.2,"_fantasyPointsAverage":2.91,"points":47,"goals":18,"assists":29,"penaltyMinutes":31,"plusMinus":2,"hits":124,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":127,"blocked":54,"faceOffPct":47.86,"gameWinningGoals":3,"games":74,"timeOnIcePerGame":"18:24"},"currentTeamId":15},{"id":8471675,"firstName":"Sidney","lastName":"Crosby","fullName":"Sidney Crosby","number":"87","position":"C","stats":{"_fantasyPoints":317.95,"_fantasyPointsAverage":3.88,"points":89,"goals":29,"assists":60,"penaltyMinutes":46,"plusMinus":0,"hits":75,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":247,"blocked":36,"faceOffPct":53.02,"gameWinningGoals":6,"games":82,"timeOnIcePerGame":"20:41"},"currentTeamId":5},{"id":8478874,"firstName":"Adam","lastName":"Gaudette","fullName":"Adam Gaudette","number":"88","position":"C","stats":{"_fantasyPoints":5.65,"_fantasyPointsAverage":1.13,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":2,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":9,"blocked":3,"faceOffPct":37.5,"gameWinningGoals":0,"games":5,"timeOnIcePerGame":"12:47"},"currentTeamId":23},{"id":8474098,"firstName":"Colton","lastName":"Sceviour","fullName":"Colton Sceviour","number":"7","position":"C","stats":{"_fantasyPoints":162.35,"_fantasyPointsAverage":2.14,"points":24,"goals":11,"assists":13,"penaltyMinutes":24,"plusMinus":6,"hits":84,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":3,"shots":141,"blocked":69,"faceOffPct":48.73,"gameWinningGoals":2,"games":76,"timeOnIcePerGame":"13:26"},"currentTeamId":13},{"id":8477974,"firstName":"Ryan","lastName":"MacInnis","fullName":"Ryan MacInnis","number":"46","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8480247,"firstName":"Jonathan","lastName":"Davidsson","fullName":"Jonathan Davidsson","number":"32","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8478008,"firstName":"Blake","lastName":"Siebenaler","fullName":"Blake Siebenaler","number":"44","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8480762,"firstName":"Eric","lastName":"Robinson","fullName":"Eric Robinson","number":"50","position":"LW","stats":{"_fantasyPoints":1.2,"_fantasyPointsAverage":1.2,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":1,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"11:21"},"currentTeamId":29},{"id":8470834,"firstName":"Dustin","lastName":"Byfuglien","fullName":"Dustin Byfuglien","number":"33","position":"D","stats":{"_fantasyPoints":225.05,"_fantasyPointsAverage":3.26,"points":45,"goals":8,"assists":37,"penaltyMinutes":112,"plusMinus":15,"hits":147,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":1,"shots":193,"blocked":100,"faceOffPct":0,"gameWinningGoals":1,"games":69,"timeOnIcePerGame":"24:20"},"currentTeamId":52},{"id":8478567,"firstName":"Dean","lastName":"Kukan","fullName":"Dean Kukan","number":"14","position":"D","stats":{"_fantasyPoints":20.2,"_fantasyPointsAverage":1.84,"points":4,"goals":0,"assists":4,"penaltyMinutes":2,"plusMinus":2,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":12,"blocked":10,"faceOffPct":0,"gameWinningGoals":0,"games":11,"timeOnIcePerGame":"12:21"},"currentTeamId":29},{"id":8475760,"firstName":"Nick","lastName":"Bjugstad","fullName":"Nick Bjugstad","number":"27","position":"C","stats":{"_fantasyPoints":190.5,"_fantasyPointsAverage":2.32,"points":49,"goals":19,"assists":30,"penaltyMinutes":41,"plusMinus":5,"hits":95,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":230,"blocked":19,"faceOffPct":51,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"15:07"},"currentTeamId":13},{"id":8478541,"firstName":"Markus","lastName":"Hannikainen","fullName":"Markus Hannikainen","number":"37","position":"LW","stats":{"_fantasyPoints":39.6,"_fantasyPointsAverage":1.2,"points":6,"goals":3,"assists":3,"penaltyMinutes":6,"plusMinus":-1,"hits":31,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":31,"blocked":15,"faceOffPct":75,"gameWinningGoals":0,"games":33,"timeOnIcePerGame":"08:22"},"currentTeamId":29},{"id":8471804,"firstName":"Nathan","lastName":"Gerbe","fullName":"Nathan Gerbe","number":"24","position":"C","stats":{"_fantasyPoints":0.1,"_fantasyPointsAverage":0.05,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"08:36"},"currentTeamId":29},{"id":8479411,"firstName":"Vitaly","lastName":"Abramov","fullName":"Vitaly Abramov","number":"43","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8476874,"firstName":"Olli","lastName":"Maatta","fullName":"Olli Maatta","number":"3","position":"D","stats":{"_fantasyPoints":203.9,"_fantasyPointsAverage":2.49,"points":29,"goals":7,"assists":22,"penaltyMinutes":28,"plusMinus":-1,"hits":131,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":164,"blocked":115,"faceOffPct":0,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"18:45"},"currentTeamId":5},{"id":8480945,"firstName":"Juuso","lastName":"Riikola","fullName":"Juuso Riikola","number":"50","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8476899,"firstName":"Matt","lastName":"Murray","fullName":"Matt Murray","number":"30","position":"G","stats":{"_fantasyPoints":"157.00","_fantasyPointsAverage":"3.20","savePercentage":0.907,"goalAgainstAverage":2.92,"wins":27,"losses":16,"saves":1290,"goalsAgainst":133,"shutouts":1},"currentTeamId":5},{"id":8476974,"firstName":"Thomas","lastName":"Di Pauli","fullName":"Thomas Di Pauli","number":"54","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8478069,"firstName":"Daniel","lastName":"Walcott","fullName":"Daniel Walcott","number":"75","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8468001,"firstName":"Derek","lastName":"MacKenzie","fullName":"Derek MacKenzie","number":"17","position":"C","stats":{"_fantasyPoints":100.85,"_fantasyPointsAverage":1.34,"points":14,"goals":3,"assists":11,"penaltyMinutes":31,"plusMinus":-9,"hits":124,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":4,"shots":86,"blocked":45,"faceOffPct":52.06,"gameWinningGoals":0,"games":75,"timeOnIcePerGame":"11:18"},"currentTeamId":13},{"id":8475234,"firstName":"J-F","lastName":"Berube","fullName":"J-F Berube","number":"35","position":"G","stats":{"_fantasyPoints":"32.20","_fantasyPointsAverage":"2.48","savePercentage":0.894,"goalAgainstAverage":3.78,"wins":3,"losses":6,"saves":356,"goalsAgainst":42,"shutouts":0},"currentTeamId":29},{"id":8477495,"firstName":"Seth","lastName":"Jones","fullName":"Seth Jones","number":"3","position":"D","stats":{"_fantasyPoints":306.4,"_fantasyPointsAverage":3.93,"points":57,"goals":16,"assists":41,"penaltyMinutes":30,"plusMinus":10,"hits":92,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":249,"blocked":124,"faceOffPct":0,"gameWinningGoals":4,"games":78,"timeOnIcePerGame":"24:36"},"currentTeamId":29},{"id":8474715,"firstName":"Cam","lastName":"Atkinson","fullName":"Cam Atkinson","number":"13","position":"RW","stats":{"_fantasyPoints":212.35,"_fantasyPointsAverage":3.27,"points":46,"goals":24,"assists":22,"penaltyMinutes":14,"plusMinus":19,"hits":32,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":1,"shortHandedPoints":1,"shots":231,"blocked":29,"faceOffPct":32.3,"gameWinningGoals":5,"games":65,"timeOnIcePerGame":"18:54"},"currentTeamId":29},{"id":8479557,"firstName":"Calvin","lastName":"Thurkauf","fullName":"Calvin Thurkauf","number":"48","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8478831,"firstName":"Kevin","lastName":"Stenlund","fullName":"Kevin Stenlund","number":"69","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8477404,"firstName":"Jake","lastName":"Guentzel","fullName":"Jake Guentzel","number":"59","position":"C","stats":{"_fantasyPoints":205.1,"_fantasyPointsAverage":2.5,"points":48,"goals":22,"assists":26,"penaltyMinutes":42,"plusMinus":-9,"hits":142,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":171,"blocked":46,"faceOffPct":50,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"16:29"},"currentTeamId":5},{"id":8477520,"firstName":"Jean-Sebastien","lastName":"Dea","fullName":"Jean-Sebastien Dea","number":"39","position":"C","stats":{"_fantasyPoints":6.6,"_fantasyPointsAverage":1.32,"points":1,"goals":1,"assists":0,"penaltyMinutes":2,"plusMinus":1,"hits":9,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":1,"faceOffPct":47.61,"gameWinningGoals":1,"games":5,"timeOnIcePerGame":"05:29"},"currentTeamId":5},{"id":8474590,"firstName":"John","lastName":"Carlson","fullName":"John Carlson","number":"74","position":"D","stats":{"_fantasyPoints":329.95,"_fantasyPointsAverage":4.02,"points":68,"goals":15,"assists":53,"penaltyMinutes":32,"plusMinus":0,"hits":47,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":237,"blocked":146,"faceOffPct":0,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"24:46"},"currentTeamId":15},{"id":8476449,"firstName":"Scott","lastName":"Harrington","fullName":"Scott Harrington","number":"4","position":"D","stats":{"_fantasyPoints":58.55,"_fantasyPointsAverage":1.83,"points":5,"goals":2,"assists":3,"penaltyMinutes":8,"plusMinus":0,"hits":35,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":28,"blocked":44,"faceOffPct":0,"gameWinningGoals":1,"games":32,"timeOnIcePerGame":"13:17"},"currentTeamId":29},{"id":8468508,"firstName":"Justin","lastName":"Williams","fullName":"Justin Williams","number":"14","position":"RW","stats":{"_fantasyPoints":183.55,"_fantasyPointsAverage":2.24,"points":51,"goals":16,"assists":35,"penaltyMinutes":56,"plusMinus":-9,"hits":79,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":198,"blocked":42,"faceOffPct":44.82,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"16:35"},"currentTeamId":12},{"id":8475907,"firstName":"Micheal","lastName":"Ferland","fullName":"Micheal Ferland","number":"79","position":"LW","stats":{"_fantasyPoints":199.15,"_fantasyPointsAverage":2.59,"points":41,"goals":21,"assists":20,"penaltyMinutes":24,"plusMinus":5,"hits":171,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":144,"blocked":30,"faceOffPct":38.59,"gameWinningGoals":0,"games":77,"timeOnIcePerGame":"15:01"},"currentTeamId":12},{"id":8473563,"firstName":"Nicklas","lastName":"Backstrom","fullName":"Nicklas Backstrom","number":"19","position":"C","stats":{"_fantasyPoints":257.5,"_fantasyPointsAverage":3.18,"points":71,"goals":21,"assists":50,"penaltyMinutes":46,"plusMinus":5,"hits":37,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":165,"blocked":51,"faceOffPct":51.2,"gameWinningGoals":4,"games":81,"timeOnIcePerGame":"19:39"},"currentTeamId":15},{"id":8474613,"firstName":"Derek","lastName":"Stepan","fullName":"Derek Stepan","number":"21","position":"C","stats":{"_fantasyPoints":224.4,"_fantasyPointsAverage":2.74,"points":56,"goals":14,"assists":42,"penaltyMinutes":26,"plusMinus":-7,"hits":52,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":2,"shortHandedPoints":2,"shots":209,"blocked":54,"faceOffPct":47.74,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"19:16"},"currentTeamId":53},{"id":8480009,"firstName":"Eeli","lastName":"Tolvanen","fullName":"Eeli Tolvanen","number":"11","position":"RW","stats":{"_fantasyPoints":1.55,"_fantasyPointsAverage":0.52,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":3,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"12:06"},"currentTeamId":18},{"id":8480931,"firstName":"Carl","lastName":"Persson","fullName":"Carl Persson","number":"85","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8478492,"firstName":"Ilya","lastName":"Samsonov","fullName":"Ilya Samsonov","number":"30","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":15},{"id":8479293,"firstName":"Brandon","lastName":"Tanev","fullName":"Brandon Tanev","number":"13","position":"LW","stats":{"_fantasyPoints":164.4,"_fantasyPointsAverage":2.7,"points":18,"goals":8,"assists":10,"penaltyMinutes":18,"plusMinus":13,"hits":188,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":3,"shortHandedPoints":3,"shots":79,"blocked":56,"faceOffPct":27.27,"gameWinningGoals":1,"games":61,"timeOnIcePerGame":"12:39"},"currentTeamId":52},{"id":8475876,"firstName":"Zane","lastName":"McIntyre","fullName":"Zane McIntyre","number":"31","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":6},{"id":8479320,"firstName":"Maxime","lastName":"Lajoie","fullName":"Maxime Lajoie","number":"58","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8480147,"firstName":"Oscar","lastName":"Fantenberg","fullName":"Oscar Fantenberg","number":"7","position":"D","stats":{"_fantasyPoints":49.8,"_fantasyPointsAverage":1.84,"points":9,"goals":2,"assists":7,"penaltyMinutes":11,"plusMinus":2,"hits":43,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":33,"blocked":17,"faceOffPct":0,"gameWinningGoals":0,"games":27,"timeOnIcePerGame":"14:15"},"currentTeamId":26},{"id":8478846,"firstName":"Christian","lastName":"Wolanin","fullName":"Christian Wolanin","number":"86","position":"D","stats":{"_fantasyPoints":10.9,"_fantasyPointsAverage":1.09,"points":3,"goals":1,"assists":2,"penaltyMinutes":0,"plusMinus":-4,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":14,"blocked":5,"faceOffPct":0,"gameWinningGoals":0,"games":10,"timeOnIcePerGame":"14:38"},"currentTeamId":9},{"id":8476949,"firstName":"Joey","lastName":"Laleggia","fullName":"Joey Laleggia","number":"48","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8476423,"firstName":"Reid","lastName":"Boucher","fullName":"Reid Boucher","number":"24","position":"C","stats":{"_fantasyPoints":13.7,"_fantasyPointsAverage":0.68,"points":5,"goals":3,"assists":2,"penaltyMinutes":0,"plusMinus":-12,"hits":13,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":37,"blocked":3,"faceOffPct":33.33,"gameWinningGoals":1,"games":20,"timeOnIcePerGame":"11:22"},"currentTeamId":23},{"id":8471276,"firstName":"David","lastName":"Krejci","fullName":"David Krejci","number":"46","position":"C","stats":{"_fantasyPoints":180.4,"_fantasyPointsAverage":2.82,"points":44,"goals":17,"assists":27,"penaltyMinutes":18,"plusMinus":10,"hits":31,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":119,"blocked":35,"faceOffPct":51.91,"gameWinningGoals":2,"games":64,"timeOnIcePerGame":"16:52"},"currentTeamId":6},{"id":8475765,"firstName":"Vladimir","lastName":"Tarasenko","fullName":"Vladimir Tarasenko","number":"91","position":"RW","stats":{"_fantasyPoints":293.1,"_fantasyPointsAverage":3.66,"points":66,"goals":33,"assists":33,"penaltyMinutes":17,"plusMinus":15,"hits":89,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":306,"blocked":37,"faceOffPct":25,"gameWinningGoals":5,"games":80,"timeOnIcePerGame":"19:03"},"currentTeamId":19},{"id":8473546,"firstName":"Michael","lastName":"Grabner","fullName":"Michael Grabner","number":"40","position":"RW","stats":{"_fantasyPoints":192.45,"_fantasyPointsAverage":2.41,"points":36,"goals":27,"assists":9,"penaltyMinutes":16,"plusMinus":11,"hits":68,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":2,"shortHandedPoints":3,"shots":167,"blocked":37,"faceOffPct":45.45,"gameWinningGoals":3,"games":80,"timeOnIcePerGame":"14:49"},"currentTeamId":53},{"id":8477715,"firstName":"Tyler","lastName":"Gaudet","fullName":"Tyler Gaudet","number":"91","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8478410,"firstName":"Gabriel","lastName":"Gagne","fullName":"Gabriel Gagne","number":"73","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8480814,"firstName":"Nicolas","lastName":"Beaudin","fullName":"Nicolas Beaudin","number":"74","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8478867,"firstName":"Spencer","lastName":"Smallman","fullName":"Spencer Smallman","number":"75","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8477488,"firstName":"Brett","lastName":"Pesce","fullName":"Brett Pesce","number":"22","position":"D","stats":{"_fantasyPoints":134.3,"_fantasyPointsAverage":2.07,"points":19,"goals":3,"assists":16,"penaltyMinutes":18,"plusMinus":-6,"hits":57,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":88,"blocked":101,"faceOffPct":0,"gameWinningGoals":1,"games":65,"timeOnIcePerGame":"20:54"},"currentTeamId":12},{"id":8478024,"firstName":"Ville","lastName":"Husso","fullName":"Ville Husso","number":"35","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":19},{"id":8477482,"firstName":"Zach","lastName":"Sanford","fullName":"Zach Sanford","number":"12","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8470604,"firstName":"Jeff","lastName":"Carter","fullName":"Jeff Carter","number":"77","position":"C","stats":{"_fantasyPoints":102.5,"_fantasyPointsAverage":3.8,"points":22,"goals":13,"assists":9,"penaltyMinutes":2,"plusMinus":4,"hits":27,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":1,"shortHandedPoints":1,"shots":85,"blocked":11,"faceOffPct":55.77,"gameWinningGoals":2,"games":27,"timeOnIcePerGame":"17:50"},"currentTeamId":26},{"id":8480935,"firstName":"Lawrence","lastName":"Pilut","fullName":"Lawrence Pilut","number":"24","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8478400,"firstName":"Colin","lastName":"White","fullName":"Colin White","number":"36","position":"C","stats":{"_fantasyPoints":30.65,"_fantasyPointsAverage":1.46,"points":6,"goals":2,"assists":4,"penaltyMinutes":8,"plusMinus":1,"hits":12,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":24,"blocked":15,"faceOffPct":33.33,"gameWinningGoals":1,"games":21,"timeOnIcePerGame":"13:20"},"currentTeamId":9},{"id":8476877,"firstName":"Jordan","lastName":"Schmaltz","fullName":"Jordan Schmaltz","number":"43","position":"D","stats":{"_fantasyPoints":10,"_fantasyPointsAverage":0.77,"points":1,"goals":0,"assists":1,"penaltyMinutes":6,"plusMinus":0,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":5,"blocked":12,"faceOffPct":0,"gameWinningGoals":0,"games":13,"timeOnIcePerGame":"10:58"},"currentTeamId":19},{"id":8478461,"firstName":"Luke","lastName":"Opilka","fullName":"Luke Opilka","number":"45","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":19},{"id":8470151,"firstName":"Jay","lastName":"Bouwmeester","fullName":"Jay Bouwmeester","number":"19","position":"D","stats":{"_fantasyPoints":71.75,"_fantasyPointsAverage":2.05,"points":7,"goals":2,"assists":5,"penaltyMinutes":16,"plusMinus":5,"hits":29,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":45,"blocked":58,"faceOffPct":0,"gameWinningGoals":0,"games":35,"timeOnIcePerGame":"20:08"},"currentTeamId":19},{"id":8477444,"firstName":"Andre","lastName":"Burakovsky","fullName":"Andre Burakovsky","number":"65","position":"LW","stats":{"_fantasyPoints":103.9,"_fantasyPointsAverage":1.86,"points":25,"goals":12,"assists":13,"penaltyMinutes":27,"plusMinus":3,"hits":40,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":84,"blocked":26,"faceOffPct":54.54,"gameWinningGoals":5,"games":56,"timeOnIcePerGame":"13:50"},"currentTeamId":15},{"id":8475809,"firstName":"Scott","lastName":"Wedgewood","fullName":"Scott Wedgewood","number":"31","position":"G","stats":{"_fantasyPoints":"51.80","_fantasyPointsAverage":"2.59","savePercentage":0.893,"goalAgainstAverage":3.45,"wins":5,"losses":9,"saves":524,"goalsAgainst":63,"shutouts":1},"currentTeamId":7},{"id":8477954,"firstName":"Conner","lastName":"Bleackley","fullName":"Conner Bleackley","number":"67","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8476447,"firstName":"Miikka","lastName":"Salomaki","fullName":"Miikka Salomaki","number":"20","position":"RW","stats":{"_fantasyPoints":56.85,"_fantasyPointsAverage":0.98,"points":8,"goals":2,"assists":6,"penaltyMinutes":34,"plusMinus":-8,"hits":114,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":51,"blocked":35,"faceOffPct":41.66,"gameWinningGoals":0,"games":58,"timeOnIcePerGame":"10:16"},"currentTeamId":18},{"id":8478497,"firstName":"Erik","lastName":"Foley","fullName":"Erik Foley","number":"52","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8479442,"firstName":"Troy","lastName":"Stecher","fullName":"Troy Stecher","number":"51","position":"D","stats":{"_fantasyPoints":101.4,"_fantasyPointsAverage":1.49,"points":11,"goals":1,"assists":10,"penaltyMinutes":35,"plusMinus":-7,"hits":111,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":94,"blocked":75,"faceOffPct":0,"gameWinningGoals":0,"games":68,"timeOnIcePerGame":"18:48"},"currentTeamId":23},{"id":8477975,"firstName":"Eric","lastName":"Cornel","fullName":"Eric Cornel","number":"46","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8478027,"firstName":"Lucas","lastName":"Wallmark","fullName":"Lucas Wallmark","number":"71","position":"C","stats":{"_fantasyPoints":4.1,"_fantasyPointsAverage":0.37,"points":1,"goals":1,"assists":0,"penaltyMinutes":2,"plusMinus":-4,"hits":13,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":16,"blocked":1,"faceOffPct":55.07,"gameWinningGoals":0,"games":11,"timeOnIcePerGame":"09:29"},"currentTeamId":12},{"id":8480023,"firstName":"Robert","lastName":"Thomas","fullName":"Robert Thomas","number":"36","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8477964,"firstName":"Ivan","lastName":"Barbashev","fullName":"Ivan Barbashev","number":"49","position":"C","stats":{"_fantasyPoints":77.25,"_fantasyPointsAverage":1.46,"points":13,"goals":7,"assists":6,"penaltyMinutes":4,"plusMinus":-1,"hits":70,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":45,"blocked":25,"faceOffPct":38.36,"gameWinningGoals":1,"games":53,"timeOnIcePerGame":"12:11"},"currentTeamId":19},{"id":8473618,"firstName":"Mathieu","lastName":"Perreault","fullName":"Mathieu Perreault","number":"85","position":"C","stats":{"_fantasyPoints":172.65,"_fantasyPointsAverage":2.47,"points":39,"goals":17,"assists":22,"penaltyMinutes":38,"plusMinus":4,"hits":120,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":1,"shots":139,"blocked":25,"faceOffPct":55.93,"gameWinningGoals":2,"games":70,"timeOnIcePerGame":"14:27"},"currentTeamId":52},{"id":8479981,"firstName":"Jonah","lastName":"Gadjovich","fullName":"Jonah Gadjovich","number":"41","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8478407,"firstName":"Vince","lastName":"Dunn","fullName":"Vince Dunn","number":"29","position":"D","stats":{"_fantasyPoints":125.8,"_fantasyPointsAverage":1.68,"points":24,"goals":5,"assists":19,"penaltyMinutes":20,"plusMinus":1,"hits":29,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":138,"blocked":59,"faceOffPct":100,"gameWinningGoals":1,"games":75,"timeOnIcePerGame":"17:13"},"currentTeamId":19},{"id":8479511,"firstName":"Janne","lastName":"Kuokkanen","fullName":"Janne Kuokkanen","number":"59","position":"C","stats":{"_fantasyPoints":-1.4,"_fantasyPointsAverage":-0.35,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-3,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"11:03"},"currentTeamId":12},{"id":8479349,"firstName":"Tanner","lastName":"Kaspick","fullName":"Tanner Kaspick","number":"83","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8480766,"firstName":"Andrew","lastName":"Sturtz","fullName":"Andrew Sturtz","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8479420,"firstName":"Tage","lastName":"Thompson","fullName":"Tage Thompson","number":"72","position":"C","stats":{"_fantasyPoints":30,"_fantasyPointsAverage":0.73,"points":9,"goals":3,"assists":6,"penaltyMinutes":12,"plusMinus":-12,"hits":39,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":55,"blocked":9,"faceOffPct":10,"gameWinningGoals":0,"games":41,"timeOnIcePerGame":"11:55"},"currentTeamId":7},{"id":8479406,"firstName":"Filip","lastName":"Gustavsson","fullName":"Filip Gustavsson","number":"30","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":9},{"id":8477992,"firstName":"Jonas","lastName":"Johansson","fullName":"Jonas Johansson","number":"34","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":7},{"id":8473534,"firstName":"Patrik","lastName":"Berglund","fullName":"Patrik Berglund","number":"10","position":"C","stats":{"_fantasyPoints":134.45,"_fantasyPointsAverage":2.36,"points":26,"goals":17,"assists":9,"penaltyMinutes":30,"plusMinus":-5,"hits":111,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":1,"shortHandedPoints":1,"shots":112,"blocked":36,"faceOffPct":55.09,"gameWinningGoals":4,"games":57,"timeOnIcePerGame":"16:09"},"currentTeamId":7},{"id":8471716,"firstName":"Justin","lastName":"Abdelkader","fullName":"Justin Abdelkader","number":"8","position":"LW","stats":{"_fantasyPoints":139.5,"_fantasyPointsAverage":1.86,"points":35,"goals":13,"assists":22,"penaltyMinutes":78,"plusMinus":-11,"hits":174,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":110,"blocked":40,"faceOffPct":48.45,"gameWinningGoals":0,"games":75,"timeOnIcePerGame":"16:33"},"currentTeamId":17},{"id":8475768,"firstName":"Jaden","lastName":"Schwartz","fullName":"Jaden Schwartz","number":"17","position":"LW","stats":{"_fantasyPoints":233.7,"_fantasyPointsAverage":3.77,"points":59,"goals":24,"assists":35,"penaltyMinutes":26,"plusMinus":15,"hits":52,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":1,"shortHandedPoints":1,"shots":157,"blocked":30,"faceOffPct":41.09,"gameWinningGoals":3,"games":62,"timeOnIcePerGame":"19:23"},"currentTeamId":19},{"id":8477933,"firstName":"Sam","lastName":"Reinhart","fullName":"Sam Reinhart","number":"23","position":"C","stats":{"_fantasyPoints":185.8,"_fantasyPointsAverage":2.27,"points":50,"goals":25,"assists":25,"penaltyMinutes":26,"plusMinus":-24,"hits":48,"powerPlayGoals":12,"powerPlayPoints":12,"shortHandedGoals":0,"shortHandedPoints":0,"shots":188,"blocked":42,"faceOffPct":39.43,"gameWinningGoals":5,"games":82,"timeOnIcePerGame":"17:06"},"currentTeamId":7},{"id":8476861,"firstName":"Oscar","lastName":"Dansk","fullName":"Oscar Dansk","number":"35","position":"G","stats":{"_fantasyPoints":"20.60","_fantasyPointsAverage":"5.15","savePercentage":0.946,"goalAgainstAverage":1.78,"wins":3,"losses":0,"saves":88,"goalsAgainst":5,"shutouts":1},"currentTeamId":54},{"id":8477952,"firstName":"Robby","lastName":"Fabbri","fullName":"Robby Fabbri","number":"15","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8471669,"firstName":"Paul","lastName":"Stastny","fullName":"Paul Stastny","number":"26","position":"C","stats":{"_fantasyPoints":203.65,"_fantasyPointsAverage":2.48,"points":53,"goals":16,"assists":37,"penaltyMinutes":18,"plusMinus":1,"hits":43,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":159,"blocked":38,"faceOffPct":54.91,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"18:18"},"currentTeamId":54},{"id":8474019,"firstName":"Tommy","lastName":"Cross","fullName":"Tommy Cross","number":"49","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8476808,"firstName":"Brian","lastName":"Flynn","fullName":"Brian Flynn","number":"32","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8471242,"firstName":"Mike","lastName":"Green","fullName":"Mike Green","number":"25","position":"D","stats":{"_fantasyPoints":152.2,"_fantasyPointsAverage":2.31,"points":33,"goals":8,"assists":25,"penaltyMinutes":38,"plusMinus":-14,"hits":78,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":132,"blocked":74,"faceOffPct":0,"gameWinningGoals":0,"games":66,"timeOnIcePerGame":"22:04"},"currentTeamId":17},{"id":8476907,"firstName":"Mackenzie","lastName":"MacEachern","fullName":"Mackenzie MacEachern","number":"62","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8476293,"firstName":"Scott","lastName":"Wilson","fullName":"Scott Wilson","number":"20","position":"C","stats":{"_fantasyPoints":84.05,"_fantasyPointsAverage":1.22,"points":14,"goals":6,"assists":8,"penaltyMinutes":8,"plusMinus":-20,"hits":128,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":98,"blocked":33,"faceOffPct":52.63,"gameWinningGoals":0,"games":69,"timeOnIcePerGame":"12:12"},"currentTeamId":7},{"id":8479400,"firstName":"Pierre-Luc","lastName":"Dubois","fullName":"Pierre-Luc Dubois","number":"18","position":"C","stats":{"_fantasyPoints":213.75,"_fantasyPointsAverage":2.61,"points":48,"goals":20,"assists":28,"penaltyMinutes":49,"plusMinus":8,"hits":127,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":165,"blocked":46,"faceOffPct":43.82,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"16:38"},"currentTeamId":29},{"id":8478056,"firstName":"Clark","lastName":"Bishop","fullName":"Clark Bishop","number":"64","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8478462,"firstName":"Nicolas","lastName":"Roy","fullName":"Nicolas Roy","number":"58","position":"C","stats":{"_fantasyPoints":-0.4,"_fantasyPointsAverage":-0.4,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":0,"faceOffPct":60,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"10:46"},"currentTeamId":12},{"id":8475253,"firstName":"Garrett","lastName":"Wilson","fullName":"Garrett Wilson","number":"10","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8477504,"firstName":"Josh","lastName":"Morrissey","fullName":"Josh Morrissey","number":"44","position":"D","stats":{"_fantasyPoints":234.95,"_fantasyPointsAverage":2.9,"points":26,"goals":7,"assists":19,"penaltyMinutes":47,"plusMinus":15,"hits":139,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":102,"blocked":168,"faceOffPct":50,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"20:27"},"currentTeamId":52},{"id":8474061,"firstName":"Anthony","lastName":"Peluso","fullName":"Anthony Peluso","number":"16","position":"RW","stats":{"_fantasyPoints":-1,"_fantasyPointsAverage":-0.5,"points":0,"goals":0,"assists":0,"penaltyMinutes":4,"plusMinus":0,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"04:38"},"currentTeamId":20},{"id":8480083,"firstName":"C.J.","lastName":"Smith","fullName":"C.J. Smith","number":"49","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8478435,"firstName":"Dan","lastName":"Vladar","fullName":"Dan Vladar","number":"80","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":6},{"id":8474056,"firstName":"P.K.","lastName":"Subban","fullName":"P.K. Subban","number":"76","position":"D","stats":{"_fantasyPoints":272.45,"_fantasyPointsAverage":3.32,"points":59,"goals":16,"assists":43,"penaltyMinutes":82,"plusMinus":18,"hits":111,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":1,"shots":207,"blocked":90,"faceOffPct":33.33,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"24:06"},"currentTeamId":18},{"id":8479324,"firstName":"Ryan","lastName":"Lindgren","fullName":"Ryan Lindgren","number":"55","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8478426,"firstName":"Paul","lastName":"Bittner","fullName":"Paul Bittner","number":"57","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8474034,"firstName":"Pat","lastName":"Maroon","fullName":"Pat Maroon","number":"7","position":"LW","stats":{"_fantasyPoints":154.6,"_fantasyPointsAverage":2.09,"points":43,"goals":17,"assists":26,"penaltyMinutes":73,"plusMinus":1,"hits":150,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":141,"blocked":14,"faceOffPct":45.83,"gameWinningGoals":4,"games":74,"timeOnIcePerGame":"16:32"},"currentTeamId":19},{"id":8470626,"firstName":"Loui","lastName":"Eriksson","fullName":"Loui Eriksson","number":"21","position":"LW","stats":{"_fantasyPoints":108.35,"_fantasyPointsAverage":2.17,"points":23,"goals":10,"assists":13,"penaltyMinutes":4,"plusMinus":0,"hits":7,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":101,"blocked":30,"faceOffPct":42.85,"gameWinningGoals":0,"games":50,"timeOnIcePerGame":"16:16"},"currentTeamId":23},{"id":8478104,"firstName":"Sammy","lastName":"Blais","fullName":"Sammy Blais","number":"64","position":"LW","stats":{"_fantasyPoints":13.15,"_fantasyPointsAverage":1.2,"points":3,"goals":1,"assists":2,"penaltyMinutes":6,"plusMinus":1,"hits":15,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":9,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":11,"timeOnIcePerGame":"10:46"},"currentTeamId":19},{"id":8477480,"firstName":"Eric","lastName":"Comrie","fullName":"Eric Comrie","number":"1","position":"G","stats":{"_fantasyPoints":"5.40","_fantasyPointsAverage":"1.80","savePercentage":0.872,"goalAgainstAverage":4,"wins":1,"losses":2,"saves":82,"goalsAgainst":12,"shutouts":0},"currentTeamId":52},{"id":8479364,"firstName":"Timothy","lastName":"Gettinger","fullName":"Timothy Gettinger","number":"97","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8476925,"firstName":"Colton","lastName":"Sissons","fullName":"Colton Sissons","number":"10","position":"C","stats":{"_fantasyPoints":154.25,"_fantasyPointsAverage":1.9,"points":27,"goals":9,"assists":18,"penaltyMinutes":42,"plusMinus":2,"hits":136,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":3,"shots":120,"blocked":49,"faceOffPct":55.29,"gameWinningGoals":4,"games":81,"timeOnIcePerGame":"16:05"},"currentTeamId":18},{"id":8481122,"firstName":"Simon","lastName":"Benoit","fullName":"Simon Benoit","number":"86","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8474612,"firstName":"Travis","lastName":"Hamonic","fullName":"Travis Hamonic","number":"24","position":"D","stats":{"_fantasyPoints":104.45,"_fantasyPointsAverage":1.41,"points":11,"goals":1,"assists":10,"penaltyMinutes":79,"plusMinus":-9,"hits":83,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":107,"blocked":124,"faceOffPct":0,"gameWinningGoals":0,"games":74,"timeOnIcePerGame":"20:41"},"currentTeamId":20},{"id":8480944,"firstName":"Par","lastName":"Lindholm","fullName":"Par Lindholm","number":"26","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8476930,"firstName":"Ludwig","lastName":"Bystrom","fullName":"Ludwig Bystrom","number":"47","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8476458,"firstName":"Ryan","lastName":"Strome","fullName":"Ryan Strome","number":"18","position":"C","stats":{"_fantasyPoints":122.2,"_fantasyPointsAverage":1.49,"points":34,"goals":13,"assists":21,"penaltyMinutes":33,"plusMinus":-4,"hits":43,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":1,"shots":147,"blocked":17,"faceOffPct":44.26,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"15:13"},"currentTeamId":22},{"id":8478425,"firstName":"Brendan","lastName":"Guhle","fullName":"Brendan Guhle","number":"45","position":"D","stats":{"_fantasyPoints":13.7,"_fantasyPointsAverage":0.76,"points":5,"goals":0,"assists":5,"penaltyMinutes":10,"plusMinus":-6,"hits":10,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":37,"blocked":8,"faceOffPct":0,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"18:06"},"currentTeamId":7},{"id":8474568,"firstName":"Luke","lastName":"Schenn","fullName":"Luke Schenn","number":"2","position":"D","stats":{"_fantasyPoints":128.4,"_fantasyPointsAverage":2.01,"points":7,"goals":1,"assists":6,"penaltyMinutes":35,"plusMinus":-12,"hits":219,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":59,"blocked":105,"faceOffPct":0,"gameWinningGoals":1,"games":64,"timeOnIcePerGame":"16:23"},"currentTeamId":24},{"id":8476043,"firstName":"Ben","lastName":"Street","fullName":"Ben Street","number":"46","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8480145,"firstName":"Neal","lastName":"Pionk","fullName":"Neal Pionk","number":"44","position":"D","stats":{"_fantasyPoints":79.9,"_fantasyPointsAverage":2.85,"points":14,"goals":1,"assists":13,"penaltyMinutes":12,"plusMinus":-1,"hits":49,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":54,"blocked":41,"faceOffPct":0,"gameWinningGoals":0,"games":28,"timeOnIcePerGame":"22:23"},"currentTeamId":3},{"id":8473446,"firstName":"Erik","lastName":"Johnson","fullName":"Erik Johnson","number":"6","position":"D","stats":{"_fantasyPoints":197.05,"_fantasyPointsAverage":3.18,"points":25,"goals":9,"assists":16,"penaltyMinutes":58,"plusMinus":3,"hits":114,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":168,"blocked":135,"faceOffPct":0,"gameWinningGoals":3,"games":62,"timeOnIcePerGame":"25:26"},"currentTeamId":21},{"id":8474596,"firstName":"Jake","lastName":"Allen","fullName":"Jake Allen","number":"34","position":"G","stats":{"_fantasyPoints":"172.40","_fantasyPointsAverage":"2.92","savePercentage":0.906,"goalAgainstAverage":2.75,"wins":27,"losses":25,"saves":1462,"goalsAgainst":152,"shutouts":1},"currentTeamId":19},{"id":8473434,"firstName":"Chad","lastName":"Johnson","fullName":"Chad Johnson","number":"31","position":"G","stats":{"_fantasyPoints":"76.40","_fantasyPointsAverage":"2.12","savePercentage":0.891,"goalAgainstAverage":3.55,"wins":10,"losses":16,"saves":857,"goalsAgainst":105,"shutouts":0},"currentTeamId":19},{"id":8475164,"firstName":"Jakob","lastName":"Silfverberg","fullName":"Jakob Silfverberg","number":"33","position":"RW","stats":{"_fantasyPoints":202.45,"_fantasyPointsAverage":2.63,"points":40,"goals":17,"assists":23,"penaltyMinutes":18,"plusMinus":6,"hits":52,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":2,"shots":187,"blocked":61,"faceOffPct":33.96,"gameWinningGoals":2,"games":77,"timeOnIcePerGame":"17:57"},"currentTeamId":24},{"id":8478396,"firstName":"Noah","lastName":"Hanifin","fullName":"Noah Hanifin","number":"55","position":"D","stats":{"_fantasyPoints":151.5,"_fantasyPointsAverage":1.92,"points":32,"goals":10,"assists":22,"penaltyMinutes":21,"plusMinus":-20,"hits":81,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":165,"blocked":69,"faceOffPct":0,"gameWinningGoals":3,"games":79,"timeOnIcePerGame":"18:51"},"currentTeamId":20},{"id":8477491,"firstName":"Nicholas","lastName":"Baptiste","fullName":"Nicholas Baptiste","number":"13","position":"RW","stats":{"_fantasyPoints":19.25,"_fantasyPointsAverage":0.58,"points":6,"goals":4,"assists":2,"penaltyMinutes":14,"plusMinus":-4,"hits":16,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":45,"blocked":3,"faceOffPct":22.22,"gameWinningGoals":1,"games":33,"timeOnIcePerGame":"09:58"},"currentTeamId":7},{"id":8474709,"firstName":"Matt","lastName":"Martin","fullName":"Matt Martin","number":"17","position":"LW","stats":{"_fantasyPoints":56.1,"_fantasyPointsAverage":1.12,"points":12,"goals":3,"assists":9,"penaltyMinutes":50,"plusMinus":0,"hits":147,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":46,"blocked":9,"faceOffPct":75,"gameWinningGoals":0,"games":50,"timeOnIcePerGame":"07:59"},"currentTeamId":2},{"id":8473449,"firstName":"Kyle","lastName":"Okposo","fullName":"Kyle Okposo","number":"21","position":"RW","stats":{"_fantasyPoints":140.6,"_fantasyPointsAverage":1.85,"points":44,"goals":15,"assists":29,"penaltyMinutes":40,"plusMinus":-34,"hits":70,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":161,"blocked":34,"faceOffPct":46,"gameWinningGoals":2,"games":76,"timeOnIcePerGame":"17:01"},"currentTeamId":7},{"id":8477902,"firstName":"Dennis","lastName":"Everberg","fullName":"Dennis Everberg","number":"45","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":52},{"id":8475715,"firstName":"Oscar","lastName":"Lindberg","fullName":"Oscar Lindberg","number":"24","position":"C","stats":{"_fantasyPoints":64.85,"_fantasyPointsAverage":1.03,"points":11,"goals":9,"assists":2,"penaltyMinutes":14,"plusMinus":-11,"hits":72,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":81,"blocked":27,"faceOffPct":52.94,"gameWinningGoals":0,"games":63,"timeOnIcePerGame":"11:46"},"currentTeamId":54},{"id":8475753,"firstName":"Justin","lastName":"Faulk","fullName":"Justin Faulk","number":"27","position":"D","stats":{"_fantasyPoints":165.6,"_fantasyPointsAverage":2.18,"points":31,"goals":8,"assists":23,"penaltyMinutes":48,"plusMinus":-26,"hits":128,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":211,"blocked":90,"faceOffPct":0,"gameWinningGoals":3,"games":76,"timeOnIcePerGame":"22:16"},"currentTeamId":12},{"id":8476454,"firstName":"Ryan","lastName":"Nugent-Hopkins","fullName":"Ryan Nugent-Hopkins","number":"93","position":"C","stats":{"_fantasyPoints":214.35,"_fantasyPointsAverage":3.46,"points":48,"goals":24,"assists":24,"penaltyMinutes":20,"plusMinus":10,"hits":44,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":2,"shortHandedPoints":3,"shots":151,"blocked":39,"faceOffPct":48.76,"gameWinningGoals":2,"games":62,"timeOnIcePerGame":"18:05"},"currentTeamId":22},{"id":8471702,"firstName":"Matt","lastName":"Niskanen","fullName":"Matt Niskanen","number":"2","position":"D","stats":{"_fantasyPoints":203.75,"_fantasyPointsAverage":3,"points":29,"goals":7,"assists":22,"penaltyMinutes":36,"plusMinus":24,"hits":117,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":120,"blocked":98,"faceOffPct":0,"gameWinningGoals":1,"games":68,"timeOnIcePerGame":"22:36"},"currentTeamId":15},{"id":8476460,"firstName":"Mark","lastName":"Scheifele","fullName":"Mark Scheifele","number":"55","position":"C","stats":{"_fantasyPoints":251.5,"_fantasyPointsAverage":4.19,"points":60,"goals":23,"assists":37,"penaltyMinutes":18,"plusMinus":19,"hits":57,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":2,"shortHandedPoints":3,"shots":125,"blocked":31,"faceOffPct":51.25,"gameWinningGoals":3,"games":60,"timeOnIcePerGame":"20:40"},"currentTeamId":52},{"id":8475343,"firstName":"Nic","lastName":"Dowd","fullName":"Nic Dowd","number":"26","position":"C","stats":{"_fantasyPoints":37.35,"_fantasyPointsAverage":0.67,"points":4,"goals":3,"assists":1,"penaltyMinutes":28,"plusMinus":-10,"hits":81,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":51,"blocked":30,"faceOffPct":51.01,"gameWinningGoals":1,"games":56,"timeOnIcePerGame":"10:32"},"currentTeamId":15},{"id":8480826,"firstName":"Bode","lastName":"Wilde","fullName":"Bode Wilde","number":"46","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8476822,"firstName":"Luke","lastName":"Glendening","fullName":"Luke Glendening","number":"41","position":"C","stats":{"_fantasyPoints":152.3,"_fantasyPointsAverage":2.21,"points":19,"goals":11,"assists":8,"penaltyMinutes":17,"plusMinus":-14,"hits":137,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":2,"shortHandedPoints":3,"shots":88,"blocked":83,"faceOffPct":58.02,"gameWinningGoals":2,"games":69,"timeOnIcePerGame":"13:11"},"currentTeamId":17},{"id":8476905,"firstName":"Chandler","lastName":"Stephenson","fullName":"Chandler Stephenson","number":"18","position":"C","stats":{"_fantasyPoints":94.85,"_fantasyPointsAverage":1.42,"points":18,"goals":6,"assists":12,"penaltyMinutes":8,"plusMinus":13,"hits":26,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":36,"blocked":33,"faceOffPct":54.79,"gameWinningGoals":0,"games":67,"timeOnIcePerGame":"11:52"},"currentTeamId":15},{"id":8477352,"firstName":"Ryan","lastName":"Fitzgerald","fullName":"Ryan Fitzgerald","number":"38","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8476209,"firstName":"Mike","lastName":"Sislo","fullName":"Mike Sislo","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8476987,"firstName":"Jake","lastName":"Bischoff","fullName":"Jake Bischoff","number":"45","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8476924,"firstName":"Martin","lastName":"Frk","fullName":"Martin Frk","number":"42","position":"RW","stats":{"_fantasyPoints":93.65,"_fantasyPointsAverage":1.38,"points":25,"goals":11,"assists":14,"penaltyMinutes":14,"plusMinus":-14,"hits":77,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":99,"blocked":10,"faceOffPct":0,"gameWinningGoals":0,"games":68,"timeOnIcePerGame":"10:17"},"currentTeamId":17},{"id":8475188,"firstName":"Brayden","lastName":"McNabb","fullName":"Brayden McNabb","number":"3","position":"D","stats":{"_fantasyPoints":239.55,"_fantasyPointsAverage":3.15,"points":15,"goals":5,"assists":10,"penaltyMinutes":52,"plusMinus":26,"hits":225,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":88,"blocked":176,"faceOffPct":0,"gameWinningGoals":1,"games":76,"timeOnIcePerGame":"20:09"},"currentTeamId":54},{"id":8476415,"firstName":"Kyle","lastName":"Rau","fullName":"Kyle Rau","number":"37","position":"C","stats":{"_fantasyPoints":4.65,"_fantasyPointsAverage":1.55,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":0,"hits":7,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"11:01"},"currentTeamId":30},{"id":8477946,"firstName":"Dylan","lastName":"Larkin","fullName":"Dylan Larkin","number":"71","position":"C","stats":{"_fantasyPoints":222.2,"_fantasyPointsAverage":2.71,"points":63,"goals":16,"assists":47,"penaltyMinutes":61,"plusMinus":-9,"hits":76,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":2,"shortHandedPoints":3,"shots":232,"blocked":42,"faceOffPct":49.92,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"19:50"},"currentTeamId":17},{"id":8476191,"firstName":"Kevan","lastName":"Miller","fullName":"Kevan Miller","number":"86","position":"D","stats":{"_fantasyPoints":159.65,"_fantasyPointsAverage":2.35,"points":16,"goals":1,"assists":15,"penaltyMinutes":70,"plusMinus":16,"hits":164,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":2,"shots":64,"blocked":111,"faceOffPct":0,"gameWinningGoals":0,"games":68,"timeOnIcePerGame":"19:27"},"currentTeamId":6},{"id":8476891,"firstName":"Matt","lastName":"Grzelcyk","fullName":"Matt Grzelcyk","number":"48","position":"D","stats":{"_fantasyPoints":102.45,"_fantasyPointsAverage":1.68,"points":15,"goals":3,"assists":12,"penaltyMinutes":22,"plusMinus":21,"hits":45,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":82,"blocked":42,"faceOffPct":0,"gameWinningGoals":0,"games":61,"timeOnIcePerGame":"16:44"},"currentTeamId":6},{"id":8477944,"firstName":"Jakub","lastName":"Vrana","fullName":"Jakub Vrana","number":"13","position":"LW","stats":{"_fantasyPoints":111.05,"_fantasyPointsAverage":1.52,"points":27,"goals":13,"assists":14,"penaltyMinutes":12,"plusMinus":2,"hits":31,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":133,"blocked":16,"faceOffPct":52,"gameWinningGoals":2,"games":73,"timeOnIcePerGame":"12:29"},"currentTeamId":15},{"id":8475279,"firstName":"Ben","lastName":"Chiarot","fullName":"Ben Chiarot","number":"7","position":"D","stats":{"_fantasyPoints":124.2,"_fantasyPointsAverage":2.18,"points":14,"goals":2,"assists":12,"penaltyMinutes":32,"plusMinus":15,"hits":105,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":57,"blocked":75,"faceOffPct":0,"gameWinningGoals":0,"games":57,"timeOnIcePerGame":"15:16"},"currentTeamId":52},{"id":8473541,"firstName":"Jonathan","lastName":"Bernier","fullName":"Jonathan Bernier","number":"45","position":"G","stats":{"_fantasyPoints":"133.40","_fantasyPointsAverage":"3.61","savePercentage":0.913,"goalAgainstAverage":2.85,"wins":19,"losses":13,"saves":997,"goalsAgainst":95,"shutouts":2},"currentTeamId":17},{"id":8477320,"firstName":"Anton","lastName":"Blidh","fullName":"Anton Blidh","number":"81","position":"LW","stats":{"_fantasyPoints":0.75,"_fantasyPointsAverage":0.75,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"10:23"},"currentTeamId":6},{"id":8476880,"firstName":"Tom","lastName":"Wilson","fullName":"Tom Wilson","number":"43","position":"RW","stats":{"_fantasyPoints":135.05,"_fantasyPointsAverage":1.73,"points":35,"goals":14,"assists":21,"penaltyMinutes":187,"plusMinus":10,"hits":250,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":123,"blocked":51,"faceOffPct":46.29,"gameWinningGoals":1,"games":78,"timeOnIcePerGame":"15:59"},"currentTeamId":15},{"id":8479984,"firstName":"Callan","lastName":"Foote","fullName":"Callan Foote","number":"52","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8475663,"firstName":"Eddie","lastName":"Lack","fullName":"Eddie Lack","number":"31","position":"G","stats":{"_fantasyPoints":"9.80","_fantasyPointsAverage":"1.23","savePercentage":0.87,"goalAgainstAverage":4.02,"wins":2,"losses":4,"saves":154,"goalsAgainst":23,"shutouts":0},"currentTeamId":1},{"id":8477417,"firstName":"Peter","lastName":"Cehlarik","fullName":"Peter Cehlarik","number":"22","position":"LW","stats":{"_fantasyPoints":10.3,"_fantasyPointsAverage":1.72,"points":2,"goals":1,"assists":1,"penaltyMinutes":2,"plusMinus":2,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":3,"blocked":3,"faceOffPct":50,"gameWinningGoals":0,"games":6,"timeOnIcePerGame":"13:56"},"currentTeamId":6},{"id":8478432,"firstName":"Christian","lastName":"Fischer","fullName":"Christian Fischer","number":"36","position":"RW","stats":{"_fantasyPoints":137.4,"_fantasyPointsAverage":1.74,"points":33,"goals":15,"assists":18,"penaltyMinutes":14,"plusMinus":-17,"hits":109,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":154,"blocked":23,"faceOffPct":17.24,"gameWinningGoals":3,"games":79,"timeOnIcePerGame":"13:54"},"currentTeamId":53},{"id":8475762,"firstName":"Derek","lastName":"Forbort","fullName":"Derek Forbort","number":"24","position":"D","stats":{"_fantasyPoints":199.8,"_fantasyPointsAverage":2.56,"points":18,"goals":1,"assists":17,"penaltyMinutes":49,"plusMinus":18,"hits":142,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":78,"blocked":156,"faceOffPct":0,"gameWinningGoals":0,"games":78,"timeOnIcePerGame":"20:47"},"currentTeamId":26},{"id":8475810,"firstName":"Bryan","lastName":"Rust","fullName":"Bryan Rust","number":"17","position":"RW","stats":{"_fantasyPoints":185.05,"_fantasyPointsAverage":2.68,"points":38,"goals":13,"assists":25,"penaltyMinutes":26,"plusMinus":11,"hits":97,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":2,"shortHandedPoints":3,"shots":123,"blocked":40,"faceOffPct":25.8,"gameWinningGoals":3,"games":69,"timeOnIcePerGame":"16:02"},"currentTeamId":5},{"id":8477365,"firstName":"Connor","lastName":"Clifton","fullName":"Connor Clifton","number":"75","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8475744,"firstName":"Evgeny","lastName":"Kuznetsov","fullName":"Evgeny Kuznetsov","number":"92","position":"C","stats":{"_fantasyPoints":282.7,"_fantasyPointsAverage":3.58,"points":83,"goals":27,"assists":56,"penaltyMinutes":48,"plusMinus":3,"hits":50,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":1,"shortHandedPoints":1,"shots":187,"blocked":26,"faceOffPct":44.2,"gameWinningGoals":8,"games":79,"timeOnIcePerGame":"18:48"},"currentTeamId":15},{"id":8475206,"firstName":"Stefan","lastName":"Elliott","fullName":"Stefan Elliott","number":"24","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8479333,"firstName":"Libor","lastName":"Hajek","fullName":"Libor Hajek","number":"43","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8477839,"firstName":"Conor","lastName":"Sheary","fullName":"Conor Sheary","number":"43","position":"LW","stats":{"_fantasyPoints":136.2,"_fantasyPointsAverage":1.72,"points":30,"goals":18,"assists":12,"penaltyMinutes":10,"plusMinus":2,"hits":29,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":142,"blocked":31,"faceOffPct":36.36,"gameWinningGoals":4,"games":79,"timeOnIcePerGame":"13:56"},"currentTeamId":7},{"id":8480950,"firstName":"Ilya","lastName":"Lyubushkin","fullName":"Ilya Lyubushkin","number":"46","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":53},{"id":8477450,"firstName":"Jason","lastName":"Dickinson","fullName":"Jason Dickinson","number":"16","position":"C","stats":{"_fantasyPoints":11.1,"_fantasyPointsAverage":0.41,"points":2,"goals":0,"assists":2,"penaltyMinutes":17,"plusMinus":-2,"hits":45,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":16,"blocked":5,"faceOffPct":48.59,"gameWinningGoals":0,"games":27,"timeOnIcePerGame":"08:32"},"currentTeamId":25},{"id":8473589,"firstName":"Chris","lastName":"Summers","fullName":"Chris Summers","number":"55","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8476927,"firstName":"Teddy","lastName":"Blueger","fullName":"Teddy Blueger","number":"53","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8476467,"firstName":"Jamie","lastName":"Oleksiak","fullName":"Jamie Oleksiak","number":"6","position":"D","stats":{"_fantasyPoints":120.1,"_fantasyPointsAverage":1.77,"points":17,"goals":5,"assists":12,"penaltyMinutes":87,"plusMinus":7,"hits":174,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":81,"blocked":76,"faceOffPct":0,"gameWinningGoals":1,"games":68,"timeOnIcePerGame":"16:39"},"currentTeamId":5},{"id":8476992,"firstName":"Marek","lastName":"Mazanec","fullName":"Marek Mazanec","number":"32","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":3},{"id":8475764,"firstName":"Cam","lastName":"Fowler","fullName":"Cam Fowler","number":"4","position":"D","stats":{"_fantasyPoints":187.45,"_fantasyPointsAverage":2.8,"points":32,"goals":8,"assists":24,"penaltyMinutes":28,"plusMinus":3,"hits":21,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":2,"shots":122,"blocked":108,"faceOffPct":50,"gameWinningGoals":1,"games":67,"timeOnIcePerGame":"24:51"},"currentTeamId":24},{"id":8464989,"firstName":"Matt","lastName":"Cullen","fullName":"Matt Cullen","number":"7","position":"C","stats":{"_fantasyPoints":100.9,"_fantasyPointsAverage":1.28,"points":22,"goals":11,"assists":11,"penaltyMinutes":20,"plusMinus":-1,"hits":14,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":104,"blocked":42,"faceOffPct":50.35,"gameWinningGoals":1,"games":79,"timeOnIcePerGame":"11:53"},"currentTeamId":5},{"id":8476967,"firstName":"Brett","lastName":"Kulak","fullName":"Brett Kulak","number":"61","position":"D","stats":{"_fantasyPoints":60.8,"_fantasyPointsAverage":0.86,"points":8,"goals":2,"assists":6,"penaltyMinutes":27,"plusMinus":-3,"hits":45,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":73,"blocked":49,"faceOffPct":0,"gameWinningGoals":0,"games":71,"timeOnIcePerGame":"12:59"},"currentTeamId":20},{"id":8468011,"firstName":"Ryan","lastName":"Miller","fullName":"Ryan Miller","number":"30","position":"G","stats":{"_fantasyPoints":"116.20","_fantasyPointsAverage":"4.15","savePercentage":0.928,"goalAgainstAverage":2.35,"wins":12,"losses":6,"saves":686,"goalsAgainst":53,"shutouts":4},"currentTeamId":24},{"id":8480341,"firstName":"Adam","lastName":"Johnson","fullName":"Adam Johnson","number":"47","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8480448,"firstName":"Parker","lastName":"Kelly","fullName":"Parker Kelly","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8479396,"firstName":"Luke","lastName":"Green","fullName":"Luke Green","number":"51","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":52},{"id":8480382,"firstName":"Alexandar","lastName":"Georgiev","fullName":"Alexandar Georgiev","number":"40","position":"G","stats":{"_fantasyPoints":"37.80","_fantasyPointsAverage":"3.78","savePercentage":0.918,"goalAgainstAverage":3.15,"wins":4,"losses":4,"saves":304,"goalsAgainst":27,"shutouts":0},"currentTeamId":3},{"id":8474683,"firstName":"Derek","lastName":"Grant","fullName":"Derek Grant","number":"38","position":"C","stats":{"_fantasyPoints":126,"_fantasyPointsAverage":1.91,"points":24,"goals":12,"assists":12,"penaltyMinutes":11,"plusMinus":3,"hits":63,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":65,"blocked":39,"faceOffPct":53.09,"gameWinningGoals":0,"games":66,"timeOnIcePerGame":"11:05"},"currentTeamId":5},{"id":8475772,"firstName":"Riley","lastName":"Sheahan","fullName":"Riley Sheahan","number":"15","position":"C","stats":{"_fantasyPoints":156.9,"_fantasyPointsAverage":1.94,"points":32,"goals":11,"assists":21,"penaltyMinutes":8,"plusMinus":4,"hits":52,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":109,"blocked":50,"faceOffPct":54.21,"gameWinningGoals":1,"games":81,"timeOnIcePerGame":"14:40"},"currentTeamId":5},{"id":8477465,"firstName":"Tristan","lastName":"Jarry","fullName":"Tristan Jarry","number":"35","position":"G","stats":{"_fantasyPoints":"85.80","_fantasyPointsAverage":"3.30","savePercentage":0.908,"goalAgainstAverage":2.77,"wins":14,"losses":6,"saves":624,"goalsAgainst":63,"shutouts":2},"currentTeamId":5},{"id":8475815,"firstName":"Julian","lastName":"Melchiori","fullName":"Julian Melchiori","number":"44","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8478512,"firstName":"Austin","lastName":"Czarnik","fullName":"Austin Czarnik","number":"27","position":"C","stats":{"_fantasyPoints":11.2,"_fantasyPointsAverage":1.12,"points":4,"goals":0,"assists":4,"penaltyMinutes":0,"plusMinus":-1,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":7,"blocked":0,"faceOffPct":50,"gameWinningGoals":0,"games":10,"timeOnIcePerGame":"10:54"},"currentTeamId":20},{"id":8478366,"firstName":"Frank","lastName":"Vatrano","fullName":"Frank Vatrano","number":"72","position":"C","stats":{"_fantasyPoints":49.2,"_fantasyPointsAverage":1.2,"points":10,"goals":7,"assists":3,"penaltyMinutes":34,"plusMinus":3,"hits":51,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":72,"blocked":15,"faceOffPct":52.63,"gameWinningGoals":0,"games":41,"timeOnIcePerGame":"10:50"},"currentTeamId":13},{"id":8471218,"firstName":"Blake","lastName":"Wheeler","fullName":"Blake Wheeler","number":"26","position":"RW","stats":{"_fantasyPoints":362.1,"_fantasyPointsAverage":4.47,"points":91,"goals":23,"assists":68,"penaltyMinutes":52,"plusMinus":13,"hits":94,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":2,"shots":246,"blocked":66,"faceOffPct":45.85,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"20:15"},"currentTeamId":52},{"id":8479986,"firstName":"Kole","lastName":"Lind","fullName":"Kole Lind","number":"78","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8477244,"firstName":"Chad","lastName":"Ruhwedel","fullName":"Chad Ruhwedel","number":"2","position":"D","stats":{"_fantasyPoints":54.2,"_fantasyPointsAverage":1.23,"points":5,"goals":2,"assists":3,"penaltyMinutes":16,"plusMinus":-8,"hits":67,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":67,"blocked":43,"faceOffPct":0,"gameWinningGoals":0,"games":44,"timeOnIcePerGame":"15:43"},"currentTeamId":5},{"id":8476459,"firstName":"Mika","lastName":"Zibanejad","fullName":"Mika Zibanejad","number":"93","position":"C","stats":{"_fantasyPoints":220.7,"_fantasyPointsAverage":3.07,"points":47,"goals":27,"assists":20,"penaltyMinutes":14,"plusMinus":-23,"hits":92,"powerPlayGoals":14,"powerPlayPoints":14,"shortHandedGoals":0,"shortHandedPoints":1,"shots":212,"blocked":64,"faceOffPct":50.81,"gameWinningGoals":4,"games":72,"timeOnIcePerGame":"17:57"},"currentTeamId":3},{"id":8470775,"firstName":"Nate","lastName":"Thompson","fullName":"Nate Thompson","number":"44","position":"C","stats":{"_fantasyPoints":105.05,"_fantasyPointsAverage":1.52,"points":17,"goals":5,"assists":12,"penaltyMinutes":20,"plusMinus":-1,"hits":122,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":53,"blocked":39,"faceOffPct":56.42,"gameWinningGoals":0,"games":69,"timeOnIcePerGame":"12:46"},"currentTeamId":26},{"id":8476495,"firstName":"Seth","lastName":"Griffith","fullName":"Seth Griffith","number":"25","position":"C","stats":{"_fantasyPoints":8,"_fantasyPointsAverage":0.38,"points":3,"goals":2,"assists":1,"penaltyMinutes":6,"plusMinus":-6,"hits":10,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":15,"blocked":4,"faceOffPct":0,"gameWinningGoals":0,"games":21,"timeOnIcePerGame":"10:33"},"currentTeamId":52},{"id":8478132,"firstName":"Emil","lastName":"Johansson","fullName":"Emil Johansson","number":"36","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8468611,"firstName":"Matt","lastName":"Hendricks","fullName":"Matt Hendricks","number":"15","position":"C","stats":{"_fantasyPoints":84.85,"_fantasyPointsAverage":1.41,"points":13,"goals":5,"assists":8,"penaltyMinutes":39,"plusMinus":-1,"hits":123,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":56,"blocked":42,"faceOffPct":49.34,"gameWinningGoals":0,"games":60,"timeOnIcePerGame":"09:25"},"currentTeamId":30},{"id":8478474,"firstName":"Lawson","lastName":"Crouse","fullName":"Lawson Crouse","number":"67","position":"LW","stats":{"_fantasyPoints":7.05,"_fantasyPointsAverage":0.64,"points":1,"goals":1,"assists":0,"penaltyMinutes":7,"plusMinus":-6,"hits":29,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":13,"blocked":6,"faceOffPct":27.27,"gameWinningGoals":0,"games":11,"timeOnIcePerGame":"10:56"},"currentTeamId":53},{"id":8476329,"firstName":"Travis","lastName":"Boyd","fullName":"Travis Boyd","number":"72","position":"C","stats":{"_fantasyPoints":4.95,"_fantasyPointsAverage":0.62,"points":1,"goals":0,"assists":1,"penaltyMinutes":2,"plusMinus":2,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":1,"faceOffPct":50,"gameWinningGoals":0,"games":8,"timeOnIcePerGame":"08:49"},"currentTeamId":15},{"id":8477474,"firstName":"Madison","lastName":"Bowey","fullName":"Madison Bowey","number":"22","position":"D","stats":{"_fantasyPoints":63.2,"_fantasyPointsAverage":1.24,"points":12,"goals":0,"assists":12,"penaltyMinutes":24,"plusMinus":-3,"hits":48,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":47,"blocked":42,"faceOffPct":0,"gameWinningGoals":0,"games":51,"timeOnIcePerGame":"13:42"},"currentTeamId":15},{"id":8474749,"firstName":"Matt","lastName":"Bartkowski","fullName":"Matt Bartkowski","number":"44","position":"D","stats":{"_fantasyPoints":22.1,"_fantasyPointsAverage":1.23,"points":3,"goals":0,"assists":3,"penaltyMinutes":4,"plusMinus":-3,"hits":31,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":21,"blocked":13,"faceOffPct":0,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"13:20"},"currentTeamId":30},{"id":8471273,"firstName":"Brandon","lastName":"Dubinsky","fullName":"Brandon Dubinsky","number":"17","position":"C","stats":{"_fantasyPoints":115.4,"_fantasyPointsAverage":1.86,"points":16,"goals":6,"assists":10,"penaltyMinutes":33,"plusMinus":-2,"hits":145,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":89,"blocked":47,"faceOffPct":54.72,"gameWinningGoals":0,"games":62,"timeOnIcePerGame":"15:20"},"currentTeamId":29},{"id":8475766,"firstName":"Austin","lastName":"Watson","fullName":"Austin Watson","number":"51","position":"LW","stats":{"_fantasyPoints":134.35,"_fantasyPointsAverage":1.77,"points":19,"goals":14,"assists":5,"penaltyMinutes":123,"plusMinus":2,"hits":187,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":4,"shortHandedPoints":5,"shots":96,"blocked":78,"faceOffPct":62.79,"gameWinningGoals":3,"games":76,"timeOnIcePerGame":"12:19"},"currentTeamId":18},{"id":8479974,"firstName":"Nolan","lastName":"Patrick","fullName":"Nolan Patrick","number":"19","position":"C","stats":{"_fantasyPoints":116.95,"_fantasyPointsAverage":1.6,"points":30,"goals":13,"assists":17,"penaltyMinutes":30,"plusMinus":1,"hits":48,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":127,"blocked":19,"faceOffPct":50.6,"gameWinningGoals":2,"games":73,"timeOnIcePerGame":"13:43"},"currentTeamId":4},{"id":8479944,"firstName":"Zach","lastName":"Aston-Reese","fullName":"Zach Aston-Reese","number":"46","position":"C","stats":{"_fantasyPoints":40.25,"_fantasyPointsAverage":2.52,"points":6,"goals":4,"assists":2,"penaltyMinutes":2,"plusMinus":2,"hits":55,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":20,"blocked":6,"faceOffPct":16.66,"gameWinningGoals":1,"games":16,"timeOnIcePerGame":"11:22"},"currentTeamId":5},{"id":8474673,"firstName":"TJ","lastName":"Brodie","fullName":"TJ Brodie","number":"7","position":"D","stats":{"_fantasyPoints":156.55,"_fantasyPointsAverage":2.14,"points":32,"goals":4,"assists":28,"penaltyMinutes":18,"plusMinus":-16,"hits":24,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":118,"blocked":99,"faceOffPct":0,"gameWinningGoals":0,"games":73,"timeOnIcePerGame":"23:40"},"currentTeamId":20},{"id":8478866,"firstName":"Dominik","lastName":"Simon","fullName":"Dominik Simon","number":"12","position":"C","stats":{"_fantasyPoints":54.35,"_fantasyPointsAverage":1.65,"points":12,"goals":4,"assists":8,"penaltyMinutes":16,"plusMinus":2,"hits":37,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":36,"blocked":18,"faceOffPct":42.85,"gameWinningGoals":0,"games":33,"timeOnIcePerGame":"11:25"},"currentTeamId":5},{"id":8479447,"firstName":"Anthony","lastName":"Greco","fullName":"Anthony Greco","number":"76","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8477429,"firstName":"Andrew","lastName":"Copp","fullName":"Andrew Copp","number":"9","position":"C","stats":{"_fantasyPoints":172.1,"_fantasyPointsAverage":2.1,"points":28,"goals":9,"assists":19,"penaltyMinutes":14,"plusMinus":17,"hits":99,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":2,"shortHandedPoints":3,"shots":96,"blocked":51,"faceOffPct":51.83,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"13:44"},"currentTeamId":52},{"id":8478466,"firstName":"Daniel","lastName":"Sprong","fullName":"Daniel Sprong","number":"41","position":"RW","stats":{"_fantasyPoints":18.95,"_fantasyPointsAverage":2.37,"points":3,"goals":2,"assists":1,"penaltyMinutes":0,"plusMinus":2,"hits":9,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":22,"blocked":4,"faceOffPct":0,"gameWinningGoals":1,"games":8,"timeOnIcePerGame":"13:58"},"currentTeamId":5},{"id":8476310,"firstName":"Lukas","lastName":"Sedlak","fullName":"Lukas Sedlak","number":"45","position":"C","stats":{"_fantasyPoints":54.25,"_fantasyPointsAverage":1.02,"points":8,"goals":4,"assists":4,"penaltyMinutes":21,"plusMinus":-3,"hits":77,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":50,"blocked":26,"faceOffPct":51.48,"gameWinningGoals":0,"games":53,"timeOnIcePerGame":"09:24"},"currentTeamId":29},{"id":8478922,"firstName":"Miroslav","lastName":"Svoboda","fullName":"Miroslav Svoboda","number":"34","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":18},{"id":8479193,"firstName":"Casey","lastName":"DeSmith","fullName":"Casey DeSmith","number":"1","position":"G","stats":{"_fantasyPoints":"48.60","_fantasyPointsAverage":"3.47","savePercentage":0.921,"goalAgainstAverage":2.4,"wins":6,"losses":4,"saves":328,"goalsAgainst":28,"shutouts":1},"currentTeamId":5},{"id":8477427,"firstName":"Tobias","lastName":"Lindberg","fullName":"Tobias Lindberg","number":"25","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":5},{"id":8475683,"firstName":"Sergei","lastName":"Bobrovsky","fullName":"Sergei Bobrovsky","number":"72","position":"G","stats":{"_fantasyPoints":"271.00","_fantasyPointsAverage":"4.17","savePercentage":0.921,"goalAgainstAverage":2.42,"wins":37,"losses":22,"saves":1835,"goalsAgainst":158,"shutouts":5},"currentTeamId":29},{"id":8473453,"firstName":"Trevor","lastName":"Lewis","fullName":"Trevor Lewis","number":"22","position":"C","stats":{"_fantasyPoints":137.65,"_fantasyPointsAverage":2.02,"points":26,"goals":14,"assists":12,"penaltyMinutes":25,"plusMinus":-6,"hits":125,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":2,"shortHandedPoints":2,"shots":134,"blocked":32,"faceOffPct":43.11,"gameWinningGoals":3,"games":68,"timeOnIcePerGame":"15:14"},"currentTeamId":26},{"id":8473575,"firstName":"Semyon","lastName":"Varlamov","fullName":"Semyon Varlamov","number":"1","position":"G","stats":{"_fantasyPoints":"199.40","_fantasyPointsAverage":"3.91","savePercentage":0.92,"goalAgainstAverage":2.68,"wins":24,"losses":16,"saves":1467,"goalsAgainst":128,"shutouts":2},"currentTeamId":21},{"id":8478585,"firstName":"Derek","lastName":"Ryan","fullName":"Derek Ryan","number":"10","position":"C","stats":{"_fantasyPoints":131.25,"_fantasyPointsAverage":1.64,"points":38,"goals":15,"assists":23,"penaltyMinutes":28,"plusMinus":-15,"hits":52,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":135,"blocked":27,"faceOffPct":56.48,"gameWinningGoals":1,"games":80,"timeOnIcePerGame":"15:36"},"currentTeamId":20},{"id":8476283,"firstName":"Alex","lastName":"Broadhurst","fullName":"Alex Broadhurst","number":"25","position":"C","stats":{"_fantasyPoints":-0.9,"_fantasyPointsAverage":-0.45,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"10:02"},"currentTeamId":29},{"id":8474166,"firstName":"Alec","lastName":"Martinez","fullName":"Alec Martinez","number":"27","position":"D","stats":{"_fantasyPoints":257.1,"_fantasyPointsAverage":3.34,"points":25,"goals":9,"assists":16,"penaltyMinutes":34,"plusMinus":3,"hits":100,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":1,"shots":111,"blocked":206,"faceOffPct":0,"gameWinningGoals":0,"games":77,"timeOnIcePerGame":"22:51"},"currentTeamId":26},{"id":8471306,"firstName":"Thomas","lastName":"Greiss","fullName":"Thomas Greiss","number":"1","position":"G","stats":{"_fantasyPoints":"79.80","_fantasyPointsAverage":"2.96","savePercentage":0.892,"goalAgainstAverage":3.82,"wins":13,"losses":8,"saves":784,"goalsAgainst":95,"shutouts":1},"currentTeamId":2},{"id":8473548,"firstName":"Phil","lastName":"Kessel","fullName":"Phil Kessel","number":"81","position":"RW","stats":{"_fantasyPoints":304.35,"_fantasyPointsAverage":3.71,"points":92,"goals":34,"assists":58,"penaltyMinutes":36,"plusMinus":-4,"hits":10,"powerPlayGoals":12,"powerPlayPoints":12,"shortHandedGoals":0,"shortHandedPoints":0,"shots":261,"blocked":17,"faceOffPct":31.57,"gameWinningGoals":6,"games":82,"timeOnIcePerGame":"18:41"},"currentTeamId":5},{"id":8479610,"firstName":"Petrus","lastName":"Palmu","fullName":"Petrus Palmu","number":"86","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8474190,"firstName":"Wayne","lastName":"Simmonds","fullName":"Wayne Simmonds","number":"17","position":"RW","stats":{"_fantasyPoints":196.85,"_fantasyPointsAverage":2.62,"points":46,"goals":24,"assists":22,"penaltyMinutes":57,"plusMinus":-16,"hits":129,"powerPlayGoals":11,"powerPlayPoints":11,"shortHandedGoals":1,"shortHandedPoints":1,"shots":176,"blocked":54,"faceOffPct":57.14,"gameWinningGoals":5,"games":75,"timeOnIcePerGame":"18:05"},"currentTeamId":4},{"id":8477500,"firstName":"Bo","lastName":"Horvat","fullName":"Bo Horvat","number":"53","position":"C","stats":{"_fantasyPoints":182.3,"_fantasyPointsAverage":2.85,"points":44,"goals":22,"assists":22,"penaltyMinutes":10,"plusMinus":-1,"hits":35,"powerPlayGoals":10,"powerPlayPoints":10,"shortHandedGoals":1,"shortHandedPoints":1,"shots":158,"blocked":29,"faceOffPct":53.77,"gameWinningGoals":3,"games":64,"timeOnIcePerGame":"19:20"},"currentTeamId":23},{"id":8473419,"firstName":"Brad","lastName":"Marchand","fullName":"Brad Marchand","number":"63","position":"LW","stats":{"_fantasyPoints":311.7,"_fantasyPointsAverage":4.58,"points":85,"goals":34,"assists":51,"penaltyMinutes":63,"plusMinus":25,"hits":37,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":1,"shortHandedPoints":4,"shots":182,"blocked":25,"faceOffPct":39.68,"gameWinningGoals":8,"games":68,"timeOnIcePerGame":"19:42"},"currentTeamId":6},{"id":8475799,"firstName":"Nino","lastName":"Niederreiter","fullName":"Nino Niederreiter","number":"22","position":"RW","stats":{"_fantasyPoints":140.8,"_fantasyPointsAverage":2.23,"points":32,"goals":18,"assists":14,"penaltyMinutes":36,"plusMinus":14,"hits":58,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":133,"blocked":20,"faceOffPct":45.45,"gameWinningGoals":4,"games":63,"timeOnIcePerGame":"15:00"},"currentTeamId":30},{"id":8476934,"firstName":"Brock","lastName":"McGinn","fullName":"Brock McGinn","number":"23","position":"LW","stats":{"_fantasyPoints":135.9,"_fantasyPointsAverage":1.7,"points":30,"goals":16,"assists":14,"penaltyMinutes":22,"plusMinus":-12,"hits":137,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":1,"shortHandedPoints":1,"shots":159,"blocked":17,"faceOffPct":45.94,"gameWinningGoals":1,"games":80,"timeOnIcePerGame":"14:29"},"currentTeamId":12},{"id":8477441,"firstName":"Jordan","lastName":"Subban","fullName":"Jordan Subban","number":"46","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8476955,"firstName":"Taylor","lastName":"Leier","fullName":"Taylor Leier","number":"20","position":"LW","stats":{"_fantasyPoints":25.05,"_fantasyPointsAverage":0.64,"points":5,"goals":1,"assists":4,"penaltyMinutes":6,"plusMinus":-7,"hits":10,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":48,"blocked":19,"faceOffPct":60,"gameWinningGoals":0,"games":39,"timeOnIcePerGame":"10:29"},"currentTeamId":4},{"id":8473504,"firstName":"Cal","lastName":"Clutterbuck","fullName":"Cal Clutterbuck","number":"15","position":"RW","stats":{"_fantasyPoints":129.35,"_fantasyPointsAverage":1.7,"points":18,"goals":8,"assists":10,"penaltyMinutes":53,"plusMinus":-7,"hits":226,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":101,"blocked":53,"faceOffPct":35,"gameWinningGoals":1,"games":76,"timeOnIcePerGame":"12:47"},"currentTeamId":2},{"id":8475598,"firstName":"Ryan","lastName":"Stanton","fullName":"Ryan Stanton","number":"20","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":22},{"id":8471685,"firstName":"Anze","lastName":"Kopitar","fullName":"Anze Kopitar","number":"11","position":"C","stats":{"_fantasyPoints":377,"_fantasyPointsAverage":4.6,"points":92,"goals":35,"assists":57,"penaltyMinutes":20,"plusMinus":21,"hits":50,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":2,"shots":200,"blocked":64,"faceOffPct":54.13,"gameWinningGoals":6,"games":82,"timeOnIcePerGame":"22:05"},"currentTeamId":26},{"id":8475735,"firstName":"Greg","lastName":"McKegg","fullName":"Greg McKegg","number":"42","position":"C","stats":{"_fantasyPoints":21.85,"_fantasyPointsAverage":0.84,"points":4,"goals":2,"assists":2,"penaltyMinutes":8,"plusMinus":-4,"hits":19,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":21,"blocked":10,"faceOffPct":49.35,"gameWinningGoals":0,"games":26,"timeOnIcePerGame":"09:40"},"currentTeamId":12},{"id":8478034,"firstName":"Ryan","lastName":"Mantha","fullName":"Ryan Mantha","number":"90","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":22},{"id":8476444,"firstName":"Christopher","lastName":"Gibson","fullName":"Christopher Gibson","number":"33","position":"G","stats":{"_fantasyPoints":"27.60","_fantasyPointsAverage":"3.45","savePercentage":0.908,"goalAgainstAverage":3.65,"wins":2,"losses":3,"saves":258,"goalsAgainst":26,"shutouts":0},"currentTeamId":2},{"id":8477451,"firstName":"Ryan","lastName":"Hartman","fullName":"Ryan Hartman","number":"38","position":"RW","stats":{"_fantasyPoints":124.15,"_fantasyPointsAverage":1.59,"points":31,"goals":11,"assists":20,"penaltyMinutes":72,"plusMinus":1,"hits":113,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":129,"blocked":38,"faceOffPct":45.81,"gameWinningGoals":2,"games":78,"timeOnIcePerGame":"13:03"},"currentTeamId":18},{"id":8477959,"firstName":"Joshua","lastName":"Ho-Sang","fullName":"Joshua Ho-Sang","number":"26","position":"RW","stats":{"_fantasyPoints":27.8,"_fantasyPointsAverage":1.26,"points":12,"goals":2,"assists":10,"penaltyMinutes":2,"plusMinus":-7,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":18,"blocked":1,"faceOffPct":40,"gameWinningGoals":0,"games":22,"timeOnIcePerGame":"14:16"},"currentTeamId":2},{"id":8476915,"firstName":"Jujhar","lastName":"Khaira","fullName":"Jujhar Khaira","number":"16","position":"LW","stats":{"_fantasyPoints":109.05,"_fantasyPointsAverage":1.58,"points":21,"goals":11,"assists":10,"penaltyMinutes":47,"plusMinus":-7,"hits":128,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":73,"blocked":39,"faceOffPct":45.43,"gameWinningGoals":2,"games":69,"timeOnIcePerGame":"12:42"},"currentTeamId":22},{"id":8470600,"firstName":"Ryan","lastName":"Suter","fullName":"Ryan Suter","number":"20","position":"D","stats":{"_fantasyPoints":268.4,"_fantasyPointsAverage":3.44,"points":51,"goals":6,"assists":45,"penaltyMinutes":34,"plusMinus":-1,"hits":78,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":149,"blocked":138,"faceOffPct":0,"gameWinningGoals":2,"games":78,"timeOnIcePerGame":"26:46"},"currentTeamId":30},{"id":8471469,"firstName":"Pekka","lastName":"Rinne","fullName":"Pekka Rinne","number":"35","position":"G","stats":{"_fantasyPoints":"289.20","_fantasyPointsAverage":"4.90","savePercentage":0.927,"goalAgainstAverage":2.31,"wins":42,"losses":13,"saves":1706,"goalsAgainst":134,"shutouts":8},"currentTeamId":18},{"id":8475177,"firstName":"Calvin","lastName":"de Haan","fullName":"Calvin de Haan","number":"44","position":"D","stats":{"_fantasyPoints":102.4,"_fantasyPointsAverage":3.1,"points":12,"goals":1,"assists":11,"penaltyMinutes":8,"plusMinus":11,"hits":45,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":44,"blocked":65,"faceOffPct":0,"gameWinningGoals":0,"games":33,"timeOnIcePerGame":"18:44"},"currentTeamId":12},{"id":8476858,"firstName":"Phillip","lastName":"Di Giuseppe","fullName":"Phillip Di Giuseppe","number":"7","position":"LW","stats":{"_fantasyPoints":67.9,"_fantasyPointsAverage":1.39,"points":13,"goals":5,"assists":8,"penaltyMinutes":17,"plusMinus":0,"hits":88,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":64,"blocked":14,"faceOffPct":0,"gameWinningGoals":1,"games":49,"timeOnIcePerGame":"10:30"},"currentTeamId":12},{"id":8480865,"firstName":"Noah","lastName":"Dobson","fullName":"Noah Dobson","number":"45","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8471392,"firstName":"Roman","lastName":"Polak","fullName":"Roman Polak","number":"45","position":"D","stats":{"_fantasyPoints":114.45,"_fantasyPointsAverage":2.12,"points":12,"goals":2,"assists":10,"penaltyMinutes":46,"plusMinus":5,"hits":131,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":47,"blocked":84,"faceOffPct":0,"gameWinningGoals":0,"games":54,"timeOnIcePerGame":"17:38"},"currentTeamId":25},{"id":8470760,"firstName":"Marc","lastName":"Methot","fullName":"Marc Methot","number":"33","position":"D","stats":{"_fantasyPoints":64.75,"_fantasyPointsAverage":1.8,"points":3,"goals":1,"assists":2,"penaltyMinutes":31,"plusMinus":11,"hits":77,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":25,"blocked":52,"faceOffPct":0,"gameWinningGoals":0,"games":36,"timeOnIcePerGame":"17:53"},"currentTeamId":25},{"id":8478445,"firstName":"Mathew","lastName":"Barzal","fullName":"Mathew Barzal","number":"13","position":"C","stats":{"_fantasyPoints":279.5,"_fantasyPointsAverage":3.41,"points":85,"goals":22,"assists":63,"penaltyMinutes":30,"plusMinus":1,"hits":21,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":170,"blocked":31,"faceOffPct":42.56,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"17:45"},"currentTeamId":2},{"id":8479206,"firstName":"Tanner","lastName":"Fritz","fullName":"Tanner Fritz","number":"11","position":"C","stats":{"_fantasyPoints":50.45,"_fantasyPointsAverage":1.48,"points":7,"goals":3,"assists":4,"penaltyMinutes":8,"plusMinus":-3,"hits":59,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":27,"blocked":26,"faceOffPct":43.51,"gameWinningGoals":0,"games":34,"timeOnIcePerGame":"12:31"},"currentTeamId":2},{"id":8478017,"firstName":"Mark","lastName":"Friedman","fullName":"Mark Friedman","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8475220,"firstName":"Marcus","lastName":"Foligno","fullName":"Marcus Foligno","number":"17","position":"LW","stats":{"_fantasyPoints":119.65,"_fantasyPointsAverage":1.55,"points":23,"goals":8,"assists":15,"penaltyMinutes":72,"plusMinus":2,"hits":185,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":79,"blocked":44,"faceOffPct":47.36,"gameWinningGoals":2,"games":77,"timeOnIcePerGame":"10:51"},"currentTeamId":30},{"id":8478463,"firstName":"Anthony","lastName":"Beauvillier","fullName":"Anthony Beauvillier","number":"18","position":"C","stats":{"_fantasyPoints":163.95,"_fantasyPointsAverage":2.31,"points":36,"goals":21,"assists":15,"penaltyMinutes":16,"plusMinus":2,"hits":80,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":132,"blocked":29,"faceOffPct":43.37,"gameWinningGoals":2,"games":71,"timeOnIcePerGame":"14:31"},"currentTeamId":2},{"id":8479962,"firstName":"John","lastName":"Stevens","fullName":"John Stevens","number":"58","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8478371,"firstName":"Matt","lastName":"Lorito","fullName":"Matt Lorito","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8478025,"firstName":"Linus","lastName":"Soderstrom","fullName":"Linus Soderstrom","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":2},{"id":8477341,"firstName":"Andreas","lastName":"Johnsson","fullName":"Andreas Johnsson","number":"18","position":"LW","stats":{"_fantasyPoints":14.9,"_fantasyPointsAverage":1.66,"points":3,"goals":2,"assists":1,"penaltyMinutes":0,"plusMinus":-2,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":19,"blocked":5,"faceOffPct":33.33,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"11:42"},"currentTeamId":10},{"id":8477406,"firstName":"Mattias","lastName":"Janmark","fullName":"Mattias Janmark","number":"13","position":"C","stats":{"_fantasyPoints":136.6,"_fantasyPointsAverage":1.69,"points":34,"goals":19,"assists":15,"penaltyMinutes":24,"plusMinus":-13,"hits":15,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":2,"shortHandedPoints":2,"shots":136,"blocked":41,"faceOffPct":39.44,"gameWinningGoals":4,"games":81,"timeOnIcePerGame":"16:55"},"currentTeamId":25},{"id":8479316,"firstName":"Luke","lastName":"Kunin","fullName":"Luke Kunin","number":"19","position":"C","stats":{"_fantasyPoints":23.7,"_fantasyPointsAverage":1.25,"points":4,"goals":2,"assists":2,"penaltyMinutes":13,"plusMinus":-3,"hits":34,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":32,"blocked":8,"faceOffPct":44.44,"gameWinningGoals":0,"games":19,"timeOnIcePerGame":"12:58"},"currentTeamId":30},{"id":8474625,"firstName":"Jimmy","lastName":"Hayes","fullName":"Jimmy Hayes","number":"11","position":"RW","stats":{"_fantasyPoints":41.7,"_fantasyPointsAverage":1.26,"points":9,"goals":3,"assists":6,"penaltyMinutes":6,"plusMinus":-2,"hits":50,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":37,"blocked":6,"faceOffPct":40,"gameWinningGoals":2,"games":33,"timeOnIcePerGame":"11:55"},"currentTeamId":5},{"id":8474091,"firstName":"Brandon","lastName":"Sutter","fullName":"Brandon Sutter","number":"20","position":"C","stats":{"_fantasyPoints":142.35,"_fantasyPointsAverage":2.33,"points":26,"goals":11,"assists":15,"penaltyMinutes":8,"plusMinus":8,"hits":55,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":4,"shots":106,"blocked":32,"faceOffPct":51.72,"gameWinningGoals":1,"games":61,"timeOnIcePerGame":"17:18"},"currentTeamId":23},{"id":8479566,"firstName":"David","lastName":"Quenneville","fullName":"David Quenneville","number":"42","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8474573,"firstName":"Josh","lastName":"Bailey","fullName":"Josh Bailey","number":"12","position":"RW","stats":{"_fantasyPoints":225.35,"_fantasyPointsAverage":2.97,"points":71,"goals":18,"assists":53,"penaltyMinutes":17,"plusMinus":-20,"hits":12,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":151,"blocked":33,"faceOffPct":22,"gameWinningGoals":3,"games":76,"timeOnIcePerGame":"17:53"},"currentTeamId":2},{"id":8479343,"firstName":"Clayton","lastName":"Keller","fullName":"Clayton Keller","number":"9","position":"C","stats":{"_fantasyPoints":223.95,"_fantasyPointsAverage":2.73,"points":65,"goals":23,"assists":42,"penaltyMinutes":24,"plusMinus":-7,"hits":7,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":1,"shots":212,"blocked":28,"faceOffPct":47.43,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"18:05"},"currentTeamId":53},{"id":8478415,"firstName":"Jakub","lastName":"Zboril","fullName":"Jakub Zboril","number":"67","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8475314,"firstName":"Anders","lastName":"Lee","fullName":"Anders Lee","number":"27","position":"LW","stats":{"_fantasyPoints":233.8,"_fantasyPointsAverage":2.85,"points":62,"goals":40,"assists":22,"penaltyMinutes":44,"plusMinus":-25,"hits":102,"powerPlayGoals":14,"powerPlayPoints":14,"shortHandedGoals":0,"shortHandedPoints":0,"shots":208,"blocked":38,"faceOffPct":68.75,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"17:16"},"currentTeamId":2},{"id":8475246,"firstName":"Kevin","lastName":"Connauton","fullName":"Kevin Connauton","number":"44","position":"D","stats":{"_fantasyPoints":149.7,"_fantasyPointsAverage":2.05,"points":21,"goals":11,"assists":10,"penaltyMinutes":20,"plusMinus":3,"hits":116,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":102,"blocked":72,"faceOffPct":0,"gameWinningGoals":3,"games":73,"timeOnIcePerGame":"15:10"},"currentTeamId":53},{"id":8477936,"firstName":"Michael","lastName":"Dal Colle","fullName":"Michael Dal Colle","number":"21","position":"LW","stats":{"_fantasyPoints":1.1,"_fantasyPointsAverage":0.28,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"13:21"},"currentTeamId":2},{"id":8476871,"firstName":"Tanner","lastName":"Pearson","fullName":"Tanner Pearson","number":"70","position":"LW","stats":{"_fantasyPoints":189,"_fantasyPointsAverage":2.3,"points":40,"goals":15,"assists":25,"penaltyMinutes":27,"plusMinus":11,"hits":116,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":180,"blocked":36,"faceOffPct":49.31,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"15:58"},"currentTeamId":26},{"id":8478481,"firstName":"Mitchell","lastName":"Vande Sompel","fullName":"Mitchell Vande Sompel","number":"39","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8475436,"firstName":"Mike","lastName":"Liambas","fullName":"Mike Liambas","position":"LW","stats":{"_fantasyPoints":-3.2,"_fantasyPointsAverage":-0.46,"points":1,"goals":0,"assists":1,"penaltyMinutes":21,"plusMinus":0,"hits":15,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":3,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":7,"timeOnIcePerGame":"05:17"},"currentTeamId":30},{"id":8477501,"firstName":"Valeri","lastName":"Nichushkin","fullName":"Valeri Nichushkin","number":"43","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":25},{"id":8477831,"firstName":"Pheonix","lastName":"Copley","fullName":"Pheonix Copley","number":"1","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":15},{"id":8477943,"firstName":"Brendan","lastName":"Perlini","fullName":"Brendan Perlini","number":"11","position":"LW","stats":{"_fantasyPoints":140.65,"_fantasyPointsAverage":1.9,"points":30,"goals":17,"assists":13,"penaltyMinutes":28,"plusMinus":-2,"hits":83,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":129,"blocked":34,"faceOffPct":45.45,"gameWinningGoals":1,"games":74,"timeOnIcePerGame":"14:30"},"currentTeamId":53},{"id":8478061,"firstName":"Joonas","lastName":"Lyytinen","fullName":"Joonas Lyytinen","number":"60","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8475218,"firstName":"Mattias","lastName":"Ekholm","fullName":"Mattias Ekholm","number":"14","position":"D","stats":{"_fantasyPoints":227,"_fantasyPointsAverage":2.8,"points":34,"goals":10,"assists":24,"penaltyMinutes":46,"plusMinus":25,"hits":75,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":1,"shortHandedPoints":1,"shots":135,"blocked":117,"faceOffPct":0,"gameWinningGoals":1,"games":81,"timeOnIcePerGame":"23:34"},"currentTeamId":18},{"id":8476966,"firstName":"Gemel","lastName":"Smith","fullName":"Gemel Smith","number":"46","position":"C","stats":{"_fantasyPoints":52.2,"_fantasyPointsAverage":1.13,"points":11,"goals":6,"assists":5,"penaltyMinutes":17,"plusMinus":5,"hits":33,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":42,"blocked":13,"faceOffPct":45.74,"gameWinningGoals":0,"games":46,"timeOnIcePerGame":"09:25"},"currentTeamId":25},{"id":8471228,"firstName":"Alexander","lastName":"Radulov","fullName":"Alexander Radulov","number":"47","position":"RW","stats":{"_fantasyPoints":275.45,"_fantasyPointsAverage":3.36,"points":72,"goals":27,"assists":45,"penaltyMinutes":72,"plusMinus":4,"hits":77,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":217,"blocked":64,"faceOffPct":60,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"20:07"},"currentTeamId":25},{"id":8475274,"firstName":"Seth","lastName":"Helgeson","fullName":"Seth Helgeson","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8476465,"firstName":"Ryan","lastName":"Murphy","fullName":"Ryan Murphy","number":"6","position":"D","stats":{"_fantasyPoints":33,"_fantasyPointsAverage":1.57,"points":5,"goals":2,"assists":3,"penaltyMinutes":16,"plusMinus":8,"hits":5,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":25,"blocked":19,"faceOffPct":0,"gameWinningGoals":0,"games":21,"timeOnIcePerGame":"19:00"},"currentTeamId":30},{"id":8475722,"firstName":"Jason","lastName":"Zucker","fullName":"Jason Zucker","number":"16","position":"LW","stats":{"_fantasyPoints":271.45,"_fantasyPointsAverage":3.31,"points":64,"goals":33,"assists":31,"penaltyMinutes":44,"plusMinus":8,"hits":80,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":1,"shortHandedPoints":2,"shots":222,"blocked":47,"faceOffPct":22.22,"gameWinningGoals":7,"games":82,"timeOnIcePerGame":"16:57"},"currentTeamId":30},{"id":8470611,"firstName":"Eric","lastName":"Fehr","fullName":"Eric Fehr","number":"21","position":"C","stats":{"_fantasyPoints":37.2,"_fantasyPointsAverage":2.07,"points":4,"goals":3,"assists":1,"penaltyMinutes":2,"plusMinus":6,"hits":24,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":27,"blocked":14,"faceOffPct":47.48,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"11:46"},"currentTeamId":30},{"id":8480943,"firstName":"Igor","lastName":"Ozhiganov","fullName":"Igor Ozhiganov","number":"92","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8474602,"firstName":"Justin","lastName":"Schultz","fullName":"Justin Schultz","number":"4","position":"D","stats":{"_fantasyPoints":181.15,"_fantasyPointsAverage":2.88,"points":27,"goals":4,"assists":23,"penaltyMinutes":14,"plusMinus":22,"hits":36,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":109,"blocked":93,"faceOffPct":0,"gameWinningGoals":1,"games":63,"timeOnIcePerGame":"19:30"},"currentTeamId":5},{"id":8475209,"firstName":"Richard","lastName":"Panik","fullName":"Richard Panik","number":"14","position":"RW","stats":{"_fantasyPoints":168.1,"_fantasyPointsAverage":2.33,"points":35,"goals":14,"assists":21,"penaltyMinutes":38,"plusMinus":7,"hits":137,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":136,"blocked":37,"faceOffPct":33.33,"gameWinningGoals":0,"games":72,"timeOnIcePerGame":"15:11"},"currentTeamId":53},{"id":8479968,"firstName":"Vinni","lastName":"Lettieri","fullName":"Vinni Lettieri","number":"95","position":"C","stats":{"_fantasyPoints":14.8,"_fantasyPointsAverage":0.78,"points":5,"goals":1,"assists":4,"penaltyMinutes":0,"plusMinus":-12,"hits":22,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":28,"blocked":6,"faceOffPct":41.66,"gameWinningGoals":0,"games":19,"timeOnIcePerGame":"12:03"},"currentTeamId":3},{"id":8480901,"firstName":"Karson","lastName":"Kuhlman","fullName":"Karson Kuhlman","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8475758,"firstName":"Devante","lastName":"Smith-Pelly","fullName":"Devante Smith-Pelly","number":"25","position":"RW","stats":{"_fantasyPoints":116.55,"_fantasyPointsAverage":1.55,"points":16,"goals":7,"assists":9,"penaltyMinutes":38,"plusMinus":-6,"hits":151,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":103,"blocked":62,"faceOffPct":48.48,"gameWinningGoals":1,"games":75,"timeOnIcePerGame":"12:20"},"currentTeamId":15},{"id":8475752,"firstName":"Tyler","lastName":"Pitlick","fullName":"Tyler Pitlick","number":"18","position":"C","stats":{"_fantasyPoints":163.15,"_fantasyPointsAverage":2.04,"points":27,"goals":14,"assists":13,"penaltyMinutes":34,"plusMinus":9,"hits":122,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":129,"blocked":57,"faceOffPct":27.66,"gameWinningGoals":2,"games":80,"timeOnIcePerGame":"13:40"},"currentTeamId":25},{"id":8473584,"firstName":"Andrew","lastName":"MacDonald","fullName":"Andrew MacDonald","number":"47","position":"D","stats":{"_fantasyPoints":170.45,"_fantasyPointsAverage":2.58,"points":21,"goals":6,"assists":15,"penaltyMinutes":30,"plusMinus":8,"hits":36,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":82,"blocked":131,"faceOffPct":0,"gameWinningGoals":2,"games":66,"timeOnIcePerGame":"19:51"},"currentTeamId":4},{"id":8473512,"firstName":"Claude","lastName":"Giroux","fullName":"Claude Giroux","number":"28","position":"C","stats":{"_fantasyPoints":369.05,"_fantasyPointsAverage":4.5,"points":102,"goals":34,"assists":68,"penaltyMinutes":20,"plusMinus":28,"hits":30,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":193,"blocked":23,"faceOffPct":58.64,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"20:21"},"currentTeamId":4},{"id":8478444,"firstName":"Brock","lastName":"Boeser","fullName":"Brock Boeser","number":"6","position":"RW","stats":{"_fantasyPoints":208.15,"_fantasyPointsAverage":3.36,"points":55,"goals":29,"assists":26,"penaltyMinutes":16,"plusMinus":-5,"hits":29,"powerPlayGoals":10,"powerPlayPoints":10,"shortHandedGoals":0,"shortHandedPoints":0,"shots":179,"blocked":24,"faceOffPct":25.64,"gameWinningGoals":4,"games":62,"timeOnIcePerGame":"17:29"},"currentTeamId":23},{"id":8475754,"firstName":"Brock","lastName":"Nelson","fullName":"Brock Nelson","number":"29","position":"C","stats":{"_fantasyPoints":150.3,"_fantasyPointsAverage":1.83,"points":35,"goals":19,"assists":16,"penaltyMinutes":43,"plusMinus":-4,"hits":50,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":138,"blocked":52,"faceOffPct":48.32,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"14:43"},"currentTeamId":2},{"id":8478020,"firstName":"Michael","lastName":"Amadio","fullName":"Michael Amadio","number":"52","position":"C","stats":{"_fantasyPoints":33.55,"_fantasyPointsAverage":0.91,"points":8,"goals":4,"assists":4,"penaltyMinutes":8,"plusMinus":-2,"hits":18,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":28,"blocked":9,"faceOffPct":43.52,"gameWinningGoals":0,"games":37,"timeOnIcePerGame":"09:18"},"currentTeamId":26},{"id":8477462,"firstName":"Robert","lastName":"Hagg","fullName":"Robert Hagg","number":"8","position":"D","stats":{"_fantasyPoints":157.9,"_fantasyPointsAverage":2.26,"points":9,"goals":3,"assists":6,"penaltyMinutes":32,"plusMinus":5,"hits":238,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":89,"blocked":100,"faceOffPct":0,"gameWinningGoals":0,"games":70,"timeOnIcePerGame":"18:08"},"currentTeamId":4},{"id":8475789,"firstName":"Jack","lastName":"Campbell","fullName":"Jack Campbell","number":"1","position":"G","stats":{"_fantasyPoints":"17.80","_fantasyPointsAverage":"3.56","savePercentage":0.924,"goalAgainstAverage":2.47,"wins":2,"losses":0,"saves":134,"goalsAgainst":11,"shutouts":0},"currentTeamId":26},{"id":8477399,"firstName":"Tyrell","lastName":"Goulbourne","fullName":"Tyrell Goulbourne","number":"56","position":"LW","stats":{"_fantasyPoints":2.45,"_fantasyPointsAverage":0.27,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":-2,"hits":15,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"05:35"},"currentTeamId":4},{"id":8476872,"firstName":"Scott","lastName":"Laughton","fullName":"Scott Laughton","number":"21","position":"C","stats":{"_fantasyPoints":95.05,"_fantasyPointsAverage":1.17,"points":20,"goals":10,"assists":10,"penaltyMinutes":42,"plusMinus":-10,"hits":126,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":108,"blocked":27,"faceOffPct":51.98,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"11:07"},"currentTeamId":4},{"id":8481124,"firstName":"Zachary","lastName":"Magwood","fullName":"Zachary Magwood","number":"78","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":18},{"id":8480801,"firstName":"Brady","lastName":"Tkachuk","fullName":"Brady Tkachuk","number":"7","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8475204,"firstName":"Brandon","lastName":"Pirri","fullName":"Brandon Pirri","number":"73","position":"C","stats":{"_fantasyPoints":15.1,"_fantasyPointsAverage":7.55,"points":3,"goals":3,"assists":0,"penaltyMinutes":0,"plusMinus":3,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":11,"blocked":0,"faceOffPct":50,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"17:37"},"currentTeamId":54},{"id":8479002,"firstName":"Gabriel","lastName":"Fontaine","fullName":"Gabriel Fontaine","number":"37","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8479353,"firstName":"Brett","lastName":"Howden","fullName":"Brett Howden","number":"48","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8479458,"firstName":"Nikita","lastName":"Zaitsev","fullName":"Nikita Zaitsev","number":"22","position":"D","stats":{"_fantasyPoints":164.15,"_fantasyPointsAverage":2.74,"points":13,"goals":5,"assists":8,"penaltyMinutes":31,"plusMinus":8,"hits":113,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":54,"blocked":134,"faceOffPct":0,"gameWinningGoals":1,"games":60,"timeOnIcePerGame":"22:13"},"currentTeamId":10},{"id":8478975,"firstName":"Mason","lastName":"Marchment","fullName":"Mason Marchment","number":"53","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8470595,"firstName":"Eric","lastName":"Staal","fullName":"Eric Staal","number":"12","position":"C","stats":{"_fantasyPoints":309.35,"_fantasyPointsAverage":3.77,"points":76,"goals":42,"assists":34,"penaltyMinutes":42,"plusMinus":8,"hits":42,"powerPlayGoals":11,"powerPlayPoints":11,"shortHandedGoals":2,"shortHandedPoints":3,"shots":241,"blocked":49,"faceOffPct":51.21,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"17:48"},"currentTeamId":30},{"id":8478042,"firstName":"Viktor","lastName":"Arvidsson","fullName":"Viktor Arvidsson","number":"33","position":"LW","stats":{"_fantasyPoints":269.2,"_fantasyPointsAverage":3.45,"points":61,"goals":29,"assists":32,"penaltyMinutes":36,"plusMinus":20,"hits":30,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":3,"shortHandedPoints":3,"shots":247,"blocked":52,"faceOffPct":33.33,"gameWinningGoals":6,"games":78,"timeOnIcePerGame":"17:44"},"currentTeamId":18},{"id":8479388,"firstName":"Riley","lastName":"Stillman","fullName":"Riley Stillman","number":"70","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8477043,"firstName":"Christian","lastName":"Djoos","fullName":"Christian Djoos","number":"29","position":"D","stats":{"_fantasyPoints":98.75,"_fantasyPointsAverage":1.57,"points":14,"goals":3,"assists":11,"penaltyMinutes":10,"plusMinus":13,"hits":22,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":60,"blocked":55,"faceOffPct":0,"gameWinningGoals":0,"games":63,"timeOnIcePerGame":"14:02"},"currentTeamId":15},{"id":8474688,"firstName":"Greg","lastName":"Pateryn","fullName":"Greg Pateryn","number":"29","position":"D","stats":{"_fantasyPoints":174.25,"_fantasyPointsAverage":2.39,"points":13,"goals":1,"assists":12,"penaltyMinutes":50,"plusMinus":6,"hits":155,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":100,"blocked":148,"faceOffPct":0,"gameWinningGoals":0,"games":73,"timeOnIcePerGame":"19:36"},"currentTeamId":30},{"id":8480965,"firstName":"Antti","lastName":"Suomela","fullName":"Antti Suomela","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8473607,"firstName":"Michal","lastName":"Neuvirth","fullName":"Michal Neuvirth","number":"30","position":"G","stats":{"_fantasyPoints":"66.00","_fantasyPointsAverage":"3.00","savePercentage":0.915,"goalAgainstAverage":2.6,"wins":9,"losses":7,"saves":485,"goalsAgainst":45,"shutouts":1},"currentTeamId":4},{"id":8471217,"firstName":"Andrew","lastName":"Ladd","fullName":"Andrew Ladd","number":"16","position":"LW","stats":{"_fantasyPoints":151.2,"_fantasyPointsAverage":2.07,"points":29,"goals":12,"assists":17,"penaltyMinutes":24,"plusMinus":11,"hits":76,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":112,"blocked":40,"faceOffPct":10,"gameWinningGoals":2,"games":73,"timeOnIcePerGame":"15:53"},"currentTeamId":2},{"id":8477958,"firstName":"Nikolay","lastName":"Goldobin","fullName":"Nikolay Goldobin","number":"77","position":"RW","stats":{"_fantasyPoints":40.25,"_fantasyPointsAverage":1.06,"points":14,"goals":8,"assists":6,"penaltyMinutes":6,"plusMinus":-14,"hits":12,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":50,"blocked":7,"faceOffPct":50,"gameWinningGoals":0,"games":38,"timeOnIcePerGame":"12:20"},"currentTeamId":23},{"id":8477234,"firstName":"Troy","lastName":"Grosenick","fullName":"Troy Grosenick","number":"1","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":18},{"id":8477502,"firstName":"Samuel","lastName":"Morin","fullName":"Samuel Morin","number":"5","position":"D","stats":{"_fantasyPoints":1.6,"_fantasyPointsAverage":0.8,"points":0,"goals":0,"assists":0,"penaltyMinutes":4,"plusMinus":1,"hits":7,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"15:48"},"currentTeamId":4},{"id":8475717,"firstName":"Calvin","lastName":"Pickard","fullName":"Calvin Pickard","number":"30","position":"G","stats":{"_fantasyPoints":"0.80","_fantasyPointsAverage":"0.80","savePercentage":0.857,"goalAgainstAverage":3.81,"wins":0,"losses":0,"saves":24,"goalsAgainst":4,"shutouts":0},"currentTeamId":10},{"id":8473544,"firstName":"Derick","lastName":"Brassard","fullName":"Derick Brassard","number":"19","position":"C","stats":{"_fantasyPoints":184.45,"_fantasyPointsAverage":2.56,"points":46,"goals":21,"assists":25,"penaltyMinutes":34,"plusMinus":0,"hits":96,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":197,"blocked":25,"faceOffPct":49.14,"gameWinningGoals":3,"games":72,"timeOnIcePerGame":"17:43"},"currentTeamId":5},{"id":8471699,"firstName":"Andrew","lastName":"Cogliano","fullName":"Andrew Cogliano","number":"7","position":"LW","stats":{"_fantasyPoints":171.75,"_fantasyPointsAverage":2.15,"points":35,"goals":12,"assists":23,"penaltyMinutes":41,"plusMinus":18,"hits":80,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":3,"shortHandedPoints":4,"shots":175,"blocked":31,"faceOffPct":49.29,"gameWinningGoals":1,"games":80,"timeOnIcePerGame":"15:11"},"currentTeamId":24},{"id":8479373,"firstName":"Jonathan","lastName":"Dahlen","fullName":"Jonathan Dahlen","number":"54","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":23},{"id":8477934,"firstName":"Leon","lastName":"Draisaitl","fullName":"Leon Draisaitl","number":"29","position":"C","stats":{"_fantasyPoints":244.9,"_fantasyPointsAverage":3.14,"points":70,"goals":25,"assists":45,"penaltyMinutes":30,"plusMinus":-7,"hits":40,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":3,"shortHandedPoints":4,"shots":194,"blocked":24,"faceOffPct":56.09,"gameWinningGoals":1,"games":78,"timeOnIcePerGame":"19:19"},"currentTeamId":22},{"id":8478843,"firstName":"Denis","lastName":"Malgin","fullName":"Denis Malgin","number":"62","position":"C","stats":{"_fantasyPoints":107.9,"_fantasyPointsAverage":2.12,"points":22,"goals":11,"assists":11,"penaltyMinutes":6,"plusMinus":4,"hits":48,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":79,"blocked":24,"faceOffPct":42.62,"gameWinningGoals":3,"games":51,"timeOnIcePerGame":"13:51"},"currentTeamId":13},{"id":8474586,"firstName":"Jordan","lastName":"Eberle","fullName":"Jordan Eberle","number":"7","position":"C","stats":{"_fantasyPoints":224.3,"_fantasyPointsAverage":2.77,"points":59,"goals":25,"assists":34,"penaltyMinutes":21,"plusMinus":5,"hits":46,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":183,"blocked":30,"faceOffPct":36.36,"gameWinningGoals":7,"games":81,"timeOnIcePerGame":"16:04"},"currentTeamId":2},{"id":8480101,"firstName":"Shane","lastName":"Starrett","fullName":"Shane Starrett","number":"40","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":22},{"id":8475883,"firstName":"Frederik","lastName":"Andersen","fullName":"Frederik Andersen","number":"31","position":"G","stats":{"_fantasyPoints":"286.80","_fantasyPointsAverage":"4.35","savePercentage":0.918,"goalAgainstAverage":2.81,"wins":38,"losses":21,"saves":2029,"goalsAgainst":182,"shutouts":5},"currentTeamId":10},{"id":8474628,"firstName":"Michael","lastName":"Stone","fullName":"Michael Stone","number":"26","position":"D","stats":{"_fantasyPoints":158.3,"_fantasyPointsAverage":1.93,"points":10,"goals":3,"assists":7,"penaltyMinutes":28,"plusMinus":-11,"hits":106,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":98,"blocked":158,"faceOffPct":0,"gameWinningGoals":0,"games":82,"timeOnIcePerGame":"16:44"},"currentTeamId":20},{"id":8471490,"firstName":"Adam","lastName":"Cracknell","fullName":"Adam Cracknell","number":"15","position":"RW","stats":{"_fantasyPoints":3.35,"_fantasyPointsAverage":0.67,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":12,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":1,"faceOffPct":50,"gameWinningGoals":0,"games":5,"timeOnIcePerGame":"07:42"},"currentTeamId":10},{"id":8476410,"firstName":"Josh","lastName":"Leivo","fullName":"Josh Leivo","number":"32","position":"LW","stats":{"_fantasyPoints":14.75,"_fantasyPointsAverage":0.92,"points":4,"goals":1,"assists":3,"penaltyMinutes":6,"plusMinus":0,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":25,"blocked":5,"faceOffPct":66.66,"gameWinningGoals":0,"games":16,"timeOnIcePerGame":"10:34"},"currentTeamId":10},{"id":8474597,"firstName":"Cody","lastName":"Goloubef","fullName":"Cody Goloubef","number":"57","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8478063,"firstName":"Shane","lastName":"Gersich","fullName":"Shane Gersich","number":"63","position":"LW","stats":{"_fantasyPoints":3.4,"_fantasyPointsAverage":1.13,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":-1,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"09:01"},"currentTeamId":15},{"id":8475231,"firstName":"Casey","lastName":"Cizikas","fullName":"Casey Cizikas","number":"53","position":"C","stats":{"_fantasyPoints":108.65,"_fantasyPointsAverage":1.7,"points":17,"goals":7,"assists":10,"penaltyMinutes":23,"plusMinus":-12,"hits":128,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":74,"blocked":53,"faceOffPct":53.08,"gameWinningGoals":0,"games":64,"timeOnIcePerGame":"13:12"},"currentTeamId":2},{"id":8475745,"firstName":"Charlie","lastName":"Coyle","fullName":"Charlie Coyle","number":"3","position":"C","stats":{"_fantasyPoints":185.45,"_fantasyPointsAverage":2.81,"points":37,"goals":11,"assists":26,"penaltyMinutes":18,"plusMinus":8,"hits":76,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":117,"blocked":63,"faceOffPct":52.17,"gameWinningGoals":1,"games":66,"timeOnIcePerGame":"16:31"},"currentTeamId":30},{"id":8477938,"firstName":"Haydn","lastName":"Fleury","fullName":"Haydn Fleury","number":"4","position":"D","stats":{"_fantasyPoints":111.35,"_fantasyPointsAverage":1.66,"points":8,"goals":0,"assists":8,"penaltyMinutes":14,"plusMinus":-2,"hits":85,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":86,"blocked":94,"faceOffPct":0,"gameWinningGoals":0,"games":67,"timeOnIcePerGame":"16:47"},"currentTeamId":12},{"id":8475324,"firstName":"Nick","lastName":"Jensen","fullName":"Nick Jensen","number":"3","position":"D","stats":{"_fantasyPoints":110.95,"_fantasyPointsAverage":1.37,"points":15,"goals":0,"assists":15,"penaltyMinutes":27,"plusMinus":-8,"hits":71,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":107,"blocked":88,"faceOffPct":0,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"16:15"},"currentTeamId":17},{"id":8476427,"firstName":"Ty","lastName":"Rattie","fullName":"Ty Rattie","number":"8","position":"RW","stats":{"_fantasyPoints":36.45,"_fantasyPointsAverage":2.6,"points":9,"goals":5,"assists":4,"penaltyMinutes":2,"plusMinus":1,"hits":11,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":32,"blocked":4,"faceOffPct":0,"gameWinningGoals":1,"games":14,"timeOnIcePerGame":"15:28"},"currentTeamId":22},{"id":8475794,"firstName":"Tyler","lastName":"Seguin","fullName":"Tyler Seguin","number":"91","position":"C","stats":{"_fantasyPoints":330,"_fantasyPointsAverage":4.02,"points":78,"goals":40,"assists":38,"penaltyMinutes":43,"plusMinus":12,"hits":74,"powerPlayGoals":14,"powerPlayPoints":14,"shortHandedGoals":1,"shortHandedPoints":2,"shots":335,"blocked":44,"faceOffPct":54.86,"gameWinningGoals":6,"games":82,"timeOnIcePerGame":"20:54"},"currentTeamId":25},{"id":8471227,"firstName":"Devan","lastName":"Dubnyk","fullName":"Devan Dubnyk","number":"40","position":"G","stats":{"_fantasyPoints":"239.80","_fantasyPointsAverage":"4.00","savePercentage":0.918,"goalAgainstAverage":2.52,"wins":35,"losses":16,"saves":1624,"goalsAgainst":145,"shutouts":5},"currentTeamId":30},{"id":8479344,"firstName":"Jesse","lastName":"Puljujarvi","fullName":"Jesse Puljujarvi","number":"98","position":"RW","stats":{"_fantasyPoints":102.6,"_fantasyPointsAverage":1.58,"points":20,"goals":12,"assists":8,"penaltyMinutes":14,"plusMinus":-1,"hits":67,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":136,"blocked":23,"faceOffPct":0,"gameWinningGoals":2,"games":65,"timeOnIcePerGame":"13:22"},"currentTeamId":22},{"id":8475179,"firstName":"Dmitry","lastName":"Kulikov","fullName":"Dmitry Kulikov","number":"5","position":"D","stats":{"_fantasyPoints":106.05,"_fantasyPointsAverage":1.71,"points":11,"goals":3,"assists":8,"penaltyMinutes":22,"plusMinus":6,"hits":69,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":48,"blocked":78,"faceOffPct":0,"gameWinningGoals":1,"games":62,"timeOnIcePerGame":"17:04"},"currentTeamId":52},{"id":8480143,"firstName":"Jakub","lastName":"Jerabek","fullName":"Jakub Jerabek","position":"D","stats":{"_fantasyPoints":66.8,"_fantasyPointsAverage":1.86,"points":8,"goals":2,"assists":6,"penaltyMinutes":6,"plusMinus":-2,"hits":42,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":33,"blocked":48,"faceOffPct":0,"gameWinningGoals":0,"games":36,"timeOnIcePerGame":"16:19"},"currentTeamId":22},{"id":8479977,"firstName":"Kailer","lastName":"Yamamoto","fullName":"Kailer Yamamoto","number":"56","position":"RW","stats":{"_fantasyPoints":11.05,"_fantasyPointsAverage":1.23,"points":3,"goals":0,"assists":3,"penaltyMinutes":2,"plusMinus":-2,"hits":6,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":23,"blocked":3,"faceOffPct":0,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"15:09"},"currentTeamId":22},{"id":8471219,"firstName":"Al","lastName":"Montoya","fullName":"Al Montoya","number":"35","position":"G","stats":{"_fantasyPoints":"28.80","_fantasyPointsAverage":"2.22","savePercentage":0.893,"goalAgainstAverage":3.21,"wins":4,"losses":3,"saves":309,"goalsAgainst":37,"shutouts":0},"currentTeamId":22},{"id":8476999,"firstName":"Linus","lastName":"Ullmark","fullName":"Linus Ullmark","number":"35","position":"G","stats":{"_fantasyPoints":"16.00","_fantasyPointsAverage":"3.20","savePercentage":0.935,"goalAgainstAverage":2,"wins":1,"losses":2,"saves":115,"goalsAgainst":8,"shutouts":0},"currentTeamId":7},{"id":8474668,"firstName":"Dale","lastName":"Weise","fullName":"Dale Weise","number":"22","position":"RW","stats":{"_fantasyPoints":40.65,"_fantasyPointsAverage":0.88,"points":8,"goals":4,"assists":4,"penaltyMinutes":21,"plusMinus":-7,"hits":77,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":44,"blocked":14,"faceOffPct":50,"gameWinningGoals":0,"games":46,"timeOnIcePerGame":"10:34"},"currentTeamId":4},{"id":8477473,"firstName":"Justin","lastName":"Bailey","fullName":"Justin Bailey","number":"95","position":"RW","stats":{"_fantasyPoints":23.4,"_fantasyPointsAverage":1.95,"points":4,"goals":3,"assists":1,"penaltyMinutes":2,"plusMinus":-2,"hits":19,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":19,"blocked":9,"faceOffPct":0,"gameWinningGoals":0,"games":12,"timeOnIcePerGame":"11:16"},"currentTeamId":7},{"id":8475215,"firstName":"Robin","lastName":"Lehner","fullName":"Robin Lehner","number":"40","position":"G","stats":{"_fantasyPoints":"169.40","_fantasyPointsAverage":"3.20","savePercentage":0.908,"goalAgainstAverage":3.01,"wins":14,"losses":26,"saves":1417,"goalsAgainst":143,"shutouts":3},"currentTeamId":2},{"id":8476889,"firstName":"Radek","lastName":"Faksa","fullName":"Radek Faksa","number":"12","position":"C","stats":{"_fantasyPoints":188.55,"_fantasyPointsAverage":2.39,"points":33,"goals":17,"assists":16,"penaltyMinutes":36,"plusMinus":21,"hits":101,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":2,"shortHandedPoints":2,"shots":118,"blocked":56,"faceOffPct":51.62,"gameWinningGoals":3,"games":79,"timeOnIcePerGame":"15:16"},"currentTeamId":25},{"id":8470598,"firstName":"Thomas","lastName":"Vanek","fullName":"Thomas Vanek","number":"26","position":"LW","stats":{"_fantasyPoints":189.8,"_fantasyPointsAverage":2.37,"points":56,"goals":24,"assists":32,"penaltyMinutes":36,"plusMinus":-3,"hits":36,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":168,"blocked":18,"faceOffPct":25,"gameWinningGoals":1,"games":80,"timeOnIcePerGame":"14:05"},"currentTeamId":17},{"id":8479465,"firstName":"Drake","lastName":"Caggiula","fullName":"Drake Caggiula","number":"91","position":"LW","stats":{"_fantasyPoints":108.4,"_fantasyPointsAverage":1.62,"points":20,"goals":13,"assists":7,"penaltyMinutes":37,"plusMinus":-13,"hits":147,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":1,"shortHandedPoints":1,"shots":104,"blocked":33,"faceOffPct":20.75,"gameWinningGoals":1,"games":67,"timeOnIcePerGame":"13:33"},"currentTeamId":22},{"id":8473473,"firstName":"Milan","lastName":"Lucic","fullName":"Milan Lucic","number":"27","position":"LW","stats":{"_fantasyPoints":143.45,"_fantasyPointsAverage":1.75,"points":34,"goals":10,"assists":24,"penaltyMinutes":80,"plusMinus":-12,"hits":254,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":147,"blocked":25,"faceOffPct":55.76,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"15:57"},"currentTeamId":22},{"id":8478367,"firstName":"Cole","lastName":"Bardreau","fullName":"Cole Bardreau","number":"51","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8478442,"firstName":"Cooper","lastName":"Marody","fullName":"Cooper Marody","number":"65","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":22},{"id":8476429,"firstName":"Scott","lastName":"Mayfield","fullName":"Scott Mayfield","number":"24","position":"D","stats":{"_fantasyPoints":83.3,"_fantasyPointsAverage":1.77,"points":12,"goals":2,"assists":10,"penaltyMinutes":45,"plusMinus":-6,"hits":77,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":58,"blocked":73,"faceOffPct":0,"gameWinningGoals":0,"games":47,"timeOnIcePerGame":"17:50"},"currentTeamId":2},{"id":8478518,"firstName":"Andrew","lastName":"Nielsen","fullName":"Andrew Nielsen","number":"56","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":10},{"id":8477942,"firstName":"Kevin","lastName":"Fiala","fullName":"Kevin Fiala","number":"22","position":"LW","stats":{"_fantasyPoints":203.95,"_fantasyPointsAverage":2.55,"points":48,"goals":23,"assists":25,"penaltyMinutes":26,"plusMinus":20,"hits":34,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":187,"blocked":27,"faceOffPct":0,"gameWinningGoals":4,"games":80,"timeOnIcePerGame":"15:08"},"currentTeamId":18},{"id":8477369,"firstName":"Carson","lastName":"Soucy","fullName":"Carson Soucy","number":"60","position":"D","stats":{"_fantasyPoints":0.65,"_fantasyPointsAverage":0.22,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":-2,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":3,"faceOffPct":0,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"14:50"},"currentTeamId":30},{"id":8479312,"firstName":"Alex","lastName":"Lyon","fullName":"Alex Lyon","number":"49","position":"G","stats":{"_fantasyPoints":"24.00","_fantasyPointsAverage":"2.18","savePercentage":0.905,"goalAgainstAverage":2.75,"wins":4,"losses":2,"saves":210,"goalsAgainst":22,"shutouts":0},"currentTeamId":4},{"id":8477979,"firstName":"Nicolas","lastName":"Aube-Kubel","fullName":"Nicolas Aube-Kubel","number":"62","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8479026,"firstName":"Philippe","lastName":"Myers","fullName":"Philippe Myers","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":4},{"id":8477506,"firstName":"Ryan","lastName":"Pulock","fullName":"Ryan Pulock","number":"6","position":"D","stats":{"_fantasyPoints":195.65,"_fantasyPointsAverage":2.88,"points":32,"goals":10,"assists":22,"penaltyMinutes":14,"plusMinus":-4,"hits":113,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":184,"blocked":86,"faceOffPct":0,"gameWinningGoals":0,"games":68,"timeOnIcePerGame":"18:24"},"currentTeamId":2},{"id":8476917,"firstName":"Adam","lastName":"Pelech","fullName":"Adam Pelech","number":"3","position":"D","stats":{"_fantasyPoints":190.1,"_fantasyPointsAverage":2.44,"points":19,"goals":3,"assists":16,"penaltyMinutes":28,"plusMinus":7,"hits":100,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":106,"blocked":142,"faceOffPct":0,"gameWinningGoals":1,"games":78,"timeOnIcePerGame":"19:16"},"currentTeamId":2},{"id":8466141,"firstName":"Roberto","lastName":"Luongo","fullName":"Roberto Luongo","number":"1","position":"G","stats":{"_fantasyPoints":"164.40","_fantasyPointsAverage":"4.70","savePercentage":0.929,"goalAgainstAverage":2.47,"wins":18,"losses":11,"saves":1062,"goalsAgainst":81,"shutouts":3},"currentTeamId":13},{"id":8471735,"firstName":"Keith","lastName":"Yandle","fullName":"Keith Yandle","number":"3","position":"D","stats":{"_fantasyPoints":253.65,"_fantasyPointsAverage":3.09,"points":56,"goals":8,"assists":48,"penaltyMinutes":35,"plusMinus":7,"hits":26,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":2,"shots":179,"blocked":101,"faceOffPct":0,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"24:29"},"currentTeamId":13},{"id":8480853,"firstName":"Liam","lastName":"Foudy","fullName":"Liam Foudy","number":"19","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8477505,"firstName":"Alexander","lastName":"Wennberg","fullName":"Alexander Wennberg","number":"10","position":"C","stats":{"_fantasyPoints":166.4,"_fantasyPointsAverage":2.52,"points":35,"goals":8,"assists":27,"penaltyMinutes":12,"plusMinus":22,"hits":28,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":74,"blocked":46,"faceOffPct":45.22,"gameWinningGoals":2,"games":66,"timeOnIcePerGame":"18:07"},"currentTeamId":29},{"id":8475423,"firstName":"Darren","lastName":"Archibald","fullName":"Darren Archibald","number":"49","position":"RW","stats":{"_fantasyPoints":55.3,"_fantasyPointsAverage":2.05,"points":9,"goals":4,"assists":5,"penaltyMinutes":14,"plusMinus":-1,"hits":80,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":28,"blocked":14,"faceOffPct":0,"gameWinningGoals":0,"games":27,"timeOnIcePerGame":"14:51"},"currentTeamId":23},{"id":8470093,"firstName":"Mike","lastName":"McKenna","fullName":"Mike McKenna","number":"33","position":"G","stats":{"_fantasyPoints":"5.00","_fantasyPointsAverage":"2.50","savePercentage":0.9,"goalAgainstAverage":2.97,"wins":1,"losses":1,"saves":45,"goalsAgainst":5,"shutouts":0},"currentTeamId":9},{"id":8476323,"firstName":"Max","lastName":"McCormick","fullName":"Max McCormick","number":"17","position":"LW","stats":{"_fantasyPoints":15.3,"_fantasyPointsAverage":0.51,"points":5,"goals":3,"assists":2,"penaltyMinutes":37,"plusMinus":-5,"hits":56,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":33,"blocked":8,"faceOffPct":42.85,"gameWinningGoals":0,"games":30,"timeOnIcePerGame":"08:21"},"currentTeamId":9},{"id":8479563,"firstName":"Dmitry","lastName":"Sokolov","fullName":"Dmitry Sokolov","number":"74","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":30},{"id":8477971,"firstName":"Andreas","lastName":"Englund","fullName":"Andreas Englund","number":"39","position":"D","stats":{"_fantasyPoints":3.25,"_fantasyPointsAverage":3.25,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":1,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"11:21"},"currentTeamId":9},{"id":8475175,"firstName":"Magnus","lastName":"Paajarvi","fullName":"Magnus Paajarvi","number":"56","position":"LW","stats":{"_fantasyPoints":91.1,"_fantasyPointsAverage":1.15,"points":12,"goals":8,"assists":4,"penaltyMinutes":12,"plusMinus":-11,"hits":104,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":126,"blocked":42,"faceOffPct":25,"gameWinningGoals":0,"games":79,"timeOnIcePerGame":"12:27"},"currentTeamId":9},{"id":8477487,"firstName":"Adam","lastName":"Tambellini","fullName":"Adam Tambellini","number":"49","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8471768,"firstName":"Tom","lastName":"Pyatt","fullName":"Tom Pyatt","number":"10","position":"LW","stats":{"_fantasyPoints":145.8,"_fantasyPointsAverage":1.8,"points":22,"goals":7,"assists":15,"penaltyMinutes":10,"plusMinus":-12,"hits":55,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":103,"blocked":93,"faceOffPct":33.33,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"14:03"},"currentTeamId":9},{"id":8480830,"firstName":"Andrei","lastName":"Svechnikov","fullName":"Andrei Svechnikov","number":"37","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8477433,"firstName":"Ben","lastName":"Harpur","fullName":"Ben Harpur","number":"67","position":"D","stats":{"_fantasyPoints":17.6,"_fantasyPointsAverage":0.43,"points":1,"goals":0,"assists":1,"penaltyMinutes":21,"plusMinus":-21,"hits":71,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":26,"blocked":35,"faceOffPct":0,"gameWinningGoals":0,"games":41,"timeOnIcePerGame":"14:53"},"currentTeamId":9},{"id":8475168,"firstName":"Matt","lastName":"Duchene","fullName":"Matt Duchene","number":"95","position":"C","stats":{"_fantasyPoints":220.75,"_fantasyPointsAverage":2.69,"points":59,"goals":27,"assists":32,"penaltyMinutes":18,"plusMinus":-22,"hits":60,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":190,"blocked":49,"faceOffPct":52.95,"gameWinningGoals":3,"games":82,"timeOnIcePerGame":"18:19"},"currentTeamId":9},{"id":8477426,"firstName":"Nick","lastName":"Paul","fullName":"Nick Paul","number":"13","position":"LW","stats":{"_fantasyPoints":7.6,"_fantasyPointsAverage":0.69,"points":1,"goals":1,"assists":0,"penaltyMinutes":0,"plusMinus":-4,"hits":16,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":11,"blocked":4,"faceOffPct":25,"gameWinningGoals":0,"games":11,"timeOnIcePerGame":"07:53"},"currentTeamId":9},{"id":8477405,"firstName":"Marcus","lastName":"Hogberg","fullName":"Marcus Hogberg","number":"35","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":9},{"id":8476419,"firstName":"Jean-Gabriel","lastName":"Pageau","fullName":"Jean-Gabriel Pageau","number":"44","position":"C","stats":{"_fantasyPoints":158.2,"_fantasyPointsAverage":2.03,"points":29,"goals":14,"assists":15,"penaltyMinutes":36,"plusMinus":-14,"hits":131,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":1,"shots":147,"blocked":69,"faceOffPct":51.19,"gameWinningGoals":2,"games":78,"timeOnIcePerGame":"16:44"},"currentTeamId":9},{"id":8476322,"firstName":"Chase","lastName":"Balisy","fullName":"Chase Balisy","number":"23","position":"C","stats":{"_fantasyPoints":1.1,"_fantasyPointsAverage":0.14,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-2,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":2,"faceOffPct":36.66,"gameWinningGoals":0,"games":8,"timeOnIcePerGame":"09:49"},"currentTeamId":9},{"id":8478469,"firstName":"Thomas","lastName":"Chabot","fullName":"Thomas Chabot","number":"72","position":"D","stats":{"_fantasyPoints":124.9,"_fantasyPointsAverage":1.98,"points":25,"goals":9,"assists":16,"penaltyMinutes":14,"plusMinus":-12,"hits":44,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":94,"blocked":64,"faceOffPct":0,"gameWinningGoals":0,"games":63,"timeOnIcePerGame":"17:30"},"currentTeamId":9},{"id":8468483,"firstName":"Marian","lastName":"Gaborik","fullName":"Marian Gaborik","number":"12","position":"RW","stats":{"_fantasyPoints":74.25,"_fantasyPointsAverage":1.61,"points":21,"goals":11,"assists":10,"penaltyMinutes":24,"plusMinus":2,"hits":12,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":80,"blocked":9,"faceOffPct":0,"gameWinningGoals":0,"games":46,"timeOnIcePerGame":"13:58"},"currentTeamId":9},{"id":8468674,"firstName":"Deryk","lastName":"Engelland","fullName":"Deryk Engelland","number":"5","position":"D","stats":{"_fantasyPoints":211.3,"_fantasyPointsAverage":2.67,"points":23,"goals":5,"assists":18,"penaltyMinutes":24,"plusMinus":6,"hits":126,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":108,"blocked":150,"faceOffPct":0,"gameWinningGoals":0,"games":79,"timeOnIcePerGame":"20:16"},"currentTeamId":54},{"id":8470543,"firstName":"Chris","lastName":"Kunitz","fullName":"Chris Kunitz","number":"14","position":"LW","stats":{"_fantasyPoints":143.35,"_fantasyPointsAverage":1.75,"points":29,"goals":13,"assists":16,"penaltyMinutes":35,"plusMinus":8,"hits":131,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":81,"blocked":30,"faceOffPct":36.84,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"11:56"},"currentTeamId":16},{"id":8476288,"firstName":"Ryan","lastName":"Dzingel","fullName":"Ryan Dzingel","number":"18","position":"LW","stats":{"_fantasyPoints":137.85,"_fantasyPointsAverage":1.74,"points":41,"goals":23,"assists":18,"penaltyMinutes":35,"plusMinus":-17,"hits":60,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":136,"blocked":19,"faceOffPct":42.85,"gameWinningGoals":2,"games":79,"timeOnIcePerGame":"16:29"},"currentTeamId":9},{"id":8474250,"firstName":"Zack","lastName":"Smith","fullName":"Zack Smith","number":"15","position":"LW","stats":{"_fantasyPoints":55.15,"_fantasyPointsAverage":0.81,"points":19,"goals":5,"assists":14,"penaltyMinutes":54,"plusMinus":-32,"hits":90,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":124,"blocked":29,"faceOffPct":47.9,"gameWinningGoals":1,"games":68,"timeOnIcePerGame":"16:43"},"currentTeamId":9},{"id":8474697,"firstName":"Mark","lastName":"Borowiecki","fullName":"Mark Borowiecki","number":"74","position":"D","stats":{"_fantasyPoints":116.35,"_fantasyPointsAverage":2.24,"points":11,"goals":3,"assists":8,"penaltyMinutes":64,"plusMinus":-6,"hits":226,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":66,"blocked":81,"faceOffPct":0,"gameWinningGoals":0,"games":52,"timeOnIcePerGame":"14:38"},"currentTeamId":9},{"id":8474571,"firstName":"Mikkel","lastName":"Boedker","fullName":"Mikkel Boedker","number":"89","position":"LW","stats":{"_fantasyPoints":145.65,"_fantasyPointsAverage":1.97,"points":37,"goals":15,"assists":22,"penaltyMinutes":12,"plusMinus":0,"hits":41,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":119,"blocked":24,"faceOffPct":26.31,"gameWinningGoals":4,"games":74,"timeOnIcePerGame":"13:21"},"currentTeamId":9},{"id":8467950,"firstName":"Craig","lastName":"Anderson","fullName":"Craig Anderson","number":"41","position":"G","stats":{"_fantasyPoints":"170.60","_fantasyPointsAverage":"2.94","savePercentage":0.898,"goalAgainstAverage":3.32,"wins":23,"losses":25,"saves":1588,"goalsAgainst":180,"shutouts":2},"currentTeamId":9},{"id":8480039,"firstName":"Martin","lastName":"Necas","fullName":"Martin Necas","number":"88","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"06:54"},"currentTeamId":12},{"id":8475227,"firstName":"Chris","lastName":"Wideman","fullName":"Chris Wideman","number":"6","position":"D","stats":{"_fantasyPoints":39.4,"_fantasyPointsAverage":2.46,"points":8,"goals":3,"assists":5,"penaltyMinutes":6,"plusMinus":5,"hits":17,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":24,"blocked":9,"faceOffPct":0,"gameWinningGoals":0,"games":16,"timeOnIcePerGame":"11:33"},"currentTeamId":9},{"id":8478868,"firstName":"Christian","lastName":"Jaros","fullName":"Christian Jaros","number":"83","position":"D","stats":{"_fantasyPoints":1,"_fantasyPointsAverage":0.5,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"07:58"},"currentTeamId":9},{"id":8478488,"firstName":"Filip","lastName":"Chlapik","fullName":"Filip Chlapik","number":"78","position":"C","stats":{"_fantasyPoints":21.85,"_fantasyPointsAverage":1.09,"points":4,"goals":1,"assists":3,"penaltyMinutes":4,"plusMinus":-5,"hits":19,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":21,"blocked":14,"faceOffPct":45.45,"gameWinningGoals":0,"games":20,"timeOnIcePerGame":"10:04"},"currentTeamId":9},{"id":8471750,"firstName":"Ben","lastName":"Bishop","fullName":"Ben Bishop","number":"30","position":"G","stats":{"_fantasyPoints":"194.40","_fantasyPointsAverage":"3.67","savePercentage":0.916,"goalAgainstAverage":2.49,"wins":26,"losses":17,"saves":1317,"goalsAgainst":120,"shutouts":5},"currentTeamId":25},{"id":8470645,"firstName":"Corey","lastName":"Crawford","fullName":"Corey Crawford","number":"50","position":"G","stats":{"_fantasyPoints":"122.40","_fantasyPointsAverage":"4.37","savePercentage":0.929,"goalAgainstAverage":2.27,"wins":16,"losses":9,"saves":782,"goalsAgainst":60,"shutouts":2},"currentTeamId":16},{"id":8477977,"firstName":"Julius","lastName":"Bergman","fullName":"Julius Bergman","number":"63","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8478904,"firstName":"Steven","lastName":"Lorentz","fullName":"Steven Lorentz","number":"78","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8470880,"firstName":"Brian","lastName":"Elliott","fullName":"Brian Elliott","number":"37","position":"G","stats":{"_fantasyPoints":"139.20","_fantasyPointsAverage":"3.24","savePercentage":0.909,"goalAgainstAverage":2.66,"wins":23,"losses":11,"saves":1116,"goalsAgainst":112,"shutouts":1},"currentTeamId":4},{"id":8477237,"firstName":"Mike","lastName":"Condon","fullName":"Mike Condon","number":"1","position":"G","stats":{"_fantasyPoints":"79.00","_fantasyPointsAverage":"2.55","savePercentage":0.902,"goalAgainstAverage":3.25,"wins":5,"losses":17,"saves":810,"goalsAgainst":88,"shutouts":0},"currentTeamId":9},{"id":8479987,"firstName":"Morgan","lastName":"Geekie","fullName":"Morgan Geekie","number":"45","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8476919,"firstName":"Chris","lastName":"Tierney","fullName":"Chris Tierney","number":"71","position":"C","stats":{"_fantasyPoints":182.55,"_fantasyPointsAverage":2.23,"points":40,"goals":17,"assists":23,"penaltyMinutes":8,"plusMinus":0,"hits":26,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":2,"shortHandedPoints":4,"shots":118,"blocked":45,"faceOffPct":51.04,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"15:59"},"currentTeamId":9},{"id":8476331,"firstName":"Dylan","lastName":"DeMelo","fullName":"Dylan DeMelo","number":"2","position":"D","stats":{"_fantasyPoints":111.45,"_fantasyPointsAverage":1.77,"points":20,"goals":0,"assists":20,"penaltyMinutes":34,"plusMinus":-1,"hits":75,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":67,"blocked":70,"faceOffPct":0,"gameWinningGoals":0,"games":63,"timeOnIcePerGame":"14:12"},"currentTeamId":9},{"id":8475328,"firstName":"Ben","lastName":"Sexton","fullName":"Ben Sexton","number":"26","position":"C","stats":{"_fantasyPoints":0.6,"_fantasyPointsAverage":0.3,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":6,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":0,"faceOffPct":60,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"10:16"},"currentTeamId":9},{"id":8478268,"firstName":"Jack","lastName":"Rodewald","fullName":"Jack Rodewald","number":"53","position":"RW","stats":{"_fantasyPoints":0.75,"_fantasyPointsAverage":0.19,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":-1,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"07:18"},"currentTeamId":9},{"id":8479366,"firstName":"Logan","lastName":"Brown","fullName":"Logan Brown","number":"21","position":"C","stats":{"_fantasyPoints":3.9,"_fantasyPointsAverage":0.97,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":0,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":1,"faceOffPct":33.33,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"08:07"},"currentTeamId":9},{"id":8479636,"firstName":"Michael","lastName":"Fora","fullName":"Michael Fora","number":"26","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":12},{"id":8478876,"firstName":"Radovan","lastName":"Bondra","fullName":"Radovan Bondra","number":"68","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8475913,"firstName":"Mark","lastName":"Stone","fullName":"Mark Stone","number":"61","position":"RW","stats":{"_fantasyPoints":247.2,"_fantasyPointsAverage":4.26,"points":62,"goals":20,"assists":42,"penaltyMinutes":10,"plusMinus":9,"hits":53,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":2,"shots":132,"blocked":39,"faceOffPct":54.09,"gameWinningGoals":3,"games":58,"timeOnIcePerGame":"20:40"},"currentTeamId":9},{"id":8478870,"firstName":"Rudolfs","lastName":"Balcers","fullName":"Rudolfs Balcers","number":"38","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8479526,"firstName":"Otto","lastName":"Koivula","fullName":"Otto Koivula","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8476876,"firstName":"Malcolm","lastName":"Subban","fullName":"Malcolm Subban","number":"30","position":"G","stats":{"_fantasyPoints":"69.80","_fantasyPointsAverage":"3.17","savePercentage":0.91,"goalAgainstAverage":2.68,"wins":13,"losses":4,"saves":559,"goalsAgainst":55,"shutouts":0},"currentTeamId":54},{"id":8477919,"firstName":"Frederick","lastName":"Gaudreau","fullName":"Frederick Gaudreau","number":"89","position":"C","stats":{"_fantasyPoints":15.9,"_fantasyPointsAverage":0.8,"points":3,"goals":0,"assists":3,"penaltyMinutes":2,"plusMinus":0,"hits":8,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":14,"blocked":8,"faceOffPct":49.64,"gameWinningGoals":0,"games":20,"timeOnIcePerGame":"09:09"},"currentTeamId":18},{"id":8471274,"firstName":"Alex","lastName":"Goligoski","fullName":"Alex Goligoski","number":"33","position":"D","stats":{"_fantasyPoints":216.9,"_fantasyPointsAverage":2.78,"points":35,"goals":12,"assists":23,"penaltyMinutes":26,"plusMinus":-31,"hits":114,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":119,"blocked":154,"faceOffPct":0,"gameWinningGoals":3,"games":78,"timeOnIcePerGame":"23:16"},"currentTeamId":53},{"id":8477467,"firstName":"Gustav","lastName":"Olofsson","fullName":"Gustav Olofsson","number":"23","position":"D","stats":{"_fantasyPoints":53.95,"_fantasyPointsAverage":1.32,"points":8,"goals":0,"assists":8,"penaltyMinutes":14,"plusMinus":0,"hits":23,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":22,"blocked":44,"faceOffPct":0,"gameWinningGoals":0,"games":41,"timeOnIcePerGame":"12:46"},"currentTeamId":30},{"id":8478460,"firstName":"Zach","lastName":"Werenski","fullName":"Zach Werenski","number":"8","position":"D","stats":{"_fantasyPoints":217.7,"_fantasyPointsAverage":2.83,"points":37,"goals":16,"assists":21,"penaltyMinutes":16,"plusMinus":8,"hits":58,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":207,"blocked":92,"faceOffPct":0,"gameWinningGoals":3,"games":77,"timeOnIcePerGame":"22:34"},"currentTeamId":29},{"id":8476918,"firstName":"Jimmy","lastName":"Vesey","fullName":"Jimmy Vesey","number":"26","position":"LW","stats":{"_fantasyPoints":120.35,"_fantasyPointsAverage":1.52,"points":28,"goals":17,"assists":11,"penaltyMinutes":20,"plusMinus":-18,"hits":83,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":136,"blocked":34,"faceOffPct":46.87,"gameWinningGoals":4,"games":79,"timeOnIcePerGame":"14:19"},"currentTeamId":3},{"id":8475982,"firstName":"Erik","lastName":"Burgdoerfer","fullName":"Erik Burgdoerfer","number":"46","position":"D","stats":{"_fantasyPoints":7.45,"_fantasyPointsAverage":3.73,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":2,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":2,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"13:25"},"currentTeamId":9},{"id":8480364,"firstName":"Aaron","lastName":"Luchuk","fullName":"Aaron Luchuk","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":9},{"id":8471676,"firstName":"Bobby","lastName":"Ryan","fullName":"Bobby Ryan","number":"9","position":"RW","stats":{"_fantasyPoints":150.95,"_fantasyPointsAverage":2.43,"points":33,"goals":11,"assists":22,"penaltyMinutes":14,"plusMinus":-12,"hits":97,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":112,"blocked":52,"faceOffPct":54.54,"gameWinningGoals":1,"games":62,"timeOnIcePerGame":"16:26"},"currentTeamId":9},{"id":8476879,"firstName":"Cody","lastName":"Ceci","fullName":"Cody Ceci","number":"5","position":"D","stats":{"_fantasyPoints":205.3,"_fantasyPointsAverage":2.5,"points":19,"goals":5,"assists":14,"penaltyMinutes":12,"plusMinus":-27,"hits":163,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":143,"blocked":171,"faceOffPct":0,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"23:20"},"currentTeamId":9},{"id":8477401,"firstName":"John","lastName":"Hayden","fullName":"John Hayden","number":"40","position":"RW","stats":{"_fantasyPoints":61.35,"_fantasyPointsAverage":1.31,"points":13,"goals":4,"assists":9,"penaltyMinutes":54,"plusMinus":-4,"hits":118,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":56,"blocked":23,"faceOffPct":50,"gameWinningGoals":0,"games":47,"timeOnIcePerGame":"10:49"},"currentTeamId":16},{"id":8470318,"firstName":"Jonathan","lastName":"Ericsson","fullName":"Jonathan Ericsson","number":"52","position":"D","stats":{"_fantasyPoints":113.35,"_fantasyPointsAverage":1.4,"points":13,"goals":3,"assists":10,"penaltyMinutes":47,"plusMinus":-7,"hits":133,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":86,"blocked":84,"faceOffPct":100,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"19:18"},"currentTeamId":17},{"id":8478055,"firstName":"Gustav","lastName":"Forsling","fullName":"Gustav Forsling","number":"42","position":"D","stats":{"_fantasyPoints":91.7,"_fantasyPointsAverage":2.24,"points":13,"goals":3,"assists":10,"penaltyMinutes":8,"plusMinus":-2,"hits":26,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":82,"blocked":56,"faceOffPct":0,"gameWinningGoals":1,"games":41,"timeOnIcePerGame":"19:09"},"currentTeamId":16},{"id":8475147,"firstName":"Jordan","lastName":"Schroeder","fullName":"Jordan Schroeder","number":"11","position":"C","stats":{"_fantasyPoints":7,"_fantasyPointsAverage":0.33,"points":2,"goals":1,"assists":1,"penaltyMinutes":4,"plusMinus":-4,"hits":14,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":20,"blocked":2,"faceOffPct":61.9,"gameWinningGoals":0,"games":21,"timeOnIcePerGame":"07:28"},"currentTeamId":16},{"id":8479523,"firstName":"Lucas","lastName":"Carlsson","fullName":"Lucas Carlsson","number":"47","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8476341,"firstName":"Anton","lastName":"Forsberg","fullName":"Anton Forsberg","number":"31","position":"G","stats":{"_fantasyPoints":"92.20","_fantasyPointsAverage":"2.63","savePercentage":0.908,"goalAgainstAverage":2.97,"wins":10,"losses":16,"saves":836,"goalsAgainst":85,"shutouts":0},"currentTeamId":16},{"id":8480946,"firstName":"Dominik","lastName":"Kahun","fullName":"Dominik Kahun","number":"24","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8477472,"firstName":"Carl","lastName":"Dahlstrom","fullName":"Carl Dahlstrom","number":"63","position":"D","stats":{"_fantasyPoints":14.95,"_fantasyPointsAverage":1.36,"points":3,"goals":0,"assists":3,"penaltyMinutes":0,"plusMinus":-2,"hits":6,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":12,"blocked":9,"faceOffPct":100,"gameWinningGoals":0,"games":11,"timeOnIcePerGame":"17:30"},"currentTeamId":16},{"id":8479337,"firstName":"Alex","lastName":"DeBrincat","fullName":"Alex DeBrincat","number":"12","position":"RW","stats":{"_fantasyPoints":213.85,"_fantasyPointsAverage":2.61,"points":52,"goals":28,"assists":24,"penaltyMinutes":6,"plusMinus":6,"hits":40,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":0,"shortHandedPoints":0,"shots":181,"blocked":25,"faceOffPct":42.37,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"14:48"},"currentTeamId":16},{"id":8477901,"firstName":"Daniel","lastName":"Carr","fullName":"Daniel Carr","number":"23","position":"LW","stats":{"_fantasyPoints":70.2,"_fantasyPointsAverage":1.85,"points":16,"goals":6,"assists":10,"penaltyMinutes":8,"plusMinus":2,"hits":30,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":52,"blocked":16,"faceOffPct":17.64,"gameWinningGoals":0,"games":38,"timeOnIcePerGame":"12:08"},"currentTeamId":54},{"id":8473604,"firstName":"Jonathan","lastName":"Toews","fullName":"Jonathan Toews","number":"19","position":"C","stats":{"_fantasyPoints":178.6,"_fantasyPointsAverage":2.41,"points":52,"goals":20,"assists":32,"penaltyMinutes":47,"plusMinus":-1,"hits":32,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":211,"blocked":24,"faceOffPct":57.95,"gameWinningGoals":2,"games":74,"timeOnIcePerGame":"19:41"},"currentTeamId":16},{"id":8479595,"firstName":"Blake","lastName":"Hillman","fullName":"Blake Hillman","number":"55","position":"D","stats":{"_fantasyPoints":13.75,"_fantasyPointsAverage":3.44,"points":1,"goals":1,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":5,"blocked":8,"faceOffPct":0,"gameWinningGoals":0,"games":4,"timeOnIcePerGame":"18:01"},"currentTeamId":16},{"id":8478070,"firstName":"Luc","lastName":"Snuggerud","fullName":"Luc Snuggerud","number":"45","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8477321,"firstName":"Anthony","lastName":"Louis","fullName":"Anthony Louis","number":"26","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8475323,"firstName":"Marcus","lastName":"Kruger","fullName":"Marcus Kruger","number":"16","position":"C","stats":{"_fantasyPoints":25,"_fantasyPointsAverage":0.52,"points":6,"goals":1,"assists":5,"penaltyMinutes":28,"plusMinus":-6,"hits":56,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":30,"blocked":16,"faceOffPct":55.4,"gameWinningGoals":0,"games":48,"timeOnIcePerGame":"10:50"},"currentTeamId":16},{"id":8470144,"firstName":"Frans","lastName":"Nielsen","fullName":"Frans Nielsen","number":"51","position":"C","stats":{"_fantasyPoints":178.65,"_fantasyPointsAverage":2.26,"points":33,"goals":16,"assists":17,"penaltyMinutes":14,"plusMinus":1,"hits":49,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":2,"shortHandedPoints":3,"shots":134,"blocked":62,"faceOffPct":46.39,"gameWinningGoals":3,"games":79,"timeOnIcePerGame":"15:49"},"currentTeamId":17},{"id":8478178,"firstName":"Darren","lastName":"Raddysh","fullName":"Darren Raddysh","number":"52","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8470803,"firstName":"Kyle","lastName":"Brodziak","fullName":"Kyle Brodziak","number":"28","position":"C","stats":{"_fantasyPoints":172.8,"_fantasyPointsAverage":2.13,"points":33,"goals":10,"assists":23,"penaltyMinutes":33,"plusMinus":13,"hits":83,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":3,"shots":113,"blocked":55,"faceOffPct":52.12,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"13:27"},"currentTeamId":22},{"id":8470657,"firstName":"Jimmy","lastName":"Howard","fullName":"Jimmy Howard","number":"35","position":"G","stats":{"_fantasyPoints":"189.00","_fantasyPointsAverage":"3.15","savePercentage":0.91,"goalAgainstAverage":2.85,"wins":22,"losses":27,"saves":1610,"goalsAgainst":160,"shutouts":1},"currentTeamId":17},{"id":8479657,"firstName":"Alexandre","lastName":"Fortin","fullName":"Alexandre Fortin","number":"84","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8480871,"firstName":"Adam","lastName":"Boqvist","fullName":"Adam Boqvist","number":"27","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8480153,"firstName":"Victor","lastName":"Ejdsell","fullName":"Victor Ejdsell","number":"17","position":"C","stats":{"_fantasyPoints":8.2,"_fantasyPointsAverage":1.37,"points":1,"goals":0,"assists":1,"penaltyMinutes":0,"plusMinus":-1,"hits":6,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":7,"blocked":6,"faceOffPct":33.33,"gameWinningGoals":0,"games":6,"timeOnIcePerGame":"13:19"},"currentTeamId":16},{"id":8475820,"firstName":"Joonas","lastName":"Donskoi","fullName":"Joonas Donskoi","number":"27","position":"RW","stats":{"_fantasyPoints":134.4,"_fantasyPointsAverage":2.04,"points":32,"goals":14,"assists":18,"penaltyMinutes":26,"plusMinus":10,"hits":28,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":129,"blocked":28,"faceOffPct":41.66,"gameWinningGoals":2,"games":66,"timeOnIcePerGame":"14:58"},"currentTeamId":28},{"id":8478493,"firstName":"Joel","lastName":"Eriksson Ek","fullName":"Joel Eriksson Ek","number":"14","position":"C","stats":{"_fantasyPoints":117.4,"_fantasyPointsAverage":1.57,"points":16,"goals":6,"assists":10,"penaltyMinutes":22,"plusMinus":2,"hits":134,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":124,"blocked":46,"faceOffPct":42.58,"gameWinningGoals":0,"games":75,"timeOnIcePerGame":"12:46"},"currentTeamId":30},{"id":8476389,"firstName":"Vincent","lastName":"Trocheck","fullName":"Vincent Trocheck","number":"21","position":"C","stats":{"_fantasyPoints":316.2,"_fantasyPointsAverage":3.86,"points":75,"goals":31,"assists":44,"penaltyMinutes":54,"plusMinus":-9,"hits":145,"powerPlayGoals":13,"powerPlayPoints":13,"shortHandedGoals":3,"shortHandedPoints":4,"shots":287,"blocked":55,"faceOffPct":54.09,"gameWinningGoals":5,"games":82,"timeOnIcePerGame":"21:21"},"currentTeamId":13},{"id":8480870,"firstName":"Benoit-Olivier","lastName":"Groulx","fullName":"Benoit-Olivier Groulx","number":"50","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8480144,"firstName":"David","lastName":"Kampf","fullName":"David Kampf","number":"64","position":"C","stats":{"_fantasyPoints":45.6,"_fantasyPointsAverage":0.99,"points":11,"goals":4,"assists":7,"penaltyMinutes":12,"plusMinus":-9,"hits":29,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":46,"blocked":23,"faceOffPct":53,"gameWinningGoals":0,"games":46,"timeOnIcePerGame":"12:47"},"currentTeamId":16},{"id":8470613,"firstName":"Brent","lastName":"Burns","fullName":"Brent Burns","number":"88","position":"D","stats":{"_fantasyPoints":312.45,"_fantasyPointsAverage":3.81,"points":67,"goals":12,"assists":55,"penaltyMinutes":46,"plusMinus":-16,"hits":79,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":1,"shots":332,"blocked":136,"faceOffPct":0,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"25:14"},"currentTeamId":28},{"id":8478099,"firstName":"Kevin","lastName":"Labanc","fullName":"Kevin Labanc","number":"62","position":"RW","stats":{"_fantasyPoints":138.1,"_fantasyPointsAverage":1.79,"points":40,"goals":11,"assists":29,"penaltyMinutes":32,"plusMinus":-6,"hits":31,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":156,"blocked":23,"faceOffPct":31.25,"gameWinningGoals":3,"games":77,"timeOnIcePerGame":"14:21"},"currentTeamId":28},{"id":8470794,"firstName":"Joe","lastName":"Pavelski","fullName":"Joe Pavelski","number":"8","position":"C","stats":{"_fantasyPoints":276.15,"_fantasyPointsAverage":3.37,"points":66,"goals":22,"assists":44,"penaltyMinutes":41,"plusMinus":0,"hits":93,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":224,"blocked":70,"faceOffPct":54.88,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"19:15"},"currentTeamId":28},{"id":8477240,"firstName":"Carter","lastName":"Rowney","fullName":"Carter Rowney","number":"24","position":"RW","stats":{"_fantasyPoints":41.6,"_fantasyPointsAverage":0.95,"points":5,"goals":2,"assists":3,"penaltyMinutes":4,"plusMinus":-13,"hits":74,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":21,"blocked":24,"faceOffPct":52.9,"gameWinningGoals":0,"games":44,"timeOnIcePerGame":"09:20"},"currentTeamId":24},{"id":8474150,"firstName":"Mikael","lastName":"Backlund","fullName":"Mikael Backlund","number":"11","position":"C","stats":{"_fantasyPoints":147.4,"_fantasyPointsAverage":1.8,"points":45,"goals":14,"assists":31,"penaltyMinutes":78,"plusMinus":-21,"hits":54,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":1,"shortHandedPoints":3,"shots":214,"blocked":40,"faceOffPct":50,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"19:01"},"currentTeamId":20},{"id":8477983,"firstName":"Maxim","lastName":"Letunov","fullName":"Maxim Letunov","number":"84","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8480806,"firstName":"Isac","lastName":"Lundestrom","fullName":"Isac Lundestrom","number":"48","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8478146,"firstName":"Matthew","lastName":"Highmore","fullName":"Matthew Highmore","number":"36","position":"C","stats":{"_fantasyPoints":13.2,"_fantasyPointsAverage":1.02,"points":2,"goals":2,"assists":0,"penaltyMinutes":0,"plusMinus":-4,"hits":9,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":27,"blocked":7,"faceOffPct":20,"gameWinningGoals":0,"games":13,"timeOnIcePerGame":"12:09"},"currentTeamId":16},{"id":8471709,"firstName":"Marc-Edouard","lastName":"Vlasic","fullName":"Marc-Edouard Vlasic","number":"44","position":"D","stats":{"_fantasyPoints":241.1,"_fantasyPointsAverage":2.98,"points":32,"goals":11,"assists":21,"penaltyMinutes":34,"plusMinus":9,"hits":26,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":161,"blocked":174,"faceOffPct":0,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"22:32"},"currentTeamId":28},{"id":8477453,"firstName":"Chris","lastName":"Bigras","fullName":"Chris Bigras","number":"28","position":"D","stats":{"_fantasyPoints":14.55,"_fantasyPointsAverage":0.97,"points":1,"goals":0,"assists":1,"penaltyMinutes":2,"plusMinus":-2,"hits":12,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":8,"blocked":15,"faceOffPct":0,"gameWinningGoals":0,"games":15,"timeOnIcePerGame":"13:51"},"currentTeamId":3},{"id":8476881,"firstName":"Tomas","lastName":"Hertl","fullName":"Tomas Hertl","number":"48","position":"C","stats":{"_fantasyPoints":222.75,"_fantasyPointsAverage":2.82,"points":46,"goals":22,"assists":24,"penaltyMinutes":41,"plusMinus":-2,"hits":84,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":1,"shortHandedPoints":3,"shots":175,"blocked":71,"faceOffPct":50.77,"gameWinningGoals":5,"games":79,"timeOnIcePerGame":"18:06"},"currentTeamId":28},{"id":8474027,"firstName":"Justin","lastName":"Braun","fullName":"Justin Braun","number":"61","position":"D","stats":{"_fantasyPoints":241.75,"_fantasyPointsAverage":2.98,"points":33,"goals":5,"assists":28,"penaltyMinutes":28,"plusMinus":7,"hits":143,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":115,"blocked":152,"faceOffPct":0,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"21:19"},"currentTeamId":28},{"id":8480926,"firstName":"Ville","lastName":"Meskanen","fullName":"Ville Meskanen","number":"81","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8470622,"firstName":"Patrick","lastName":"Eaves","fullName":"Patrick Eaves","number":"18","position":"RW","stats":{"_fantasyPoints":5.8,"_fantasyPointsAverage":2.9,"points":1,"goals":1,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":3,"blocked":1,"faceOffPct":0,"gameWinningGoals":1,"games":2,"timeOnIcePerGame":"16:27"},"currentTeamId":24},{"id":8475455,"firstName":"Brenden","lastName":"Dillon","fullName":"Brenden Dillon","number":"4","position":"D","stats":{"_fantasyPoints":161.3,"_fantasyPointsAverage":1.99,"points":22,"goals":5,"assists":17,"penaltyMinutes":60,"plusMinus":-7,"hits":197,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":88,"blocked":107,"faceOffPct":0,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"17:19"},"currentTeamId":28},{"id":8477337,"firstName":"John","lastName":"Gilmour","fullName":"John Gilmour","number":"58","position":"D","stats":{"_fantasyPoints":30.1,"_fantasyPointsAverage":1.07,"points":5,"goals":2,"assists":3,"penaltyMinutes":14,"plusMinus":-11,"hits":27,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":61,"blocked":27,"faceOffPct":0,"gameWinningGoals":1,"games":28,"timeOnIcePerGame":"17:10"},"currentTeamId":3},{"id":8476368,"firstName":"Fredrik","lastName":"Claesson","fullName":"Fredrik Claesson","number":"33","position":"D","stats":{"_fantasyPoints":102.5,"_fantasyPointsAverage":1.6,"points":7,"goals":1,"assists":6,"penaltyMinutes":35,"plusMinus":-7,"hits":158,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":60,"blocked":84,"faceOffPct":0,"gameWinningGoals":0,"games":64,"timeOnIcePerGame":"15:20"},"currentTeamId":3},{"id":8477414,"firstName":"Keaton","lastName":"Thompson","fullName":"Keaton Thompson","number":"66","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8475855,"firstName":"Jesper","lastName":"Fast","fullName":"Jesper Fast","number":"17","position":"RW","stats":{"_fantasyPoints":153,"_fantasyPointsAverage":2.15,"points":33,"goals":13,"assists":20,"penaltyMinutes":26,"plusMinus":-10,"hits":130,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":2,"shots":80,"blocked":44,"faceOffPct":36.84,"gameWinningGoals":0,"games":71,"timeOnIcePerGame":"14:52"},"currentTeamId":3},{"id":8474031,"firstName":"Kevin","lastName":"Shattenkirk","fullName":"Kevin Shattenkirk","number":"22","position":"D","stats":{"_fantasyPoints":101.65,"_fantasyPointsAverage":2.21,"points":23,"goals":5,"assists":18,"penaltyMinutes":44,"plusMinus":-14,"hits":44,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":94,"blocked":65,"faceOffPct":0,"gameWinningGoals":1,"games":46,"timeOnIcePerGame":"20:16"},"currentTeamId":3},{"id":8479294,"firstName":"Kevin","lastName":"Boyle","fullName":"Kevin Boyle","number":"40","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":24},{"id":8478029,"firstName":"Chase","lastName":"De Leo","fullName":"Chase De Leo","number":"58","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8475201,"firstName":"Kevin","lastName":"Lynch","fullName":"Kevin Lynch","number":"56","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8474564,"firstName":"Steven","lastName":"Stamkos","fullName":"Steven Stamkos","number":"91","position":"C","stats":{"_fantasyPoints":303.2,"_fantasyPointsAverage":3.89,"points":86,"goals":27,"assists":59,"penaltyMinutes":72,"plusMinus":18,"hits":61,"powerPlayGoals":15,"powerPlayPoints":15,"shortHandedGoals":0,"shortHandedPoints":0,"shots":212,"blocked":35,"faceOffPct":52.24,"gameWinningGoals":1,"games":78,"timeOnIcePerGame":"18:46"},"currentTeamId":14},{"id":8475184,"firstName":"Chris","lastName":"Kreider","fullName":"Chris Kreider","number":"20","position":"LW","stats":{"_fantasyPoints":147.95,"_fantasyPointsAverage":2.55,"points":37,"goals":16,"assists":21,"penaltyMinutes":44,"plusMinus":-2,"hits":103,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":137,"blocked":24,"faceOffPct":41.66,"gameWinningGoals":0,"games":58,"timeOnIcePerGame":"15:37"},"currentTeamId":3},{"id":8473492,"firstName":"Matt","lastName":"Beleskey","fullName":"Matt Beleskey","number":"39","position":"LW","stats":{"_fantasyPoints":-5.55,"_fantasyPointsAverage":-0.37,"points":0,"goals":0,"assists":0,"penaltyMinutes":21,"plusMinus":-9,"hits":34,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":17,"blocked":5,"faceOffPct":22.22,"gameWinningGoals":0,"games":15,"timeOnIcePerGame":"10:58"},"currentTeamId":3},{"id":8475167,"firstName":"Victor","lastName":"Hedman","fullName":"Victor Hedman","number":"77","position":"D","stats":{"_fantasyPoints":338.35,"_fantasyPointsAverage":4.39,"points":63,"goals":17,"assists":46,"penaltyMinutes":54,"plusMinus":32,"hits":139,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":2,"shots":216,"blocked":110,"faceOffPct":50,"gameWinningGoals":1,"games":77,"timeOnIcePerGame":"25:51"},"currentTeamId":14},{"id":8475834,"firstName":"Marcus","lastName":"Sorensen","fullName":"Marcus Sorensen","number":"20","position":"LW","stats":{"_fantasyPoints":35.25,"_fantasyPointsAverage":1.1,"points":7,"goals":5,"assists":2,"penaltyMinutes":5,"plusMinus":-5,"hits":26,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":25,"blocked":15,"faceOffPct":50,"gameWinningGoals":1,"games":32,"timeOnIcePerGame":"10:08"},"currentTeamId":28},{"id":8474053,"firstName":"Logan","lastName":"Couture","fullName":"Logan Couture","number":"39","position":"C","stats":{"_fantasyPoints":279.15,"_fantasyPointsAverage":3.58,"points":61,"goals":34,"assists":27,"penaltyMinutes":18,"plusMinus":-2,"hits":33,"powerPlayGoals":10,"powerPlayPoints":10,"shortHandedGoals":2,"shortHandedPoints":3,"shots":204,"blocked":72,"faceOffPct":45.84,"gameWinningGoals":4,"games":78,"timeOnIcePerGame":"18:32"},"currentTeamId":28},{"id":8478414,"firstName":"Timo","lastName":"Meier","fullName":"Timo Meier","number":"28","position":"RW","stats":{"_fantasyPoints":172.75,"_fantasyPointsAverage":2.13,"points":36,"goals":21,"assists":15,"penaltyMinutes":51,"plusMinus":2,"hits":105,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":210,"blocked":48,"faceOffPct":48.63,"gameWinningGoals":4,"games":81,"timeOnIcePerGame":"14:52"},"currentTeamId":28},{"id":8479365,"firstName":"Trent","lastName":"Frederic","fullName":"Trent Frederic","number":"82","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8475841,"firstName":"Tim","lastName":"Heed","fullName":"Tim Heed","number":"72","position":"D","stats":{"_fantasyPoints":62.35,"_fantasyPointsAverage":2.15,"points":11,"goals":3,"assists":8,"penaltyMinutes":8,"plusMinus":0,"hits":8,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":51,"blocked":35,"faceOffPct":0,"gameWinningGoals":2,"games":29,"timeOnIcePerGame":"16:01"},"currentTeamId":28},{"id":8473986,"firstName":"Alex","lastName":"Killorn","fullName":"Alex Killorn","number":"17","position":"LW","stats":{"_fantasyPoints":191.35,"_fantasyPointsAverage":2.33,"points":47,"goals":15,"assists":32,"penaltyMinutes":45,"plusMinus":22,"hits":82,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":156,"blocked":25,"faceOffPct":40,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"16:29"},"currentTeamId":14},{"id":8476453,"firstName":"Nikita","lastName":"Kucherov","fullName":"Nikita Kucherov","number":"86","position":"RW","stats":{"_fantasyPoints":347.9,"_fantasyPointsAverage":4.35,"points":100,"goals":39,"assists":61,"penaltyMinutes":42,"plusMinus":15,"hits":31,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":0,"shortHandedPoints":0,"shots":279,"blocked":15,"faceOffPct":60,"gameWinningGoals":7,"games":80,"timeOnIcePerGame":"19:49"},"currentTeamId":14},{"id":8478873,"firstName":"Troy","lastName":"Terry","fullName":"Troy Terry","number":"61","position":"RW","stats":{"_fantasyPoints":1.8,"_fantasyPointsAverage":0.9,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":3,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":2,"timeOnIcePerGame":"10:12"},"currentTeamId":24},{"id":8476766,"firstName":"Cole","lastName":"Schneider","fullName":"Cole Schneider","number":"29","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":3},{"id":8480160,"firstName":"Radim","lastName":"Simek","fullName":"Radim Simek","number":"51","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8479533,"firstName":"Joona","lastName":"Koppanen","fullName":"Joona Koppanen","number":"45","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8476624,"firstName":"Barclay","lastName":"Goodrow","fullName":"Barclay Goodrow","number":"23","position":"RW","stats":{"_fantasyPoints":77.7,"_fantasyPointsAverage":1.65,"points":14,"goals":7,"assists":7,"penaltyMinutes":28,"plusMinus":1,"hits":68,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":57,"blocked":30,"faceOffPct":58.77,"gameWinningGoals":1,"games":47,"timeOnIcePerGame":"10:53"},"currentTeamId":28},{"id":8477454,"firstName":"Adam","lastName":"Erne","fullName":"Adam Erne","number":"73","position":"LW","stats":{"_fantasyPoints":24.65,"_fantasyPointsAverage":1.07,"points":4,"goals":3,"assists":1,"penaltyMinutes":11,"plusMinus":-1,"hits":37,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":29,"blocked":8,"faceOffPct":62.5,"gameWinningGoals":1,"games":23,"timeOnIcePerGame":"10:07"},"currentTeamId":14},{"id":8477969,"firstName":"Marcus","lastName":"Pettersson","fullName":"Marcus Pettersson","number":"28","position":"D","stats":{"_fantasyPoints":39.85,"_fantasyPointsAverage":1.81,"points":4,"goals":1,"assists":3,"penaltyMinutes":6,"plusMinus":5,"hits":18,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":16,"blocked":27,"faceOffPct":0,"gameWinningGoals":0,"games":22,"timeOnIcePerGame":"13:36"},"currentTeamId":24},{"id":8477225,"firstName":"Jared","lastName":"Coreau","fullName":"Jared Coreau","number":"31","position":"G","stats":{"_fantasyPoints":"8.20","_fantasyPointsAverage":"1.17","savePercentage":0.867,"goalAgainstAverage":4.26,"wins":0,"losses":5,"saves":176,"goalsAgainst":27,"shutouts":0},"currentTeamId":24},{"id":8466138,"firstName":"Joe","lastName":"Thornton","fullName":"Joe Thornton","number":"19","position":"C","stats":{"_fantasyPoints":113,"_fantasyPointsAverage":2.4,"points":36,"goals":13,"assists":23,"penaltyMinutes":38,"plusMinus":-9,"hits":32,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":75,"blocked":18,"faceOffPct":52.04,"gameWinningGoals":1,"games":47,"timeOnIcePerGame":"18:20"},"currentTeamId":28},{"id":8479290,"firstName":"Kalle","lastName":"Kossila","fullName":"Kalle Kossila","number":"83","position":"C","stats":{"_fantasyPoints":7.65,"_fantasyPointsAverage":0.77,"points":2,"goals":1,"assists":1,"penaltyMinutes":0,"plusMinus":-4,"hits":7,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":9,"blocked":4,"faceOffPct":49.05,"gameWinningGoals":0,"games":10,"timeOnIcePerGame":"09:05"},"currentTeamId":24},{"id":8477312,"firstName":"Antoine","lastName":"Bibeau","fullName":"Antoine Bibeau","number":"34","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":28},{"id":8471958,"firstName":"Dan","lastName":"Girardi","fullName":"Dan Girardi","number":"5","position":"D","stats":{"_fantasyPoints":218.3,"_fantasyPointsAverage":2.84,"points":18,"goals":6,"assists":12,"penaltyMinutes":27,"plusMinus":18,"hits":133,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":93,"blocked":155,"faceOffPct":0,"gameWinningGoals":1,"games":77,"timeOnIcePerGame":"17:23"},"currentTeamId":14},{"id":8477986,"firstName":"Brandon","lastName":"Montour","fullName":"Brandon Montour","number":"26","position":"D","stats":{"_fantasyPoints":199.25,"_fantasyPointsAverage":2.49,"points":32,"goals":9,"assists":23,"penaltyMinutes":42,"plusMinus":16,"hits":96,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":1,"shortHandedPoints":2,"shots":160,"blocked":83,"faceOffPct":0,"gameWinningGoals":5,"games":80,"timeOnIcePerGame":"20:28"},"currentTeamId":24},{"id":8479405,"firstName":"Otto","lastName":"Somppi","fullName":"Otto Somppi","number":"42","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8476792,"firstName":"Torey","lastName":"Krug","fullName":"Torey Krug","number":"47","position":"D","stats":{"_fantasyPoints":253.2,"_fantasyPointsAverage":3.33,"points":59,"goals":14,"assists":45,"penaltyMinutes":36,"plusMinus":0,"hits":79,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":1,"shortHandedPoints":1,"shots":197,"blocked":73,"faceOffPct":0,"gameWinningGoals":4,"games":76,"timeOnIcePerGame":"20:24"},"currentTeamId":6},{"id":8479391,"firstName":"Jack","lastName":"Kopacka","fullName":"Jack Kopacka","number":"59","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8475739,"firstName":"Michael","lastName":"Bournival","fullName":"Michael Bournival","number":"15","position":"LW","stats":{"_fantasyPoints":6.25,"_fantasyPointsAverage":1.25,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":8,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":5,"blocked":5,"faceOffPct":0,"gameWinningGoals":0,"games":5,"timeOnIcePerGame":"09:20"},"currentTeamId":14},{"id":8476826,"firstName":"Yanni","lastName":"Gourde","fullName":"Yanni Gourde","number":"37","position":"C","stats":{"_fantasyPoints":266.85,"_fantasyPointsAverage":3.25,"points":64,"goals":25,"assists":39,"penaltyMinutes":50,"plusMinus":34,"hits":57,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":1,"shortHandedPoints":2,"shots":136,"blocked":42,"faceOffPct":43.4,"gameWinningGoals":5,"games":82,"timeOnIcePerGame":"16:09"},"currentTeamId":14},{"id":8474151,"firstName":"Ryan","lastName":"McDonagh","fullName":"Ryan McDonagh","number":"27","position":"D","stats":{"_fantasyPoints":232.4,"_fantasyPointsAverage":3.69,"points":29,"goals":4,"assists":25,"penaltyMinutes":20,"plusMinus":8,"hits":71,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":1,"shots":99,"blocked":163,"faceOffPct":0,"gameWinningGoals":0,"games":63,"timeOnIcePerGame":"23:19"},"currentTeamId":14},{"id":8479525,"firstName":"Ross","lastName":"Colton","fullName":"Ross Colton","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8478477,"firstName":"Mitchell","lastName":"Stephens","fullName":"Mitchell Stephens","number":"67","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8471657,"firstName":"Cody","lastName":"McLeod","fullName":"Cody McLeod","number":"8","position":"LW","stats":{"_fantasyPoints":-4.9,"_fantasyPointsAverage":-0.1,"points":4,"goals":1,"assists":3,"penaltyMinutes":111,"plusMinus":-11,"hits":131,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":36,"blocked":19,"faceOffPct":0,"gameWinningGoals":0,"games":48,"timeOnIcePerGame":"07:23"},"currentTeamId":3},{"id":8479351,"firstName":"Sam","lastName":"Steel","fullName":"Sam Steel","number":"34","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8476442,"firstName":"Matt","lastName":"Nieto","fullName":"Matt Nieto","number":"83","position":"LW","stats":{"_fantasyPoints":139.65,"_fantasyPointsAverage":1.89,"points":26,"goals":15,"assists":11,"penaltyMinutes":14,"plusMinus":6,"hits":27,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":84,"blocked":56,"faceOffPct":30.76,"gameWinningGoals":1,"games":74,"timeOnIcePerGame":"14:54"},"currentTeamId":21},{"id":8479398,"firstName":"Samuel","lastName":"Girard","fullName":"Samuel Girard","number":"49","position":"D","stats":{"_fantasyPoints":124.65,"_fantasyPointsAverage":1.71,"points":23,"goals":4,"assists":19,"penaltyMinutes":8,"plusMinus":-11,"hits":46,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":84,"blocked":69,"faceOffPct":0,"gameWinningGoals":0,"games":73,"timeOnIcePerGame":"17:38"},"currentTeamId":21},{"id":8477507,"firstName":"Nikita","lastName":"Zadorov","fullName":"Nikita Zadorov","number":"16","position":"D","stats":{"_fantasyPoints":168.4,"_fantasyPointsAverage":2.19,"points":20,"goals":7,"assists":13,"penaltyMinutes":103,"plusMinus":4,"hits":278,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":94,"blocked":106,"faceOffPct":0,"gameWinningGoals":1,"games":77,"timeOnIcePerGame":"19:27"},"currentTeamId":21},{"id":8477346,"firstName":"MacKenzie","lastName":"Weegar","fullName":"MacKenzie Weegar","number":"52","position":"D","stats":{"_fantasyPoints":95.55,"_fantasyPointsAverage":1.59,"points":8,"goals":2,"assists":6,"penaltyMinutes":32,"plusMinus":5,"hits":108,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":58,"blocked":69,"faceOffPct":0,"gameWinningGoals":0,"games":60,"timeOnIcePerGame":"14:34"},"currentTeamId":13},{"id":8478906,"firstName":"Markus","lastName":"Nutivaara","fullName":"Markus Nutivaara","number":"65","position":"D","stats":{"_fantasyPoints":119.9,"_fantasyPointsAverage":1.97,"points":23,"goals":7,"assists":16,"penaltyMinutes":14,"plusMinus":13,"hits":42,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":79,"blocked":40,"faceOffPct":0,"gameWinningGoals":1,"games":61,"timeOnIcePerGame":"16:01"},"currentTeamId":29},{"id":8479561,"firstName":"Travis","lastName":"Barron","fullName":"Travis Barron","number":"73","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8476979,"firstName":"Erik","lastName":"Gustafsson","fullName":"Erik Gustafsson","number":"56","position":"D","stats":{"_fantasyPoints":93.35,"_fantasyPointsAverage":2.67,"points":16,"goals":5,"assists":11,"penaltyMinutes":6,"plusMinus":1,"hits":30,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":71,"blocked":45,"faceOffPct":0,"gameWinningGoals":0,"games":35,"timeOnIcePerGame":"18:33"},"currentTeamId":16},{"id":8478073,"firstName":"Anton","lastName":"Lindholm","fullName":"Anton Lindholm","number":"54","position":"D","stats":{"_fantasyPoints":72.2,"_fantasyPointsAverage":1.5,"points":4,"goals":0,"assists":4,"penaltyMinutes":14,"plusMinus":4,"hits":99,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":22,"blocked":51,"faceOffPct":0,"gameWinningGoals":0,"games":48,"timeOnIcePerGame":"13:10"},"currentTeamId":21},{"id":8478443,"firstName":"Brandon","lastName":"Carlo","fullName":"Brandon Carlo","number":"25","position":"D","stats":{"_fantasyPoints":98.85,"_fantasyPointsAverage":1.3,"points":6,"goals":0,"assists":6,"penaltyMinutes":45,"plusMinus":10,"hits":89,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":76,"blocked":84,"faceOffPct":100,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"19:14"},"currentTeamId":6},{"id":8474207,"firstName":"Nick","lastName":"Holden","fullName":"Nick Holden","number":"22","position":"D","stats":{"_fantasyPoints":140.25,"_fantasyPointsAverage":1.92,"points":17,"goals":4,"assists":13,"penaltyMinutes":14,"plusMinus":-5,"hits":136,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":80,"blocked":83,"faceOffPct":0,"gameWinningGoals":0,"games":73,"timeOnIcePerGame":"19:00"},"currentTeamId":54},{"id":8471339,"firstName":"Ryan","lastName":"Callahan","fullName":"Ryan Callahan","number":"24","position":"RW","stats":{"_fantasyPoints":114.4,"_fantasyPointsAverage":1.71,"points":18,"goals":5,"assists":13,"penaltyMinutes":29,"plusMinus":-4,"hits":138,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":1,"shortHandedPoints":2,"shots":104,"blocked":40,"faceOffPct":40.9,"gameWinningGoals":0,"games":67,"timeOnIcePerGame":"13:19"},"currentTeamId":14},{"id":8476470,"firstName":"Nathan","lastName":"Beaulieu","fullName":"Nathan Beaulieu","number":"82","position":"D","stats":{"_fantasyPoints":53.7,"_fantasyPointsAverage":0.91,"points":9,"goals":1,"assists":8,"penaltyMinutes":36,"plusMinus":-19,"hits":45,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":67,"blocked":65,"faceOffPct":0,"gameWinningGoals":0,"games":59,"timeOnIcePerGame":"15:56"},"currentTeamId":7},{"id":8479439,"firstName":"Jacob","lastName":"MacDonald","fullName":"Jacob MacDonald","number":"23","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":13},{"id":8475763,"firstName":"Kevin","lastName":"Hayes","fullName":"Kevin Hayes","number":"13","position":"C","stats":{"_fantasyPoints":192.2,"_fantasyPointsAverage":2.53,"points":44,"goals":25,"assists":19,"penaltyMinutes":18,"plusMinus":1,"hits":40,"powerPlayGoals":6,"powerPlayPoints":6,"shortHandedGoals":2,"shortHandedPoints":2,"shots":172,"blocked":36,"faceOffPct":50.54,"gameWinningGoals":4,"games":76,"timeOnIcePerGame":"17:21"},"currentTeamId":3},{"id":8477492,"firstName":"Nathan","lastName":"MacKinnon","fullName":"Nathan MacKinnon","number":"29","position":"C","stats":{"_fantasyPoints":338.9,"_fantasyPointsAverage":4.58,"points":97,"goals":39,"assists":58,"penaltyMinutes":55,"plusMinus":11,"hits":38,"powerPlayGoals":12,"powerPlayPoints":12,"shortHandedGoals":0,"shortHandedPoints":1,"shots":284,"blocked":22,"faceOffPct":41.91,"gameWinningGoals":12,"games":74,"timeOnIcePerGame":"19:54"},"currentTeamId":21},{"id":8468083,"firstName":"Henrik","lastName":"Zetterberg","fullName":"Henrik Zetterberg","number":"40","position":"C","stats":{"_fantasyPoints":209.75,"_fantasyPointsAverage":2.56,"points":56,"goals":11,"assists":45,"penaltyMinutes":14,"plusMinus":1,"hits":49,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":180,"blocked":34,"faceOffPct":48.43,"gameWinningGoals":2,"games":82,"timeOnIcePerGame":"19:29"},"currentTeamId":17},{"id":8478106,"firstName":"Dylan","lastName":"Sikura","fullName":"Dylan Sikura","number":"95","position":"RW","stats":{"_fantasyPoints":11.9,"_fantasyPointsAverage":2.38,"points":3,"goals":0,"assists":3,"penaltyMinutes":0,"plusMinus":2,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":9,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":5,"timeOnIcePerGame":"13:24"},"currentTeamId":16},{"id":8478484,"firstName":"Graham","lastName":"Knott","fullName":"Graham Knott","number":"37","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8478387,"firstName":"Tyler","lastName":"Sikura","fullName":"Tyler Sikura","number":"70","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8470110,"firstName":"Trevor","lastName":"Daley","fullName":"Trevor Daley","number":"83","position":"D","stats":{"_fantasyPoints":146.55,"_fantasyPointsAverage":1.9,"points":16,"goals":9,"assists":7,"penaltyMinutes":36,"plusMinus":-5,"hits":24,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":3,"shots":103,"blocked":125,"faceOffPct":0,"gameWinningGoals":4,"games":77,"timeOnIcePerGame":"20:41"},"currentTeamId":17},{"id":8480727,"firstName":"Zach","lastName":"Whitecloud","fullName":"Zach Whitecloud","number":"2","position":"D","stats":{"_fantasyPoints":3.75,"_fantasyPointsAverage":3.75,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":3,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":1,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"16:42"},"currentTeamId":54},{"id":8477046,"firstName":"Joakim","lastName":"Ryan","fullName":"Joakim Ryan","number":"47","position":"D","stats":{"_fantasyPoints":135.15,"_fantasyPointsAverage":2.18,"points":12,"goals":3,"assists":9,"penaltyMinutes":8,"plusMinus":13,"hits":33,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":79,"blocked":98,"faceOffPct":0,"gameWinningGoals":1,"games":62,"timeOnIcePerGame":"16:45"},"currentTeamId":28},{"id":8481036,"firstName":"Roman","lastName":"Durny","fullName":"Roman Durny","number":"68","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":24},{"id":8478485,"firstName":"Zach","lastName":"Senyshyn","fullName":"Zach Senyshyn","number":"19","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8468685,"firstName":"Henrik","lastName":"Lundqvist","fullName":"Henrik Lundqvist","number":"30","position":"G","stats":{"_fantasyPoints":"234.40","_fantasyPointsAverage":"3.72","savePercentage":0.915,"goalAgainstAverage":2.98,"wins":26,"losses":26,"saves":1862,"goalsAgainst":174,"shutouts":2},"currentTeamId":3},{"id":8475430,"firstName":"Brandon","lastName":"Manning","fullName":"Brandon Manning","number":"23","position":"D","stats":{"_fantasyPoints":123.35,"_fantasyPointsAverage":1.9,"points":19,"goals":7,"assists":12,"penaltyMinutes":56,"plusMinus":0,"hits":113,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":111,"blocked":76,"faceOffPct":0,"gameWinningGoals":2,"games":65,"timeOnIcePerGame":"17:57"},"currentTeamId":16},{"id":8474618,"firstName":"Marco","lastName":"Scandella","fullName":"Marco Scandella","number":"6","position":"D","stats":{"_fantasyPoints":154.05,"_fantasyPointsAverage":1.88,"points":22,"goals":5,"assists":17,"penaltyMinutes":37,"plusMinus":-15,"hits":91,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":138,"blocked":114,"faceOffPct":0,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"23:19"},"currentTeamId":7},{"id":8471686,"firstName":"Marc","lastName":"Staal","fullName":"Marc Staal","number":"18","position":"D","stats":{"_fantasyPoints":120.8,"_fantasyPointsAverage":1.68,"points":8,"goals":1,"assists":7,"penaltyMinutes":18,"plusMinus":11,"hits":76,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":68,"blocked":96,"faceOffPct":0,"gameWinningGoals":0,"games":72,"timeOnIcePerGame":"18:31"},"currentTeamId":3},{"id":8480089,"firstName":"Angus","lastName":"Redmond","fullName":"Angus Redmond","number":"79","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":24},{"id":8477366,"firstName":"Luke","lastName":"Johnson","fullName":"Luke Johnson","number":"62","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8478467,"firstName":"Nicolas","lastName":"Meloche","fullName":"Nicolas Meloche","number":"41","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8476473,"firstName":"Connor","lastName":"Murphy","fullName":"Connor Murphy","number":"5","position":"D","stats":{"_fantasyPoints":138.15,"_fantasyPointsAverage":1.82,"points":14,"goals":2,"assists":12,"penaltyMinutes":34,"plusMinus":-3,"hits":138,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":109,"blocked":101,"faceOffPct":0,"gameWinningGoals":0,"games":76,"timeOnIcePerGame":"16:22"},"currentTeamId":16},{"id":8478888,"firstName":"Cameron","lastName":"Hughes","fullName":"Cameron Hughes","number":"53","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8478498,"firstName":"Jake","lastName":"DeBrusk","fullName":"Jake DeBrusk","number":"74","position":"LW","stats":{"_fantasyPoints":182.8,"_fantasyPointsAverage":2.61,"points":43,"goals":16,"assists":27,"penaltyMinutes":19,"plusMinus":13,"hits":70,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":143,"blocked":26,"faceOffPct":43.33,"gameWinningGoals":5,"games":70,"timeOnIcePerGame":"14:22"},"currentTeamId":6},{"id":8478502,"firstName":"Dennis","lastName":"Gilbert","fullName":"Dennis Gilbert","number":"39","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8475233,"firstName":"David","lastName":"Savard","fullName":"David Savard","number":"58","position":"D","stats":{"_fantasyPoints":191.25,"_fantasyPointsAverage":2.36,"points":16,"goals":4,"assists":12,"penaltyMinutes":32,"plusMinus":2,"hits":144,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":145,"blocked":143,"faceOffPct":0,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"19:22"},"currentTeamId":29},{"id":8477951,"firstName":"Nick","lastName":"Schmaltz","fullName":"Nick Schmaltz","number":"8","position":"C","stats":{"_fantasyPoints":200.8,"_fantasyPointsAverage":2.57,"points":52,"goals":21,"assists":31,"penaltyMinutes":18,"plusMinus":1,"hits":13,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":2,"shots":118,"blocked":39,"faceOffPct":40.07,"gameWinningGoals":2,"games":78,"timeOnIcePerGame":"18:13"},"currentTeamId":16},{"id":8480420,"firstName":"Collin","lastName":"Delia","fullName":"Collin Delia","number":"60","position":"G","stats":{"_fantasyPoints":"5.20","_fantasyPointsAverage":"2.60","savePercentage":0.889,"goalAgainstAverage":3.96,"wins":1,"losses":1,"saves":56,"goalsAgainst":7,"shutouts":0},"currentTeamId":16},{"id":8468509,"firstName":"Niklas","lastName":"Kronwall","fullName":"Niklas Kronwall","number":"55","position":"D","stats":{"_fantasyPoints":155.35,"_fantasyPointsAverage":1.97,"points":27,"goals":4,"assists":23,"penaltyMinutes":36,"plusMinus":-14,"hits":82,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":76,"blocked":107,"faceOffPct":0,"gameWinningGoals":0,"games":79,"timeOnIcePerGame":"18:31"},"currentTeamId":17},{"id":8480035,"firstName":"Henri","lastName":"Jokiharju","fullName":"Henri Jokiharju","number":"28","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8478014,"firstName":"Matheson","lastName":"Iacopelli","fullName":"Matheson Iacopelli","number":"59","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8480172,"firstName":"Jan","lastName":"Rutta","fullName":"Jan Rutta","number":"44","position":"D","stats":{"_fantasyPoints":109.6,"_fantasyPointsAverage":1.92,"points":20,"goals":6,"assists":14,"penaltyMinutes":24,"plusMinus":-1,"hits":24,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":1,"shots":71,"blocked":64,"faceOffPct":0,"gameWinningGoals":1,"games":57,"timeOnIcePerGame":"19:15"},"currentTeamId":16},{"id":8476438,"firstName":"Brandon","lastName":"Saad","fullName":"Brandon Saad","number":"20","position":"LW","stats":{"_fantasyPoints":143.95,"_fantasyPointsAverage":1.76,"points":35,"goals":18,"assists":17,"penaltyMinutes":14,"plusMinus":-10,"hits":29,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":237,"blocked":32,"faceOffPct":46.28,"gameWinningGoals":8,"games":82,"timeOnIcePerGame":"17:30"},"currentTeamId":16},{"id":8470607,"firstName":"Brent","lastName":"Seabrook","fullName":"Brent Seabrook","number":"7","position":"D","stats":{"_fantasyPoints":216.35,"_fantasyPointsAverage":2.67,"points":26,"goals":7,"assists":19,"penaltyMinutes":38,"plusMinus":-3,"hits":85,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":136,"blocked":170,"faceOffPct":0,"gameWinningGoals":0,"games":81,"timeOnIcePerGame":"20:11"},"currentTeamId":16},{"id":8478417,"firstName":"Jakob","lastName":"Forsbacka Karlsson","fullName":"Jakob Forsbacka Karlsson","number":"23","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8474638,"firstName":"Andrew","lastName":"Campbell","fullName":"Andrew Campbell","number":"6","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8474141,"firstName":"Patrick","lastName":"Kane","fullName":"Patrick Kane","number":"88","position":"RW","stats":{"_fantasyPoints":235.5,"_fantasyPointsAverage":2.87,"points":76,"goals":27,"assists":49,"penaltyMinutes":32,"plusMinus":-20,"hits":18,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":285,"blocked":14,"faceOffPct":38.88,"gameWinningGoals":4,"games":82,"timeOnIcePerGame":"20:11"},"currentTeamId":16},{"id":8478468,"firstName":"Jeremy","lastName":"Lauzon","fullName":"Jeremy Lauzon","number":"79","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8473573,"firstName":"Artem","lastName":"Anisimov","fullName":"Artem Anisimov","number":"15","position":"C","stats":{"_fantasyPoints":125.75,"_fantasyPointsAverage":1.75,"points":31,"goals":20,"assists":11,"penaltyMinutes":22,"plusMinus":-17,"hits":15,"powerPlayGoals":11,"powerPlayPoints":11,"shortHandedGoals":1,"shortHandedPoints":1,"shots":130,"blocked":40,"faceOffPct":45.71,"gameWinningGoals":6,"games":72,"timeOnIcePerGame":"16:47"},"currentTeamId":16},{"id":8478456,"firstName":"Jesse","lastName":"Gabrielle","fullName":"Jesse Gabrielle","number":"82","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":6},{"id":8480947,"firstName":"Kevin","lastName":"Lankinen","fullName":"Kevin Lankinen","number":"34","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":16},{"id":8476869,"firstName":"Brady","lastName":"Skjei","fullName":"Brady Skjei","number":"76","position":"D","stats":{"_fantasyPoints":162.8,"_fantasyPointsAverage":1.99,"points":25,"goals":4,"assists":21,"penaltyMinutes":39,"plusMinus":-27,"hits":127,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":153,"blocked":119,"faceOffPct":0,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"21:01"},"currentTeamId":3},{"id":8480030,"firstName":"Antoine","lastName":"Morand","fullName":"Antoine Morand","number":"54","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8471717,"firstName":"Adam","lastName":"McQuaid","fullName":"Adam McQuaid","number":"54","position":"D","stats":{"_fantasyPoints":44.9,"_fantasyPointsAverage":1.18,"points":4,"goals":1,"assists":3,"penaltyMinutes":62,"plusMinus":-1,"hits":80,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":39,"blocked":56,"faceOffPct":0,"gameWinningGoals":1,"games":38,"timeOnIcePerGame":"15:42"},"currentTeamId":3},{"id":8478491,"firstName":"Jacob","lastName":"Larsson","fullName":"Jacob Larsson","number":"32","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8479748,"firstName":"Gage","lastName":"Quinney","fullName":"Gage Quinney","number":"72","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8475254,"firstName":"Gabriel","lastName":"Dumont","fullName":"Gabriel Dumont","number":"40","position":"C","stats":{"_fantasyPoints":35.3,"_fantasyPointsAverage":1.18,"points":2,"goals":1,"assists":1,"penaltyMinutes":6,"plusMinus":1,"hits":62,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":38,"blocked":16,"faceOffPct":39.8,"gameWinningGoals":0,"games":30,"timeOnIcePerGame":"09:02"},"currentTeamId":14},{"id":8477034,"firstName":"Jaycob","lastName":"Megna","fullName":"Jaycob Megna","number":"44","position":"D","stats":{"_fantasyPoints":22.2,"_fantasyPointsAverage":1.59,"points":1,"goals":0,"assists":1,"penaltyMinutes":2,"plusMinus":-4,"hits":6,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":7,"blocked":30,"faceOffPct":0,"gameWinningGoals":0,"games":14,"timeOnIcePerGame":"15:42"},"currentTeamId":24},{"id":8474682,"firstName":"Dustin","lastName":"Tokarski","fullName":"Dustin Tokarski","number":"31","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":3},{"id":8480031,"firstName":"Max","lastName":"Comtois","fullName":"Max Comtois","number":"53","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8476195,"firstName":"Cory","lastName":"Conacher","fullName":"Cory Conacher","number":"89","position":"C","stats":{"_fantasyPoints":49.5,"_fantasyPointsAverage":1.38,"points":12,"goals":8,"assists":4,"penaltyMinutes":24,"plusMinus":0,"hits":32,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":45,"blocked":14,"faceOffPct":25,"gameWinningGoals":2,"games":36,"timeOnIcePerGame":"09:59"},"currentTeamId":14},{"id":8479951,"firstName":"Mitch","lastName":"Hults","fullName":"Mitch Hults","number":"87","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8479383,"firstName":"Boris","lastName":"Katchouk","fullName":"Boris Katchouk","number":"41","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8477484,"firstName":"Spencer","lastName":"Martin","fullName":"Spencer Martin","number":"30","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":21},{"id":8478496,"firstName":"Deven","lastName":"Sideroff","fullName":"Deven Sideroff","number":"80","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8471873,"firstName":"Anton","lastName":"Stralman","fullName":"Anton Stralman","number":"6","position":"D","stats":{"_fantasyPoints":183.1,"_fantasyPointsAverage":2.29,"points":18,"goals":4,"assists":14,"penaltyMinutes":18,"plusMinus":29,"hits":104,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":131,"blocked":100,"faceOffPct":0,"gameWinningGoals":0,"games":80,"timeOnIcePerGame":"21:29"},"currentTeamId":14},{"id":8481003,"firstName":"Hunter","lastName":"Drew","fullName":"Hunter Drew","number":"72","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8479372,"firstName":"Josh","lastName":"Mahura","fullName":"Josh Mahura","number":"76","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8475461,"firstName":"Andrew","lastName":"Agozzino","fullName":"Andrew Agozzino","number":"26","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8480073,"firstName":"Erik","lastName":"Brannstrom","fullName":"Erik Brannstrom","number":"12","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8478434,"firstName":"Keegan","lastName":"Kolesar","fullName":"Keegan Kolesar","number":"55","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8477922,"firstName":"Melker","lastName":"Karlsson","fullName":"Melker Karlsson","number":"68","position":"C","stats":{"_fantasyPoints":120.6,"_fantasyPointsAverage":1.7,"points":19,"goals":8,"assists":11,"penaltyMinutes":26,"plusMinus":-5,"hits":81,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":76,"blocked":69,"faceOffPct":66.66,"gameWinningGoals":1,"games":71,"timeOnIcePerGame":"13:14"},"currentTeamId":28},{"id":8478459,"firstName":"Dennis","lastName":"Yan","fullName":"Dennis Yan","number":"38","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8477180,"firstName":"Aaron","lastName":"Dell","fullName":"Aaron Dell","number":"30","position":"G","stats":{"_fantasyPoints":"99.60","_fantasyPointsAverage":"3.43","savePercentage":0.914,"goalAgainstAverage":2.64,"wins":15,"losses":5,"saves":708,"goalsAgainst":67,"shutouts":2},"currentTeamId":28},{"id":8479639,"firstName":"Dylan","lastName":"Coghlan","fullName":"Dylan Coghlan","number":"52","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8476476,"firstName":"Joe","lastName":"Morrow","fullName":"Joe Morrow","number":"70","position":"D","stats":{"_fantasyPoints":109.8,"_fantasyPointsAverage":1.96,"points":16,"goals":6,"assists":10,"penaltyMinutes":26,"plusMinus":-4,"hits":79,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":83,"blocked":67,"faceOffPct":0,"gameWinningGoals":0,"games":56,"timeOnIcePerGame":"16:43"},"currentTeamId":52},{"id":8475729,"firstName":"Mark","lastName":"Alt","fullName":"Mark Alt","number":"7","position":"D","stats":{"_fantasyPoints":16.85,"_fantasyPointsAverage":1.12,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":-1,"hits":17,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":11,"blocked":18,"faceOffPct":0,"gameWinningGoals":0,"games":15,"timeOnIcePerGame":"12:26"},"currentTeamId":21},{"id":8475208,"firstName":"Brian","lastName":"Dumoulin","fullName":"Brian Dumoulin","number":"8","position":"D","stats":{"_fantasyPoints":164.45,"_fantasyPointsAverage":2.06,"points":18,"goals":5,"assists":13,"penaltyMinutes":30,"plusMinus":-5,"hits":101,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":102,"blocked":132,"faceOffPct":0,"gameWinningGoals":1,"games":80,"timeOnIcePerGame":"20:37"},"currentTeamId":5},{"id":8476292,"firstName":"Ondrej","lastName":"Palat","fullName":"Ondrej Palat","number":"18","position":"LW","stats":{"_fantasyPoints":186.4,"_fantasyPointsAverage":3.33,"points":35,"goals":11,"assists":24,"penaltyMinutes":6,"plusMinus":16,"hits":80,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":1,"shortHandedPoints":1,"shots":109,"blocked":48,"faceOffPct":22.58,"gameWinningGoals":0,"games":56,"timeOnIcePerGame":"16:59"},"currentTeamId":14},{"id":8475197,"firstName":"Tyson","lastName":"Barrie","fullName":"Tyson Barrie","number":"4","position":"D","stats":{"_fantasyPoints":232.55,"_fantasyPointsAverage":3.42,"points":57,"goals":14,"assists":43,"penaltyMinutes":22,"plusMinus":-15,"hits":40,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":178,"blocked":79,"faceOffPct":0,"gameWinningGoals":3,"games":68,"timeOnIcePerGame":"22:41"},"currentTeamId":21},{"id":8479325,"firstName":"Charlie","lastName":"McAvoy","fullName":"Charlie McAvoy","number":"73","position":"D","stats":{"_fantasyPoints":184.95,"_fantasyPointsAverage":2.94,"points":32,"goals":7,"assists":25,"penaltyMinutes":53,"plusMinus":20,"hits":133,"powerPlayGoals":2,"powerPlayPoints":2,"shortHandedGoals":0,"shortHandedPoints":0,"shots":77,"blocked":80,"faceOffPct":0,"gameWinningGoals":2,"games":63,"timeOnIcePerGame":"22:08"},"currentTeamId":6},{"id":8479368,"firstName":"Max","lastName":"Jones","fullName":"Max Jones","number":"49","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8480304,"firstName":"Jayden","lastName":"Halbgewachs","fullName":"Jayden Halbgewachs","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8478569,"firstName":"Noel","lastName":"Acciari","fullName":"Noel Acciari","number":"55","position":"C","stats":{"_fantasyPoints":105.85,"_fantasyPointsAverage":1.76,"points":11,"goals":10,"assists":1,"penaltyMinutes":9,"plusMinus":-6,"hits":152,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":66,"blocked":41,"faceOffPct":45.16,"gameWinningGoals":0,"games":60,"timeOnIcePerGame":"12:54"},"currentTeamId":6},{"id":8478900,"firstName":"Joni","lastName":"Tuulola","fullName":"Joni Tuulola","number":"41","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8477456,"firstName":"J.T.","lastName":"Compher","fullName":"J.T. Compher","number":"37","position":"LW","stats":{"_fantasyPoints":115.1,"_fantasyPointsAverage":1.67,"points":23,"goals":13,"assists":10,"penaltyMinutes":20,"plusMinus":-29,"hits":45,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":2,"shortHandedPoints":2,"shots":131,"blocked":65,"faceOffPct":45.12,"gameWinningGoals":3,"games":69,"timeOnIcePerGame":"15:59"},"currentTeamId":21},{"id":8477021,"firstName":"Alexander","lastName":"Kerfoot","fullName":"Alexander Kerfoot","number":"13","position":"C","stats":{"_fantasyPoints":158.85,"_fantasyPointsAverage":2.01,"points":43,"goals":19,"assists":24,"penaltyMinutes":28,"plusMinus":-7,"hits":42,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":81,"blocked":35,"faceOffPct":42.07,"gameWinningGoals":0,"games":79,"timeOnIcePerGame":"13:26"},"currentTeamId":21},{"id":8475747,"firstName":"Patrik","lastName":"Nemeth","fullName":"Patrik Nemeth","number":"12","position":"D","stats":{"_fantasyPoints":216.55,"_fantasyPointsAverage":3.18,"points":15,"goals":3,"assists":12,"penaltyMinutes":41,"plusMinus":27,"hits":66,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":2,"shots":73,"blocked":185,"faceOffPct":0,"gameWinningGoals":0,"games":68,"timeOnIcePerGame":"19:51"},"currentTeamId":21},{"id":8476922,"firstName":"Boo","lastName":"Nieves","fullName":"Boo Nieves","number":"24","position":"C","stats":{"_fantasyPoints":47.55,"_fantasyPointsAverage":1.7,"points":9,"goals":1,"assists":8,"penaltyMinutes":12,"plusMinus":6,"hits":30,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":23,"blocked":19,"faceOffPct":44.29,"gameWinningGoals":0,"games":28,"timeOnIcePerGame":"10:11"},"currentTeamId":3},{"id":8477010,"firstName":"Joseph","lastName":"Blandisi","fullName":"Joseph Blandisi","number":"39","position":"C","stats":{"_fantasyPoints":3.4,"_fantasyPointsAverage":1.13,"points":0,"goals":0,"assists":0,"penaltyMinutes":2,"plusMinus":2,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":2,"faceOffPct":0,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"11:40"},"currentTeamId":24},{"id":8478550,"firstName":"Artemi","lastName":"Panarin","fullName":"Artemi Panarin","number":"9","position":"LW","stats":{"_fantasyPoints":293.3,"_fantasyPointsAverage":3.62,"points":82,"goals":27,"assists":55,"penaltyMinutes":26,"plusMinus":23,"hits":15,"powerPlayGoals":7,"powerPlayPoints":7,"shortHandedGoals":0,"shortHandedPoints":0,"shots":228,"blocked":19,"faceOffPct":0,"gameWinningGoals":5,"games":81,"timeOnIcePerGame":"20:07"},"currentTeamId":29},{"id":8476886,"firstName":"Slater","lastName":"Koekkoek","fullName":"Slater Koekkoek","number":"29","position":"D","stats":{"_fantasyPoints":50.3,"_fantasyPointsAverage":1.44,"points":8,"goals":4,"assists":4,"penaltyMinutes":18,"plusMinus":4,"hits":36,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":43,"blocked":24,"faceOffPct":0,"gameWinningGoals":1,"games":35,"timeOnIcePerGame":"11:14"},"currentTeamId":14},{"id":8479410,"firstName":"Mikhail","lastName":"Sergachev","fullName":"Mikhail Sergachev","number":"98","position":"D","stats":{"_fantasyPoints":193.6,"_fantasyPointsAverage":2.45,"points":40,"goals":9,"assists":31,"penaltyMinutes":38,"plusMinus":11,"hits":90,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":141,"blocked":64,"faceOffPct":0,"gameWinningGoals":5,"games":79,"timeOnIcePerGame":"15:21"},"currentTeamId":14},{"id":8476982,"firstName":"Danny","lastName":"O'Regan","fullName":"Danny O'Regan","number":"65","position":"C","stats":{"_fantasyPoints":14.95,"_fantasyPointsAverage":0.71,"points":4,"goals":0,"assists":4,"penaltyMinutes":2,"plusMinus":-2,"hits":5,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":17,"blocked":6,"faceOffPct":48.33,"gameWinningGoals":0,"games":21,"timeOnIcePerGame":"09:58"},"currentTeamId":7},{"id":8479980,"firstName":"Nicolas","lastName":"Hague","fullName":"Nicolas Hague","number":"14","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8476807,"firstName":"Matt","lastName":"Tennyson","fullName":"Matt Tennyson","number":"5","position":"D","stats":{"_fantasyPoints":2,"_fantasyPointsAverage":0.13,"points":0,"goals":0,"assists":0,"penaltyMinutes":8,"plusMinus":-8,"hits":13,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":25,"blocked":11,"faceOffPct":0,"gameWinningGoals":0,"games":15,"timeOnIcePerGame":"17:58"},"currentTeamId":7},{"id":8478416,"firstName":"Erik","lastName":"Cernak","fullName":"Erik Cernak","number":"81","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8475728,"firstName":"Johan","lastName":"Larsson","fullName":"Johan Larsson","number":"22","position":"C","stats":{"_fantasyPoints":72.1,"_fantasyPointsAverage":0.9,"points":17,"goals":4,"assists":13,"penaltyMinutes":49,"plusMinus":-30,"hits":117,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":86,"blocked":47,"faceOffPct":54.46,"gameWinningGoals":0,"games":80,"timeOnIcePerGame":"14:06"},"currentTeamId":7},{"id":8478131,"firstName":"Ondrej","lastName":"Kase","fullName":"Ondrej Kase","number":"25","position":"RW","stats":{"_fantasyPoints":168.6,"_fantasyPointsAverage":2.55,"points":38,"goals":20,"assists":18,"penaltyMinutes":14,"plusMinus":18,"hits":28,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":146,"blocked":26,"faceOffPct":19.23,"gameWinningGoals":5,"games":66,"timeOnIcePerGame":"13:55"},"currentTeamId":24},{"id":8477973,"firstName":"Vladislav","lastName":"Kamenev","fullName":"Vladislav Kamenev","number":"91","position":"C","stats":{"_fantasyPoints":-1.15,"_fantasyPointsAverage":-0.38,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-2,"hits":3,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":0,"faceOffPct":38.88,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"08:49"},"currentTeamId":21},{"id":8477413,"firstName":"Sven","lastName":"Andrighetto","fullName":"Sven Andrighetto","number":"10","position":"RW","stats":{"_fantasyPoints":81.6,"_fantasyPointsAverage":1.63,"points":22,"goals":8,"assists":14,"penaltyMinutes":10,"plusMinus":-15,"hits":38,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":0,"shots":111,"blocked":18,"faceOffPct":31.81,"gameWinningGoals":2,"games":50,"timeOnIcePerGame":"14:29"},"currentTeamId":21},{"id":8475268,"firstName":"Gabriel","lastName":"Bourque","fullName":"Gabriel Bourque","number":"57","position":"LW","stats":{"_fantasyPoints":99.9,"_fantasyPointsAverage":1.72,"points":11,"goals":5,"assists":6,"penaltyMinutes":12,"plusMinus":-6,"hits":123,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":44,"blocked":59,"faceOffPct":30.43,"gameWinningGoals":1,"games":58,"timeOnIcePerGame":"10:54"},"currentTeamId":21},{"id":8480822,"firstName":"Martin","lastName":"Kaut","fullName":"Martin Kaut","number":"61","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8474013,"firstName":"Ian","lastName":"Cole","fullName":"Ian Cole","number":"28","position":"D","stats":{"_fantasyPoints":150.65,"_fantasyPointsAverage":2.25,"points":20,"goals":5,"assists":15,"penaltyMinutes":76,"plusMinus":14,"hits":95,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":84,"blocked":116,"faceOffPct":0,"gameWinningGoals":0,"games":67,"timeOnIcePerGame":"17:46"},"currentTeamId":21},{"id":8478561,"firstName":"Andreas","lastName":"Martinsen","fullName":"Andreas Martinsen","number":"29","position":"LW","stats":{"_fantasyPoints":7.15,"_fantasyPointsAverage":0.79,"points":1,"goals":1,"assists":0,"penaltyMinutes":17,"plusMinus":-1,"hits":35,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":14,"blocked":4,"faceOffPct":0,"gameWinningGoals":0,"games":9,"timeOnIcePerGame":"12:38"},"currentTeamId":16},{"id":8478421,"firstName":"A.J.","lastName":"Greer","fullName":"A.J. Greer","number":"24","position":"LW","stats":{"_fantasyPoints":7.55,"_fantasyPointsAverage":0.44,"points":3,"goals":0,"assists":3,"penaltyMinutes":29,"plusMinus":2,"hits":30,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":13,"blocked":5,"faceOffPct":33.33,"gameWinningGoals":0,"games":17,"timeOnIcePerGame":"07:23"},"currentTeamId":21},{"id":8471262,"firstName":"Carl","lastName":"Soderberg","fullName":"Carl Soderberg","number":"34","position":"C","stats":{"_fantasyPoints":182.25,"_fantasyPointsAverage":2.37,"points":37,"goals":16,"assists":21,"penaltyMinutes":26,"plusMinus":0,"hits":71,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":150,"blocked":64,"faceOffPct":45.26,"gameWinningGoals":3,"games":77,"timeOnIcePerGame":"17:21"},"currentTeamId":21},{"id":8475831,"firstName":"Philipp","lastName":"Grubauer","fullName":"Philipp Grubauer","number":"31","position":"G","stats":{"_fantasyPoints":"133.00","_fantasyPointsAverage":"3.80","savePercentage":0.923,"goalAgainstAverage":2.35,"wins":15,"losses":10,"saves":880,"goalsAgainst":73,"shutouts":3},"currentTeamId":21},{"id":8478884,"firstName":"Sergei","lastName":"Boikov","fullName":"Sergei Boikov","number":"42","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8474569,"firstName":"Colin","lastName":"Wilson","fullName":"Colin Wilson","number":"22","position":"C","stats":{"_fantasyPoints":80.25,"_fantasyPointsAverage":1.43,"points":18,"goals":6,"assists":12,"penaltyMinutes":6,"plusMinus":-5,"hits":38,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":75,"blocked":23,"faceOffPct":52.17,"gameWinningGoals":1,"games":56,"timeOnIcePerGame":"13:07"},"currentTeamId":21},{"id":8480954,"firstName":"Jacob","lastName":"Nilsson","fullName":"Jacob Nilsson","number":"67","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8477419,"firstName":"Mason","lastName":"Geertsen","fullName":"Mason Geertsen","number":"2","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8469506,"firstName":"Jason","lastName":"Pominville","fullName":"Jason Pominville","number":"29","position":"RW","stats":{"_fantasyPoints":136.3,"_fantasyPointsAverage":1.66,"points":34,"goals":16,"assists":18,"penaltyMinutes":8,"plusMinus":-17,"hits":39,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":168,"blocked":35,"faceOffPct":57.89,"gameWinningGoals":1,"games":82,"timeOnIcePerGame":"14:54"},"currentTeamId":7},{"id":8480326,"firstName":"Sheldon","lastName":"Dries","fullName":"Sheldon Dries","number":"15","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8477435,"firstName":"Ryan","lastName":"Graves","fullName":"Ryan Graves","number":"27","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8477931,"firstName":"Tomas","lastName":"Nosek","fullName":"Tomas Nosek","number":"92","position":"LW","stats":{"_fantasyPoints":90.95,"_fantasyPointsAverage":1.36,"points":15,"goals":7,"assists":8,"penaltyMinutes":14,"plusMinus":6,"hits":53,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":92,"blocked":24,"faceOffPct":53.84,"gameWinningGoals":0,"games":67,"timeOnIcePerGame":"11:05"},"currentTeamId":54},{"id":8471436,"firstName":"Matt","lastName":"Hunwick","fullName":"Matt Hunwick","number":"48","position":"D","stats":{"_fantasyPoints":75.7,"_fantasyPointsAverage":1.8,"points":10,"goals":4,"assists":6,"penaltyMinutes":21,"plusMinus":-4,"hits":51,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":52,"blocked":53,"faceOffPct":0,"gameWinningGoals":1,"games":42,"timeOnIcePerGame":"17:30"},"currentTeamId":7},{"id":8475727,"firstName":"Ryan","lastName":"Spooner","fullName":"Ryan Spooner","number":"23","position":"C","stats":{"_fantasyPoints":162.2,"_fantasyPointsAverage":2.75,"points":41,"goals":13,"assists":28,"penaltyMinutes":4,"plusMinus":6,"hits":66,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":107,"blocked":16,"faceOffPct":43.33,"gameWinningGoals":3,"games":59,"timeOnIcePerGame":"15:17"},"currentTeamId":3},{"id":8480843,"firstName":"Lukas","lastName":"Dostal","fullName":"Lukas Dostal","number":"1","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":24},{"id":8478519,"firstName":"Anthony","lastName":"Cirelli","fullName":"Anthony Cirelli","number":"71","position":"C","stats":{"_fantasyPoints":55.35,"_fantasyPointsAverage":3.08,"points":11,"goals":5,"assists":6,"penaltyMinutes":6,"plusMinus":11,"hits":17,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":26,"blocked":6,"faceOffPct":44.86,"gameWinningGoals":0,"games":18,"timeOnIcePerGame":"13:13"},"currentTeamId":14},{"id":8470612,"firstName":"Ryan","lastName":"Getzlaf","fullName":"Ryan Getzlaf","number":"15","position":"C","stats":{"_fantasyPoints":254.45,"_fantasyPointsAverage":4.54,"points":61,"goals":11,"assists":50,"penaltyMinutes":42,"plusMinus":20,"hits":96,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":117,"blocked":57,"faceOffPct":47.82,"gameWinningGoals":0,"games":56,"timeOnIcePerGame":"21:25"},"currentTeamId":24},{"id":8475210,"firstName":"Anton","lastName":"Rodin","fullName":"Anton Rodin","number":"38","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8474870,"firstName":"Tyler","lastName":"Johnson","fullName":"Tyler Johnson","number":"9","position":"C","stats":{"_fantasyPoints":216.35,"_fantasyPointsAverage":2.67,"points":50,"goals":21,"assists":29,"penaltyMinutes":24,"plusMinus":3,"hits":48,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":2,"shortHandedPoints":2,"shots":186,"blocked":47,"faceOffPct":50.07,"gameWinningGoals":3,"games":81,"timeOnIcePerGame":"16:59"},"currentTeamId":14},{"id":8478412,"firstName":"Nathan","lastName":"Noel","fullName":"Nathan Noel","number":"78","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":16},{"id":8477205,"firstName":"Andrej","lastName":"Sustr","fullName":"Andrej Sustr","number":"62","position":"D","stats":{"_fantasyPoints":37,"_fantasyPointsAverage":0.84,"points":7,"goals":2,"assists":5,"penaltyMinutes":18,"plusMinus":-5,"hits":9,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":45,"blocked":33,"faceOffPct":0,"gameWinningGoals":0,"games":44,"timeOnIcePerGame":"12:50"},"currentTeamId":24},{"id":8479946,"firstName":"Sam","lastName":"Vigneault","fullName":"Sam Vigneault","number":"74","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8478949,"firstName":"Kole","lastName":"Sherwood","fullName":"Kole Sherwood","number":"88","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":29},{"id":8477448,"firstName":"Marko","lastName":"Dano","fullName":"Marko Dano","number":"56","position":"C","stats":{"_fantasyPoints":18.45,"_fantasyPointsAverage":0.8,"points":3,"goals":2,"assists":1,"penaltyMinutes":6,"plusMinus":-2,"hits":26,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":22,"blocked":7,"faceOffPct":50,"gameWinningGoals":2,"games":23,"timeOnIcePerGame":"07:11"},"currentTeamId":52},{"id":8480384,"firstName":"Alexander","lastName":"True","fullName":"Alexander True","number":"70","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8476162,"firstName":"Steve","lastName":"Oleksy","fullName":"Steve Oleksy","number":"43","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8470601,"firstName":"Braydon","lastName":"Coburn","fullName":"Braydon Coburn","number":"55","position":"D","stats":{"_fantasyPoints":104.3,"_fantasyPointsAverage":1.45,"points":15,"goals":1,"assists":14,"penaltyMinutes":40,"plusMinus":3,"hits":77,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":73,"blocked":75,"faceOffPct":0,"gameWinningGoals":0,"games":72,"timeOnIcePerGame":"16:01"},"currentTeamId":14},{"id":8474230,"firstName":"Micheal","lastName":"Haley","fullName":"Micheal Haley","number":"18","position":"C","stats":{"_fantasyPoints":-39.75,"_fantasyPointsAverage":-0.53,"points":9,"goals":3,"assists":6,"penaltyMinutes":212,"plusMinus":-13,"hits":124,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":55,"blocked":23,"faceOffPct":47.5,"gameWinningGoals":1,"games":75,"timeOnIcePerGame":"07:47"},"currentTeamId":13},{"id":8477930,"firstName":"Pierre-Edouard","lastName":"Bellemare","fullName":"Pierre-Edouard Bellemare","number":"41","position":"LW","stats":{"_fantasyPoints":110.7,"_fantasyPointsAverage":1.54,"points":16,"goals":6,"assists":10,"penaltyMinutes":14,"plusMinus":5,"hits":41,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":92,"blocked":63,"faceOffPct":51.15,"gameWinningGoals":1,"games":72,"timeOnIcePerGame":"12:19"},"currentTeamId":54},{"id":8478097,"firstName":"Reid","lastName":"Duke","fullName":"Reid Duke","number":"37","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8479176,"firstName":"Alex","lastName":"Gallant","fullName":"Alex Gallant","number":"48","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8474660,"firstName":"David","lastName":"Warsofsky","fullName":"David Warsofsky","number":"5","position":"D","stats":{"_fantasyPoints":35.05,"_fantasyPointsAverage":2.19,"points":5,"goals":0,"assists":5,"penaltyMinutes":0,"plusMinus":4,"hits":1,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":18,"blocked":22,"faceOffPct":0,"gameWinningGoals":0,"games":16,"timeOnIcePerGame":"13:23"},"currentTeamId":21},{"id":8476952,"firstName":"Dominic","lastName":"Toninato","fullName":"Dominic Toninato","number":"47","position":"C","stats":{"_fantasyPoints":18,"_fantasyPointsAverage":0.49,"points":2,"goals":0,"assists":2,"penaltyMinutes":12,"plusMinus":0,"hits":24,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":25,"blocked":14,"faceOffPct":41.7,"gameWinningGoals":0,"games":37,"timeOnIcePerGame":"07:53"},"currentTeamId":21},{"id":8479996,"firstName":"Cody","lastName":"Glass","fullName":"Cody Glass","number":"9","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8475300,"firstName":"Joe","lastName":"Cannata","fullName":"Joe Cannata","number":"35","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":21},{"id":8476431,"firstName":"Adam","lastName":"Clendening","fullName":"Adam Clendening","number":"6","position":"D","stats":{"_fantasyPoints":8.4,"_fantasyPointsAverage":1.68,"points":2,"goals":0,"assists":2,"penaltyMinutes":2,"plusMinus":-1,"hits":2,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":4,"blocked":6,"faceOffPct":0,"gameWinningGoals":0,"games":5,"timeOnIcePerGame":"15:56"},"currentTeamId":29},{"id":8476407,"firstName":"Andy","lastName":"Welinski","fullName":"Andy Welinski","number":"45","position":"D","stats":{"_fantasyPoints":11.6,"_fantasyPointsAverage":1.66,"points":2,"goals":0,"assists":2,"penaltyMinutes":0,"plusMinus":-1,"hits":4,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":6,"blocked":8,"faceOffPct":0,"gameWinningGoals":0,"games":7,"timeOnIcePerGame":"16:10"},"currentTeamId":24},{"id":8477402,"firstName":"Pavel","lastName":"Buchnevich","fullName":"Pavel Buchnevich","number":"89","position":"RW","stats":{"_fantasyPoints":169.6,"_fantasyPointsAverage":2.29,"points":43,"goals":14,"assists":29,"penaltyMinutes":20,"plusMinus":-3,"hits":51,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":136,"blocked":35,"faceOffPct":26.08,"gameWinningGoals":4,"games":74,"timeOnIcePerGame":"15:00"},"currentTeamId":3},{"id":8480454,"firstName":"Vincent","lastName":"Praplan","fullName":"Vincent Praplan","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8473503,"firstName":"James","lastName":"Reimer","fullName":"James Reimer","number":"34","position":"G","stats":{"_fantasyPoints":"172.60","_fantasyPointsAverage":"3.92","savePercentage":0.913,"goalAgainstAverage":2.99,"wins":22,"losses":14,"saves":1253,"goalsAgainst":120,"shutouts":4},"currentTeamId":13},{"id":8476480,"firstName":"Vladislav","lastName":"Namestnikov","fullName":"Vladislav Namestnikov","number":"90","position":"C","stats":{"_fantasyPoints":201.75,"_fantasyPointsAverage":2.49,"points":48,"goals":22,"assists":26,"penaltyMinutes":45,"plusMinus":6,"hits":79,"powerPlayGoals":9,"powerPlayPoints":9,"shortHandedGoals":0,"shortHandedPoints":0,"shots":155,"blocked":44,"faceOffPct":45.82,"gameWinningGoals":2,"games":81,"timeOnIcePerGame":"17:05"},"currentTeamId":3},{"id":8478441,"firstName":"Matthew","lastName":"Spencer","fullName":"Matthew Spencer","number":"64","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8475839,"firstName":"Louis","lastName":"Domingue","fullName":"Louis Domingue","number":"70","position":"G","stats":{"_fantasyPoints":"49.40","_fantasyPointsAverage":"2.60","savePercentage":0.894,"goalAgainstAverage":3.41,"wins":7,"losses":9,"saves":517,"goalsAgainst":61,"shutouts":0},"currentTeamId":14},{"id":8476404,"firstName":"Andy","lastName":"Andreoff","fullName":"Andy Andreoff","position":"C","stats":{"_fantasyPoints":26.7,"_fantasyPointsAverage":0.59,"points":9,"goals":3,"assists":6,"penaltyMinutes":50,"plusMinus":-6,"hits":77,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":47,"blocked":11,"faceOffPct":45.28,"gameWinningGoals":2,"games":45,"timeOnIcePerGame":"09:23"},"currentTeamId":14},{"id":8479390,"firstName":"Taylor","lastName":"Raddysh","fullName":"Taylor Raddysh","number":"46","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8475277,"firstName":"Edward","lastName":"Pasquale","fullName":"Edward Pasquale","number":"32","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":14},{"id":8474090,"firstName":"Brendan","lastName":"Smith","fullName":"Brendan Smith","number":"42","position":"D","stats":{"_fantasyPoints":37.85,"_fantasyPointsAverage":0.86,"points":8,"goals":1,"assists":7,"penaltyMinutes":69,"plusMinus":2,"hits":58,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":66,"blocked":37,"faceOffPct":0,"gameWinningGoals":0,"games":44,"timeOnIcePerGame":"17:10"},"currentTeamId":3},{"id":8479613,"firstName":"Giovanni","lastName":"Fiore","fullName":"Giovanni Fiore","number":"90","position":"LW","stats":{"_fantasyPoints":-1,"_fantasyPointsAverage":-1,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":1,"timeOnIcePerGame":"07:53"},"currentTeamId":24},{"id":8480748,"firstName":"Kiefer","lastName":"Sherwood","fullName":"Kiefer Sherwood","number":"64","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":24},{"id":8476468,"firstName":"J.T.","lastName":"Miller","fullName":"J.T. Miller","number":"10","position":"C","stats":{"_fantasyPoints":217.8,"_fantasyPointsAverage":2.66,"points":58,"goals":23,"assists":35,"penaltyMinutes":40,"plusMinus":-4,"hits":124,"powerPlayGoals":11,"powerPlayPoints":11,"shortHandedGoals":0,"shortHandedPoints":0,"shots":143,"blocked":26,"faceOffPct":54.28,"gameWinningGoals":5,"games":82,"timeOnIcePerGame":"17:01"},"currentTeamId":14},{"id":8476975,"firstName":"Cedric","lastName":"Paquette","fullName":"Cedric Paquette","number":"13","position":"C","stats":{"_fantasyPoints":60.9,"_fantasyPointsAverage":1.09,"points":9,"goals":5,"assists":4,"penaltyMinutes":41,"plusMinus":-5,"hits":112,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":64,"blocked":32,"faceOffPct":46.89,"gameWinningGoals":2,"games":56,"timeOnIcePerGame":"10:12"},"currentTeamId":14},{"id":8478472,"firstName":"Mathieu","lastName":"Joseph","fullName":"Mathieu Joseph","number":"7","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8479598,"firstName":"Oleg","lastName":"Sosunov","fullName":"Oleg Sosunov","number":"76","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":14},{"id":8475692,"firstName":"Mats","lastName":"Zuccarello","fullName":"Mats Zuccarello","number":"36","position":"RW","stats":{"_fantasyPoints":212.55,"_fantasyPointsAverage":2.66,"points":53,"goals":16,"assists":37,"penaltyMinutes":36,"plusMinus":-10,"hits":62,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":178,"blocked":67,"faceOffPct":26.25,"gameWinningGoals":3,"games":80,"timeOnIcePerGame":"18:55"},"currentTeamId":3},{"id":8475180,"firstName":"Peter","lastName":"Holland","fullName":"Peter Holland","number":"12","position":"C","stats":{"_fantasyPoints":16.5,"_fantasyPointsAverage":0.72,"points":4,"goals":1,"assists":3,"penaltyMinutes":7,"plusMinus":-10,"hits":14,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":1,"shots":30,"blocked":12,"faceOffPct":47.13,"gameWinningGoals":0,"games":23,"timeOnIcePerGame":"12:23"},"currentTeamId":3},{"id":8474685,"firstName":"Matt","lastName":"Calvert","fullName":"Matt Calvert","number":"11","position":"LW","stats":{"_fantasyPoints":102.3,"_fantasyPointsAverage":1.48,"points":24,"goals":9,"assists":15,"penaltyMinutes":33,"plusMinus":-10,"hits":61,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":2,"shortHandedPoints":2,"shots":108,"blocked":35,"faceOffPct":34.09,"gameWinningGoals":0,"games":69,"timeOnIcePerGame":"13:22"},"currentTeamId":21},{"id":8480925,"firstName":"Pavel","lastName":"Francouz","fullName":"Pavel Francouz","number":"39","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":21},{"id":8479370,"firstName":"Tyson","lastName":"Jost","fullName":"Tyson Jost","number":"17","position":"C","stats":{"_fantasyPoints":87.05,"_fantasyPointsAverage":1.34,"points":22,"goals":12,"assists":10,"penaltyMinutes":26,"plusMinus":-10,"hits":33,"powerPlayGoals":5,"powerPlayPoints":5,"shortHandedGoals":0,"shortHandedPoints":0,"shots":113,"blocked":26,"faceOffPct":36.68,"gameWinningGoals":1,"games":65,"timeOnIcePerGame":"14:38"},"currentTeamId":21},{"id":8479601,"firstName":"Vasily","lastName":"Glotov","fullName":"Vasily Glotov","number":"77","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8480210,"firstName":"Igor","lastName":"Shvyrev","fullName":"Igor Shvyrev","number":"43","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8478420,"firstName":"Mikko","lastName":"Rantanen","fullName":"Mikko Rantanen","number":"96","position":"RW","stats":{"_fantasyPoints":295.3,"_fantasyPointsAverage":3.65,"points":84,"goals":29,"assists":55,"penaltyMinutes":34,"plusMinus":0,"hits":32,"powerPlayGoals":12,"powerPlayPoints":12,"shortHandedGoals":0,"shortHandedPoints":0,"shots":178,"blocked":40,"faceOffPct":51.28,"gameWinningGoals":3,"games":81,"timeOnIcePerGame":"18:57"},"currentTeamId":21},{"id":8480405,"firstName":"Ty","lastName":"Lewis","fullName":"Ty Lewis","number":"65","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8476931,"firstName":"Jake","lastName":"McCabe","fullName":"Jake McCabe","number":"19","position":"D","stats":{"_fantasyPoints":101.55,"_fantasyPointsAverage":1.92,"points":12,"goals":3,"assists":9,"penaltyMinutes":26,"plusMinus":-11,"hits":110,"powerPlayGoals":1,"powerPlayPoints":1,"shortHandedGoals":0,"shortHandedPoints":0,"shots":53,"blocked":79,"faceOffPct":0,"gameWinningGoals":0,"games":53,"timeOnIcePerGame":"19:30"},"currentTeamId":7},{"id":8477949,"firstName":"Alex","lastName":"Tuch","fullName":"Alex Tuch","number":"89","position":"RW","stats":{"_fantasyPoints":175.35,"_fantasyPointsAverage":2.25,"points":37,"goals":15,"assists":22,"penaltyMinutes":27,"plusMinus":3,"hits":99,"powerPlayGoals":4,"powerPlayPoints":4,"shortHandedGoals":0,"shortHandedPoints":0,"shots":171,"blocked":42,"faceOffPct":42.42,"gameWinningGoals":4,"games":78,"timeOnIcePerGame":"15:15"},"currentTeamId":54},{"id":8478971,"firstName":"Connor","lastName":"Ingram","fullName":"Connor Ingram","number":"1","position":"G","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"savePercentage":0,"goalAgainstAverage":0,"wins":0,"losses":0,"saves":0,"goalsAgainst":0,"shutouts":0},"currentTeamId":14},{"id":8481186,"firstName":"Logan","lastName":"O'Connor","fullName":"Logan O'Connor","number":"25","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8479982,"firstName":"Conor","lastName":"Timmins","fullName":"Conor Timmins","number":"18","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8471331,"firstName":"Kevin","lastName":"Porter","fullName":"Kevin Porter","number":"12","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":7},{"id":8471743,"firstName":"Vladimir","lastName":"Sobotka","fullName":"Vladimir Sobotka","number":"17","position":"C","stats":{"_fantasyPoints":141.6,"_fantasyPointsAverage":1.75,"points":31,"goals":11,"assists":20,"penaltyMinutes":50,"plusMinus":-6,"hits":127,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":136,"blocked":45,"faceOffPct":54.26,"gameWinningGoals":4,"games":81,"timeOnIcePerGame":"17:07"},"currentTeamId":7},{"id":8476878,"firstName":"Zemgus","lastName":"Girgensons","fullName":"Zemgus Girgensons","number":"28","position":"C","stats":{"_fantasyPoints":95.3,"_fantasyPointsAverage":1.34,"points":15,"goals":7,"assists":8,"penaltyMinutes":26,"plusMinus":-12,"hits":134,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":2,"shortHandedPoints":2,"shots":113,"blocked":32,"faceOffPct":36.5,"gameWinningGoals":0,"games":71,"timeOnIcePerGame":"13:42"},"currentTeamId":7},{"id":8476455,"firstName":"Gabriel","lastName":"Landeskog","fullName":"Gabriel Landeskog","number":"92","position":"LW","stats":{"_fantasyPoints":283.3,"_fantasyPointsAverage":3.63,"points":62,"goals":25,"assists":37,"penaltyMinutes":37,"plusMinus":16,"hits":149,"powerPlayGoals":8,"powerPlayPoints":8,"shortHandedGoals":0,"shortHandedPoints":1,"shots":183,"blocked":51,"faceOffPct":51.43,"gameWinningGoals":1,"games":78,"timeOnIcePerGame":"20:08"},"currentTeamId":21},{"id":8479340,"firstName":"Josh","lastName":"Anderson","fullName":"Josh Anderson","number":"76","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8474717,"firstName":"Mark","lastName":"Barberio","fullName":"Mark Barberio","number":"44","position":"D","stats":{"_fantasyPoints":91.7,"_fantasyPointsAverage":1.99,"points":13,"goals":3,"assists":10,"penaltyMinutes":31,"plusMinus":6,"hits":26,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":2,"shots":52,"blocked":62,"faceOffPct":0,"gameWinningGoals":1,"games":46,"timeOnIcePerGame":"17:16"},"currentTeamId":21},{"id":8476910,"firstName":"Scott","lastName":"Kosmachuk","fullName":"Scott Kosmachuk","number":"32","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":21},{"id":8478040,"firstName":"Austin","lastName":"Poganski","fullName":"Austin Poganski","number":"53","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":19},{"id":8477846,"firstName":"Ryan","lastName":"Carpenter","fullName":"Ryan Carpenter","number":"40","position":"C","stats":{"_fantasyPoints":85.75,"_fantasyPointsAverage":1.65,"points":15,"goals":9,"assists":6,"penaltyMinutes":11,"plusMinus":1,"hits":76,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":1,"shortHandedPoints":1,"shots":85,"blocked":17,"faceOffPct":50.25,"gameWinningGoals":2,"games":52,"timeOnIcePerGame":"12:35"},"currentTeamId":54},{"id":8476512,"firstName":"Jimmy","lastName":"Oligny","fullName":"Jimmy Oligny","number":"47","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8476852,"firstName":"Griffin","lastName":"Reinhart","fullName":"Griffin Reinhart","number":"8","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":54},{"id":8479494,"firstName":"Travis","lastName":"St. Denis","fullName":"Travis St. Denis","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":2},{"id":8478464,"firstName":"Jeremy","lastName":"Roy","fullName":"Jeremy Roy","number":"81","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8475169,"firstName":"Evander","lastName":"Kane","fullName":"Evander Kane","number":"9","position":"LW","stats":{"_fantasyPoints":228.45,"_fantasyPointsAverage":2.93,"points":54,"goals":29,"assists":25,"penaltyMinutes":82,"plusMinus":-9,"hits":159,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":4,"shortHandedPoints":4,"shots":307,"blocked":34,"faceOffPct":44.44,"gameWinningGoals":2,"games":78,"timeOnIcePerGame":"19:34"},"currentTeamId":28},{"id":8479580,"firstName":"Dylan","lastName":"Gambrell","fullName":"Dylan Gambrell","number":"14","position":"C","stats":{"_fantasyPoints":0.6,"_fantasyPointsAverage":0.2,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":-1,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":1,"blocked":2,"faceOffPct":50,"gameWinningGoals":0,"games":3,"timeOnIcePerGame":"10:33"},"currentTeamId":28},{"id":8474578,"firstName":"Erik","lastName":"Karlsson","fullName":"Erik Karlsson","number":"65","position":"D","stats":{"_fantasyPoints":257.6,"_fantasyPointsAverage":3.63,"points":62,"goals":9,"assists":53,"penaltyMinutes":36,"plusMinus":-25,"hits":58,"powerPlayGoals":3,"powerPlayPoints":3,"shortHandedGoals":0,"shortHandedPoints":1,"shots":196,"blocked":120,"faceOffPct":0,"gameWinningGoals":2,"games":71,"timeOnIcePerGame":"26:44"},"currentTeamId":28},{"id":8478981,"firstName":"Cavan","lastName":"Fitzgerald","fullName":"Cavan Fitzgerald","number":"76","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8479950,"firstName":"Tim","lastName":"Clifton","fullName":"Tim Clifton","number":"45","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8480780,"firstName":"Lukas","lastName":"Radil","fullName":"Lukas Radil","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8479538,"firstName":"Manuel","lastName":"Wiederer","fullName":"Manuel Wiederer","number":"59","position":"RW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8480084,"firstName":"Nick","lastName":"DeSimone","fullName":"Nick DeSimone","number":"57","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8478015,"firstName":"Kyle","lastName":"Wood","fullName":"Kyle Wood","number":"65","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8480053,"firstName":"Alexander","lastName":"Chmelevski","fullName":"Alexander Chmelevski","number":"55","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8480847,"firstName":"Ryan","lastName":"Merkley","fullName":"Ryan Merkley","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8478078,"firstName":"Rourke","lastName":"Chartier","fullName":"Rourke Chartier","number":"60","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8479393,"firstName":"Noah","lastName":"Gregor","fullName":"Noah Gregor","number":"73","position":"C","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8478136,"firstName":"Jacob","lastName":"Middleton","fullName":"Jacob Middleton","number":"67","position":"D","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8478117,"firstName":"Francis","lastName":"Perron","fullName":"Francis Perron","number":"47","position":"LW","stats":{"_fantasyPoints":0,"_fantasyPointsAverage":0,"points":0,"goals":0,"assists":0,"penaltyMinutes":0,"plusMinus":0,"hits":0,"powerPlayGoals":0,"powerPlayPoints":0,"shortHandedGoals":0,"shortHandedPoints":0,"shots":0,"blocked":0,"faceOffPct":0,"gameWinningGoals":0,"games":0,"timeOnIcePerGame":"0"},"currentTeamId":28},{"id":8474889,"firstName":"Martin","lastName":"Jones","fullName":"Martin Jones","number":"31","position":"G","stats":{"_fantasyPoints":"215.80","_fantasyPointsAverage":"3.60","savePercentage":0.915,"goalAgainstAverage":2.55,"wins":30,"losses":22,"saves":1554,"goalsAgainst":145,"shutouts":4},"currentTeamId":28}]

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconAdd__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IconEdit__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_common__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  .options {\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  table {\n    border-spacing: 0 20px;\n    width: 100%;\n  }\n\n  table td:first-child {\n    width: 200px;\n  }\n\n  table input {\n    border: 1px solid white;\n    font-size: 1.3em;\n    padding: 5px;\n  }\n\n  svg {\n    cursor: pointer;\n    fill: #999;\n  }\n\n  .button {\n    display: inline-block;\n    margin: 0 25px;\n  }\n'],['\n  .options {\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  table {\n    border-spacing: 0 20px;\n    width: 100%;\n  }\n\n  table td:first-child {\n    width: 200px;\n  }\n\n  table input {\n    border: 1px solid white;\n    font-size: 1.3em;\n    padding: 5px;\n  }\n\n  svg {\n    cursor: pointer;\n    fill: #999;\n  }\n\n  .button {\n    display: inline-block;\n    margin: 0 25px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WelcomeModal=function(_React$Component){_inherits(WelcomeModal,_React$Component);function WelcomeModal(){_classCallCheck(this,WelcomeModal);var _this=_possibleConstructorReturn(this,(WelcomeModal.__proto__||Object.getPrototypeOf(WelcomeModal)).apply(this,arguments));_this.state={listId:undefined,showNewListForm:false,showLoadListForm:false};_this.setListId=function(event){console.log("set listId");_this.setState({listId:event.currentTarget.value});};_this.loadList=function(listId){var loadListId=listId?listId:_this.state.listId;_this.props.handlers.loadList(loadListId);};_this.showOptionsHandler=function(){_this.setState({showNewListForm:false,showLoadListForm:false});};_this.newListHandler=function(){console.log("newListHandler");_this.setState({showNewListForm:true,showLoadListForm:false});};_this.loadListHandler=function(){console.log("loadListHandler");_this.setState({showNewListForm:false,showLoadListForm:true});};return _this;}_createClass(WelcomeModal,[{key:'render',value:function render(){var _this2=this;console.log("render WelcomeModal");var common=new __WEBPACK_IMPORTED_MODULE_6__util_common__["a" /* default */]();var title="Draft Assist";var buttons=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */],{label:"Back",clicked:this.showOptionsHandler}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */],{label:"Continue",clicked:function clicked(){_this2.loadList();}}));var handlers={closeModal:this.props.handlers.closeWelcomeModal};var newListComponent=function newListComponent(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"Give your list a name. All changes will be automatically saved under this name."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,"New List Name"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input",{id:"newListId",type:"text",onChange:_this2.setListId}))))),buttons);};var loadListComponent=function loadListComponent(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,"Choose List"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["b" /* default */],{onChange:function onChange(data){_this2.loadList(data.value);},isSearchable:false,styles:common.selectStyles(),isMulti:false,options:common.listsForSelect()}))))),buttons);};var chooseOptionComponent=function chooseOptionComponent(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{className:'options'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconAdd__["a" /* default */],{className:"button newList",width:"150px",height:"150px",clicked:_this2.newListHandler},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"New List")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__IconEdit__["a" /* default */],{className:"button loadList",width:"150px",height:"150px",clicked:_this2.loadListHandler},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"Load List")));};var form=this.state.showNewListForm?newListComponent():this.state.showLoadListForm?loadListComponent():chooseOptionComponent();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */],{title:title,show:true,handlers:handlers},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ModalStyle,null,form));}}]);return WelcomeModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (WelcomeModal);var ModalStyle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["a" /* default */].div(_templateObject);//# sourceMappingURL=WelcomeModal.js.map

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral([''],['']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyleDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);var IconEdit=function(_React$Component){_inherits(IconEdit,_React$Component);function IconEdit(){_classCallCheck(this,IconEdit);return _possibleConstructorReturn(this,(IconEdit.__proto__||Object.getPrototypeOf(IconEdit)).apply(this,arguments));}_createClass(IconEdit,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyleDiv,{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{onClick:this.props.clicked,width:this.props.width,height:this.props.height,viewBox:"0 0 300 300"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M149.996,0C67.157,0,0.001,67.161,0.001,149.997S67.157,300,149.996,300s150.003-67.163,150.003-150.003\n                S232.835,0,149.996,0z M221.302,107.945l-14.247,14.247l-29.001-28.999l-11.002,11.002l29.001,29.001l-71.132,71.126\n                l-28.999-28.996L84.92,186.328l28.999,28.999l-7.088,7.088l-0.135-0.135c-0.786,1.294-2.064,2.238-3.582,2.575l-27.043,6.03\n                c-0.405,0.091-0.817,0.135-1.224,0.135c-1.476,0-2.91-0.581-3.973-1.647c-1.364-1.359-1.932-3.322-1.512-5.203l6.027-27.035\n                c0.34-1.517,1.286-2.798,2.578-3.582l-0.137-0.137L192.3,78.941c1.678-1.675,4.404-1.675,6.082,0.005l22.922,22.917\n                C222.982,103.541,222.982,106.267,221.302,107.945z"})))),this.props.children);}}]);return IconEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (IconEdit);//# sourceMappingURL=IconEdit.js.map

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.bd60974a.js